import { Fragment as e, computed as t, createBlock as n, createCommentVNode as r, createElementBlock as i, createElementVNode as a, createSlots as o, createTextVNode as s, createVNode as c, isRef as l, mergeProps as u, nextTick as d, normalizeClass as f, normalizeStyle as p, onBeforeUnmount as m, onMounted as h, onUnmounted as g, openBlock as _, reactive as v, ref as y, renderList as b, renderSlot as x, resolveComponent as S, resolveDirective as C, resolveDynamicComponent as w, toDisplayString as T, unref as E, watch as D, withCtx as O, withDirectives as k, withKeys as A, withModifiers as j } from "vue";
import { format as M, parseISO as N } from "date-fns";
import { OnifyAPIEndpoint as P, apiSettings as F, applyPeriodToWidget as I, bootstrapPublicSettings as L, clearHelixCacheOnLogout as R, describeCronExpression as z, getHelixApiBaseUrl as B, hGetAppRouteUrl as V, hValidate as H, isPathOnlySettingUrl as U, publicSettings as ee, reloadAtConsumedInternalLoginRedirect as W, resolvePrevPeriod as te, useAdminDashboardConfig as ne, useAdminDashboardData as re, useFormRules as ie, useHAdminDataFetch as G, useHAdminDataSave as ae, useHAdminFormDataFetch as K, useHAlerts as q, useHBindQueryParams as J, useHBulletin as oe, useHCommon as Y, useHConfig as se, useHConfirm as ce, useHDefaults as X, useHFetch as le, useHFilterActions as ue, useHFilterQueryBuilder as de, useHFormatDateTime as fe, useHHomepageLink as pe, useHLocale as me, useHPageHead as he, useHThemePack as ge, useHTranslate as Z, useOCommon as _e, useOSettings as ve, useOUserSettingsStore as ye } from "@onify/helix-core";
import { VCol as Q, VRow as $, VSpacer as be } from "vuetify/components/VGrid";
import { VSkeletonLoader as xe } from "vuetify/components/VSkeletonLoader";
import { HAdminLogsFromDateOptions as Se, HAdminLogsLevelOptions as Ce, HAdminLogsSourceOptions as we, HAdminLogsTable as Te, HFormCodeEditor as Ee, HFormPassword as De, HMetricAlertBanner as Oe, HMetricBreakdownCard as ke, HMetricCard as Ae, HMetricFiltered as je, HMetricHistogramCard as Me, HMetricInfoCard as Ne, HMetricKpiLarge as Pe } from "@onify/helix-components";
import { VCard as Fe, VCardActions as Ie, VCardText as Le, VCardTitle as Re } from "vuetify/components/VCard";
import { VIcon as ze } from "vuetify/components/VIcon";
import { VAlert as Be, VAlertTitle as Ve } from "vuetify/components/VAlert";
import { VAvatar as He } from "vuetify/components/VAvatar";
import { VBtn as Ue } from "vuetify/components/VBtn";
import { VBtnToggle as We } from "vuetify/components/VBtnToggle";
import { VDatePicker as Ge } from "vuetify/components/VDatePicker";
import { VDialog as Ke } from "vuetify/components/VDialog";
import { useDebounceFn as qe, useIntervalFn as Je, useToggle as Ye } from "@vueuse/core";
import { useRoute as Xe, useRouter as Ze } from "vue-router";
import { VTextField as Qe } from "vuetify/components/VTextField";
import { VTooltip as $e } from "vuetify/components/VTooltip";
import { VList as et, VListItem as tt } from "vuetify/components/VList";
import { VMenu as nt } from "vuetify/components/VMenu";
import { VProgressCircular as rt } from "vuetify/components/VProgressCircular";
import { storeToRefs as it } from "pinia";
import { VForm as at } from "vuetify/components/VForm";
import { VSelect as ot } from "vuetify/components/VSelect";
import { useDefaults as st } from "vuetify";
import { VAvatar as ct, VBtn as lt, VCard as ut } from "vuetify/components";
import { VDivider as dt } from "vuetify/components/VDivider";
import { VFooter as ft } from "vuetify/components/VFooter";
import { VImg as pt } from "vuetify/components/VImg";
import { VSheet as mt } from "vuetify/components/VSheet";
import { VAppBar as ht, VAppBarNavIcon as gt, VAppBarTitle as _t } from "vuetify/components/VAppBar";
import { VMain as vt } from "vuetify/components/VMain";
import { VNavigationDrawer as yt } from "vuetify/components/VNavigationDrawer";
import { VLayout as bt } from "vuetify/components/VLayout";
//#region \0plugin-vue:export-helper
var xt = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, St = {}, Ct = { class: "h-dashboard-page-skeleton" }, wt = { class: "d-flex align-center justify-space-between mb-6" }, Tt = { class: "d-flex align-center ga-2 mb-3 mt-6" };
function Et(t, n) {
	return _(), i("div", Ct, [a("div", wt, [c(xe, {
		type: "heading",
		width: "220"
	}), c(xe, {
		type: "chip",
		width: "200",
		height: "36"
	})]), (_(), i(e, null, b(3, (t) => (_(), i(e, { key: t }, [a("div", Tt, [c(xe, {
		type: "avatar",
		width: "24",
		height: "24"
	}), c(xe, {
		type: "text",
		width: "120",
		height: "18"
	})]), c($, null, {
		default: O(() => [(_(), i(e, null, b(4, (e) => c(Q, {
			key: e,
			cols: "12",
			sm: "6",
			md: "4",
			lg: "3"
		}, {
			default: O(() => [c(xe, {
				type: "card",
				height: "96"
			})]),
			_: 1
		})), 64))]),
		_: 1
	})], 64))), 64))]);
}
var Dt = /*#__PURE__*/ xt(St, [["render", Et]]), Ot = {
	__name: "dashboard-widget-renderer",
	props: {
		widget: {
			type: Object,
			required: !0
		},
		widgetState: {
			type: Object,
			default: null
		}
	},
	setup(e) {
		let r = X(e, "HDashboardWidgetRenderer"), i = t(() => r.widgetState);
		return (t, r) => e.widget.type === "kpi" ? (_(), n(E(Ae), {
			key: 0,
			widget: e.widget,
			value: i.value?.value ?? null,
			loading: i.value?.loading ?? !0,
			error: i.value?.error ?? null,
			trend: i.value?.trend ?? null
		}, null, 8, [
			"widget",
			"value",
			"loading",
			"error",
			"trend"
		])) : e.widget.type === "breakdown" ? (_(), n(E(ke), {
			key: 1,
			widget: e.widget,
			"items-data": i.value?.items ?? {},
			loading: i.value?.loading ?? !0
		}, null, 8, [
			"widget",
			"items-data",
			"loading"
		])) : e.widget.type === "histogram" ? (_(), n(E(Me), {
			key: 2,
			widget: e.widget,
			buckets: Array.isArray(i.value?.value) ? i.value.value : [],
			loading: i.value?.loading ?? !0,
			error: i.value?.error ?? null
		}, null, 8, [
			"widget",
			"buckets",
			"loading",
			"error"
		])) : e.widget.type === "kpi-large" ? (_(), n(E(Pe), {
			key: 3,
			widget: e.widget,
			value: i.value?.value ?? null,
			loading: i.value?.loading ?? !0,
			error: i.value?.error ?? null,
			trend: i.value?.trend ?? null,
			"breakdown-data": i.value?.items ?? {}
		}, null, 8, [
			"widget",
			"value",
			"loading",
			"error",
			"trend",
			"breakdown-data"
		])) : e.widget.type === "info" ? (_(), n(E(Ne), {
			key: 4,
			widget: e.widget
		}, null, 8, ["widget"])) : e.widget.type === "filtered" ? (_(), n(E(je), {
			key: 5,
			widget: e.widget,
			groups: i.value?.groups ?? null,
			loading: i.value?.loading ?? !0,
			error: i.value?.error ?? null
		}, null, 8, [
			"widget",
			"groups",
			"loading",
			"error"
		])) : (_(), n(Fe, {
			key: 6,
			rounded: "lg",
			elevation: "1",
			class: "pa-4 text-body-2 text-medium-emphasis"
		}, {
			default: O(() => [s(T(e.widget.name), 1)]),
			_: 1
		}));
	}
}, kt = {
	key: 0,
	class: "h-dashboard-section mt-4 mb-6"
}, At = { class: "h-dashboard-section__heading d-flex align-center ga-2 mb-3" }, jt = {
	__name: "dashboard-section",
	props: {
		section: {
			type: Object,
			required: !0
		},
		widgetData: {
			type: Object,
			default: () => ({})
		}
	},
	setup(o) {
		let s = X(o, "HDashboardSection"), l = t(() => (s.section.children || []).filter((e) => e.display !== "banner"));
		function u(e) {
			let t = e.type === "kpi", n = e.size ?? {}, r = Object.keys(n).length > 0 || e.fullWidth, i = e.fullWidth ? 12 : n.cols ?? e.cols ?? null, a = n.md ?? e.md ?? i ?? (t ? 4 : 6);
			return {
				cols: i ?? 12,
				sm: n.sm ?? e.sm ?? (r ? a : t ? 6 : 12),
				md: a,
				lg: n.lg ?? e.lg ?? (r ? a : t ? 3 : 6)
			};
		}
		return (t, s) => l.value.length > 0 ? (_(), i("div", kt, [a("div", At, [o.section.icon ? (_(), n(ze, {
			key: 0,
			icon: o.section.icon,
			size: "small",
			color: "primary"
		}, null, 8, ["icon"])) : r("", !0), a("h2", null, T(o.section.name), 1)]), c($, null, {
			default: O(() => [(_(!0), i(e, null, b(l.value, (e) => (_(), n(Q, {
				key: e._id,
				cols: u(e).cols,
				sm: u(e).sm,
				md: u(e).md,
				lg: u(e).lg
			}, {
				default: O(() => [c(Ot, {
					widget: e,
					"widget-state": o.widgetData[e._id]
				}, null, 8, ["widget", "widget-state"])]),
				_: 2
			}, 1032, [
				"cols",
				"sm",
				"md",
				"lg"
			]))), 128))]),
			_: 1
		})])) : r("", !0);
	}
}, Mt = { class: "mt-1 text-body-2" }, Nt = {
	__name: "dashboard-error-state",
	props: { message: {
		type: String,
		default: null
	} },
	setup(e) {
		return X(e, "HDashboardErrorState"), (t, r) => (_(), n(Be, {
			class: "h-dashboard-error-state",
			type: "error",
			variant: "tonal",
			rounded: "lg",
			icon: "mdi:mdi-alert-circle-outline"
		}, {
			default: O(() => [c(Ve, null, {
				default: O(() => [s(T(E(Z)("admin_dashboard_error_title")), 1)]),
				_: 1
			}), a("p", Mt, T(e.message || E(Z)("admin_dashboard_error_desc")), 1)]),
			_: 1
		}));
	}
}, Pt = { class: "h-dashboard-empty-state text-center py-12" }, Ft = { class: "text-body-1 text-medium-emphasis" }, It = { class: "text-body-2 text-medium-emphasis mt-1" }, Lt = {
	__name: "dashboard-empty-state",
	props: {},
	setup(e) {
		return X(e, "HDashboardEmptyState"), (e, t) => (_(), i("div", Pt, [
			c(ze, {
				icon: "mdi:mdi-view-dashboard-outline",
				size: "64",
				color: "grey-lighten-2",
				class: "mb-4"
			}),
			a("p", Ft, T(E(Z)("admin_dashboard_empty")), 1),
			a("p", It, T(E(Z)("admin_dashboard_empty_hint")), 1)
		]));
	}
}, Rt = { class: "h-admin-links" }, zt = { class: "h-admin-links__heading d-flex align-center ga-2 mb-3" }, Bt = { class: "text-body-1 font-weight-semibold" }, Vt = {
	key: 0,
	class: "text-body-2 text-medium-emphasis"
}, Ht = {
	key: 0,
	class: "text-center mt-3"
}, Ut = {
	__name: "admin-links",
	props: {
		links: {
			type: Array,
			default: () => []
		},
		defaultVisible: {
			type: Number,
			default: 6
		}
	},
	setup(o) {
		let l = X(o, "HAdminLinks"), u = y(!1), d = t(() => u.value ? l.links : l.links.slice(0, l.defaultVisible));
		return (t, l) => (_(), i("div", Rt, [
			a("div", zt, [c(ze, {
				icon: "mdi:mdi-view-dashboard",
				size: "small",
				color: "primary"
			}), a("h2", null, T(E(Z)("admin_links_heading")), 1)]),
			c($, null, {
				default: O(() => [(_(!0), i(e, null, b(d.value, (e) => (_(), n(Q, {
					key: e.href,
					cols: "12",
					sm: "6",
					md: "4",
					lg: "4"
				}, {
					default: O(() => [c(Fe, {
						href: e.href,
						class: "h-admin-links__card",
						rounded: "lg",
						elevation: "1",
						height: "96"
					}, {
						default: O(() => [c(Le, { class: "d-flex align-center h-100 pa-4" }, {
							default: O(() => [c(He, {
								color: "primary-lighten-4",
								size: "48",
								class: "mr-3 flex-0-0"
							}, {
								default: O(() => [c(ze, {
									icon: e.icon || "mdi:mdi-link",
									color: "primary"
								}, null, 8, ["icon"])]),
								_: 2
							}, 1024), a("div", null, [a("div", Bt, T(e.name), 1), e.description ? (_(), i("div", Vt, T(e.description), 1)) : r("", !0)])]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1032, ["href"])]),
					_: 2
				}, 1024))), 128))]),
				_: 1
			}),
			o.links.length > o.defaultVisible ? (_(), i("div", Ht, [c(Ue, {
				variant: "text",
				size: "small",
				"append-icon": u.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down",
				onClick: l[0] ||= (e) => u.value = !u.value
			}, {
				default: O(() => [s(T(u.value ? E(Z)("show_less") : E(Z)("show_more")), 1)]),
				_: 1
			}, 8, ["append-icon"])])) : r("", !0)
		]));
	}
}, Wt = {
	key: 0,
	class: "h-admin-dashboard__periods"
}, Gt = { class: "text-caption text-medium-emphasis" }, Kt = {
	key: 0,
	class: "text-caption text-medium-emphasis"
}, qt = {
	key: 1,
	class: "text-caption text-error"
}, Jt = {
	key: 3,
	class: "h-admin-dashboard"
}, Yt = {
	__name: "admin-dashboard",
	props: {},
	setup(o) {
		X(o, "HAdminDashboard");
		let l = [{
			title: Z("home"),
			text: Z("home")
		}, {
			title: Z("admin"),
			text: Z("admin")
		}], { loading: u, error: d, enabledSections: f, periods: p, defaultPeriod: m, navigationLinks: h, hasSections: g } = ne(), v = y(!1), x = y(m.value || "30d");
		D(m, (e) => {
			e && !v.value && (x.value = e);
		});
		let C = y(!1), w = y([]), k = t(() => x.value?.startsWith("custom:")), A = t(() => {
			if (!k.value) return "Custom";
			let [, e, t] = x.value.split(":"), n = p.value.find((e) => e.value === "custom")?.dateFormat || "d MMM yyyy";
			try {
				return `${M(N(e), n)} – ${M(N(t), n)}`;
			} catch {
				return `${e} – ${t}`;
			}
		}), j = t({
			get: () => k.value ? "custom" : x.value,
			set: (e) => {
				e != null && e !== "custom" && (v.value = !0, x.value = e);
			}
		});
		function P(e) {
			let t = new Date(e);
			return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, "0")}-${String(t.getDate()).padStart(2, "0")}`;
		}
		let F = P(/* @__PURE__ */ new Date()), L = t(() => {
			let e = p.value.find((e) => e.value === "custom");
			return Math.min(e?.maxRange ?? 180, 180);
		}), R = t(() => {
			if (w.value.length !== 1) return F;
			let e = new Date(w.value[0]), t = new Date(e);
			t.setDate(t.getDate() + L.value);
			let n = P(t);
			return n < F ? n : F;
		}), z = t(() => {
			if (w.value.length < 1) return "";
			let e = new Date(w.value[0]);
			return (new Date(w.value[w.value.length - 1]) - e) / (1e3 * 60 * 60 * 24) > L.value ? Z("admin_dashboard_custom_period_range_error") : "";
		});
		function B() {
			if (k.value) {
				let [, e, t] = x.value.split(":");
				w.value = [e, t];
			} else w.value = [];
			C.value = !0;
		}
		function V() {
			C.value = !1, !k.value && x.value === "custom" && (x.value = m.value || "30d");
		}
		function H() {
			if (z.value || w.value.length < 1) return;
			let e = P(w.value[0]), t = P(w.value[w.value.length - 1]);
			v.value = !0, x.value = `custom:${e}:${t}`, C.value = !1;
		}
		let { widgetData: U } = re({
			enabledSections: f,
			selectedPeriod: x,
			periods: p
		}), ee = t(() => {
			let e = x.value, t = k.value ? A.value : p.value.find((t) => t.value === e)?.label ?? e, n = te(e, p.value), r, i;
			if (k.value) {
				let t = e.split(":");
				r = t[1], i = t[2];
			} else {
				let t = e?.match(/^(\d+)d$/);
				if (t) {
					let e = parseInt(t[1], 10), n = /* @__PURE__ */ new Date();
					n.setDate(n.getDate() - (e - 1)), r = P(n);
				}
				i = F;
			}
			return f.value.map((a) => ({
				...a,
				children: a.children.map((a) => ({
					...I(a, e, n, t),
					...a.type === "histogram" ? {
						_dateFrom: r,
						_dateTo: i
					} : {}
				}))
			}));
		}), W = t(() => {
			let e = [];
			for (let t of ee.value) for (let n of t.children || []) n.display === "banner" && e.push(n);
			return e;
		});
		return (t, o) => {
			let f = S("h-admin-layout");
			return _(), n(f, {
				"page-key": "dashboard",
				"page-title": E(Z)("admin_dashboard_title"),
				"header-title": E(Z)("admin_dashboard_title"),
				"breadcrumb-items": l
			}, {
				"header-right-content": O(() => [!E(u) && E(p).length > 0 ? (_(), i("div", Wt, [c(We, {
					modelValue: j.value,
					"onUpdate:modelValue": o[0] ||= (e) => j.value = e,
					density: "compact",
					variant: "outlined",
					class: "h-admin-dashboard__period-toggle",
					"aria-label": E(Z)("date")
				}, {
					default: O(() => [(_(!0), i(e, null, b(E(p), (e) => (_(), n(Ue, {
						key: e.value,
						value: e.value,
						size: "small",
						onClick: (t) => e.value === "custom" ? B() : void 0
					}, {
						default: O(() => [s(T(e.value === "custom" && k.value ? A.value : e.label), 1)]),
						_: 2
					}, 1032, ["value", "onClick"]))), 128))]),
					_: 1
				}, 8, ["modelValue", "aria-label"])])) : r("", !0), c(Ke, {
					modelValue: C.value,
					"onUpdate:modelValue": o[2] ||= (e) => C.value = e,
					"max-width": "360"
				}, {
					default: O(() => [c(Fe, { class: "h-admin-dashboard__date-dialog" }, {
						default: O(() => [
							c(Re, { class: "text-body-1 font-weight-medium pt-4 px-4" }, {
								default: O(() => [s(T(E(Z)("admin_dashboard_custom_period_title")) + " ", 1), a("span", Gt, T(E(Z)("admin_dashboard_custom_period_max_days", { days: L.value })), 1)]),
								_: 1
							}),
							c(Le, { class: "pa-0" }, {
								default: O(() => [c(Ge, {
									modelValue: w.value,
									"onUpdate:modelValue": o[1] ||= (e) => w.value = e,
									multiple: "range",
									max: R.value,
									"hide-header": "",
									"show-adjacent-months": "",
									width: "100%"
								}, null, 8, ["modelValue", "max"])]),
								_: 1
							}),
							c(Ie, { class: "px-4 pb-4" }, {
								default: O(() => [
									w.value.length === 1 ? (_(), i("span", Kt, T(E(Z)("admin_dashboard_custom_period_hint")), 1)) : z.value ? (_(), i("span", qt, T(z.value), 1)) : r("", !0),
									c(be),
									c(Ue, {
										variant: "text",
										onClick: V
									}, {
										default: O(() => [s(T(E(Z)("cancel")), 1)]),
										_: 1
									}),
									c(Ue, {
										color: "primary",
										variant: "flat",
										disabled: w.value.length < 1 || !!z.value,
										onClick: H
									}, {
										default: O(() => [s(T(E(Z)("apply")), 1)]),
										_: 1
									}, 8, ["disabled"])
								]),
								_: 1
							})
						]),
						_: 1
					})]),
					_: 1
				}, 8, ["modelValue"])]),
				default: O(() => [E(u) ? (_(), n(Dt, { key: 0 })) : E(d) ? (_(), n(Nt, {
					key: 1,
					message: E(d)
				}, null, 8, ["message"])) : E(g) ? (_(), i("div", Jt, [
					(_(!0), i(e, null, b(W.value, (e) => (_(), n(E(Oe), {
						key: e._id,
						widget: e,
						value: E(U)[e._id]?.value,
						loading: E(U)[e._id]?.loading,
						error: E(U)[e._id]?.error,
						class: "mb-4"
					}, null, 8, [
						"widget",
						"value",
						"loading",
						"error"
					]))), 128)),
					(_(!0), i(e, null, b(ee.value, (e) => (_(), n(jt, {
						key: e.name,
						section: e,
						"widget-data": E(U)
					}, null, 8, ["section", "widget-data"]))), 128)),
					E(h).length > 0 ? (_(), n(Ut, {
						key: 0,
						links: E(h),
						class: "mt-6"
					}, null, 8, ["links"])) : r("", !0)
				])) : (_(), n(Lt, { key: 2 }))]),
				_: 1
			}, 8, ["page-title", "header-title"]);
		};
	}
}, Xt = { class: "c-logs__actions admin-logs-actions d-flex flex-wrap mb-4" }, Zt = { class: "c-logs__list" }, Qt = "/tools/logs", $t = {
	__name: "admin-logs",
	setup(e) {
		let r = Ze(), i = le(), o = v({
			fromDate: 300,
			searchTerm: "",
			isLiveUpdatesEnabled: !0,
			interval: 2e3,
			logLevel: null,
			sources: []
		}), { params: s, data: l } = i({
			url: Qt,
			params: {
				query: void 0,
				sort: "@timestamp"
			},
			immediate: !1,
			isLive: !0
		}), u = () => {
			let e = o.searchTerm.trim() ? `(${o.searchTerm})` : "*", t = o.logLevel ? `(log.level:${o.logLevel})` : void 0, n = o.sources?.length ? `(name:(${o.sources.join(" OR ")}))` : void 0;
			s.fromdate = Date.now() - o.fromDate * 1e3, s.query = [
				e,
				t,
				n
			].filter((e) => !!e).join(" AND ") || void 0;
		}, d = () => {
			u();
		};
		r.isReady().then(d);
		let f = qe(() => {
			d();
		}, 300);
		J(o, f);
		let p = t(() => l.value?.records);
		return (e, t) => {
			let r = S("h-live-update-controls"), i = S("h-admin-layout");
			return _(), n(i, {
				class: "c-logs h-admin-logs-page-container",
				"page-key": "logs",
				"page-title": E(Z)("system-logs"),
				"header-title": E(Z)("system-logs"),
				"breadcrumb-items": [{
					title: E(Z)("admin"),
					text: E(Z)("admin"),
					href: "/admin/dashboard"
				}, {
					title: E(Z)("system-logs"),
					text: E(Z)("system-logs")
				}]
			}, {
				default: O(() => [a("div", Xt, [
					c(Qe, {
						modelValue: o.searchTerm,
						"onUpdate:modelValue": t[0] ||= (e) => o.searchTerm = e,
						class: "c-search admin-logs-actions__action",
						label: E(Z)("search_logs"),
						type: "search",
						name: "search",
						autocomplete: "off",
						"data-1p-ignore": "",
						"data-lpignore": "true"
					}, null, 8, ["modelValue", "label"]),
					c(E(Se), {
						modelValue: o.fromDate,
						"onUpdate:modelValue": t[1] ||= (e) => o.fromDate = e,
						class: "admin-logs-actions__action"
					}, null, 8, ["modelValue"]),
					c(r, {
						interval: o.interval,
						"onUpdate:interval": t[2] ||= (e) => o.interval = e,
						"is-live-updates-enabled": o.isLiveUpdatesEnabled,
						"onUpdate:isLiveUpdatesEnabled": t[3] ||= (e) => o.isLiveUpdatesEnabled = e,
						class: "admin-logs-actions__action",
						onIntervalTrigger: E(f)
					}, null, 8, [
						"interval",
						"is-live-updates-enabled",
						"onIntervalTrigger"
					]),
					c(E(Ce), {
						modelValue: o.logLevel,
						"onUpdate:modelValue": t[4] ||= (e) => o.logLevel = e,
						class: "admin-logs-actions__action"
					}, null, 8, ["modelValue"]),
					c(E(we), {
						modelValue: o.sources,
						"onUpdate:modelValue": t[5] ||= (e) => o.sources = e,
						class: "admin-logs-actions__action"
					}, null, 8, ["modelValue"])
				]), a("div", Zt, [c(E(Te), {
					class: "c-table h-admin-logs-table",
					logs: p.value
				}, null, 8, ["logs"])])]),
				_: 1
			}, 8, [
				"page-title",
				"header-title",
				"breadcrumb-items"
			]);
		};
	}
}, en = {
	__name: "admin-processes",
	props: {},
	setup(n) {
		X(n, "HAdminProcesses");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { confirm: l } = ce(), { hAddAlert: u } = q(), d = y(!0), f = y(!1), p = y(""), m = y(""), g = y(""), b = y(!1), x = y({}), C = {
			term: "",
			title: "",
			titleMatchType: "contains",
			workflow: "",
			workflowMatchType: "contains",
			user: "",
			userMatchType: "contains",
			status: [],
			tag: [],
			sortBy: "startdate",
			sortOrder: "desc",
			page: 1,
			pageSize: 25,
			startdatePreset: null,
			enddatePreset: null,
			modifieddatePreset: null
		}, w = v({ ...C }), D = [
			{
				label: Z("running"),
				value: "start",
				icon: "mdi:mdi-rotate-right",
				color: "admin-process-running"
			},
			{
				label: Z("status_paused"),
				value: "pause",
				icon: "mdi:mdi-alert-circle-outline",
				color: "admin-process-paused"
			},
			{
				label: Z("stopped"),
				value: "stop",
				icon: "mdi:mdi-cancel",
				color: "admin-process-stopped"
			},
			{
				label: Z("completed"),
				value: "complete",
				icon: "mdi:mdi-check",
				color: "admin-process-completed"
			}
		], k = D.reduce((e, t) => (e[t.value] = t, e), {}), A = (e) => {
			let t = k[e];
			return t ? t.color : "grey";
		}, j = (e) => {
			let t = k[e];
			return t ? t.icon : "mdi:mdi-circle";
		}, M = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "title",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("title_filter"),
					placeholder: Z("title_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-format-title",
					defaultMatchType: "contains"
				}
			},
			{
				key: "workflow",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("workflow_filter"),
					placeholder: Z("workflow_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-sitemap",
					defaultMatchType: "contains"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-pound"
				}
			},
			{
				key: "status",
				type: "array",
				arrayOperator: "OR",
				component: "h-filter-multiselect",
				queryParamKey: "status.statuskey",
				props: {
					title: Z("status_filter"),
					icon: "mdi:mdi-alert-octagon",
					showAsChips: !0,
					options: D
				}
			},
			{
				key: "user",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("user_filter"),
					placeholder: Z("user_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-account",
					defaultMatchType: "contains"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [
					{
						key: "startdate",
						type: "date",
						component: "h-filter-datetime",
						model: "startdatePreset",
						props: {
							label: Z("startdate"),
							manualSync: !0
						}
					},
					{
						key: "enddate",
						type: "date",
						component: "h-filter-datetime",
						model: "enddatePreset",
						props: {
							label: Z("enddate"),
							minDatePresetFilter: w.startdatePreset,
							manualSync: !0
						}
					},
					{
						key: "modifieddate",
						type: "date",
						component: "h-filter-datetime",
						model: "modifieddatePreset",
						props: {
							label: Z("modifieddate_filter"),
							minDatePresetFilter: w.startdatePreset,
							manualSync: !0
						}
					}
				]
			}
		] }, N = [
			{
				title: "title",
				key: "title",
				align: "start",
				sortable: !0,
				width: 212,
				value: "title",
				nowrap: !1,
				customSortKey: "title.lower",
				translate: !0
			},
			{
				title: "workflow",
				key: "workflow",
				sortable: !0,
				width: 200,
				value: "workflow",
				nowrap: !1,
				translate: !0,
				filterOnClick: (e) => L("workflow", e.workflow, "exact"),
				isFilterActive: (e) => I("workflow", e.workflow, "exact")
			},
			{
				title: "status",
				key: "status",
				width: 133,
				sortable: !0,
				value: "status",
				customSortKey: "status.statuskey",
				translate: !0,
				component: "h-chip-table-cell",
				defaultValue: {
					statuskey: "",
					name: ""
				},
				componentProps: {
					getColor: (e) => A(e?.statuskey || ""),
					getIcon: (e) => j(e?.statuskey || "")
				},
				formatCell: (e) => e?.name || "",
				filterOnClick: (e) => R("status", e?.statuskey),
				isFilterActive: (e) => I("status", e?.statuskey)
			},
			{
				title: "state",
				key: "state",
				sortable: !1,
				width: 122,
				value: "state",
				nowrap: !1,
				translate: !0,
				component: "h-process-state-simple",
				componentProps: { maxVisible: 5 }
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 291,
				value: "tag",
				nowrap: !1,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => R("tag", e),
				isFilterActive: (e) => I("tag", e)
			},
			{
				title: "user",
				key: "createdby",
				width: 96,
				sortable: !0,
				value: "createdby",
				nowrap: !1,
				translate: !0,
				filterOnClick: (e) => L("user", e.createdby, "exact"),
				isFilterActive: (e) => I("user", e.createdby, "exact")
			},
			{
				title: "startdate",
				key: "startdate",
				sortable: !0,
				width: 200,
				value: "startdate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			},
			{
				title: "enddate",
				key: "enddate",
				sortable: !0,
				width: 200,
				value: "enddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 200,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], P = {
			pageKey: "processes",
			pageTitle: Z("admin_processes_title"),
			headerTitle: Z("admin_processes_title"),
			searchPlaceholder: Z("search_processes"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("processes"),
					text: Z("processes")
				}
			]
		}, F = qe(me, 300), { isFilterActive: I, toggleFilter: L, toggleArrayFilter: R } = ue({
			filters: w,
			onFilterChange: F
		}), { params: z, execute: B } = G({
			url: "/admin/processes",
			filters: w,
			additionalParams: { includebpmn: !1 }
		}), V = y(null), H = y(!1), U = t(() => V.value?.meta?.totalresults ?? 0), ee = Z("total_processes"), W = Z("total_running"), te = Z("total_completed"), ne = Z("total_stopped"), re = y(0), ie = y(0), ae = y(0), K = t(() => ({ widgets: [
			{
				summary: !0,
				title: ee,
				count: U.value,
				icon: "mdi:mdi-file-tree",
				color: "#9CF1EF",
				iconColor: "#00201F"
			},
			{
				title: W,
				count: re.value,
				icon: "mdi:mdi-rotate-right",
				color: "admin-process-running",
				iconColor: "#FFFFFF"
			},
			{
				title: te,
				count: ie.value,
				icon: "mdi:mdi-check",
				color: "#008568",
				iconColor: "#FFFFFF"
			},
			{
				title: ne,
				count: ae.value,
				icon: "mdi:mdi-cancel",
				color: "#FF9887",
				iconColor: "#191919"
			}
		] })), oe = [
			"start",
			"complete",
			"stop"
		].map((e) => o({
			url: "/admin/processes",
			method: "get",
			immediate: !1,
			params: {
				query: () => `(${z.query}) AND status.statuskey:${e}`,
				metaonly: !0,
				includebpmn: !1
			}
		})), se = 0;
		async function le() {
			let e = ++se;
			H.value = !0;
			try {
				let t = await Promise.all([B(), ...oe.map((e) => e.execute())]);
				if (t.some((e) => !e?.ok)) throw Error("Process summary request failed");
				let [n, r, i, a] = await Promise.all(t.map((e) => e.json()));
				if (e !== se) return;
				V.value = n, re.value = r.meta?.totalresults ?? 0, ie.value = i.meta?.totalresults ?? 0, ae.value = a.meta?.totalresults ?? 0;
			} catch {
				e === se && u({
					title: Z("error_occurred"),
					type: "error",
					timeout: 5e3
				});
			} finally {
				e === se && (H.value = !1);
			}
		}
		function pe() {
			me(!0);
		}
		function me(e = !1) {
			let { query: t, sort: n } = a(M.filters, w);
			if (z.query = `(${t.replace(/^\*(?= AND |$)/, "*:*")}) AND NOT system:true`, z.sort = n, e || d.value) return le();
		}
		let he = [
			{
				label: Z("view_flow_bpmn"),
				icon: "mdi:mdi-sitemap",
				color: "neutral-70",
				action: async (e) => {
					let { execute: t, data: n } = o({
						url: `/admin/processes/${e.id}`,
						method: "get",
						immediate: !1,
						params: { includebpmn: !0 }
					});
					try {
						await t(), p.value = n.value?.bpmn || "", m.value = e.title || "", g.value = e.id || "", f.value = !0;
					} catch {
						u({
							title: Z("error_occurred"),
							body: Z("failed_to_load_bpmn"),
							type: "error",
							timeout: 5e3
						});
					}
				}
			},
			{
				label: Z("view_raw_data"),
				icon: "mdi:mdi-code-tags",
				color: "neutral-70",
				action: (e) => {
					x.value = e, b.value = !0;
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await l({
						title: Z("admin_delete_process_question"),
						message: `“${e.title || e.id}”`,
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = o({
							url: `/admin/processes/${e.id}`,
							method: "delete",
							immediate: !1
						});
						try {
							await t(), await le();
						} catch {
							u({
								title: Z("error_occurred"),
								body: Z("process_delete_error"),
								type: "error",
								timeout: 5e3
							});
						}
					}
				}
			}
		];
		function ge() {
			return Object.assign(w, { ...C }), me(!0);
		}
		return h(async () => {
			J(w, F), await me(!0);
		}), (t, n) => {
			let r = S("h-admin-template"), a = S("h-view-workflow-dialog"), o = S("h-view-code-dialog");
			return _(), i(e, null, [
				c(r, {
					"auto-search-enabled": d.value,
					"onUpdate:autoSearchEnabled": n[0] ||= (e) => d.value = e,
					"page-configuration": P,
					"widgets-config": K.value,
					"filters-config": M,
					filters: w,
					"table-headers": N,
					"table-actions": he,
					"table-params": E(z),
					"table-data": V.value,
					"table-loading": H.value,
					"total-results": U.value,
					onSearch: pe,
					onClearFilters: ge
				}, null, 8, [
					"auto-search-enabled",
					"widgets-config",
					"filters",
					"table-params",
					"table-data",
					"table-loading",
					"total-results"
				]),
				c(a, {
					id: g.value,
					"dialog-visible": f.value,
					"onUpdate:dialogVisible": n[1] ||= (e) => f.value = e,
					"bpmn-data": p.value,
					title: m.value
				}, null, 8, [
					"id",
					"dialog-visible",
					"bpmn-data",
					"title"
				]),
				c(o, {
					modelValue: b.value,
					"onUpdate:modelValue": n[2] ||= (e) => b.value = e,
					item: x.value,
					"field-name": "id",
					"field-label": E(Z)("process_id")
				}, {
					"raw-json": O(() => [s(T(JSON.stringify(x.value, null, 2)), 1)]),
					_: 1
				}, 8, [
					"modelValue",
					"item",
					"field-label"
				])
			], 64);
		};
	}
}, tn = {
	__name: "admin-audit",
	props: {},
	setup(n) {
		X(n, "HAdminAudit");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), o = y(!0), l = y(!1), u = y({}), d = t(() => ({
			title: u.value?.title || u.value?.name || "",
			name: u.value?.name
		})), f = t(() => JSON.stringify(u.value ?? {}, null, 2)), p = {
			term: "",
			name: "",
			nameMatchType: "contains",
			title: "",
			titleMatchType: "contains",
			userid: "",
			useridMatchType: "contains",
			tag: [],
			datetimePreset: null,
			sortBy: "datetime",
			sortOrder: "desc",
			page: 1,
			pageSize: 25
		}, m = v({ ...p }), g = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "title",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("title_filter"),
					placeholder: "Filter by title...",
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-format-title",
					defaultMatchType: "contains"
				}
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: "Filter by name...",
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "userid",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("user_filter"),
					placeholder: "Filter by user...",
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-account",
					defaultMatchType: "contains"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					controlsSync: !0
				},
				filters: [{
					key: "datetime",
					type: "date",
					component: "h-filter-datetime",
					model: "datetimePreset",
					props: {
						label: Z("datetime"),
						manualSync: !0
					}
				}]
			}
		] }, b = [
			{
				title: "title",
				key: "title",
				align: "start",
				sortable: !0,
				width: 300,
				value: "title",
				nowrap: !1,
				customSortKey: "title.lower",
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 200,
				value: "tag",
				nowrap: !1,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => z("tag", e),
				isFilterActive: (e) => L("tag", e)
			},
			{
				title: "userid",
				key: "userid",
				sortable: !0,
				value: "userid",
				nowrap: !1,
				customSortKey: "userid",
				translate: !0,
				filterOnClick: (e) => R("userid", e.userid, "exact"),
				isFilterActive: (e) => L("userid", e.userid, "exact")
			},
			{
				title: "datetime",
				key: "datetime",
				sortable: !0,
				value: "datetime",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], x = {
			pageKey: "audit",
			pageTitle: Z("activity_log"),
			headerTitle: Z("activity_log"),
			searchPlaceholder: Z("search_audits"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("audit"),
					text: Z("audit")
				}
			]
		}, { data: C, loading: w, params: D, execute: k, totalResults: A } = G({
			url: "/admin/audit",
			filters: m
		}), j = Z("total_audits"), M = t(() => ({ widgets: [{
			summary: !0,
			title: j,
			count: A.value,
			icon: "mdi:mdi-database",
			color: "grey-lighten-3",
			iconColor: "grey-darken-4"
		}] })), N = [{
			icon: "mdi:mdi-code-tags",
			label: Z("view_raw_data"),
			color: "neutral-70",
			action: (e) => {
				u.value = e, l.value = !0;
			}
		}];
		function P() {
			F(!0);
		}
		function F(e = !1) {
			let { query: t, sort: n } = a(g.filters, m);
			D.query = t, D.sort = n, (e || o.value) && k();
		}
		let I = qe(F, 300), { isFilterActive: L, toggleFilter: R, toggleArrayFilter: z } = ue({
			filters: m,
			onFilterChange: I
		});
		function B() {
			return Object.assign(m, { ...p }), F(!0);
		}
		return h(async () => {
			J(m, I), F(), k();
		}), (t, n) => {
			let r = S("h-admin-template"), a = S("h-view-code-dialog");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": o.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => o.value = e,
				"page-configuration": x,
				"widgets-config": M.value,
				"filters-config": g,
				filters: m,
				"table-headers": b,
				"table-data": E(C),
				"table-loading": E(w),
				"total-results": E(A),
				"table-actions": N,
				onSearch: P,
				onClearFilters: B
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-data",
				"table-loading",
				"total-results"
			]), c(a, {
				modelValue: l.value,
				"onUpdate:modelValue": n[1] ||= (e) => l.value = e,
				item: d.value,
				"field-name": "name",
				"field-label": E(Z)("name")
			}, {
				"raw-json": O(() => [s(T(f.value), 1)]),
				_: 1
			}, 8, [
				"modelValue",
				"item",
				"field-label"
			])], 64);
		};
	}
}, nn = { class: "text-headline-small" }, rn = {
	__name: "bulletin-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 600
		}
	},
	emits: ["success", "cancel"],
	setup(t, { expose: r, emit: o }) {
		let { hAddAlert: l } = q(), { keyRules: u, nameRules: d, idRules: f, requiredRules: p, integerRules: m } = ie(), { save: h } = ae();
		X(t, "HBulletinForm");
		let g = {
			title: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			key: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			status: {
				type: String,
				default: "informational"
			},
			sticky: {
				type: Boolean,
				default: !1
			},
			workspace: {
				type: Array,
				default: () => null
			},
			role: {
				type: Array,
				default: () => null
			},
			tag: {
				type: Array,
				default: () => null
			},
			domain: {
				type: Array,
				default: () => null
			},
			order: {
				type: Number,
				default: null
			},
			startdate: {
				type: String,
				default: null
			},
			enddate: {
				type: String,
				default: null
			},
			action: {
				type: Array,
				default: () => null
			}
		}, x = {
			id: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			url: {
				type: Array,
				default: () => []
			},
			order: {
				type: Number,
				default: null
			},
			target: {
				type: String,
				default: "_self"
			}
		}, C = () => {
			let e = {};
			return Object.keys(g).forEach((t) => {
				let n = g[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, w = () => {
			let e = {};
			return Object.keys(x).forEach((t) => {
				let n = x[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, k = o, A = y(null), j = y(!1), M = y(!1), N = y(!1), P = y(null), F = v(C()), I = y(!1), L = y({}), R = [
			{
				title: Z("informational"),
				value: "informational"
			},
			{
				title: Z("warning"),
				value: "warning"
			},
			{
				title: Z("critical"),
				value: "critical"
			}
		], z = [
			{
				title: "-",
				value: ""
			},
			{
				title: "_self - " + Z("target_self"),
				value: "_self"
			},
			{
				title: "_blank - " + Z("target_blank"),
				value: "_blank"
			},
			{
				title: "_top - " + Z("target_top"),
				value: "_top"
			},
			{
				title: "_modal - " + Z("target_modal"),
				value: "_modal"
			},
			{
				title: "_window - " + Z("target_window"),
				value: "_window"
			}
		], B = m(), { data: V, loading: H } = K({
			url: "/admin/domains",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.name,
				key: e.key
			}))
		}), { data: U, loading: ee } = K({
			url: "/admin/roles",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), { data: W, loading: te } = K({
			url: "/admin/workspaces",
			formatter: (e) => e.map((e) => ({
				title: e.title,
				value: e.slug,
				key: e.slug
			}))
		});
		D(F, () => {
			I.value = JSON.stringify(F) !== JSON.stringify(L.value);
		}, { deep: !0 }), D(() => F.startdate, (e) => {
			let t = Y(e), n = Y(F.enddate);
			!t || !n || n.getTime() <= t.getTime() && (F.enddate = null, A.value?.resetValidation?.());
		}), D(j, (e) => {
			e || ne();
		});
		function ne() {
			let e = C();
			Object.keys(e).forEach((t) => {
				F[t] = e[t];
			}), L.value = JSON.parse(JSON.stringify(F)), N.value = !1, P.value = null, I.value = !1;
		}
		function re(e, t = !0) {
			Object.keys(g).forEach((t) => {
				let n = g[t], r = e?.[t], i = r != null;
				n.type === Array ? F[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : n.type === Boolean ? F[t] = i ? !!r : typeof n.default == "function" ? n.default() : n.default : (n.type === String || n.type, F[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), t || (F.key = ""), L.value = JSON.parse(JSON.stringify(F)), N.value = t, P.value = t && e?.key || null, I.value = !t;
		}
		async function G() {
			if (!M.value && ((await A.value?.validate())?.valid ?? !0)) {
				M.value = !0;
				try {
					await le(ce()), k("success"), j.value = !1;
				} catch (e) {
					l({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					M.value = !1;
				}
			}
		}
		function J(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) r === null || r === "" || Array.isArray(r) && r.length === 0 || (t[n] = r);
			return t;
		}
		function oe(e) {
			if (e == null || e === "") return null;
			let t = e instanceof Date ? e : new Date(e);
			return Number.isNaN(t.getTime()) ? null : t.toISOString();
		}
		function Y(e) {
			if (e == null || e === "") return null;
			let t = e instanceof Date ? e : new Date(e);
			return Number.isNaN(t.getTime()) ? null : t;
		}
		let se = [(e) => {
			let t = Y(e), n = Y(F.startdate);
			return !t || !n ? !0 : t.getTime() > n.getTime() || Z("enddate_after_startdate");
		}];
		function ce() {
			let e = (e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [], t = e(F.workspace, (e) => typeof e == "string" ? e.toLowerCase().trim() : e), n = e(F.role, (e) => typeof e == "string" ? e.toLowerCase().trim() : e), r = e(F.tag), i = e(F.domain), a = J({
				key: F.key?.trim() || null,
				title: F.title?.trim() || "",
				name: F.name?.trim() || null,
				description: F.description?.trim() || null,
				status: F.status || null,
				sticky: !!F.sticky,
				workspace: t,
				role: n,
				tag: r,
				domain: i,
				order: F.order === null || F.order === void 0 || F.order === "" ? null : Number(F.order),
				startdate: oe(F.startdate),
				enddate: oe(F.enddate),
				action: Array.isArray(F.action) ? F.action.filter((e) => e && typeof e == "object").map((e) => {
					let t = String(e.name || "").trim(), n = Array.isArray(e.url) ? e.url.filter(Boolean) : e.url ? [e.url] : [], r = n.length > 0 ? String(n[0]) : "", i = String(e.description || "").trim(), a = String(e.target || "").trim();
					return !t || !r ? null : {
						id: e.id ? String(e.id) : void 0,
						name: t,
						url: r,
						description: i || void 0,
						order: e.order ? parseInt(e.order, 10) : 0,
						target: a || "_self"
					};
				}).filter(Boolean) : []
			});
			return N.value && L.value?.startdate && !F.startdate && (a.startdate = null), N.value && L.value?.enddate && !F.enddate && (a.enddate = null), a;
		}
		async function le(e) {
			let t = N.value ? "update" : "create", n = {
				create: "/admin/bulletins?refresh=true",
				update: `/admin/bulletins/${P.value}?refresh=true`
			}, r = {
				create: "post",
				update: "put"
			}, i = {
				error: {
					create: "bulletin_create_error",
					update: "bulletin_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			}, a = t === "update" ? (({ key: e, ...t }) => t)(e) : e;
			if (!(await h({
				url: n[t],
				method: r[t],
				payload: a
			}))?.ok) throw Error(Z(i.error[t]));
			l({
				title: Z(i.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function ue() {
			k("cancel"), j.value = !1;
		}
		function de() {
			F.action ||= [], F.action.push(w());
		}
		function fe(e) {
			F.action.splice(e, 1);
		}
		function pe(e = null) {
			e && re(e), j.value = !0;
		}
		function me(e) {
			re(e, !1), j.value = !0;
		}
		return r({
			validate: () => A.value?.validate(),
			reset: () => A.value?.reset(),
			resetValidation: () => A.value?.resetValidation(),
			formData: F,
			open: pe,
			openCopy: me,
			addAction: de,
			endDateRules: se
		}), (r, o) => {
			let l = S("h-form-text"), m = S("h-form-textarea"), h = S("h-form-select"), g = S("h-form-switch"), v = S("h-form-autocomplete"), y = S("h-form-combobox"), x = S("h-form-date-time-picker"), C = S("h-action-button"), w = S("h-form-field"), D = S("h-form-layout");
			return _(), n(D, {
				ref_key: "formRef",
				ref: A,
				modelValue: j.value,
				"onUpdate:modelValue": o[13] ||= (e) => j.value = e,
				loading: M.value,
				"bg-color": t.bgColor,
				"header-text": N.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": t.drawerWidth,
				"has-changes": I.value,
				onSubmit: G,
				onCancel: ue
			}, {
				default: O(() => [
					c(l, {
						modelValue: F.key,
						"onUpdate:modelValue": o[0] ||= (e) => F.key = e,
						icon: "mdi:mdi-key",
						label: E(Z)("key"),
						required: !N.value,
						rules: N.value ? [] : E(u)(),
						messages: [E(Z)("key_hint")],
						disabled: N.value
					}, null, 8, [
						"modelValue",
						"label",
						"required",
						"rules",
						"messages",
						"disabled"
					]),
					c(l, {
						modelValue: F.title,
						"onUpdate:modelValue": o[1] ||= (e) => F.title = e,
						icon: "mdi:mdi-format-title",
						label: E(Z)("title"),
						hint: E(Z)("bulletin_title_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(l, {
						modelValue: F.name,
						"onUpdate:modelValue": o[2] ||= (e) => F.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						required: "",
						rules: E(d),
						hint: E(Z)("bulletin_name_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(m, {
						modelValue: F.description,
						"onUpdate:modelValue": o[3] ||= (e) => F.description = e,
						label: E(Z)("description"),
						rules: E(p)(E(Z)("description_required")),
						hint: E(Z)("bulletin_description_hint"),
						icon: "mdi:mdi-text",
						required: "",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3"
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(h, {
						modelValue: F.status,
						"onUpdate:modelValue": o[4] ||= (e) => F.status = e,
						icon: "mdi:mdi-alert-circle",
						label: E(Z)("status"),
						items: R,
						rules: E(p)(E(Z)("status_required")),
						hint: E(Z)("bulletin_status_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(g, {
						modelValue: F.sticky,
						"onUpdate:modelValue": o[5] ||= (e) => F.sticky = e,
						icon: F.sticky ? "mdi:mdi-pin" : "mdi:mdi-pin-off",
						label: E(Z)("sticky"),
						hint: E(Z)("bulletin_sticky_hint")
					}, null, 8, [
						"modelValue",
						"icon",
						"label",
						"hint"
					]),
					c(v, {
						modelValue: F.workspace,
						"onUpdate:modelValue": o[6] ||= (e) => F.workspace = e,
						icon: "mdi:mdi-folder",
						label: E(Z)("workspaces"),
						items: E(W),
						loading: E(te),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading"
					]),
					c(v, {
						modelValue: F.role,
						"onUpdate:modelValue": o[7] ||= (e) => F.role = e,
						icon: "mdi:mdi-account-key",
						label: E(Z)("roles"),
						items: E(U),
						loading: E(ee),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading"
					]),
					c(y, {
						modelValue: F.tag,
						"onUpdate:modelValue": o[8] ||= (e) => F.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "]
					}, null, 8, ["modelValue", "label"]),
					c(v, {
						modelValue: F.domain,
						"onUpdate:modelValue": o[9] ||= (e) => F.domain = e,
						icon: "mdi:mdi-domain",
						label: E(Z)("domains"),
						items: E(V),
						loading: E(H),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading"
					]),
					c(l, {
						modelValue: F.order,
						"onUpdate:modelValue": o[10] ||= (e) => F.order = e,
						type: "number",
						icon: "mdi:mdi-order-numeric-ascending",
						label: E(Z)("order"),
						rules: E(B)
					}, null, 8, [
						"modelValue",
						"label",
						"rules"
					]),
					c(x, {
						modelValue: F.startdate,
						"onUpdate:modelValue": o[11] ||= (e) => F.startdate = e,
						icon: "mdi:mdi-calendar-start",
						label: E(Z)("startdate"),
						hint: E(Z)("bulletin_startdate_hint"),
						clearable: ""
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(x, {
						modelValue: F.enddate,
						"onUpdate:modelValue": o[12] ||= (e) => F.enddate = e,
						icon: "mdi:mdi-calendar-end",
						label: E(Z)("enddate"),
						hint: E(Z)("bulletin_enddate_hint"),
						min: F.startdate || void 0,
						rules: se,
						clearable: ""
					}, null, 8, [
						"modelValue",
						"label",
						"hint",
						"min"
					]),
					c(w, {
						icon: "mdi:mdi-link",
						label: E(Z)("actions"),
						hint: E(Z)("bulletin_actions_hint")
					}, {
						default: O(() => [c($, null, {
							default: O(() => [(_(!0), i(e, null, b(F.action, (e, t) => (_(), n(Q, {
								key: t,
								cols: "12",
								class: "mb-2 ga-4 pa-6"
							}, {
								default: O(() => [c($, { class: "align-center" }, {
									default: O(() => [
										c(Q, {
											cols: "auto",
											class: "d-flex align-center"
										}, {
											default: O(() => [c(ze, {
												icon: "mdi:mdi-link-variant",
												class: "mr-2"
											}), a("span", nn, T(E(Z)("action")) + " #" + T(t + 1), 1)]),
											_: 2
										}, 1024),
										c(be),
										c(Q, { cols: "auto" }, {
											default: O(() => [c(C, {
												icon: "mdi:mdi-delete",
												variant: "text",
												color: "error",
												onClick: (e) => fe(t)
											}, null, 8, ["onClick"])]),
											_: 2
										}, 1024)
									]),
									_: 2
								}, 1024), c($, { class: "d-flex flex-column" }, {
									default: O(() => [c(Q, { class: "d-flex flex-column pt-0" }, {
										default: O(() => [
											c(l, {
												modelValue: e.id,
												"onUpdate:modelValue": (t) => e.id = t,
												label: E(Z)("id"),
												rules: E(f)(E(Z)("action_id_format"))
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"rules"
											]),
											c(l, {
												modelValue: e.name,
												"onUpdate:modelValue": (t) => e.name = t,
												label: E(Z)("name"),
												rules: E(p)(E(Z)("action_name_required")),
												required: ""
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"rules"
											]),
											c(l, {
												modelValue: e.description,
												"onUpdate:modelValue": (t) => e.description = t,
												label: E(Z)("description")
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label"
											]),
											c(y, {
												modelValue: e.url,
												"onUpdate:modelValue": (t) => e.url = t,
												label: E(Z)("url"),
												rules: E(p)(E(Z)("action_url_required")),
												multiple: "",
												chips: "",
												"closable-chips": "",
												required: ""
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"rules"
											]),
											c(l, {
												modelValue: e.order,
												"onUpdate:modelValue": (t) => e.order = t,
												label: E(Z)("order"),
												type: "number"
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label"
											]),
											c(h, {
												modelValue: e.target,
												"onUpdate:modelValue": (t) => e.target = t,
												label: E(Z)("target"),
												items: z,
												hint: E(Z)("target_hint"),
												"persistent-hint": ""
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"hint"
											])
										]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024))), 128)), c(Q, { cols: "12" }, {
								default: O(() => [c(C, {
									type: "primary",
									variant: "outlined",
									"prepend-icon": "mdi:mdi-plus",
									class: "mt-4",
									onClick: de
								}, {
									default: O(() => [s(T(E(Z)("add_action")), 1)]),
									_: 1
								})]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}, 8, ["label", "hint"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, an = {
	__name: "admin-bulletins",
	props: {},
	setup(n) {
		X(n, "HAdminBulletins");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { confirm: s } = ce(), { hAddAlert: l } = q(), u = y(!0), d = y(null), f = {
			term: "",
			name: "",
			nameMatchType: "contains",
			description: "",
			descriptionMatchType: "contains",
			status: [],
			sticky: null,
			workspace: [],
			role: [],
			tag: [],
			startdatePreset: null,
			enddatePreset: null,
			modifieddatePreset: null,
			createdatePreset: null,
			sortBy: "createdate",
			sortOrder: "desc",
			page: 1,
			pageSize: 25
		}, p = v({ ...f }), m = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "status",
				type: "array",
				component: "h-filter-multiselect",
				props: {
					title: Z("status_filter"),
					icon: "mdi:mdi-alert-circle",
					showAsChips: !0,
					options: [
						{
							label: "Warning",
							value: "warning",
							icon: "mdi:mdi-alert",
							color: "warning"
						},
						{
							label: "Critical",
							value: "critical",
							icon: "mdi:mdi-alert-circle",
							color: "error"
						},
						{
							label: "Informational",
							value: "informational",
							icon: "mdi:mdi-information",
							color: "blue"
						}
					]
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "workspace",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("workspace_filter"),
					icon: "mdi:mdi-briefcase"
				}
			},
			{
				key: "role",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("role_filter"),
					icon: "mdi:mdi-account-key"
				}
			},
			{
				key: "sticky",
				type: "boolean"
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [
					{
						key: "startdate",
						type: "date",
						component: "h-filter-datetime",
						model: "startdatePreset",
						props: {
							label: Z("startdate"),
							manualSync: !0
						}
					},
					{
						key: "enddate",
						type: "date",
						component: "h-filter-datetime",
						model: "enddatePreset",
						props: {
							label: Z("enddate"),
							minDatePresetFilter: p.startdatePreset,
							manualSync: !0
						}
					},
					{
						key: "createdate",
						type: "date",
						component: "h-filter-datetime",
						model: "createdatePreset",
						props: {
							label: Z("createdate_filter"),
							manualSync: !0
						}
					},
					{
						key: "modifieddate",
						type: "date",
						component: "h-filter-datetime",
						model: "modifieddatePreset",
						props: {
							label: Z("modifieddate_filter"),
							minDatePresetFilter: p.createdatePreset,
							manualSync: !0
						}
					}
				]
			}
		] }, g = [
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 200,
				value: "name",
				nowrap: !0,
				customSortKey: "name.lower",
				translate: !0
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "status",
				key: "status",
				sortable: !0,
				width: 150,
				value: "status",
				nowrap: !0,
				customSortKey: "status.lower",
				translate: !0,
				component: "h-chip-table-cell",
				componentProps: {
					getColor: (e) => {
						let t = {
							warning: "orange",
							critical: "error",
							informational: "blue"
						};
						return t[e] || t.informational;
					},
					getIcon: (e) => ({
						warning: "mdi:mdi-alert",
						critical: "mdi:mdi-alert-octagon",
						informational: "mdi:mdi-information"
					})[e] || "mdi:mdi-information"
				},
				filterOnClick: (e) => F("status", e),
				isFilterActive: (e) => N("status", e)
			},
			{
				title: "sticky",
				key: "sticky",
				sortable: !0,
				width: 40,
				value: "sticky",
				nowrap: !0,
				translate: !0,
				component: "h-btn-table-cell",
				defaultValue: !1,
				componentProps: {
					getIcon: (e) => e.sticky ? "mdi:mdi-pin" : "mdi:mdi-pin-off",
					getColor: (e) => e.sticky ? "primary" : "grey"
				},
				filterOnClick: (e) => P("sticky", e.sticky),
				isFilterActive: (e) => N("sticky", e.sticky)
			},
			{
				title: "workspace",
				key: "workspace",
				sortable: !0,
				width: 150,
				value: "workspace",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => F("workspace", e),
				isFilterActive: (e) => N("workspace", e)
			},
			{
				title: "role",
				key: "role",
				sortable: !0,
				width: 150,
				value: "role",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => F("role", e),
				isFilterActive: (e) => N("role", e)
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => F("tag", e),
				isFilterActive: (e) => N("tag", e)
			},
			{
				title: "startdate",
				key: "startdate",
				sortable: !0,
				width: 140,
				value: "startdate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			},
			{
				title: "enddate",
				key: "enddate",
				sortable: !0,
				width: 140,
				value: "enddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			},
			{
				title: "createdate",
				key: "createdate",
				sortable: !0,
				width: 140,
				value: "createdate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 140,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], b = {
			pageKey: "bulletins",
			pageTitle: Z("bulletins_page_title"),
			headerTitle: Z("bulletins"),
			searchPlaceholder: Z("search_bulletins"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("bulletins"),
					text: Z("bulletins")
				}
			]
		}, { data: x, loading: C, params: w, execute: T, totalResults: D } = G({
			url: "/admin/bulletins",
			filters: p,
			additionalParams: { includebpmn: !1 }
		}), O = Z("total_bulletins"), k = t(() => ({ widgets: [{
			summary: !0,
			title: O,
			count: D.value,
			icon: "mdi:mdi-bullhorn",
			color: "grey-lighten-3",
			iconColor: "grey-darken-4"
		}] }));
		function A() {
			j(!0);
		}
		function j(e = !1) {
			let { query: t, sort: n } = a(m.filters, p);
			w.query = t, w.sort = n, (e || u.value) && T();
		}
		let M = qe(j, 300), { isFilterActive: N, toggleFilter: P, toggleArrayFilter: F } = ue({
			filters: p,
			onFilterChange: M
		}), I = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					d.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					d.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await s({
						title: Z("delete_bulletin"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = o({
							url: `/admin/bulletins/${e.key}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							l({
								title: Z("error_occurred"),
								body: Z("bulletin_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await T();
					}
				}
			}
		];
		function L() {
			return Object.assign(p, { ...f }), j(!0);
		}
		function R() {
			d.value?.open();
		}
		return h(async () => {
			J(p, M), j(), T();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": u.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => u.value = e,
				"page-configuration": b,
				"widgets-config": k.value,
				"filters-config": m,
				filters: p,
				"table-headers": g,
				"table-actions": I,
				"table-params": E(w),
				"table-data": E(x),
				"table-loading": E(C),
				"total-results": E(D),
				"open-form": R,
				onSearch: A,
				onClearFilters: L
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(rn, {
				ref_key: "bulletinFormRef",
				ref: d,
				onSuccess: E(T)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, on = {
	__name: "domain-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 700
		}
	},
	emits: ["success", "cancel"],
	setup(a, { expose: o, emit: s }) {
		let { hAddAlert: l } = q(), { requiredRules: u, urlRules: d, noSpacesRules: f, objectValueRules: p } = ie(), { save: m } = ae(), h = (e = !1) => e ? [] : [...u(Z("key_required")), ...f(Z("domain_key_no_spaces"))], g = [...u(Z("name_required")), ...f(Z("domain_name_no_spaces"))];
		X(a, "HDomainForm");
		let b = t(() => [
			{
				title: Z("auth_method_internal"),
				value: "internal"
			},
			{
				title: Z("auth_method_saml2"),
				value: "saml2"
			},
			{
				title: Z("auth_method_oauth2"),
				value: "oauth2"
			}
		]), x = {
			key: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			alias: {
				type: Array,
				default: () => []
			},
			description: {
				type: String,
				default: ""
			},
			authMethod: {
				type: String,
				default: ""
			},
			debug: {
				type: Boolean,
				default: !1
			},
			signoutURL: {
				type: String,
				default: ""
			},
			appDomain: {
				type: String,
				default: ""
			},
			authConfig: {
				type: String,
				default: ""
			},
			fieldMapping: {
				type: Object,
				default: () => ({
					username: "",
					name: "",
					email: "",
					key: "",
					custom: "",
					settings: ""
				})
			},
			roleMapping: {
				type: Object,
				default: () => ({
					field: "",
					replaceroles: !0,
					mapping: "",
					defaultRole: []
				})
			},
			tag: {
				type: Array,
				default: () => []
			},
			authScript: {
				type: String,
				default: ""
			}
		}, C = () => {
			let e = {};
			return Object.keys(x).forEach((t) => {
				let n = x[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, w = s, T = y(null), k = y(!1), A = y(!1), j = y(!1), M = y(null), N = v(C()), P = y(!1), F = y({}), I = t(() => N.authMethod === "saml2" || N.authMethod === "oauth2"), L = t(() => I.value ? u() : []), R = [...p, (e) => {
			if (!e || String(e).trim() === "") return !0;
			try {
				let t = JSON.parse(e);
				return !Array.isArray(t) || t.some((e) => !e || typeof e != "object" || Array.isArray(e)) ? Z("role_mapping_array_required") : !0;
			} catch {
				return Z("json_invalid");
			}
		}], { data: z, loading: B } = K({
			url: "/admin/roles",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		});
		D(k, (e) => {
			e || V();
		}), D(() => N.authMethod, (e, t) => {
			t && (t === "saml2" || t === "oauth2") && e === "internal" && H();
		}), D(N, () => {
			P.value = JSON.stringify(N) !== JSON.stringify(F.value);
		}, { deep: !0 });
		function V() {
			let e = C();
			Object.keys(e).forEach((t) => {
				N[t] = e[t];
			}), F.value = JSON.parse(JSON.stringify(N)), j.value = !1, M.value = null, P.value = !1;
		}
		function H() {
			N.debug = !1, N.signoutURL = "", N.appDomain = "", N.authConfig = "", N.authScript = "", N.fieldMapping = {
				username: "",
				name: "",
				email: "",
				key: "",
				custom: "",
				settings: ""
			}, N.roleMapping = {
				field: "",
				replaceroles: !0,
				mapping: "",
				defaultRole: []
			};
		}
		function U(e, t = !0) {
			Object.keys(x).forEach((t) => {
				let n = x[t], r = e?.[t], i = r != null;
				if (t === "fieldMapping") {
					let e = n.default();
					i && typeof r == "object" ? N[t] = {
						...e,
						username: r.username || "",
						name: r.name || "",
						email: r.email || "",
						key: r.key || "",
						custom: r.custom ? JSON.stringify(r.custom, null, 2) : "",
						settings: r.settings ? JSON.stringify(r.settings, null, 2) : ""
					} : N[t] = e;
				} else if (t === "roleMapping") {
					let e = n.default();
					i && typeof r == "object" ? N[t] = {
						...e,
						field: r.field || "",
						replaceroles: r.replaceroles === void 0 ? !0 : r.replaceroles,
						mapping: r.mapping ? JSON.stringify(r.mapping, null, 2) : "",
						defaultRole: r.defaultRole || []
					} : N[t] = e;
				} else t === "authConfig" ? N[t] = i && typeof r == "object" ? JSON.stringify(r, null, 2) : "" : n.type === Array ? N[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : n.type === Boolean ? N[t] = i ? !!r : typeof n.default == "function" ? n.default() : n.default : N[t] = i ? r : typeof n.default == "function" ? n.default() : n.default;
			}), t || (N.key = ""), F.value = JSON.parse(JSON.stringify(N)), j.value = t, M.value = t && (e?.key || e?.name) || null, P.value = !t;
		}
		async function ee() {
			if (!A.value && ((await T.value?.validate())?.valid ?? !0)) {
				A.value = !0;
				try {
					await ne(te()), w("success"), k.value = !1;
				} catch (e) {
					l({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					A.value = !1;
				}
			}
		}
		function W(e) {
			if (!e || e.trim() === "") return null;
			try {
				return JSON.parse(e);
			} catch {
				return null;
			}
		}
		function te() {
			let e = {
				name: N.name?.trim().toLowerCase() || null,
				alias: N.alias?.length > 0 ? N.alias : null,
				description: N.description?.trim() || null,
				authMethod: N.authMethod || null,
				tag: N.tag?.length > 0 ? N.tag : null
			};
			if (j.value || (e.key = N.key?.trim().toLowerCase() || null), I.value) {
				e.debug = N.debug, e.signoutURL = N.signoutURL?.trim() || null, e.appDomain = N.appDomain?.trim() || null, e.authConfig = W(N.authConfig), e.authScript = N.authScript?.trim() || null;
				let t = {
					username: N.fieldMapping.username?.trim() || null,
					name: N.fieldMapping.name?.trim() || null,
					email: N.fieldMapping.email?.trim() || "",
					key: N.fieldMapping.key?.trim() || null
				}, n = W(N.fieldMapping.custom);
				n && (t.custom = n);
				let r = W(N.fieldMapping.settings);
				r && (t.settings = r), e.fieldMapping = t;
				let i = {
					field: N.roleMapping.field?.trim() || null,
					replaceroles: N.roleMapping.replaceroles
				}, a = W(N.roleMapping.mapping);
				Array.isArray(a) && (i.mapping = a), N.roleMapping.defaultRole?.length > 0 && (i.defaultRole = N.roleMapping.defaultRole), (i.field || Array.isArray(a) || i.defaultRole) && (e.roleMapping = i);
			}
			return Object.fromEntries(Object.entries(e).filter(([e, t]) => t !== null));
		}
		async function ne(e) {
			let t = j.value ? "update" : "create", n = {
				create: "/admin/domains",
				update: `/admin/domains/${M.value}`
			}, r = {
				create: "post",
				update: "put"
			}, i = {
				error: {
					create: "domain_create_error",
					update: "domain_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			};
			if (!(await m({
				url: n[t],
				method: r[t],
				payload: e
			}))?.ok) throw Error(Z(i.error[t]));
			l({
				title: Z(i.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function re() {
			w("cancel"), k.value = !1;
		}
		function G(e = null) {
			e && U(e), k.value = !0;
		}
		function J(e) {
			U(e, !1), k.value = !0;
		}
		return o({
			validate: () => T.value?.validate(),
			reset: () => T.value?.reset(),
			resetValidation: () => T.value?.resetValidation(),
			formData: N,
			open: G,
			openCopy: J
		}), (t, o) => {
			let s = S("h-form-text"), l = S("h-form-combobox"), f = S("h-form-textarea"), p = S("h-form-select"), m = S("h-form-switch"), v = S("h-form-field"), y = S("h-form-autocomplete"), x = S("h-form-layout");
			return _(), n(x, {
				ref_key: "formRef",
				ref: T,
				modelValue: k.value,
				"onUpdate:modelValue": o[21] ||= (e) => k.value = e,
				loading: A.value,
				"bg-color": a.bgColor,
				"header-text": j.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": a.drawerWidth,
				"has-changes": P.value,
				onSubmit: ee,
				onCancel: re
			}, {
				default: O(() => [
					c(s, {
						modelValue: N.key,
						"onUpdate:modelValue": o[0] ||= (e) => N.key = e,
						icon: "mdi:mdi-key",
						label: E(Z)("key"),
						required: !j.value,
						rules: h(j.value),
						disabled: j.value,
						hint: E(Z)("domain_key_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"required",
						"rules",
						"disabled",
						"hint"
					]),
					c(s, {
						modelValue: N.name,
						"onUpdate:modelValue": o[1] ||= (e) => N.name = e,
						icon: "mdi:mdi-domain",
						label: E(Z)("name"),
						rules: g,
						hint: E(Z)("domain_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(l, {
						modelValue: N.alias,
						"onUpdate:modelValue": o[2] ||= (e) => N.alias = e,
						icon: "mdi:mdi-link-variant",
						label: E(Z)("alias"),
						items: [],
						rules: E(d),
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "],
						hint: E(Z)("domain_alias_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(f, {
						modelValue: N.description,
						"onUpdate:modelValue": o[3] ||= (e) => N.description = e,
						label: E(Z)("description"),
						icon: "mdi:mdi-text",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3",
						hint: E(Z)("domain_description_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(l, {
						modelValue: N.tag,
						"onUpdate:modelValue": o[4] ||= (e) => N.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "],
						hint: E(Z)("domain_tag_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(p, {
						modelValue: N.authMethod,
						"onUpdate:modelValue": o[5] ||= (e) => N.authMethod = e,
						icon: "mdi:mdi-shield-key",
						label: E(Z)("auth_method"),
						items: b.value,
						rules: E(u)(E(Z)("auth_method_required")),
						hint: E(Z)("domain_auth_method_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"rules",
						"hint"
					]),
					I.value ? (_(), i(e, { key: 0 }, [
						c(v, {
							icon: "mdi:mdi-security",
							label: E(Z)("sso_settings"),
							indent: ""
						}, {
							default: O(() => [c($, null, {
								default: O(() => [
									c(Q, { cols: "12" }, {
										default: O(() => [c(m, {
											modelValue: N.debug,
											"onUpdate:modelValue": o[6] ||= (e) => N.debug = e,
											icon: N.debug ? "mdi:mdi-bug-check" : "mdi:mdi-bug-outline",
											label: E(Z)("debug"),
											hint: E(Z)("domain_debug_hint")
										}, null, 8, [
											"modelValue",
											"icon",
											"label",
											"hint"
										])]),
										_: 1
									}),
									c(Q, { cols: "12" }, {
										default: O(() => [c(s, {
											modelValue: N.signoutURL,
											"onUpdate:modelValue": o[7] ||= (e) => N.signoutURL = e,
											icon: "mdi:mdi-logout",
											label: E(Z)("signout_url"),
											rules: E(d),
											hint: E(Z)("domain_signout_url_hint")
										}, null, 8, [
											"modelValue",
											"label",
											"rules",
											"hint"
										])]),
										_: 1
									}),
									c(Q, { cols: "12" }, {
										default: O(() => [c(s, {
											modelValue: N.appDomain,
											"onUpdate:modelValue": o[8] ||= (e) => N.appDomain = e,
											icon: "mdi:mdi-web",
											label: E(Z)("app_domain"),
											rules: E(d),
											hint: E(Z)("domain_app_domain_hint")
										}, null, 8, [
											"modelValue",
											"label",
											"rules",
											"hint"
										])]),
										_: 1
									}),
									c(Q, { cols: "12" }, {
										default: O(() => [c(E(Ee), {
											modelValue: N.authConfig,
											"onUpdate:modelValue": o[9] ||= (e) => N.authConfig = e,
											language: "json",
											icon: "mdi:mdi-code-json",
											label: E(Z)("auth_config"),
											hint: E(Z)("domain_auth_config_hint")
										}, null, 8, [
											"modelValue",
											"label",
											"hint"
										])]),
										_: 1
									})
								]),
								_: 1
							})]),
							_: 1
						}, 8, ["label"]),
						c(v, {
							icon: "mdi:mdi-map",
							label: E(Z)("field_mapping"),
							indent: ""
						}, {
							default: O(() => [c($, null, {
								default: O(() => [
									c(Q, {
										cols: "12",
										md: "6"
									}, {
										default: O(() => [c(s, {
											modelValue: N.fieldMapping.username,
											"onUpdate:modelValue": o[10] ||= (e) => N.fieldMapping.username = e,
											icon: "mdi:mdi-account",
											label: E(Z)("username"),
											rules: L.value,
											required: "",
											hint: E(Z)("domain_field_mapping_username_hint")
										}, null, 8, [
											"modelValue",
											"label",
											"rules",
											"hint"
										])]),
										_: 1
									}),
									c(Q, {
										cols: "12",
										md: "6"
									}, {
										default: O(() => [c(s, {
											modelValue: N.fieldMapping.name,
											"onUpdate:modelValue": o[11] ||= (e) => N.fieldMapping.name = e,
											icon: "mdi:mdi-card-account-details",
											label: E(Z)("name"),
											rules: L.value,
											required: "",
											hint: E(Z)("domain_field_mapping_name_hint")
										}, null, 8, [
											"modelValue",
											"label",
											"rules",
											"hint"
										])]),
										_: 1
									}),
									c(Q, {
										cols: "12",
										md: "6"
									}, {
										default: O(() => [c(s, {
											modelValue: N.fieldMapping.email,
											"onUpdate:modelValue": o[12] ||= (e) => N.fieldMapping.email = e,
											icon: "mdi:mdi-email",
											label: E(Z)("email"),
											hint: E(Z)("domain_field_mapping_email_hint")
										}, null, 8, [
											"modelValue",
											"label",
											"hint"
										])]),
										_: 1
									}),
									c(Q, {
										cols: "12",
										md: "6"
									}, {
										default: O(() => [c(s, {
											modelValue: N.fieldMapping.key,
											"onUpdate:modelValue": o[13] ||= (e) => N.fieldMapping.key = e,
											icon: "mdi:mdi-key",
											label: E(Z)("key"),
											rules: L.value,
											required: "",
											hint: E(Z)("domain_field_mapping_key_hint")
										}, null, 8, [
											"modelValue",
											"label",
											"rules",
											"hint"
										])]),
										_: 1
									}),
									c(Q, { cols: "12" }, {
										default: O(() => [c(E(Ee), {
											modelValue: N.fieldMapping.custom,
											"onUpdate:modelValue": o[14] ||= (e) => N.fieldMapping.custom = e,
											language: "json",
											icon: "mdi:mdi-code-json",
											label: E(Z)("custom"),
											hint: E(Z)("domain_field_mapping_custom_hint")
										}, null, 8, [
											"modelValue",
											"label",
											"hint"
										])]),
										_: 1
									}),
									c(Q, { cols: "12" }, {
										default: O(() => [c(E(Ee), {
											modelValue: N.fieldMapping.settings,
											"onUpdate:modelValue": o[15] ||= (e) => N.fieldMapping.settings = e,
											language: "json",
											icon: "mdi:mdi-cog",
											label: E(Z)("settings"),
											hint: E(Z)("domain_field_mapping_settings_hint")
										}, null, 8, [
											"modelValue",
											"label",
											"hint"
										])]),
										_: 1
									})
								]),
								_: 1
							})]),
							_: 1
						}, 8, ["label"]),
						c(v, {
							icon: "mdi:mdi-account-key",
							label: E(Z)("role_mapping"),
							indent: ""
						}, {
							default: O(() => [c($, null, {
								default: O(() => [
									c(Q, {
										cols: "12",
										md: "6"
									}, {
										default: O(() => [c(s, {
											modelValue: N.roleMapping.field,
											"onUpdate:modelValue": o[16] ||= (e) => N.roleMapping.field = e,
											icon: "mdi:mdi-form-textbox",
											label: E(Z)("field"),
											hint: E(Z)("domain_role_mapping_field_hint")
										}, null, 8, [
											"modelValue",
											"label",
											"hint"
										])]),
										_: 1
									}),
									c(Q, {
										cols: "12",
										md: "6"
									}, {
										default: O(() => [c(m, {
											modelValue: N.roleMapping.replaceroles,
											"onUpdate:modelValue": o[17] ||= (e) => N.roleMapping.replaceroles = e,
											icon: N.roleMapping.replaceroles ? "mdi:mdi-swap-horizontal" : "mdi:mdi-plus-box",
											label: E(Z)("replace_roles"),
											hint: E(Z)("domain_role_mapping_replaceroles_hint")
										}, null, 8, [
											"modelValue",
											"icon",
											"label",
											"hint"
										])]),
										_: 1
									}),
									c(Q, { cols: "12" }, {
										default: O(() => [c(E(Ee), {
											modelValue: N.roleMapping.mapping,
											"onUpdate:modelValue": o[18] ||= (e) => N.roleMapping.mapping = e,
											language: "json",
											icon: "mdi:mdi-code-json",
											label: E(Z)("mapping"),
											hint: E(Z)("domain_role_mapping_mapping_hint"),
											rules: R
										}, null, 8, [
											"modelValue",
											"label",
											"hint"
										])]),
										_: 1
									}),
									c(Q, { cols: "12" }, {
										default: O(() => [c(y, {
											modelValue: N.roleMapping.defaultRole,
											"onUpdate:modelValue": o[19] ||= (e) => N.roleMapping.defaultRole = e,
											icon: "mdi:mdi-account-key",
											label: E(Z)("default_role"),
											items: E(z),
											loading: E(B),
											multiple: "",
											chips: "",
											"closable-chips": "",
											hint: E(Z)("domain_role_mapping_default_role_hint")
										}, null, 8, [
											"modelValue",
											"label",
											"items",
											"loading",
											"hint"
										])]),
										_: 1
									})
								]),
								_: 1
							})]),
							_: 1
						}, 8, ["label"]),
						c(E(Ee), {
							modelValue: N.authScript,
							"onUpdate:modelValue": o[20] ||= (e) => N.authScript = e,
							language: "javascript",
							icon: "mdi:mdi-script-text",
							label: E(Z)("auth_script"),
							hint: E(Z)("domain_auth_script_hint")
						}, null, 8, [
							"modelValue",
							"label",
							"hint"
						])
					], 64)) : r("", !0)
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, sn = {
	__name: "admin-domains",
	props: {},
	setup(n) {
		X(n, "HAdminDomains");
		let { buildQueryParams: r } = de(), { hHttpRequest: a } = Y(), { confirm: o } = ce(), { hAddAlert: s } = q(), l = y(!0), u = y(null), d = {
			term: "",
			key: "",
			keyMatchType: "contains",
			name: "",
			nameMatchType: "contains",
			alias: [],
			tag: [],
			sortBy: "name",
			sortOrder: "asc",
			page: 1,
			pageSize: 25
		}, f = v({ ...d }), p = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "key",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("key_filter"),
					placeholder: Z("key_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-key",
					defaultMatchType: "contains"
				}
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			}
		] }, m = [
			{
				title: "key",
				key: "key",
				sortable: !0,
				width: 150,
				value: "key",
				nowrap: !0,
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 200,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 250,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "alias",
				key: "alias",
				sortable: !0,
				width: 150,
				value: "alias",
				nowrap: !1,
				translate: !0,
				component: "h-chip-group-table-cell",
				componentProps: { column: !0 }
			},
			{
				title: "auth_method",
				key: "authMethod",
				sortable: !0,
				width: 150,
				value: "authMethod",
				nowrap: !0,
				customSortKey: "authMethod.lower",
				translate: !0
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !1,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => N("tag", e),
				isFilterActive: (e) => M("tag", e)
			}
		], g = {
			pageKey: "domains",
			pageTitle: Z("admin_domains_title"),
			headerTitle: Z("domains"),
			searchPlaceholder: Z("search_domains"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("domains"),
					text: Z("domains")
				}
			]
		}, { data: b, loading: x, params: C, execute: w, totalResults: T } = G({
			url: "/admin/domains",
			filters: f
		}), D = Z("total_domains"), O = t(() => ({ widgets: [{
			summary: !0,
			title: D,
			count: T.value,
			icon: "mdi:mdi-domain",
			color: "grey-lighten-3",
			iconColor: "grey-darken-4"
		}] }));
		function k() {
			A(!0);
		}
		function A(e = !1) {
			let { query: t, sort: n } = r(p.filters, f);
			C.query = t, C.sort = n, (e || l.value) && w();
		}
		let j = qe(A, 300), { isFilterActive: M, toggleArrayFilter: N } = ue({
			filters: f,
			onFilterChange: j
		}), P = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					u.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					u.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await o({
						title: Z("delete_domain"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = a({
							url: `/admin/domains/${e.key}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							s({
								title: Z("error_occurred"),
								body: Z("domain_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await w();
					}
				}
			}
		];
		function F() {
			return Object.assign(f, { ...d }), A(!0);
		}
		function I() {
			u.value?.open();
		}
		return h(async () => {
			J(f, j), A(), w();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": l.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => l.value = e,
				"page-configuration": g,
				"widgets-config": O.value,
				"filters-config": p,
				filters: f,
				"table-headers": m,
				"table-actions": P,
				"table-params": E(C),
				"table-data": E(b),
				"table-loading": E(x),
				"total-results": E(T),
				"open-form": I,
				onSearch: k,
				onClearFilters: F
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(on, {
				ref_key: "domainFormRef",
				ref: u,
				onSuccess: E(w)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, cn = {
	__name: "dashboard-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 700
		}
	},
	emits: ["success", "cancel"],
	setup(e, { expose: t, emit: r }) {
		let { hAddAlert: i } = q(), { nameRules: a, slugRules: o, integerRules: s } = ie(), { save: l } = ae(), u = [(e) => !!e || Z("title_required")], d = [(e) => !!e || Z("template_required")], f = s();
		X(e, "HDashboardForm");
		let p = {
			slug: {
				type: String,
				default: ""
			},
			title: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			template: {
				type: String,
				default: ""
			},
			role: {
				type: Array,
				default: () => []
			},
			domain: {
				type: Array,
				default: () => []
			},
			tag: {
				type: Array,
				default: () => []
			},
			requireitem: {
				type: Boolean,
				default: !1
			},
			refreshinterval: {
				type: Number,
				default: 0
			}
		}, m = () => {
			let e = {};
			return Object.keys(p).forEach((t) => {
				let n = p[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, h = r, g = y(null), b = y(!1), x = y(!1), C = y(!1), w = y(null), T = v(m()), k = y(!1), A = y({}), { data: j, loading: M } = K({
			url: "/admin/roles",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), { data: N, loading: P } = K({
			url: "/admin/domains",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), { data: F, loading: I } = K({
			url: "/my/resources/dashboards",
			params: { tree: !1 },
			formatter: (e) => e.map((e) => ({
				title: e.name || e,
				value: e.path || e.name || e,
				key: e.path || e.name || e
			}))
		});
		D(b, (e) => {
			e || L();
		}), D(T, () => {
			k.value = JSON.stringify(T) !== JSON.stringify(A.value);
		}, { deep: !0 });
		function L() {
			let e = m();
			Object.keys(e).forEach((t) => {
				T[t] = e[t];
			}), A.value = JSON.parse(JSON.stringify(T)), C.value = !1, w.value = null, k.value = !1;
		}
		function R(e, t = !0) {
			Object.keys(p).forEach((t) => {
				let n = p[t], r = e?.[t], i = r != null;
				n.type === Array ? T[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : n.type === Boolean ? T[t] = i ? !!r : typeof n.default == "function" ? n.default() : n.default : n.type === Number ? T[t] = i ? Number(r) : typeof n.default == "function" ? n.default() : n.default : (n.type, T[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), t || (T.slug = ""), A.value = JSON.parse(JSON.stringify(T)), C.value = t, w.value = t && e?.slug || null, k.value = !t;
		}
		async function z() {
			if (!x.value && ((await g.value?.validate())?.valid ?? !0)) {
				x.value = !0;
				try {
					await H(V()), h("success"), b.value = !1;
				} catch (e) {
					i({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					x.value = !1;
				}
			}
		}
		function B(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) r === null || r === "" || Array.isArray(r) && r.length === 0 || (t[n] = r);
			return t;
		}
		function V() {
			let e = (e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [], t = e(T.role), n = e(T.domain), r = e(T.tag);
			return B({
				slug: T.slug?.trim()?.toLowerCase() || null,
				title: T.title?.trim() || null,
				name: T.name?.trim() || null,
				description: T.description?.trim() || null,
				template: typeof T.template == "object" ? T.template?.value || T.template?.key : T.template?.trim() || null,
				role: t,
				domain: n,
				tag: r,
				requireitem: T.requireitem || !1,
				refreshinterval: T.refreshinterval ? Number(T.refreshinterval) : 0
			});
		}
		async function H(e) {
			let t = C.value ? "update" : "create", n = {
				create: "/admin/dashboards",
				update: `/admin/dashboards/${w.value}`
			}, r = {
				create: "post",
				update: "put"
			}, a = {
				error: {
					create: "dashboard_create_error",
					update: "dashboard_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			}, o = t === "update" ? (({ slug: e, ...t }) => t)(e) : e;
			if (!(await l({
				url: n[t],
				method: r[t],
				payload: o
			}))?.ok) throw Error(Z(a.error[t]));
			i({
				title: Z(a.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function U() {
			h("cancel"), b.value = !1;
		}
		function ee(e = null) {
			e && R(e), b.value = !0;
		}
		function W(e) {
			R(e, !1), b.value = !0;
		}
		return t({
			validate: () => g.value?.validate(),
			reset: () => g.value?.reset(),
			resetValidation: () => g.value?.resetValidation(),
			formData: T,
			open: ee,
			openCopy: W
		}), (t, r) => {
			let i = S("h-form-text"), s = S("h-form-textarea"), l = S("h-form-autocomplete"), p = S("h-form-combobox"), m = S("h-form-switch"), h = S("h-form-layout");
			return _(), n(h, {
				ref_key: "formRef",
				ref: g,
				modelValue: b.value,
				"onUpdate:modelValue": r[10] ||= (e) => b.value = e,
				loading: x.value || E(M) || E(P) || E(I),
				"bg-color": e.bgColor,
				"header-text": C.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": e.drawerWidth,
				"has-changes": k.value,
				onSubmit: z,
				onCancel: U
			}, {
				default: O(() => [
					c(i, {
						modelValue: T.slug,
						"onUpdate:modelValue": r[0] ||= (e) => T.slug = e,
						icon: "mdi:mdi-link",
						label: E(Z)("slug"),
						required: !C.value,
						rules: C.value ? [] : E(o)(),
						disabled: C.value,
						hint: E(Z)("dashboard_slug_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"required",
						"rules",
						"disabled",
						"hint"
					]),
					c(i, {
						modelValue: T.title,
						"onUpdate:modelValue": r[1] ||= (e) => T.title = e,
						icon: "mdi:mdi-format-title",
						label: E(Z)("title"),
						rules: u,
						hint: E(Z)("dashboard_title_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(i, {
						modelValue: T.name,
						"onUpdate:modelValue": r[2] ||= (e) => T.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: E(a),
						hint: E(Z)("dashboard_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(s, {
						modelValue: T.description,
						"onUpdate:modelValue": r[3] ||= (e) => T.description = e,
						label: E(Z)("description"),
						hint: E(Z)("dashboard_description_hint"),
						icon: "mdi:mdi-text",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3"
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(l, {
						modelValue: T.template,
						"onUpdate:modelValue": r[4] ||= (e) => T.template = e,
						icon: "mdi:mdi-view-dashboard",
						label: E(Z)("template"),
						items: E(F),
						loading: E(I),
						rules: d,
						hint: E(Z)("dashboard_template_hint"),
						required: "",
						clearable: ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint"
					]),
					c(l, {
						modelValue: T.role,
						"onUpdate:modelValue": r[5] ||= (e) => T.role = e,
						icon: "mdi:mdi-account-key",
						label: E(Z)("roles"),
						items: E(j),
						loading: E(M),
						hint: E(Z)("dashboard_role_hint"),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint"
					]),
					c(l, {
						modelValue: T.domain,
						"onUpdate:modelValue": r[6] ||= (e) => T.domain = e,
						icon: "mdi:mdi-domain",
						label: E(Z)("domains"),
						items: E(N),
						loading: E(P),
						hint: E(Z)("dashboard_domain_hint"),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint"
					]),
					c(p, {
						modelValue: T.tag,
						"onUpdate:modelValue": r[7] ||= (e) => T.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						hint: E(Z)("dashboard_tag_hint"),
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "]
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(m, {
						modelValue: T.requireitem,
						"onUpdate:modelValue": r[8] ||= (e) => T.requireitem = e,
						icon: T.requireitem ? "mdi:mdi-checkbox-marked" : "mdi:mdi-checkbox-blank-outline",
						label: E(Z)("dashboard_require_item"),
						hint: E(Z)("dashboard_requireitem_hint")
					}, null, 8, [
						"modelValue",
						"icon",
						"label",
						"hint"
					]),
					c(i, {
						modelValue: T.refreshinterval,
						"onUpdate:modelValue": r[9] ||= (e) => T.refreshinterval = e,
						type: "number",
						icon: "mdi:mdi-timer-refresh",
						label: E(Z)("refresh_interval"),
						hint: E(Z)("dashboard_refreshinterval_hint"),
						rules: E(f)
					}, null, 8, [
						"modelValue",
						"label",
						"hint",
						"rules"
					])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, ln = {
	__name: "admin-dashboards",
	props: {},
	setup(n) {
		X(n, "HAdminDashboards");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { confirm: s } = ce(), { hAddAlert: l } = q(), u = y(!0), d = y(null), f = {
			term: "",
			title: "",
			titleMatchType: "contains",
			name: "",
			nameMatchType: "contains",
			role: [],
			tag: [],
			domain: [],
			modifieddatePreset: null,
			sortBy: "modifieddate",
			sortOrder: "desc",
			page: 1,
			pageSize: 25
		}, p = v({ ...f }), m = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "title",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("title_filter"),
					placeholder: Z("title_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-format-title",
					defaultMatchType: "contains"
				}
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "role",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("role_filter"),
					icon: "mdi:mdi-account-key"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "domain",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("domain_filter"),
					icon: "mdi:mdi-web"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [{
					key: "modifieddate",
					type: "date",
					component: "h-filter-datetime",
					model: "modifieddatePreset",
					props: {
						label: Z("modifieddate_filter"),
						manualSync: !0
					}
				}]
			}
		] }, g = [
			{
				title: "slug",
				key: "slug",
				sortable: !0,
				width: 150,
				value: "slug",
				nowrap: !0,
				translate: !0
			},
			{
				title: "title",
				key: "title",
				align: "start",
				sortable: !0,
				width: 200,
				value: "title",
				nowrap: !1,
				customSortKey: "title.lower",
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 200,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "role",
				key: "role",
				sortable: !0,
				width: 150,
				value: "role",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => P("role", e),
				isFilterActive: (e) => N("role", e)
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => P("tag", e),
				isFilterActive: (e) => N("tag", e)
			},
			{
				title: "refreshinterval",
				key: "refreshinterval",
				sortable: !0,
				width: 120,
				value: "refreshinterval",
				nowrap: !0,
				translate: !0
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 150,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], b = {
			pageKey: "dashboards",
			pageTitle: Z("admin_dashboards_title"),
			headerTitle: Z("dashboards"),
			searchPlaceholder: Z("search_dashboards"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("dashboards"),
					text: Z("dashboards")
				}
			]
		}, { data: x, loading: C, params: w, execute: T, totalResults: D } = G({
			url: "/admin/dashboards",
			filters: p,
			additionalParams: {}
		}), O = Z("total_dashboards"), k = t(() => ({ widgets: [{
			summary: !0,
			title: O,
			count: D.value,
			icon: "mdi:mdi-view-dashboard",
			color: "blue-grey-lighten-3",
			iconColor: "blue-grey-darken-4"
		}] }));
		function A() {
			j(!0);
		}
		function j(e = !1) {
			let { query: t, sort: n } = a(m.filters, p);
			w.query = t, w.sort = n, (e || u.value) && T();
		}
		let M = qe(j, 300), { isFilterActive: N, toggleArrayFilter: P } = ue({
			filters: p,
			onFilterChange: M
		}), F = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					d.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					d.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await s({
						title: Z("delete_dashboard"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = o({
							url: `/admin/dashboards/${e.slug}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							l({
								title: Z("error_occurred"),
								body: Z("dashboard_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await T();
					}
				}
			}
		];
		function I() {
			return Object.assign(p, { ...f }), j(!0);
		}
		function L() {
			d.value?.open();
		}
		return h(async () => {
			J(p, M), j(), T();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": u.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => u.value = e,
				"page-configuration": b,
				"widgets-config": k.value,
				"filters-config": m,
				filters: p,
				"table-headers": g,
				"table-actions": F,
				"table-params": E(w),
				"table-data": E(x),
				"table-loading": E(C),
				"total-results": E(D),
				"open-form": L,
				onSearch: A,
				onClearFilters: I
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(cn, {
				ref_key: "dashboardFormRef",
				ref: d,
				onSuccess: E(T)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, un = { class: "text-headline-small" }, dn = {
	__name: "forms-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 700
		}
	},
	emits: ["success", "cancel"],
	setup(o, { expose: l, emit: u }) {
		let { hAddAlert: d } = q(), { slugRules: f, nameRules: p, idRules: m, requiredRules: h, objectValueRules: g, urlRules: x, emailRules: C } = ie(), { save: w } = ae();
		function k(e) {
			return typeof e == "object" && !!e && !Array.isArray(e);
		}
		function A(e) {
			return typeof e == "boolean" || typeof e == "string" ? !0 : Array.isArray(e) && e.every((e) => typeof e == "string");
		}
		let j = [...g, (e) => {
			if (!e || String(e).trim() === "") return !0;
			try {
				let t = JSON.parse(e);
				if (!k(t)) return Z("json_object_required");
				for (let e of Object.values(t)) if (!A(e)) return Z("webhook_json_value_invalid");
				return !0;
			} catch {
				return Z("json_invalid");
			}
		}], M = [...g, (e) => {
			if (!e || String(e).trim() === "") return !0;
			try {
				let t = JSON.parse(e);
				if (!k(t)) return Z("json_object_required");
				for (let e of Object.values(t)) if (typeof e != "string") return Z("meta_json_value_invalid");
				return !0;
			} catch {
				return Z("json_invalid");
			}
		}], N = [...h(Z("title_required"))], P = [(e) => {
			if (e == null || e === "") return !0;
			let t = parseInt(e, 10);
			return !isNaN(t) && t >= 0 || Z("timeout_invalid");
		}];
		X(o, "HFormsForm");
		let F = {
			slug: {
				type: String,
				default: ""
			},
			title: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			role: {
				type: Array,
				default: () => []
			},
			domain: {
				type: Array,
				default: () => []
			},
			tag: {
				type: Array,
				default: () => []
			},
			public: {
				type: Boolean,
				default: !1
			},
			test: {
				type: Boolean,
				default: !1
			},
			disableprepopulate: {
				type: Boolean,
				default: !1
			},
			noninteractive: {
				type: Boolean,
				default: !1
			},
			template: {
				type: Object,
				default: () => ({
					form: "",
					result: ""
				})
			},
			webhook: {
				type: Object,
				default: () => ({
					method: "",
					url: "",
					body: "",
					header: "",
					responseType: "json",
					contentType: "application/json"
				})
			},
			notification: {
				type: Object,
				default: () => ({
					to: "",
					from: "",
					cc: "",
					subject: "",
					body: "",
					attachments: ""
				})
			},
			agenttask: {
				type: Object,
				default: () => ({
					command: "",
					async: !1,
					tag: [],
					vars: [],
					meta: "",
					timeout: 0
				})
			},
			process: {
				type: Object,
				default: () => ({
					workflow: "",
					title: "",
					description: "",
					hide: !1,
					action: []
				})
			},
			meta: {
				type: String,
				default: ""
			}
		}, I = {
			id: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			url: {
				type: String,
				default: ""
			},
			status: {
				type: Array,
				default: () => []
			}
		}, L = [
			{
				title: "-",
				value: ""
			},
			{
				title: "POST",
				value: "POST"
			},
			{
				title: "PUT",
				value: "PUT"
			},
			{
				title: "PATCH",
				value: "PATCH"
			},
			{
				title: "GET",
				value: "GET"
			},
			{
				title: "DELETE",
				value: "DELETE"
			}
		], R = [
			{
				title: "JSON",
				value: "json"
			},
			{
				title: "XML",
				value: "xml"
			},
			{
				title: "Text",
				value: "text"
			}
		], z = [
			{
				title: "application/json",
				value: "application/json"
			},
			{
				title: "application/x-www-form-urlencoded",
				value: "application/x-www-form-urlencoded"
			},
			{
				title: "multipart/form-data",
				value: "multipart/form-data"
			}
		], B = [
			{
				title: Z("status_running"),
				value: "Running"
			},
			{
				title: Z("status_completed"),
				value: "Completed"
			},
			{
				title: Z("status_paused"),
				value: "Paused"
			},
			{
				title: Z("status_stopped"),
				value: "Stopped"
			}
		], V = () => {
			let e = {};
			return Object.keys(F).forEach((t) => {
				let n = F[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, H = () => {
			let e = {};
			return Object.keys(I).forEach((t) => {
				let n = I[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, U = u, ee = y(null), W = y(!1), te = y(!1), ne = y(!1), re = y(null), G = v(V()), J = y(!1), oe = y({}), { data: Y, loading: se } = K({
			url: "/admin/roles",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), { data: ce, loading: le } = K({
			url: "/admin/domains",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), { data: ue, loading: de } = K({
			url: "/admin/workflows",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), { data: fe, loading: pe } = K({
			url: "/admin/forms",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.slug,
				key: e.slug
			}))
		}), { data: me, loading: he } = K({
			url: "/admin/agents",
			formatter: (e) => e
		}), ge = t(() => {
			if (!me.value || !Array.isArray(me.value)) return [];
			let e = /* @__PURE__ */ new Set();
			return me.value.forEach((t) => {
				t.tag && Array.isArray(t.tag) && t.tag.forEach((t) => e.add(t));
			}), Array.from(e).map((e) => ({
				title: e,
				value: e
			}));
		});
		D(W, (e) => {
			e || _e();
		}), D(G, () => {
			J.value = JSON.stringify(G) !== JSON.stringify(oe.value);
		}, { deep: !0 });
		function _e() {
			let e = V();
			Object.keys(e).forEach((t) => {
				G[t] = e[t];
			}), oe.value = JSON.parse(JSON.stringify(G)), ne.value = !1, re.value = null, J.value = !1;
		}
		function ve(e, t = !0) {
			Object.keys(F).forEach((t) => {
				let n = F[t], r = e?.[t], i = r != null;
				if (t === "template") {
					let e = n.default();
					G[t] = i && typeof r == "object" ? {
						...e,
						...r
					} : e;
				} else if (t === "webhook") {
					let e = n.default();
					i && typeof r == "object" ? G[t] = {
						...e,
						...r,
						body: r.body ? typeof r.body == "string" ? r.body : JSON.stringify(r.body, null, 2) : "",
						header: r.header ? typeof r.header == "string" ? r.header : JSON.stringify(r.header, null, 2) : ""
					} : G[t] = e;
				} else if (t === "notification") {
					let e = n.default();
					G[t] = i && typeof r == "object" ? {
						...e,
						...r
					} : e;
				} else if (t === "agenttask") {
					let e = n.default();
					i && typeof r == "object" ? G[t] = {
						...e,
						...r,
						meta: r.meta ? typeof r.meta == "string" ? r.meta : JSON.stringify(r.meta, null, 2) : ""
					} : G[t] = e;
				} else if (t === "process") {
					let e = n.default();
					G[t] = i && typeof r == "object" ? {
						...e,
						...r
					} : e;
				} else t === "meta" ? i && typeof r == "object" && !Array.isArray(r) ? G[t] = JSON.stringify(r, null, 2) : i && typeof r == "string" ? G[t] = r : G[t] = "" : n.type === Array ? G[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : n.type === Boolean ? G[t] = i ? !!r : typeof n.default == "function" ? n.default() : n.default : (n.type, G[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), t || (G.slug = ""), oe.value = JSON.parse(JSON.stringify(G)), ne.value = t, re.value = t && e?.slug || null, J.value = !t;
		}
		async function ye() {
			if (!te.value && ((await ee.value?.validate())?.valid ?? !0)) {
				te.value = !0;
				try {
					await Ce(Se()), U("success"), W.value = !1;
				} catch (e) {
					d({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					te.value = !1;
				}
			}
		}
		function xe(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) if (!(r === null || r === "" || Array.isArray(r) && r.length === 0)) if (typeof r == "object" && !Array.isArray(r)) {
				let e = {}, i = !1;
				for (let [t, n] of Object.entries(r)) n !== null && n !== "" && !(Array.isArray(n) && n.length === 0) && (e[t] = n, i = !0);
				i && (t[n] = e);
			} else t[n] = r;
			return t;
		}
		function Se() {
			let e = (e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [], t = e(G.role), n = e(G.domain), r = e(G.tag), i = null;
			G.template?.form && (i = {
				form: G.template.form,
				...G.template.result && { result: G.template.result }
			});
			let a = null;
			if (G.webhook?.method && G.webhook?.url) {
				if (a = {
					method: G.webhook.method,
					url: G.webhook.url,
					responseType: G.webhook.responseType || "json",
					contentType: G.webhook.contentType || "application/json"
				}, G.webhook.body) try {
					a.body = JSON.parse(G.webhook.body);
				} catch {
					a.body = G.webhook.body;
				}
				if (G.webhook.header) try {
					a.header = JSON.parse(G.webhook.header);
				} catch {
					a.header = G.webhook.header;
				}
			}
			let o = null;
			G.notification?.to && G.notification?.subject && G.notification?.body && (o = {
				to: G.notification.to,
				subject: G.notification.subject,
				body: G.notification.body,
				...G.notification.from && { from: G.notification.from },
				...G.notification.cc && { cc: G.notification.cc },
				...G.notification.attachments && { attachments: G.notification.attachments }
			});
			let s = null;
			if (G.agenttask?.command && G.agenttask?.tag?.length > 0 && (s = {
				command: G.agenttask.command,
				tag: e(G.agenttask.tag),
				async: G.agenttask.async || !1,
				timeout: parseInt(G.agenttask.timeout, 10) || 0
			}, G.agenttask.vars?.length > 0 && (s.vars = e(G.agenttask.vars)), G.agenttask.meta)) try {
				s.meta = JSON.parse(G.agenttask.meta);
			} catch {}
			let c = null;
			G.process?.workflow && G.process?.title && G.process?.description && (c = {
				workflow: G.process.workflow,
				title: G.process.title,
				description: G.process.description,
				hide: G.process.hide || !1
			}, G.process.action?.length > 0 && (c.action = G.process.action.filter((e) => e.name && e.url).map((t) => ({
				...t.id && { id: t.id },
				name: t.name,
				url: t.url,
				...t.status?.length > 0 && { status: e(t.status) }
			}))));
			let l = null;
			if (G.meta) try {
				l = JSON.parse(G.meta), Object.keys(l).length === 0 && (l = null);
			} catch {}
			return xe({
				slug: G.slug?.trim().toLowerCase() || null,
				title: G.title?.trim() || null,
				name: G.name?.trim() || null,
				description: G.description?.trim() || null,
				role: t,
				domain: n,
				tag: r,
				public: G.public || !1,
				test: G.test || !1,
				disableprepopulate: G.disableprepopulate || !1,
				noninteractive: G.noninteractive || !1,
				template: i,
				webhook: a,
				notification: o,
				agenttask: s,
				process: c,
				meta: l
			});
		}
		async function Ce(e) {
			let t = ne.value ? "update" : "create", n = {
				create: "/admin/forms",
				update: `/admin/forms/${re.value}`
			}, r = {
				create: "post",
				update: "put"
			}, i = {
				error: {
					create: "form_create_error",
					update: "form_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			}, a = t === "update" ? (({ slug: e, ...t }) => t)(e) : e;
			if (!(await w({
				url: n[t],
				method: r[t],
				payload: a
			}))?.ok) throw Error(Z(i.error[t]));
			d({
				title: Z(i.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function we() {
			U("cancel"), W.value = !1;
		}
		function Te() {
			G.process.action || (G.process.action = []), G.process.action.push(H());
		}
		function De(e) {
			G.process.action.splice(e, 1);
		}
		function Oe(e = null) {
			e ? ve(e) : _e(), W.value = !0;
		}
		function ke(e) {
			ve(e, !1), W.value = !0;
		}
		return l({
			validate: () => ee.value?.validate(),
			reset: () => ee.value?.reset(),
			resetValidation: () => ee.value?.resetValidation(),
			formData: G,
			open: Oe,
			openCopy: ke,
			addProcessAction: Te
		}), (t, l) => {
			let u = S("h-form-text"), d = S("h-form-textarea"), g = S("h-form-autocomplete"), v = S("h-form-combobox"), y = S("h-form-switch"), w = S("h-form-field"), D = S("h-form-select"), k = S("h-action-button"), A = S("h-form-layout");
			return _(), n(A, {
				ref_key: "formRef",
				ref: ee,
				modelValue: W.value,
				"onUpdate:modelValue": l[36] ||= (e) => W.value = e,
				loading: te.value || E(se) || E(le) || E(de) || E(pe) || E(he),
				"bg-color": o.bgColor,
				"header-text": ne.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": o.drawerWidth,
				"has-changes": J.value,
				onSubmit: ye,
				onCancel: we
			}, {
				default: O(() => [
					c(u, {
						modelValue: G.slug,
						"onUpdate:modelValue": l[0] ||= (e) => G.slug = e,
						icon: "mdi:mdi-identifier",
						label: E(Z)("slug"),
						rules: ne.value ? [] : E(f)(!1),
						disabled: ne.value,
						hint: E(Z)("form_slug_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"disabled",
						"hint"
					]),
					c(u, {
						modelValue: G.title,
						"onUpdate:modelValue": l[1] ||= (e) => G.title = e,
						icon: "mdi:mdi-format-title",
						label: E(Z)("title"),
						rules: N,
						hint: E(Z)("form_title_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(u, {
						modelValue: G.name,
						"onUpdate:modelValue": l[2] ||= (e) => G.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: E(p),
						hint: E(Z)("form_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(d, {
						modelValue: G.description,
						"onUpdate:modelValue": l[3] ||= (e) => G.description = e,
						label: E(Z)("description"),
						hint: E(Z)("form_description_hint"),
						icon: "mdi:mdi-text",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3"
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(g, {
						modelValue: G.role,
						"onUpdate:modelValue": l[4] ||= (e) => G.role = e,
						icon: "mdi:mdi-account-key",
						label: E(Z)("roles"),
						items: E(Y),
						loading: E(se),
						hint: E(Z)("form_role_hint"),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint"
					]),
					c(g, {
						modelValue: G.domain,
						"onUpdate:modelValue": l[5] ||= (e) => G.domain = e,
						icon: "mdi:mdi-domain",
						label: E(Z)("domains"),
						items: E(ce),
						loading: E(le),
						hint: E(Z)("form_domain_hint"),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint"
					]),
					c(v, {
						modelValue: G.tag,
						"onUpdate:modelValue": l[6] ||= (e) => G.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						hint: E(Z)("form_tag_hint"),
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "]
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(y, {
						modelValue: G.public,
						"onUpdate:modelValue": l[7] ||= (e) => G.public = e,
						icon: G.public ? "mdi:mdi-earth" : "mdi:mdi-lock",
						label: E(Z)("public"),
						hint: E(Z)("form_public_hint")
					}, null, 8, [
						"modelValue",
						"icon",
						"label",
						"hint"
					]),
					c(y, {
						modelValue: G.test,
						"onUpdate:modelValue": l[8] ||= (e) => G.test = e,
						icon: G.test ? "mdi:mdi-flask" : "mdi:mdi-flask-outline",
						label: E(Z)("test"),
						hint: E(Z)("form_test_hint")
					}, null, 8, [
						"modelValue",
						"icon",
						"label",
						"hint"
					]),
					c(y, {
						modelValue: G.disableprepopulate,
						"onUpdate:modelValue": l[9] ||= (e) => G.disableprepopulate = e,
						icon: G.disableprepopulate ? "mdi:mdi-form-textbox-lock" : "mdi:mdi-form-textbox",
						label: E(Z)("disable_prepopulate"),
						hint: E(Z)("form_disable_prepopulate_hint")
					}, null, 8, [
						"modelValue",
						"icon",
						"label",
						"hint"
					]),
					c(y, {
						modelValue: G.noninteractive,
						"onUpdate:modelValue": l[10] ||= (e) => G.noninteractive = e,
						icon: G.noninteractive ? "mdi:mdi-gesture-tap-button" : "mdi:mdi-cursor-default-click",
						label: E(Z)("noninteractive"),
						hint: E(Z)("form_noninteractive_hint")
					}, null, 8, [
						"modelValue",
						"icon",
						"label",
						"hint"
					]),
					c(w, {
						icon: "mdi:mdi-file-document",
						label: E(Z)("template"),
						hint: E(Z)("form_template_hint"),
						indent: ""
					}, {
						default: O(() => [c($, null, {
							default: O(() => [c(Q, { cols: "12" }, {
								default: O(() => [c(g, {
									modelValue: G.template.form,
									"onUpdate:modelValue": l[11] ||= (e) => G.template.form = e,
									icon: "mdi:mdi-file-document-outline",
									label: E(Z)("template_form"),
									items: E(fe),
									loading: E(pe),
									hint: E(Z)("form_template_form_hint"),
									rules: G.template.form || G.template.result ? E(h)(E(Z)("template_form_required")) : []
								}, null, 8, [
									"modelValue",
									"label",
									"items",
									"loading",
									"hint",
									"rules"
								])]),
								_: 1
							}), c(Q, { cols: "12" }, {
								default: O(() => [c(g, {
									modelValue: G.template.result,
									"onUpdate:modelValue": l[12] ||= (e) => G.template.result = e,
									icon: "mdi:mdi-file-document-check",
									label: E(Z)("template_result"),
									items: E(fe),
									loading: E(pe),
									hint: E(Z)("form_template_result_hint"),
									clearable: ""
								}, null, 8, [
									"modelValue",
									"label",
									"items",
									"loading",
									"hint"
								])]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}, 8, ["label", "hint"]),
					c(w, {
						icon: "mdi:mdi-webhook",
						label: E(Z)("webhook"),
						hint: E(Z)("form_webhook_hint"),
						indent: ""
					}, {
						default: O(() => [c($, null, {
							default: O(() => [
								c(Q, {
									cols: "12",
									md: "6"
								}, {
									default: O(() => [c(D, {
										modelValue: G.webhook.method,
										"onUpdate:modelValue": l[13] ||= (e) => G.webhook.method = e,
										icon: "mdi:mdi-api",
										label: E(Z)("method"),
										items: L,
										hint: E(Z)("form_webhook_method_hint")
									}, null, 8, [
										"modelValue",
										"label",
										"hint"
									])]),
									_: 1
								}),
								c(Q, {
									cols: "12",
									md: "6"
								}, {
									default: O(() => [c(D, {
										modelValue: G.webhook.responseType,
										"onUpdate:modelValue": l[14] ||= (e) => G.webhook.responseType = e,
										icon: "mdi:mdi-file-code",
										label: E(Z)("response_type"),
										items: R,
										hint: E(Z)("form_webhook_response_type_hint")
									}, null, 8, [
										"modelValue",
										"label",
										"hint"
									])]),
									_: 1
								}),
								c(Q, { cols: "12" }, {
									default: O(() => [c(u, {
										modelValue: G.webhook.url,
										"onUpdate:modelValue": l[15] ||= (e) => G.webhook.url = e,
										icon: "mdi:mdi-link",
										label: E(Z)("url"),
										hint: E(Z)("form_webhook_url_hint"),
										rules: G.webhook.method ? [...E(h)(E(Z)("url_required")), ...E(x)] : E(x)
									}, null, 8, [
										"modelValue",
										"label",
										"hint",
										"rules"
									])]),
									_: 1
								}),
								c(Q, { cols: "12" }, {
									default: O(() => [c(D, {
										modelValue: G.webhook.contentType,
										"onUpdate:modelValue": l[16] ||= (e) => G.webhook.contentType = e,
										icon: "mdi:mdi-file-document",
										label: E(Z)("content_type"),
										items: z,
										hint: E(Z)("form_webhook_content_type_hint")
									}, null, 8, [
										"modelValue",
										"label",
										"hint"
									])]),
									_: 1
								}),
								c(Q, { cols: "12" }, {
									default: O(() => [c(E(Ee), {
										modelValue: G.webhook.body,
										"onUpdate:modelValue": l[17] ||= (e) => G.webhook.body = e,
										language: "json",
										icon: "mdi:mdi-code-json",
										label: E(Z)("body"),
										hint: E(Z)("form_webhook_body_hint"),
										rules: j
									}, null, 8, [
										"modelValue",
										"label",
										"hint"
									])]),
									_: 1
								}),
								c(Q, { cols: "12" }, {
									default: O(() => [c(E(Ee), {
										modelValue: G.webhook.header,
										"onUpdate:modelValue": l[18] ||= (e) => G.webhook.header = e,
										language: "json",
										icon: "mdi:mdi-code-braces",
										label: E(Z)("headers"),
										hint: E(Z)("form_webhook_header_hint"),
										rules: j
									}, null, 8, [
										"modelValue",
										"label",
										"hint"
									])]),
									_: 1
								})
							]),
							_: 1
						})]),
						_: 1
					}, 8, ["label", "hint"]),
					c(w, {
						icon: "mdi:mdi-email",
						label: E(Z)("notification"),
						hint: E(Z)("form_notification_hint"),
						indent: ""
					}, {
						default: O(() => [c($, null, {
							default: O(() => [
								c(Q, {
									cols: "12",
									md: "6"
								}, {
									default: O(() => [c(u, {
										modelValue: G.notification.to,
										"onUpdate:modelValue": l[19] ||= (e) => G.notification.to = e,
										icon: "mdi:mdi-email-arrow-right",
										label: E(Z)("to"),
										hint: E(Z)("form_notification_to_hint"),
										rules: G.notification.to ? E(C)(!1, { format: "hub" }) : []
									}, null, 8, [
										"modelValue",
										"label",
										"hint",
										"rules"
									])]),
									_: 1
								}),
								c(Q, {
									cols: "12",
									md: "6"
								}, {
									default: O(() => [c(u, {
										modelValue: G.notification.from,
										"onUpdate:modelValue": l[20] ||= (e) => G.notification.from = e,
										icon: "mdi:mdi-email-arrow-left",
										label: E(Z)("from"),
										hint: E(Z)("form_notification_from_hint"),
										rules: G.notification.from ? E(C)(!1) : []
									}, null, 8, [
										"modelValue",
										"label",
										"hint",
										"rules"
									])]),
									_: 1
								}),
								c(Q, { cols: "12" }, {
									default: O(() => [c(u, {
										modelValue: G.notification.cc,
										"onUpdate:modelValue": l[21] ||= (e) => G.notification.cc = e,
										icon: "mdi:mdi-email-multiple",
										label: E(Z)("cc"),
										hint: E(Z)("form_notification_cc_hint"),
										rules: G.notification.cc ? E(C)(!1, { format: "hub" }) : []
									}, null, 8, [
										"modelValue",
										"label",
										"hint",
										"rules"
									])]),
									_: 1
								}),
								c(Q, { cols: "12" }, {
									default: O(() => [c(u, {
										modelValue: G.notification.subject,
										"onUpdate:modelValue": l[22] ||= (e) => G.notification.subject = e,
										icon: "mdi:mdi-format-title",
										label: E(Z)("subject"),
										hint: E(Z)("form_notification_subject_hint"),
										rules: G.notification.to ? E(h)(E(Z)("subject_required")) : []
									}, null, 8, [
										"modelValue",
										"label",
										"hint",
										"rules"
									])]),
									_: 1
								}),
								c(Q, { cols: "12" }, {
									default: O(() => [c(d, {
										modelValue: G.notification.body,
										"onUpdate:modelValue": l[23] ||= (e) => G.notification.body = e,
										icon: "mdi:mdi-text",
										label: E(Z)("body"),
										hint: E(Z)("form_notification_body_hint"),
										rules: G.notification.to ? E(h)(E(Z)("body_required")) : [],
										"auto-grow": "",
										rows: "3"
									}, null, 8, [
										"modelValue",
										"label",
										"hint",
										"rules"
									])]),
									_: 1
								}),
								c(Q, { cols: "12" }, {
									default: O(() => [c(u, {
										modelValue: G.notification.attachments,
										"onUpdate:modelValue": l[24] ||= (e) => G.notification.attachments = e,
										icon: "mdi:mdi-attachment",
										label: E(Z)("attachments"),
										hint: E(Z)("form_notification_attachments_hint")
									}, null, 8, [
										"modelValue",
										"label",
										"hint"
									])]),
									_: 1
								})
							]),
							_: 1
						})]),
						_: 1
					}, 8, ["label", "hint"]),
					c(w, {
						icon: "mdi:mdi-robot",
						label: E(Z)("agent_task"),
						hint: E(Z)("form_agenttask_hint"),
						indent: ""
					}, {
						default: O(() => [c($, null, {
							default: O(() => [
								c(Q, { cols: "12" }, {
									default: O(() => [c(u, {
										modelValue: G.agenttask.command,
										"onUpdate:modelValue": l[25] ||= (e) => G.agenttask.command = e,
										icon: "mdi:mdi-console",
										label: E(Z)("command"),
										hint: E(Z)("form_agenttask_command_hint")
									}, null, 8, [
										"modelValue",
										"label",
										"hint"
									])]),
									_: 1
								}),
								c(Q, {
									cols: "12",
									md: "6"
								}, {
									default: O(() => [c(y, {
										modelValue: G.agenttask.async,
										"onUpdate:modelValue": l[26] ||= (e) => G.agenttask.async = e,
										icon: G.agenttask.async ? "mdi:mdi-sync" : "mdi:mdi-sync-off",
										label: E(Z)("async"),
										hint: E(Z)("form_agenttask_async_hint")
									}, null, 8, [
										"modelValue",
										"icon",
										"label",
										"hint"
									])]),
									_: 1
								}),
								c(Q, {
									cols: "12",
									md: "6"
								}, {
									default: O(() => [c(u, {
										modelValue: G.agenttask.timeout,
										"onUpdate:modelValue": l[27] ||= (e) => G.agenttask.timeout = e,
										type: "number",
										icon: "mdi:mdi-timer",
										label: E(Z)("timeout"),
										hint: E(Z)("form_agenttask_timeout_hint"),
										rules: P
									}, null, 8, [
										"modelValue",
										"label",
										"hint"
									])]),
									_: 1
								}),
								c(Q, { cols: "12" }, {
									default: O(() => [c(v, {
										modelValue: G.agenttask.tag,
										"onUpdate:modelValue": l[28] ||= (e) => G.agenttask.tag = e,
										icon: "mdi:mdi-tag",
										label: E(Z)("agent_tags"),
										items: ge.value,
										loading: E(he),
										hint: E(Z)("form_agenttask_tag_hint"),
										rules: G.agenttask.command ? E(h)(E(Z)("agent_tag_required")) : [],
										multiple: "",
										chips: "",
										"closable-chips": "",
										delimiters: [",", " "]
									}, null, 8, [
										"modelValue",
										"label",
										"items",
										"loading",
										"hint",
										"rules"
									])]),
									_: 1
								}),
								c(Q, { cols: "12" }, {
									default: O(() => [c(v, {
										modelValue: G.agenttask.vars,
										"onUpdate:modelValue": l[29] ||= (e) => G.agenttask.vars = e,
										icon: "mdi:mdi-variable",
										label: E(Z)("variables"),
										items: [],
										hint: E(Z)("form_agenttask_vars_hint"),
										"hide-no-data": "",
										multiple: "",
										chips: "",
										"closable-chips": "",
										delimiters: [",", " "]
									}, null, 8, [
										"modelValue",
										"label",
										"hint"
									])]),
									_: 1
								}),
								c(Q, { cols: "12" }, {
									default: O(() => [c(E(Ee), {
										modelValue: G.agenttask.meta,
										"onUpdate:modelValue": l[30] ||= (e) => G.agenttask.meta = e,
										language: "json",
										icon: "mdi:mdi-database-cog",
										label: E(Z)("meta"),
										hint: E(Z)("form_agenttask_meta_hint"),
										rules: M
									}, null, 8, [
										"modelValue",
										"label",
										"hint"
									])]),
									_: 1
								})
							]),
							_: 1
						})]),
						_: 1
					}, 8, ["label", "hint"]),
					c(w, {
						icon: "mdi:mdi-cog",
						label: E(Z)("process"),
						hint: E(Z)("form_process_hint"),
						indent: ""
					}, {
						default: O(() => [c($, null, {
							default: O(() => [
								c(Q, { cols: "12" }, {
									default: O(() => [c(g, {
										modelValue: G.process.workflow,
										"onUpdate:modelValue": l[31] ||= (e) => G.process.workflow = e,
										icon: "mdi:mdi-sitemap",
										label: E(Z)("workflow"),
										items: E(ue),
										loading: E(de),
										hint: E(Z)("form_process_workflow_hint")
									}, null, 8, [
										"modelValue",
										"label",
										"items",
										"loading",
										"hint"
									])]),
									_: 1
								}),
								c(Q, { cols: "12" }, {
									default: O(() => [c(u, {
										modelValue: G.process.title,
										"onUpdate:modelValue": l[32] ||= (e) => G.process.title = e,
										icon: "mdi:mdi-format-title",
										label: E(Z)("process_title"),
										hint: E(Z)("form_process_title_hint"),
										rules: G.process.workflow ? E(h)(E(Z)("process_title_required")) : []
									}, null, 8, [
										"modelValue",
										"label",
										"hint",
										"rules"
									])]),
									_: 1
								}),
								c(Q, { cols: "12" }, {
									default: O(() => [c(d, {
										modelValue: G.process.description,
										"onUpdate:modelValue": l[33] ||= (e) => G.process.description = e,
										icon: "mdi:mdi-text",
										label: E(Z)("process_description"),
										hint: E(Z)("form_process_description_hint"),
										rules: G.process.workflow ? E(h)(E(Z)("process_description_required")) : [],
										"auto-grow": "",
										rows: "3"
									}, null, 8, [
										"modelValue",
										"label",
										"hint",
										"rules"
									])]),
									_: 1
								}),
								c(Q, { cols: "12" }, {
									default: O(() => [c(y, {
										modelValue: G.process.hide,
										"onUpdate:modelValue": l[34] ||= (e) => G.process.hide = e,
										icon: G.process.hide ? "mdi:mdi-eye-off" : "mdi:mdi-eye",
										label: E(Z)("hide_process"),
										hint: E(Z)("form_process_hide_hint")
									}, null, 8, [
										"modelValue",
										"icon",
										"label",
										"hint"
									])]),
									_: 1
								})
							]),
							_: 1
						}), G.process.workflow ? (_(), n($, { key: 0 }, {
							default: O(() => [c(Q, { cols: "12" }, {
								default: O(() => [c(w, {
									icon: "mdi:mdi-link",
									label: E(Z)("process_actions"),
									hint: E(Z)("form_process_actions_hint")
								}, {
									default: O(() => [c($, null, {
										default: O(() => [(_(!0), i(e, null, b(G.process.action, (e, t) => (_(), n(Q, {
											key: t,
											cols: "12",
											class: "mb-2 ga-4 pa-6"
										}, {
											default: O(() => [c($, { class: "align-center" }, {
												default: O(() => [
													c(Q, {
														cols: "auto",
														class: "d-flex align-center"
													}, {
														default: O(() => [c(ze, {
															icon: "mdi:mdi-link-variant",
															class: "mr-2"
														}), a("span", un, T(E(Z)("action")) + " #" + T(t + 1), 1)]),
														_: 2
													}, 1024),
													c(be),
													c(Q, { cols: "auto" }, {
														default: O(() => [c(k, {
															icon: "mdi:mdi-delete",
															variant: "text",
															color: "error",
															onClick: (e) => De(t)
														}, null, 8, ["onClick"])]),
														_: 2
													}, 1024)
												]),
												_: 2
											}, 1024), c($, { class: "d-flex flex-column ga-2" }, {
												default: O(() => [c(Q, { class: "d-flex flex-column pt-0 ga-2" }, {
													default: O(() => [
														c(u, {
															modelValue: e.id,
															"onUpdate:modelValue": (t) => e.id = t,
															label: E(Z)("id"),
															rules: E(m)(E(Z)("action_id_format")),
															hint: E(Z)("form_process_action_id_hint")
														}, null, 8, [
															"modelValue",
															"onUpdate:modelValue",
															"label",
															"rules",
															"hint"
														]),
														c(u, {
															modelValue: e.name,
															"onUpdate:modelValue": (t) => e.name = t,
															label: E(Z)("name"),
															rules: E(h)(E(Z)("action_name_required")),
															required: ""
														}, null, 8, [
															"modelValue",
															"onUpdate:modelValue",
															"label",
															"rules"
														]),
														c(u, {
															modelValue: e.url,
															"onUpdate:modelValue": (t) => e.url = t,
															label: E(Z)("url"),
															rules: [...E(h)(E(Z)("action_url_required")), ...E(x)],
															required: ""
														}, null, 8, [
															"modelValue",
															"onUpdate:modelValue",
															"label",
															"rules"
														]),
														c(g, {
															modelValue: e.status,
															"onUpdate:modelValue": (t) => e.status = t,
															label: E(Z)("status"),
															items: B,
															hint: E(Z)("form_process_action_status_hint"),
															multiple: "",
															chips: "",
															"closable-chips": ""
														}, null, 8, [
															"modelValue",
															"onUpdate:modelValue",
															"label",
															"hint"
														])
													]),
													_: 2
												}, 1024)]),
												_: 2
											}, 1024)]),
											_: 2
										}, 1024))), 128)), c(Q, { cols: "12" }, {
											default: O(() => [c(k, {
												type: "primary",
												variant: "outlined",
												"prepend-icon": "mdi:mdi-plus",
												class: "mt-4",
												onClick: Te
											}, {
												default: O(() => [s(T(E(Z)("add_action")), 1)]),
												_: 1
											})]),
											_: 1
										})]),
										_: 1
									})]),
									_: 1
								}, 8, ["label", "hint"])]),
								_: 1
							})]),
							_: 1
						})) : r("", !0)]),
						_: 1
					}, 8, ["label", "hint"]),
					c(w, {
						icon: "mdi:mdi-database-cog",
						label: E(Z)("meta"),
						hint: E(Z)("form_meta_hint")
					}, {
						default: O(() => [c($, null, {
							default: O(() => [c(Q, { cols: "12" }, {
								default: O(() => [c(E(Ee), {
									modelValue: G.meta,
									"onUpdate:modelValue": l[35] ||= (e) => G.meta = e,
									language: "json",
									icon: "mdi:mdi-code-json",
									label: E(Z)("meta"),
									hint: E(Z)("form_meta_hint"),
									rules: M
								}, null, 8, [
									"modelValue",
									"label",
									"hint"
								])]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}, 8, ["label", "hint"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, fn = {
	__name: "admin-forms",
	props: {},
	setup(n) {
		X(n, "HAdminForms");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { confirm: s } = ce(), { hAddAlert: l } = q(), u = y(null), d = y(!0), f = {
			term: "",
			slug: "",
			slugMatchType: "contains",
			title: "",
			titleMatchType: "contains",
			name: "",
			nameMatchType: "contains",
			role: [],
			domain: [],
			tag: [],
			modifieddatePreset: null,
			sortBy: "modifieddate",
			sortOrder: "desc",
			page: 1,
			pageSize: 25
		}, p = v({ ...f }), m = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "slug",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("slug_filter"),
					placeholder: Z("slug_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-identifier",
					defaultMatchType: "contains"
				}
			},
			{
				key: "title",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("title_filter"),
					placeholder: Z("title_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-format-title",
					defaultMatchType: "contains"
				}
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "role",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("role_filter"),
					icon: "mdi:mdi-account-key"
				}
			},
			{
				key: "domain",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("domain_filter"),
					icon: "mdi:mdi-web"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [{
					key: "modifieddate",
					type: "date",
					component: "h-filter-datetime",
					model: "modifieddatePreset",
					props: {
						label: Z("modifieddate_filter"),
						manualSync: !0
					}
				}]
			}
		] }, g = [
			{
				title: "slug",
				key: "slug",
				sortable: !0,
				width: 150,
				value: "slug",
				nowrap: !0,
				translate: !0
			},
			{
				title: "title",
				key: "title",
				align: "start",
				sortable: !0,
				width: 200,
				value: "title",
				nowrap: !1,
				customSortKey: "title.lower",
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 200,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "role",
				key: "role",
				sortable: !0,
				width: 150,
				value: "role",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => P("role", e),
				isFilterActive: (e) => N("role", e)
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => P("tag", e),
				isFilterActive: (e) => N("tag", e)
			},
			{
				title: "noninteractive",
				key: "noninteractive",
				sortable: !1,
				width: 40,
				value: "noninteractive",
				nowrap: !0,
				translate: !0,
				component: "h-btn-table-cell",
				defaultValue: !1,
				componentProps: {
					getIcon: (e) => e.noninteractive ? "mdi:mdi-gesture-tap-button" : "mdi:mdi-cursor-default-click",
					getColor: (e) => e.noninteractive ? "grey" : "primary"
				}
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 150,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], b = {
			pageKey: "forms",
			pageTitle: Z("admin_forms_title"),
			headerTitle: Z("forms"),
			searchPlaceholder: Z("search_forms"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("forms"),
					text: Z("forms")
				}
			]
		}, { data: x, loading: C, params: w, execute: T, totalResults: D } = G({
			url: "/admin/forms",
			filters: p,
			additionalParams: {}
		}), O = Z("total_forms"), k = t(() => ({ widgets: [{
			summary: !0,
			title: O,
			count: D.value,
			icon: "mdi:mdi-form-select",
			color: "blue-grey-lighten-3",
			iconColor: "blue-grey-darken-4"
		}] }));
		function A() {
			j(!0);
		}
		function j(e = !1) {
			let { query: t, sort: n } = a(m.filters, p);
			w.query = t, w.sort = n, (e || d.value) && T();
		}
		let M = qe(j, 300), { isFilterActive: N, toggleArrayFilter: P } = ue({
			filters: p,
			onFilterChange: M
		});
		function F() {
			return Object.assign(p, { ...f }), j(!0);
		}
		let I = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => u.value?.openCopy(e)
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => u.value?.open(e)
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await s({
						title: Z("delete_form"),
						message: Z("delete_form_confirm", { slug: e.slug }),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = o({
							url: `/admin/forms/${e.slug}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							l({
								title: Z("error_occurred"),
								body: Z("form_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await T();
					}
				}
			}
		];
		function L() {
			u.value?.open();
		}
		return h(async () => {
			J(p, M), j(), T();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": d.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => d.value = e,
				"page-configuration": b,
				"widgets-config": k.value,
				"filters-config": m,
				filters: p,
				"table-headers": g,
				"table-params": E(w),
				"table-data": E(x),
				"table-loading": E(C),
				"total-results": E(D),
				"table-actions": I,
				"open-form": L,
				onSearch: A,
				onClearFilters: F
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(dn, {
				ref_key: "formsFormRef",
				ref: u,
				onSuccess: E(T)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, pn = { class: "text-headline-small" }, mn = {
	__name: "guide-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 700
		}
	},
	emits: ["success", "cancel"],
	setup(t, { expose: o, emit: l }) {
		let { hAddAlert: u } = q(), { nameRules: d, requiredRules: f, urlRules: p, slugRules: m, integerRules: h } = ie(), { save: g } = ae(), x = [(e) => !!e || Z("title_required")], C = [(e) => !e || /^[a-z0-9_-]*$/.test(e) || Z("guide_step_id_format")], w = [(e) => !!e || Z("title_required")], k = h({ min: 0 }), A = [(e) => {
			let t = Array.isArray(e) ? e : [];
			return t.length === 0 ? Z("guide_step_required") : t.every((e) => String(e?.title || "").trim()) || Z("guide_step_required");
		}];
		X(t, "HGuideForm");
		let j = {
			slug: {
				type: String,
				default: ""
			},
			title: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			instructions: {
				type: String,
				default: ""
			},
			role: {
				type: Array,
				default: () => []
			},
			tag: {
				type: Array,
				default: () => []
			},
			domain: {
				type: Array,
				default: () => []
			},
			step: {
				type: Array,
				default: () => []
			}
		}, M = {
			id: {
				type: String,
				default: ""
			},
			title: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			role: {
				type: Array,
				default: () => []
			},
			order: {
				type: Number,
				default: null
			},
			icon: {
				type: String,
				default: ""
			},
			path: {
				type: Object,
				default: () => ({
					type: "",
					guide: "",
					url: "",
					target: ""
				})
			}
		}, N = () => {
			let e = {};
			return Object.keys(j).forEach((t) => {
				let n = j[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e.step = [P()], e;
		}, P = () => {
			let e = {};
			return Object.keys(M).forEach((t) => {
				let n = M[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, F = l, I = y(null), L = y(!1), R = y(!1), z = y(!1), B = y(null), V = v(N()), H = y(!1), U = y({}), ee = [
			{
				title: "-",
				value: ""
			},
			{
				title: Z("link"),
				value: "link"
			},
			{
				title: Z("guide"),
				value: "guide"
			}
		], W = [
			{
				title: "-",
				value: ""
			},
			{
				title: "_blank - " + Z("target_blank"),
				value: "_blank"
			},
			{
				title: "_self - " + Z("target_self"),
				value: "_self"
			},
			{
				title: "_top - " + Z("target_top"),
				value: "_top"
			}
		], { data: te, loading: ne } = K({
			url: "/admin/roles",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), { data: re, loading: G } = K({
			url: "/admin/domains",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), { data: J, loading: oe } = K({
			url: "/admin/guides",
			formatter: (e) => e.map((e) => ({
				title: e.title || e.name,
				value: e.slug,
				key: e.slug
			}))
		});
		D(L, (e) => {
			e || Y();
		}), D(V, () => {
			H.value = JSON.stringify(V) !== JSON.stringify(U.value);
		}, { deep: !0 });
		function Y() {
			let e = N();
			Object.keys(e).forEach((t) => {
				V[t] = e[t];
			}), U.value = JSON.parse(JSON.stringify(V)), z.value = !1, B.value = null, H.value = !1;
		}
		function se(e, t = !0) {
			Object.keys(j).forEach((t) => {
				let n = j[t], r = e?.[t], i = r != null;
				t === "step" ? i && Array.isArray(r) ? V[t] = r.map((e) => {
					let t = P();
					return Object.keys(M).forEach((n) => {
						let r = M[n], i = e?.[n], a = i != null;
						if (n === "path") {
							let e = r.default();
							t[n] = a && typeof i == "object" ? {
								...e,
								...i
							} : e;
						} else r.type === Array ? t[n] = a && Array.isArray(i) ? [...i] : typeof r.default == "function" ? r.default() : r.default : t[n] = a ? i : typeof r.default == "function" ? r.default() : r.default;
					}), t;
				}) : V[t] = typeof n.default == "function" ? n.default() : n.default : n.type === Array ? V[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : n.type === Boolean ? V[t] = i ? !!r : typeof n.default == "function" ? n.default() : n.default : (n.type === String || n.type, V[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), t || (V.slug = ""), U.value = JSON.parse(JSON.stringify(V)), z.value = t, B.value = t && e?.slug || null, H.value = !t;
		}
		async function ce() {
			if (R.value) return;
			let e = (await I.value?.validate())?.valid ?? !0, t = A.every((e) => e(V.step) === !0);
			if (!e || !t) {
				t || u({
					title: Z("error_occurred"),
					body: Z("guide_step_required"),
					type: "error",
					timeout: 5e3
				});
				return;
			}
			R.value = !0;
			try {
				await de(ue()), F("success"), L.value = !1;
			} catch (e) {
				u({
					title: Z("error_occurred"),
					body: e.message,
					type: "error",
					timeout: 5e3
				});
			} finally {
				R.value = !1;
			}
		}
		function le(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) if (!(r === null || r === "")) if (typeof r == "object" && !Array.isArray(r)) {
				let e = {};
				for (let [t, n] of Object.entries(r)) n !== null && n !== "" && !(Array.isArray(n) && n.length === 0) && (e[t] = n);
				Object.keys(e).length > 0 && (t[n] = e);
			} else if (Array.isArray(r)) {
				if (r.length === 0 && n !== "step") continue;
				t[n] = r;
			} else t[n] = r;
			return t;
		}
		function ue() {
			let e = (e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [], t = e(V.role), n = e(V.domain), r = e(V.tag), i = Array.isArray(V.step) ? V.step.filter((e) => e && typeof e == "object").map((t) => {
				let n = String(t.title || "").trim();
				if (!n) return null;
				let r = null;
				if (t.path?.type) if (r = { type: t.path.type }, t.path.type === "guide" && t.path.guide) {
					let e = typeof t.path.guide == "object" ? t.path.guide.value || t.path.guide.key : t.path.guide;
					r.guide = e;
				} else t.path.type === "link" && (t.path.url && (r.url = t.path.url.trim()), t.path.target && (r.target = t.path.target));
				return {
					title: n,
					...t.id && { id: t.id.trim() },
					...t.description && { description: t.description.trim() },
					...t.role?.length && { role: e(t.role) },
					...t.order !== null && t.order !== void 0 && t.order !== "" && { order: parseInt(t.order, 10) },
					...t.icon && { icon: t.icon.trim() },
					...r && { path: r }
				};
			}).filter(Boolean) : [];
			return le({
				slug: V.slug?.trim()?.toLowerCase() || null,
				title: V.title?.trim() || null,
				name: V.name?.trim() || null,
				description: V.description?.trim() || null,
				instructions: V.instructions?.trim() || null,
				role: t,
				domain: n,
				tag: r,
				step: i
			});
		}
		async function de(e) {
			let t = z.value ? "update" : "create", n = {
				create: "/admin/guides",
				update: `/admin/guides/${B.value}`
			}, r = {
				create: "post",
				update: "put"
			}, i = {
				error: {
					create: "guide_create_error",
					update: "guide_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			}, a = t === "update" ? (({ slug: e, ...t }) => t)(e) : e;
			if (!(await g({
				url: n[t],
				method: r[t],
				payload: a
			}))?.ok) throw Error(Z(i.error[t]));
			u({
				title: Z(i.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function fe() {
			F("cancel"), L.value = !1;
		}
		function pe() {
			V.step ||= [], V.step.push(P());
		}
		function me(e) {
			V.step.length <= 1 || V.step.splice(e, 1);
		}
		function he(e = null) {
			e && se(e), L.value = !0;
		}
		function ge(e) {
			se(e, !1), L.value = !0;
		}
		return o({
			validate: () => I.value?.validate(),
			reset: () => I.value?.reset(),
			resetValidation: () => I.value?.resetValidation(),
			formData: V,
			open: he,
			openCopy: ge
		}), (o, l) => {
			let u = S("h-form-text"), h = S("h-form-textarea"), g = S("h-form-autocomplete"), v = S("h-form-combobox"), y = S("h-action-button"), D = S("h-form-select"), A = S("h-form-field"), j = S("h-form-layout");
			return _(), n(j, {
				ref_key: "formRef",
				ref: I,
				modelValue: L.value,
				"onUpdate:modelValue": l[8] ||= (e) => L.value = e,
				loading: R.value,
				"bg-color": t.bgColor,
				"header-text": z.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": t.drawerWidth,
				"has-changes": H.value,
				onSubmit: ce,
				onCancel: fe
			}, {
				default: O(() => [
					c(u, {
						modelValue: V.slug,
						"onUpdate:modelValue": l[0] ||= (e) => V.slug = e,
						icon: "mdi:mdi-link",
						label: E(Z)("slug"),
						rules: z.value ? [] : E(m)(!1),
						disabled: z.value,
						hint: E(Z)("guide_slug_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"disabled",
						"hint"
					]),
					c(u, {
						modelValue: V.title,
						"onUpdate:modelValue": l[1] ||= (e) => V.title = e,
						icon: "mdi:mdi-format-title",
						label: E(Z)("title"),
						rules: x,
						hint: E(Z)("guide_title_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(u, {
						modelValue: V.name,
						"onUpdate:modelValue": l[2] ||= (e) => V.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: E(d),
						hint: E(Z)("guide_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(h, {
						modelValue: V.description,
						"onUpdate:modelValue": l[3] ||= (e) => V.description = e,
						label: E(Z)("description"),
						hint: E(Z)("guide_description_hint"),
						icon: "mdi:mdi-text",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3"
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(h, {
						modelValue: V.instructions,
						"onUpdate:modelValue": l[4] ||= (e) => V.instructions = e,
						label: E(Z)("instructions"),
						hint: E(Z)("guide_instructions_hint"),
						icon: "mdi:mdi-text-long",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "4"
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(g, {
						modelValue: V.role,
						"onUpdate:modelValue": l[5] ||= (e) => V.role = e,
						icon: "mdi:mdi-account-key",
						label: E(Z)("roles"),
						items: E(te),
						loading: E(ne),
						hint: E(Z)("guide_role_hint"),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint"
					]),
					c(v, {
						modelValue: V.tag,
						"onUpdate:modelValue": l[6] ||= (e) => V.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						hint: E(Z)("guide_tag_hint"),
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "]
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(g, {
						modelValue: V.domain,
						"onUpdate:modelValue": l[7] ||= (e) => V.domain = e,
						icon: "mdi:mdi-domain",
						label: E(Z)("domains"),
						items: E(re),
						loading: E(G),
						hint: E(Z)("guide_domain_hint"),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint"
					]),
					c(A, {
						icon: "mdi:mdi-format-list-numbered",
						label: E(Z)("steps"),
						hint: E(Z)("guide_steps_hint")
					}, {
						default: O(() => [c($, null, {
							default: O(() => [(_(!0), i(e, null, b(V.step, (e, t) => (_(), n(Q, {
								key: t,
								cols: "12",
								class: "mb-6"
							}, {
								default: O(() => [c($, { class: "align-center" }, {
									default: O(() => [
										c(Q, {
											cols: "auto",
											class: "d-flex align-center"
										}, {
											default: O(() => [c(ze, {
												icon: "mdi:mdi-numeric",
												class: "mr-2"
											}), a("span", pn, T(E(Z)("step")) + " #" + T(t + 1), 1)]),
											_: 2
										}, 1024),
										c(be),
										c(Q, { cols: "auto" }, {
											default: O(() => [c(y, {
												icon: "mdi:mdi-delete",
												variant: "text",
												color: "error",
												disabled: V.step.length <= 1,
												onClick: (e) => me(t)
											}, null, 8, ["disabled", "onClick"])]),
											_: 2
										}, 1024)
									]),
									_: 2
								}, 1024), c($, { class: "d-flex flex-column mt-2" }, {
									default: O(() => [c(Q, { class: "d-flex flex-column ga-4 pt-0" }, {
										default: O(() => [
											c(u, {
												modelValue: e.id,
												"onUpdate:modelValue": (t) => e.id = t,
												label: E(Z)("id"),
												rules: C,
												hint: E(Z)("guide_step_id_hint")
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"hint"
											]),
											c(u, {
												modelValue: e.title,
												"onUpdate:modelValue": (t) => e.title = t,
												label: E(Z)("title"),
												rules: w,
												required: ""
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label"
											]),
											c(h, {
												modelValue: e.description,
												"onUpdate:modelValue": (t) => e.description = t,
												label: E(Z)("description"),
												hint: E(Z)("guide_step_description_hint"),
												density: "comfortable",
												variant: "outlined",
												"bg-color": "white",
												"auto-grow": "",
												rows: "2"
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"hint"
											]),
											c(g, {
												modelValue: e.role,
												"onUpdate:modelValue": (t) => e.role = t,
												icon: "mdi:mdi-account-key",
												label: E(Z)("roles"),
												items: E(te),
												loading: E(ne),
												multiple: "",
												chips: "",
												"closable-chips": ""
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"items",
												"loading"
											]),
											c(u, {
												modelValue: e.order,
												"onUpdate:modelValue": (t) => e.order = t,
												label: E(Z)("order"),
												type: "number",
												rules: E(k)
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"rules"
											]),
											c(u, {
												modelValue: e.icon,
												"onUpdate:modelValue": (t) => e.icon = t,
												label: E(Z)("icon"),
												hint: E(Z)("guide_step_icon_hint")
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"hint"
											]),
											c(Fe, {
												variant: "outlined",
												class: "mt-4 pa-4"
											}, {
												default: O(() => [c(Re, { class: "text-body-large" }, {
													default: O(() => [s(T(E(Z)("path")), 1)]),
													_: 1
												}), c(Le, { class: "d-flex flex-column ga-4" }, {
													default: O(() => [
														c(D, {
															modelValue: e.path.type,
															"onUpdate:modelValue": (t) => e.path.type = t,
															label: E(Z)("type"),
															items: ee,
															hint: E(Z)("guide_step_path_type_hint")
														}, null, 8, [
															"modelValue",
															"onUpdate:modelValue",
															"label",
															"hint"
														]),
														e.path.type === "guide" ? (_(), n(g, {
															key: 0,
															modelValue: e.path.guide,
															"onUpdate:modelValue": (t) => e.path.guide = t,
															label: E(Z)("guide"),
															items: E(J),
															loading: E(oe),
															rules: e.path.type === "guide" ? E(f)() : [],
															required: e.path.type === "guide"
														}, null, 8, [
															"modelValue",
															"onUpdate:modelValue",
															"label",
															"items",
															"loading",
															"rules",
															"required"
														])) : r("", !0),
														e.path.type === "link" ? (_(), n(u, {
															key: 1,
															modelValue: e.path.url,
															"onUpdate:modelValue": (t) => e.path.url = t,
															label: E(Z)("url"),
															rules: e.path.type === "link" ? [...E(f)(), ...E(p)] : [],
															required: e.path.type === "link"
														}, null, 8, [
															"modelValue",
															"onUpdate:modelValue",
															"label",
															"rules",
															"required"
														])) : r("", !0),
														e.path.type === "link" ? (_(), n(D, {
															key: 2,
															modelValue: e.path.target,
															"onUpdate:modelValue": (t) => e.path.target = t,
															label: E(Z)("target"),
															items: W,
															hint: E(Z)("target_hint"),
															clearable: ""
														}, null, 8, [
															"modelValue",
															"onUpdate:modelValue",
															"label",
															"hint"
														])) : r("", !0)
													]),
													_: 2
												}, 1024)]),
												_: 2
											}, 1024)
										]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024))), 128)), c(Q, { cols: "12" }, {
								default: O(() => [c(y, {
									type: "primary",
									variant: "outlined",
									"prepend-icon": "mdi:mdi-plus",
									class: "mt-4",
									onClick: pe
								}, {
									default: O(() => [s(T(E(Z)("add_step")), 1)]),
									_: 1
								})]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}, 8, ["label", "hint"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, hn = {
	__name: "admin-guides",
	props: {},
	setup(n) {
		X(n, "HAdminGuides");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { confirm: s } = ce(), { hAddAlert: l } = q(), u = y(!0), d = y(null), f = {
			term: "",
			slug: "",
			slugMatchType: "contains",
			title: "",
			titleMatchType: "contains",
			name: "",
			nameMatchType: "contains",
			role: [],
			tag: [],
			domain: [],
			modifieddatePreset: null,
			sortBy: "modifieddate",
			sortOrder: "desc",
			page: 1,
			pageSize: 25
		}, p = v({ ...f }), m = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "slug",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("slug_filter"),
					placeholder: Z("slug_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-link-variant",
					defaultMatchType: "contains"
				}
			},
			{
				key: "title",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("title_filter"),
					placeholder: Z("title_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-format-title",
					defaultMatchType: "contains"
				}
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "role",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("role_filter"),
					icon: "mdi:mdi-account-key"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "domain",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("domain_filter"),
					icon: "mdi:mdi-web"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [{
					key: "modifieddate",
					type: "date",
					component: "h-filter-datetime",
					model: "modifieddatePreset",
					props: {
						label: Z("modifieddate_filter"),
						manualSync: !0
					}
				}]
			}
		] }, g = [
			{
				title: "slug",
				key: "slug",
				sortable: !0,
				width: 150,
				value: "slug",
				nowrap: !0,
				translate: !0
			},
			{
				title: "title",
				key: "title",
				align: "start",
				sortable: !0,
				width: 200,
				value: "title",
				nowrap: !1,
				customSortKey: "title.lower",
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 150,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "role",
				key: "role",
				sortable: !0,
				width: 150,
				value: "role",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => P("role", e),
				isFilterActive: (e) => N("role", e)
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => P("tag", e),
				isFilterActive: (e) => N("tag", e)
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 150,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], b = {
			pageKey: "guides",
			pageTitle: Z("admin_guides_title"),
			headerTitle: Z("guides"),
			searchPlaceholder: Z("search_guides"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("guides"),
					text: Z("guides")
				}
			]
		}, { data: x, loading: C, params: w, execute: T, totalResults: D } = G({
			url: "/admin/guides",
			filters: p,
			additionalParams: {}
		}), O = Z("total_guides"), k = t(() => ({ widgets: [{
			summary: !0,
			title: O,
			count: D.value,
			icon: "mdi:mdi-book-open-variant",
			color: "grey-lighten-3",
			iconColor: "grey-darken-4"
		}] }));
		function A() {
			j(!0);
		}
		function j(e = !1) {
			let { query: t, sort: n } = a(m.filters, p);
			w.query = t, w.sort = n, (e || u.value) && T();
		}
		let M = qe(j, 300), { isFilterActive: N, toggleArrayFilter: P } = ue({
			filters: p,
			onFilterChange: M
		});
		function F() {
			return Object.assign(p, { ...f }), j(!0);
		}
		let I = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					d.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					d.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await s({
						title: Z("delete_guide"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = o({
							url: `/admin/guides/${e.slug}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							l({
								title: Z("error_occurred"),
								body: Z("guide_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await T();
					}
				}
			}
		];
		function L() {
			d.value?.open();
		}
		return h(async () => {
			J(p, M), j(), T();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": u.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => u.value = e,
				"page-configuration": b,
				"widgets-config": k.value,
				"filters-config": m,
				filters: p,
				"table-headers": g,
				"table-actions": I,
				"table-params": E(w),
				"table-data": E(x),
				"table-loading": E(C),
				"total-results": E(D),
				"open-form": L,
				onSearch: A,
				onClearFilters: F
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(mn, {
				ref_key: "guideFormRef",
				ref: d,
				onSuccess: E(T)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, gn = { class: "text-headline-small" }, _n = { class: "text-headline-small" }, vn = { class: "text-headline-small" }, yn = {
	__name: "item-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 700
		}
	},
	emits: ["success", "cancel"],
	setup(t, { expose: o, emit: l }) {
		let { hAddAlert: u } = q(), { nameRules: d, idRules: f, objectValueRules: p, requiredRules: m, urlRules: h, integerRules: g } = ie(), { save: x } = ae(), C = (e = !1) => e ? [] : [(e) => !e || /^[a-z0-9A-Z_-]*$/.test(e) || Z("item_key_format")], w = [(e) => !!e || Z("type_required"), (e) => e && /^[a-z0-9_]*$/.test(e) || Z("item_type_format")], k = [(e) => {
			if (e == null || e === "") return !0;
			let t = Number(e);
			return isNaN(t) ? Z("number_invalid") : t < 0 ? Z("price_min_zero") : !0;
		}], A = /^[a-z0-9åäö_$]*$/, j = [...p, (e) => {
			if (!e || String(e).trim() === "") return !0;
			try {
				let t = JSON.parse(e);
				if (t === null || Array.isArray(t) || typeof t != "object") return Z("json_object_required");
				for (let e of Object.keys(t)) if (!A.test(e)) return Z("item_attribute_key_format");
				return !0;
			} catch {
				return Z("json_invalid");
			}
		}], M = [...m(Z("action_url_required")), ...h], N = [...h], P = g({
			min: 1,
			required: !0
		});
		X(t, "HItemForm");
		let F = {
			key: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			type: {
				type: String,
				default: ""
			},
			tag: {
				type: Array,
				default: () => []
			},
			keyword: {
				type: Array,
				default: () => []
			},
			icon: {
				type: String,
				default: ""
			},
			color: {
				type: String,
				default: ""
			},
			status: {
				type: String,
				default: ""
			},
			geolocation: {
				type: String,
				default: ""
			},
			role: {
				type: Array,
				default: () => []
			},
			domain: {
				type: Array,
				default: () => []
			},
			locale: {
				type: Array,
				default: () => []
			},
			owner: {
				type: String,
				default: ""
			},
			unmanaged: {
				type: Boolean,
				default: !1
			},
			attribute: {
				type: String,
				default: ""
			},
			cost: {
				type: Object,
				default: () => ({
					cart: !1,
					price: null,
					payment: null,
					subscription: null,
					pricelist: []
				})
			},
			action: {
				type: Array,
				default: () => []
			},
			attachment: {
				type: Array,
				default: () => []
			}
		}, I = {
			id: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			icon: {
				type: String,
				default: ""
			},
			color: {
				type: String,
				default: ""
			},
			url: {
				type: String,
				default: ""
			},
			order: {
				type: Number,
				default: null
			},
			bulksupported: {
				type: Boolean,
				default: !1
			},
			target: {
				type: String,
				default: ""
			},
			role: {
				type: Array,
				default: () => []
			},
			primary: {
				type: Boolean,
				default: !1
			}
		}, L = {
			id: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			url: {
				type: String,
				default: ""
			},
			type: {
				type: String,
				default: "file"
			},
			meta: {
				type: String,
				default: ""
			},
			role: {
				type: Array,
				default: () => []
			}
		}, R = {
			id: {
				type: String,
				default: ""
			},
			role: {
				type: Array,
				default: () => []
			},
			price: {
				type: Number,
				default: 0
			},
			order: {
				type: Number,
				default: 1
			}
		}, z = () => {
			let e = {};
			return Object.keys(F).forEach((t) => {
				let n = F[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, B = () => {
			let e = {};
			return Object.keys(I).forEach((t) => {
				let n = I[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, V = () => {
			let e = {};
			return Object.keys(L).forEach((t) => {
				let n = L[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, H = () => {
			let e = {};
			return Object.keys(R).forEach((t) => {
				let n = R[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, U = l, ee = y(null), W = y(!1), te = y(!1), ne = y(!1), re = y(null), G = v(z()), J = y(!1), oe = y({}), Y = [
			{
				title: Z("subscription"),
				value: "subscription"
			},
			{
				title: Z("purchase"),
				value: "purchase"
			},
			{
				title: Z("other"),
				value: "other"
			}
		], se = [
			{
				title: Z("monthly"),
				value: "monthly"
			},
			{
				title: Z("quarterly"),
				value: "quarterly"
			},
			{
				title: Z("annual"),
				value: "annual"
			},
			{
				title: Z("other"),
				value: "other"
			}
		], ce = [
			{
				title: "-",
				value: ""
			},
			{
				title: "_self - " + Z("target_self"),
				value: "_self"
			},
			{
				title: "_blank - " + Z("target_blank"),
				value: "_blank"
			},
			{
				title: "_top - " + Z("target_top"),
				value: "_top"
			},
			{
				title: "_modal - " + Z("target_modal"),
				value: "_modal"
			},
			{
				title: "_window - " + Z("target_window"),
				value: "_window"
			}
		], le = [{
			title: "file",
			value: "file"
		}], { data: ue, loading: de } = K({
			url: "/admin/domains",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), { data: fe, loading: pe } = K({
			url: "/admin/roles",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), { data: me, loading: he } = K({
			url: "/admin/users",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.username,
				key: e.username
			}))
		}), { data: ge, loading: _e } = K({
			url: "/admin/locales",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		});
		D(G, () => {
			J.value = JSON.stringify(G) !== JSON.stringify(oe.value);
		}, { deep: !0 }), D(W, (e) => {
			e || ve();
		}), D(() => G.cost.payment, (e) => {
			e !== "subscription" && (G.cost.subscription = null);
		});
		function ve() {
			let e = z();
			Object.keys(e).forEach((t) => {
				G[t] = e[t];
			}), oe.value = JSON.parse(JSON.stringify(G)), ne.value = !1, re.value = null, J.value = !1;
		}
		function ye(e, t = !0) {
			Object.keys(F).forEach((t) => {
				let n = F[t], r = e?.[t], i = r != null;
				if (t === "cost") {
					let e = n.default();
					G[t] = i && typeof r == "object" ? {
						...e,
						...r
					} : e, Array.isArray(G[t].pricelist) || (G[t].pricelist = []);
				} else t === "attribute" ? i && typeof r == "object" ? G[t] = JSON.stringify(r, null, 2) : i && typeof r == "string" ? G[t] = r : G[t] = "" : n.type === Array ? G[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : n.type === Boolean ? G[t] = i ? !!r : typeof n.default == "function" ? n.default() : n.default : (n.type === String || n.type, G[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), t || (G.key = ""), oe.value = JSON.parse(JSON.stringify(G)), ne.value = t, re.value = t && e?.key || null, J.value = !t;
		}
		async function xe() {
			if (!te.value && ((await ee.value?.validate())?.valid ?? !0)) {
				te.value = !0;
				try {
					await we(Ce()), U("success"), W.value = !1;
				} catch (e) {
					u({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					te.value = !1;
				}
			}
		}
		function Se(e) {
			let t = {}, n = [
				"action",
				"attachment",
				"attribute",
				"tag"
			], r = [
				"description",
				"keyword",
				"icon",
				"owner",
				"role",
				"domain",
				"locale"
			];
			for (let [i, a] of Object.entries(e)) if (a !== void 0) {
				if (n.includes(i)) {
					t[i] = a;
					continue;
				}
				if (r.includes(i) && a === null) {
					t[i] = null;
					continue;
				}
				if (!(a === null || a === "")) {
					if (typeof a == "object" && !Array.isArray(a)) {
						let e = {};
						for (let [t, n] of Object.entries(a)) n != null && n !== "" && !(Array.isArray(n) && n.length === 0) && (e[t] = n);
						Object.keys(e).length > 0 && (t[i] = e);
						continue;
					}
					t[i] = a;
				}
			}
			return t;
		}
		function Ce() {
			let e = (e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [], t = e(G.tag), n = e(G.keyword), r = e(G.role, (e) => typeof e == "string" ? e.toLowerCase().trim() : e), i = e(G.domain), a = e(G.locale), o = null;
			if (G.attribute) try {
				o = JSON.parse(G.attribute.trim());
			} catch {
				o = null;
			}
			let s = null;
			(G.cost.cart || G.cost.price !== null || G.cost.payment || G.cost.pricelist?.length > 0) && (s = {
				...G.cost.cart && { cart: !0 },
				...G.cost.price !== null && G.cost.price !== "" && { price: Number(G.cost.price) },
				...G.cost.payment && { payment: G.cost.payment },
				...G.cost.payment === "subscription" && G.cost.subscription && { subscription: G.cost.subscription },
				...G.cost.pricelist?.length > 0 && { pricelist: G.cost.pricelist.filter((e) => e.role?.length > 0 && e.order !== null && e.order !== void 0 && e.order !== "").map((t) => ({
					...t.id && { id: t.id },
					role: e(t.role),
					price: Number(t.price) || 0,
					order: Number(t.order)
				})) }
			}, Object.keys(s).length === 0 && (s = null));
			let c = Array.isArray(G.action) ? G.action.filter((e) => e && typeof e == "object" && e.name).map((t) => {
				let n = { name: String(t.name).trim() };
				return t.id && (n.id = String(t.id)), t.description && (n.description = String(t.description).trim()), t.icon && (n.icon = String(t.icon).trim()), t.color && (n.color = String(t.color).trim()), t.url && (n.url = String(t.url).trim()), t.order !== null && t.order !== void 0 && t.order !== "" && (n.order = Number(t.order)), t.bulksupported && (n.bulksupported = !0), t.target && (n.target = t.target), t.role?.length > 0 && (n.role = e(t.role)), t.primary && (n.primary = !0), n;
			}) : [], l = Array.isArray(G.attachment) ? G.attachment.filter((e) => e && typeof e == "object" && e.name && e.url).map((t) => {
				let n = {
					name: String(t.name).trim(),
					url: String(t.url).trim(),
					type: t.type || "file"
				};
				return t.id && (n.id = String(t.id)), t.meta && (n.meta = String(t.meta).trim()), t.role?.length > 0 && (n.role = e(t.role)), n;
			}) : [];
			return Se({
				key: G.key?.trim() || null,
				name: G.name?.trim() || null,
				type: G.type?.trim() || null,
				tag: t.length > 0 ? t : [],
				description: G.description?.trim() || null,
				keyword: n.length > 0 ? n : null,
				icon: G.icon?.trim() || null,
				owner: G.owner?.trim() || null,
				role: r.length > 0 ? r : null,
				domain: i.length > 0 ? i : null,
				locale: a.length > 0 ? a : null,
				color: G.color?.trim() || void 0,
				status: G.status?.trim() || void 0,
				geolocation: G.geolocation?.trim() || void 0,
				unmanaged: G.unmanaged || void 0,
				attribute: o || {},
				cost: s,
				action: c,
				attachment: l
			});
		}
		async function we(e) {
			let t = ne.value ? "update" : "create", n = {
				create: "/admin/items?refresh=true",
				update: `/admin/items/${re.value}?refresh=true`
			}, r = {
				create: "post",
				update: "put"
			}, i = {
				error: {
					create: "item_create_error",
					update: "item_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			}, a = t === "update" ? (({ key: e, ...t }) => t)(e) : e;
			if (!(await x({
				url: n[t],
				method: r[t],
				payload: a
			}))?.ok) throw Error(Z(i.error[t]));
			u({
				title: Z(i.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function Te() {
			U("cancel"), W.value = !1;
		}
		function De() {
			G.action ||= [], G.action.push(B());
		}
		function Oe(e) {
			G.action.splice(e, 1);
		}
		function ke() {
			G.attachment ||= [], G.attachment.push(V());
		}
		function Ae(e) {
			G.attachment.splice(e, 1);
		}
		function je() {
			G.cost.pricelist || (G.cost.pricelist = []), G.cost.pricelist.push(H());
		}
		function Me(e) {
			G.cost.pricelist.splice(e, 1);
		}
		function Ne(e = null) {
			e ? ye(e) : ve(), W.value = !0;
		}
		function Pe(e) {
			ye(e, !1), W.value = !0;
		}
		return o({
			validate: () => ee.value?.validate(),
			reset: () => ee.value?.reset(),
			resetValidation: () => ee.value?.resetValidation(),
			formData: G,
			open: Ne,
			openCopy: Pe
		}), (o, l) => {
			let u = S("h-form-text"), p = S("h-form-textarea"), g = S("h-form-combobox"), v = S("h-form-autocomplete"), y = S("h-form-switch"), x = S("h-form-select"), D = S("h-action-button"), A = S("h-form-field"), F = S("h-form-layout");
			return _(), n(F, {
				ref_key: "formRef",
				ref: ee,
				modelValue: W.value,
				"onUpdate:modelValue": l[20] ||= (e) => W.value = e,
				loading: te.value,
				"bg-color": t.bgColor,
				"header-text": ne.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": t.drawerWidth,
				"has-changes": J.value,
				onSubmit: xe,
				onCancel: Te
			}, {
				default: O(() => [
					c(u, {
						modelValue: G.key,
						"onUpdate:modelValue": l[0] ||= (e) => G.key = e,
						icon: "mdi:mdi-key",
						label: E(Z)("key"),
						rules: C(ne.value),
						disabled: ne.value,
						hint: E(Z)("item_key_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"disabled",
						"hint"
					]),
					c(u, {
						modelValue: G.name,
						"onUpdate:modelValue": l[1] ||= (e) => G.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: E(d),
						hint: E(Z)("item_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(p, {
						modelValue: G.description,
						"onUpdate:modelValue": l[2] ||= (e) => G.description = e,
						label: E(Z)("description"),
						icon: "mdi:mdi-text",
						hint: E(Z)("item_description_hint"),
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3"
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(u, {
						modelValue: G.type,
						"onUpdate:modelValue": l[3] ||= (e) => G.type = e,
						icon: "mdi:mdi-shape",
						label: E(Z)("type"),
						rules: w,
						hint: E(Z)("item_type_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(g, {
						modelValue: G.tag,
						"onUpdate:modelValue": l[4] ||= (e) => G.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						rules: E(m)(E(Z)("tag_required")),
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "],
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules"
					]),
					c(g, {
						modelValue: G.keyword,
						"onUpdate:modelValue": l[5] ||= (e) => G.keyword = e,
						icon: "mdi:mdi-key-chain",
						label: E(Z)("keywords"),
						items: [],
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "],
						hint: E(Z)("item_keyword_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(u, {
						modelValue: G.icon,
						"onUpdate:modelValue": l[6] ||= (e) => G.icon = e,
						icon: "mdi:mdi-image-outline",
						label: E(Z)("icon"),
						hint: E(Z)("item_icon_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(u, {
						modelValue: G.color,
						"onUpdate:modelValue": l[7] ||= (e) => G.color = e,
						icon: "mdi:mdi-palette",
						label: E(Z)("color"),
						hint: E(Z)("item_color_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(u, {
						modelValue: G.status,
						"onUpdate:modelValue": l[8] ||= (e) => G.status = e,
						icon: "mdi:mdi-alert-circle",
						label: E(Z)("status"),
						hint: E(Z)("item_status_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(u, {
						modelValue: G.geolocation,
						"onUpdate:modelValue": l[9] ||= (e) => G.geolocation = e,
						icon: "mdi:mdi-map-marker",
						label: E(Z)("geolocation"),
						hint: E(Z)("item_geolocation_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(v, {
						modelValue: G.role,
						"onUpdate:modelValue": l[10] ||= (e) => G.role = e,
						icon: "mdi:mdi-account-key",
						label: E(Z)("roles"),
						items: E(fe),
						loading: E(pe),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading"
					]),
					c(v, {
						modelValue: G.domain,
						"onUpdate:modelValue": l[11] ||= (e) => G.domain = e,
						icon: "mdi:mdi-domain",
						label: E(Z)("domains"),
						items: E(ue),
						loading: E(de),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading"
					]),
					c(v, {
						modelValue: G.locale,
						"onUpdate:modelValue": l[12] ||= (e) => G.locale = e,
						icon: "mdi:mdi-translate",
						label: E(Z)("locales"),
						items: E(ge),
						loading: E(_e),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading"
					]),
					c(v, {
						modelValue: G.owner,
						"onUpdate:modelValue": l[13] ||= (e) => G.owner = e,
						icon: "mdi:mdi-account",
						label: E(Z)("owner"),
						items: E(me),
						loading: E(he),
						hint: E(Z)("item_owner_hint"),
						clearable: ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint"
					]),
					c(y, {
						modelValue: G.unmanaged,
						"onUpdate:modelValue": l[14] ||= (e) => G.unmanaged = e,
						icon: G.unmanaged ? "mdi:mdi-cog-off" : "mdi:mdi-cog",
						label: E(Z)("unmanaged"),
						hint: E(Z)("item_unmanaged_hint")
					}, null, 8, [
						"modelValue",
						"icon",
						"label",
						"hint"
					]),
					c(E(Ee), {
						modelValue: G.attribute,
						"onUpdate:modelValue": l[15] ||= (e) => G.attribute = e,
						language: "json",
						icon: "mdi:mdi-code-json",
						label: E(Z)("attribute"),
						rules: j,
						hint: E(Z)("item_attribute_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(A, {
						icon: "mdi:mdi-currency-usd",
						label: E(Z)("cost"),
						hint: E(Z)("item_cost_hint"),
						indent: ""
					}, {
						default: O(() => [c($, null, {
							default: O(() => [
								c(Q, { cols: "12" }, {
									default: O(() => [c(y, {
										modelValue: G.cost.cart,
										"onUpdate:modelValue": l[16] ||= (e) => G.cost.cart = e,
										icon: G.cost.cart ? "mdi:mdi-cart" : "mdi:mdi-cart-off",
										label: E(Z)("cart"),
										hint: E(Z)("item_cart_hint")
									}, null, 8, [
										"modelValue",
										"icon",
										"label",
										"hint"
									])]),
									_: 1
								}),
								c(Q, { cols: "12" }, {
									default: O(() => [c(u, {
										modelValue: G.cost.price,
										"onUpdate:modelValue": l[17] ||= (e) => G.cost.price = e,
										type: "number",
										icon: "mdi:mdi-cash",
										label: E(Z)("price"),
										rules: k,
										hint: E(Z)("item_price_hint")
									}, null, 8, [
										"modelValue",
										"label",
										"hint"
									])]),
									_: 1
								}),
								c(Q, { cols: "12" }, {
									default: O(() => [c(x, {
										modelValue: G.cost.payment,
										"onUpdate:modelValue": l[18] ||= (e) => G.cost.payment = e,
										icon: "mdi:mdi-credit-card",
										label: E(Z)("payment"),
										items: Y,
										hint: E(Z)("item_payment_hint"),
										clearable: ""
									}, null, 8, [
										"modelValue",
										"label",
										"hint"
									])]),
									_: 1
								}),
								G.cost.payment === "subscription" ? (_(), n(Q, {
									key: 0,
									cols: "12"
								}, {
									default: O(() => [c(x, {
										modelValue: G.cost.subscription,
										"onUpdate:modelValue": l[19] ||= (e) => G.cost.subscription = e,
										icon: "mdi:mdi-calendar-sync",
										label: E(Z)("subscription"),
										items: se,
										hint: E(Z)("item_subscription_hint")
									}, null, 8, [
										"modelValue",
										"label",
										"hint"
									])]),
									_: 1
								})) : r("", !0),
								c(Q, { cols: "12" }, {
									default: O(() => [c(A, {
										icon: "mdi:mdi-format-list-bulleted",
										label: E(Z)("pricelist"),
										hint: E(Z)("item_pricelist_hint")
									}, {
										default: O(() => [c($, null, {
											default: O(() => [(_(!0), i(e, null, b(G.cost.pricelist, (e, t) => (_(), n(Q, {
												key: t,
												cols: "12",
												class: "mb-2 ga-4 pa-6"
											}, {
												default: O(() => [c($, { class: "align-center" }, {
													default: O(() => [
														c(Q, {
															cols: "auto",
															class: "d-flex align-center"
														}, {
															default: O(() => [c(ze, {
																icon: "mdi:mdi-cash-multiple",
																class: "mr-2"
															}), a("span", gn, T(E(Z)("pricelist_item")) + " #" + T(t + 1), 1)]),
															_: 2
														}, 1024),
														c(be),
														c(Q, { cols: "auto" }, {
															default: O(() => [c(D, {
																icon: "mdi:mdi-delete",
																variant: "text",
																color: "error",
																onClick: (e) => Me(t)
															}, null, 8, ["onClick"])]),
															_: 2
														}, 1024)
													]),
													_: 2
												}, 1024), c($, { class: "d-flex flex-column" }, {
													default: O(() => [c(Q, { class: "d-flex flex-column pt-0 ga-4" }, {
														default: O(() => [
															c(u, {
																modelValue: e.id,
																"onUpdate:modelValue": (t) => e.id = t,
																label: E(Z)("id"),
																rules: E(f)(E(Z)("action_id_format"))
															}, null, 8, [
																"modelValue",
																"onUpdate:modelValue",
																"label",
																"rules"
															]),
															c(v, {
																modelValue: e.role,
																"onUpdate:modelValue": (t) => e.role = t,
																label: E(Z)("roles"),
																items: E(fe),
																loading: E(pe),
																rules: E(m)(E(Z)("role_required")),
																multiple: "",
																chips: "",
																"closable-chips": "",
																required: ""
															}, null, 8, [
																"modelValue",
																"onUpdate:modelValue",
																"label",
																"items",
																"loading",
																"rules"
															]),
															c(u, {
																modelValue: e.price,
																"onUpdate:modelValue": (t) => e.price = t,
																type: "number",
																label: E(Z)("price"),
																rules: k
															}, null, 8, [
																"modelValue",
																"onUpdate:modelValue",
																"label"
															]),
															c(u, {
																modelValue: e.order,
																"onUpdate:modelValue": (t) => e.order = t,
																type: "number",
																label: E(Z)("order"),
																rules: E(P),
																required: ""
															}, null, 8, [
																"modelValue",
																"onUpdate:modelValue",
																"label",
																"rules"
															])
														]),
														_: 2
													}, 1024)]),
													_: 2
												}, 1024)]),
												_: 2
											}, 1024))), 128)), c(Q, { cols: "12" }, {
												default: O(() => [c(D, {
													type: "primary",
													variant: "outlined",
													"prepend-icon": "mdi:mdi-plus",
													class: "mt-4",
													onClick: je
												}, {
													default: O(() => [s(T(E(Z)("add_pricelist_item")), 1)]),
													_: 1
												})]),
												_: 1
											})]),
											_: 1
										})]),
										_: 1
									}, 8, ["label", "hint"])]),
									_: 1
								})
							]),
							_: 1
						})]),
						_: 1
					}, 8, ["label", "hint"]),
					c(A, {
						icon: "mdi:mdi-link",
						label: E(Z)("actions"),
						hint: E(Z)("item_actions_hint")
					}, {
						default: O(() => [c($, null, {
							default: O(() => [(_(!0), i(e, null, b(G.action, (e, t) => (_(), n(Q, {
								key: t,
								cols: "12",
								class: "mb-2 ga-4 pa-6"
							}, {
								default: O(() => [c($, { class: "align-center" }, {
									default: O(() => [
										c(Q, {
											cols: "auto",
											class: "d-flex align-center"
										}, {
											default: O(() => [c(ze, {
												icon: "mdi:mdi-link-variant",
												class: "mr-2"
											}), a("span", _n, T(E(Z)("action")) + " #" + T(t + 1), 1)]),
											_: 2
										}, 1024),
										c(be),
										c(Q, { cols: "auto" }, {
											default: O(() => [c(D, {
												icon: "mdi:mdi-delete",
												variant: "text",
												color: "error",
												onClick: (e) => Oe(t)
											}, null, 8, ["onClick"])]),
											_: 2
										}, 1024)
									]),
									_: 2
								}, 1024), c($, { class: "d-flex flex-column" }, {
									default: O(() => [c(Q, { class: "d-flex flex-column pt-0 ga-4" }, {
										default: O(() => [
											c(u, {
												modelValue: e.id,
												"onUpdate:modelValue": (t) => e.id = t,
												label: E(Z)("id"),
												rules: E(f)(E(Z)("action_id_format")),
												hint: E(Z)("item_action_id_hint")
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"rules",
												"hint"
											]),
											c(u, {
												modelValue: e.name,
												"onUpdate:modelValue": (t) => e.name = t,
												label: E(Z)("name"),
												rules: E(m)(E(Z)("action_name_required")),
												required: ""
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"rules"
											]),
											c(u, {
												modelValue: e.description,
												"onUpdate:modelValue": (t) => e.description = t,
												label: E(Z)("description")
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label"
											]),
											c(u, {
												modelValue: e.icon,
												"onUpdate:modelValue": (t) => e.icon = t,
												label: E(Z)("icon")
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label"
											]),
											c(u, {
												modelValue: e.color,
												"onUpdate:modelValue": (t) => e.color = t,
												label: E(Z)("color")
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label"
											]),
											c(u, {
												modelValue: e.url,
												"onUpdate:modelValue": (t) => e.url = t,
												label: E(Z)("url"),
												rules: ne.value ? N : M,
												required: !ne.value
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"rules",
												"required"
											]),
											c(u, {
												modelValue: e.order,
												"onUpdate:modelValue": (t) => e.order = t,
												label: E(Z)("order"),
												type: "number"
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label"
											]),
											c(y, {
												modelValue: e.bulksupported,
												"onUpdate:modelValue": (t) => e.bulksupported = t,
												label: E(Z)("bulksupported"),
												hint: E(Z)("item_bulksupported_hint")
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"hint"
											]),
											c(x, {
												modelValue: e.target,
												"onUpdate:modelValue": (t) => e.target = t,
												label: E(Z)("target"),
												items: ce,
												hint: E(Z)("item_target_hint")
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"hint"
											]),
											c(v, {
												modelValue: e.role,
												"onUpdate:modelValue": (t) => e.role = t,
												label: E(Z)("roles"),
												items: E(fe),
												loading: E(pe),
												multiple: "",
												chips: "",
												"closable-chips": ""
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"items",
												"loading"
											]),
											c(y, {
												modelValue: e.primary,
												"onUpdate:modelValue": (t) => e.primary = t,
												label: E(Z)("primary_action"),
												hint: E(Z)("item_primary_action_hint")
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"hint"
											])
										]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024))), 128)), c(Q, { cols: "12" }, {
								default: O(() => [c(D, {
									type: "primary",
									variant: "outlined",
									"prepend-icon": "mdi:mdi-plus",
									class: "mt-4",
									onClick: De
								}, {
									default: O(() => [s(T(E(Z)("add_action")), 1)]),
									_: 1
								})]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}, 8, ["label", "hint"]),
					c(A, {
						icon: "mdi:mdi-attachment",
						label: E(Z)("attachments"),
						hint: E(Z)("item_attachments_hint")
					}, {
						default: O(() => [c($, null, {
							default: O(() => [(_(!0), i(e, null, b(G.attachment, (e, t) => (_(), n(Q, {
								key: t,
								cols: "12",
								class: "mb-2 ga-4 pa-6"
							}, {
								default: O(() => [c($, { class: "align-center" }, {
									default: O(() => [
										c(Q, {
											cols: "auto",
											class: "d-flex align-center"
										}, {
											default: O(() => [c(ze, {
												icon: "mdi:mdi-file",
												class: "mr-2"
											}), a("span", vn, T(E(Z)("attachment")) + " #" + T(t + 1), 1)]),
											_: 2
										}, 1024),
										c(be),
										c(Q, { cols: "auto" }, {
											default: O(() => [c(D, {
												icon: "mdi:mdi-delete",
												variant: "text",
												color: "error",
												onClick: (e) => Ae(t)
											}, null, 8, ["onClick"])]),
											_: 2
										}, 1024)
									]),
									_: 2
								}, 1024), c($, { class: "d-flex flex-column" }, {
									default: O(() => [c(Q, { class: "d-flex flex-column pt-0 ga-4" }, {
										default: O(() => [
											c(u, {
												modelValue: e.id,
												"onUpdate:modelValue": (t) => e.id = t,
												label: E(Z)("id"),
												rules: E(f)(E(Z)("action_id_format"))
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"rules"
											]),
											c(u, {
												modelValue: e.name,
												"onUpdate:modelValue": (t) => e.name = t,
												label: E(Z)("name"),
												rules: E(m)(E(Z)("action_name_required")),
												required: ""
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"rules"
											]),
											c(u, {
												modelValue: e.url,
												"onUpdate:modelValue": (t) => e.url = t,
												label: E(Z)("url"),
												rules: [...E(m)(E(Z)("action_url_required")), ...E(h)],
												required: ""
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"rules"
											]),
											c(x, {
												modelValue: e.type,
												"onUpdate:modelValue": (t) => e.type = t,
												label: E(Z)("type"),
												items: le
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label"
											]),
											c(u, {
												modelValue: e.meta,
												"onUpdate:modelValue": (t) => e.meta = t,
												label: E(Z)("meta")
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label"
											]),
											c(v, {
												modelValue: e.role,
												"onUpdate:modelValue": (t) => e.role = t,
												label: E(Z)("roles"),
												items: E(fe),
												loading: E(pe),
												multiple: "",
												chips: "",
												"closable-chips": ""
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"items",
												"loading"
											])
										]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024))), 128)), c(Q, { cols: "12" }, {
								default: O(() => [c(D, {
									type: "primary",
									variant: "outlined",
									"prepend-icon": "mdi:mdi-plus",
									class: "mt-4",
									onClick: ke
								}, {
									default: O(() => [s(T(E(Z)("add_attachment")), 1)]),
									_: 1
								})]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}, 8, ["label", "hint"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, bn = {
	__name: "admin-items",
	props: {},
	setup(n) {
		X(n, "HAdminItems");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { hAddAlert: l } = q(), { confirm: u } = ce(), d = y(!0), f = y(null), p = y(!1), m = y({}), g = t(() => ({
			title: m.value?.name || m.value?.key || "",
			key: m.value?.key
		})), b = t(() => JSON.stringify(m.value ?? {}, null, 2)), x = {
			term: "",
			key: "",
			keyMatchType: "contains",
			name: "",
			nameMatchType: "contains",
			status: "",
			statusMatchType: "contains",
			role: [],
			tag: [],
			type: "",
			typeMatchType: "contains",
			domain: [],
			unmanaged: null,
			createdatePreset: null,
			modifieddatePreset: null,
			sortBy: "createdate",
			sortOrder: "desc",
			page: 1,
			pageSize: 25
		}, C = v({ ...x }), w = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "key",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("key_filter"),
					placeholder: Z("key_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-key",
					defaultMatchType: "contains"
				}
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "status",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("status_filter"),
					placeholder: Z("status_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alert-circle",
					defaultMatchType: "contains"
				}
			},
			{
				key: "role",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("role_filter"),
					icon: "mdi:mdi-account-key"
				}
			},
			{
				key: "type",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("type_filter"),
					placeholder: Z("type_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-shape",
					defaultMatchType: "contains"
				}
			},
			{
				key: "domain",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("domain_filter"),
					icon: "mdi:mdi-domain"
				}
			},
			{
				key: "unmanaged",
				type: "boolean"
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [{
					key: "createdate",
					type: "date",
					component: "h-filter-datetime",
					model: "createdatePreset",
					props: {
						label: Z("createdate_filter"),
						manualSync: !0
					}
				}, {
					key: "modifieddate",
					type: "date",
					component: "h-filter-datetime",
					model: "modifieddatePreset",
					props: {
						label: Z("modifieddate_filter"),
						minDatePresetFilter: C.createdatePreset,
						manualSync: !0
					}
				}]
			}
		] }, D = [
			{
				title: "key",
				key: "key",
				sortable: !0,
				width: 150,
				value: "key",
				nowrap: !0,
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 200,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !1,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => H("tag", e),
				isFilterActive: (e) => B("tag", e)
			},
			{
				title: "status",
				key: "status",
				sortable: !0,
				width: 120,
				value: "status",
				nowrap: !0,
				customSortKey: "status.lower",
				translate: !0,
				filterOnClick: (e) => V("status", e.status, "exact"),
				isFilterActive: (e) => B("status", e.status, "exact")
			},
			{
				title: "role",
				key: "role",
				sortable: !0,
				width: 150,
				value: "role",
				nowrap: !1,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => H("role", e),
				isFilterActive: (e) => B("role", e)
			},
			{
				title: "type",
				key: "type",
				sortable: !0,
				width: 120,
				value: "type",
				nowrap: !0,
				customSortKey: "type.lower",
				translate: !0,
				filterOnClick: (e) => V("type", e.type, "exact"),
				isFilterActive: (e) => B("type", e.type, "exact")
			},
			{
				title: "createdate",
				key: "createdate",
				sortable: !0,
				width: 150,
				value: "createdate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 150,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], k = {
			pageKey: "items",
			pageTitle: Z("admin_items_title"),
			headerTitle: Z("admin_items_title"),
			searchPlaceholder: Z("search_items"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("items"),
					text: Z("items")
				}
			]
		}, { data: A, loading: j, params: M, execute: N, totalResults: P } = G({
			url: "/admin/items",
			filters: C,
			additionalParams: {}
		}), F = Z("total_items"), I = t(() => ({ widgets: [{
			summary: !0,
			title: F,
			count: P.value,
			icon: "mdi:mdi-database",
			color: "blue-grey-lighten-3",
			iconColor: "blue-grey-darken-4"
		}] }));
		function L() {
			R(!0);
		}
		function R(e = !1) {
			let { query: t, sort: n } = a(w.filters, C);
			M.query = t, M.sort = n, (e || d.value) && N();
		}
		let z = qe(R, 300), { isFilterActive: B, toggleFilter: V, toggleArrayFilter: H } = ue({
			filters: C,
			onFilterChange: z
		});
		function U() {
			return Object.assign(C, { ...x }), R(!0);
		}
		let ee = [
			{
				icon: "mdi:mdi-content-copy",
				label: Z("copy"),
				color: "neutral-70",
				action: (e) => f.value?.openCopy(e)
			},
			{
				icon: "mdi:mdi-pencil",
				label: Z("edit"),
				color: "neutral-70",
				action: (e) => f.value?.open(e)
			},
			{
				icon: "mdi:mdi-code-tags",
				label: Z("view_raw_data"),
				color: "neutral-70",
				action: (e) => {
					m.value = e, p.value = !0;
				}
			},
			{
				icon: "mdi:mdi-delete",
				label: Z("delete"),
				color: "neutral-70",
				action: (e) => te(e)
			}
		];
		function W() {
			f.value?.open();
		}
		async function te(e) {
			(await u({
				title: Z("confirm_delete"),
				message: Z("confirm_delete_item_message", { name: e.name }),
				confirmText: Z("delete"),
				cancelText: Z("cancel")
			})).confirmed && await ne(e);
		}
		async function ne(e) {
			try {
				if ((await o({
					url: `/admin/items/${e.key}?refresh=true`,
					method: "DELETE",
					immediate: !1
				}).execute())?.ok) l({
					title: Z("deleted_success"),
					type: "success",
					timeout: 3e3
				}), N();
				else throw Error(Z("item_delete_error"));
			} catch (e) {
				l({
					title: Z("error_occurred"),
					body: e.message,
					type: "error",
					timeout: 5e3
				});
			}
		}
		return h(async () => {
			J(C, z), R(), N();
		}), (t, n) => {
			let r = S("h-admin-template"), a = S("h-view-code-dialog");
			return _(), i(e, null, [
				c(r, {
					"auto-search-enabled": d.value,
					"onUpdate:autoSearchEnabled": n[0] ||= (e) => d.value = e,
					"page-configuration": k,
					"widgets-config": I.value,
					"filters-config": w,
					filters: C,
					"table-headers": D,
					"table-params": E(M),
					"table-data": E(A),
					"table-loading": E(j),
					"total-results": E(P),
					"table-actions": ee,
					"open-form": W,
					onSearch: L,
					onClearFilters: U
				}, null, 8, [
					"auto-search-enabled",
					"widgets-config",
					"filters",
					"table-params",
					"table-data",
					"table-loading",
					"total-results"
				]),
				c(yn, {
					ref_key: "itemFormRef",
					ref: f,
					onSuccess: E(N)
				}, null, 8, ["onSuccess"]),
				c(a, {
					modelValue: p.value,
					"onUpdate:modelValue": n[1] ||= (e) => p.value = e,
					item: g.value,
					"field-name": "key",
					"field-label": E(Z)("key")
				}, {
					"raw-json": O(() => [s(T(b.value), 1)]),
					_: 1
				}, 8, [
					"modelValue",
					"item",
					"field-label"
				])
			], 64);
		};
	}
}, xn = { class: "text-headline-small" }, Sn = {
	__name: "option-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 600
		}
	},
	emits: ["success", "cancel"],
	setup(t, { expose: r, emit: o }) {
		let { hAddAlert: l } = q(), { keyRules: u, nameRules: d, requiredRules: f } = ie(), { save: p } = ae(), m = [];
		X(t, "HOptionForm");
		let h = {
			key: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			value: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			role: {
				type: Array,
				default: () => []
			},
			tag: {
				type: Array,
				default: () => []
			},
			domain: {
				type: Array,
				default: () => []
			},
			locale: {
				type: Array,
				default: () => []
			},
			meta: {
				type: Array,
				default: () => []
			}
		}, g = {
			key: {
				type: String,
				default: ""
			},
			value: {
				type: String,
				default: ""
			}
		}, x = () => {
			let e = {};
			return Object.keys(h).forEach((t) => {
				let n = h[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, C = () => {
			let e = {};
			return Object.keys(g).forEach((t) => {
				let n = g[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, w = o, k = y(null), A = y(!1), j = y(!1), M = y(!1), N = y(null), P = v(x()), F = y(!1), I = y({}), { data: L, loading: R } = K({
			url: "/admin/roles",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), { data: z, loading: B } = K({
			url: "/admin/domains",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), { data: V, loading: H } = K({
			url: "/admin/locales",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		});
		D(A, (e) => {
			e || U();
		}), D(P, () => {
			F.value = JSON.stringify(P) !== JSON.stringify(I.value);
		}, { deep: !0 });
		function U() {
			let e = x();
			Object.keys(e).forEach((t) => {
				P[t] = e[t];
			}), I.value = JSON.parse(JSON.stringify(P)), M.value = !1, N.value = null, F.value = !1;
		}
		function ee(e, t = !0) {
			Object.keys(h).forEach((t) => {
				let n = h[t], r = e?.[t], i = r != null;
				t === "meta" ? i && typeof r == "object" && !Array.isArray(r) ? P[t] = Object.entries(r).map(([e, t]) => ({
					key: e,
					value: t
				})) : P[t] = typeof n.default == "function" ? n.default() : n.default : n.type === Array ? P[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : n.type === Boolean ? P[t] = i ? !!r : typeof n.default == "function" ? n.default() : n.default : (n.type === String || n.type, P[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), t || (P.key = ""), I.value = JSON.parse(JSON.stringify(P)), M.value = t, N.value = t && e?.key || null, F.value = !t;
		}
		async function W() {
			if (!j.value && ((await k.value?.validate())?.valid ?? !0)) {
				j.value = !0;
				try {
					await re(ne()), w("success"), A.value = !1;
				} catch (e) {
					l({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					j.value = !1;
				}
			}
		}
		function te(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) r === null || r === "" || Array.isArray(r) && r.length === 0 || (t[n] = r);
			return t;
		}
		function ne() {
			let e = (e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [], t = e(P.role, (e) => typeof e == "string" ? e.toLowerCase().trim() : e), n = e(P.tag), r = e(P.domain), i = e(P.locale), a = null;
			return Array.isArray(P.meta) && P.meta.length > 0 && (a = {}, P.meta.forEach((e) => {
				e.key && e.key.trim() && (a[e.key.trim()] = e.value || "");
			}), Object.keys(a).length === 0 && (a = null)), te({
				key: P.key?.trim() || null,
				name: P.name?.trim() || null,
				value: P.value?.trim() || null,
				description: P.description?.trim() || null,
				role: t,
				tag: n,
				domain: r,
				locale: i,
				meta: a
			});
		}
		async function re(e) {
			let t = M.value ? "update" : "create", n = {
				create: "/admin/options",
				update: `/admin/options/${N.value}`
			}, r = {
				create: "post",
				update: "put"
			}, i = {
				error: {
					create: "option_create_error",
					update: "option_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			}, a = t === "update" ? (({ key: e, ...t }) => t)(e) : e;
			if (!(await p({
				url: n[t],
				method: r[t],
				payload: a
			}))?.ok) throw Error(Z(i.error[t]));
			l({
				title: Z(i.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function G() {
			w("cancel"), A.value = !1;
		}
		function J() {
			P.meta ||= [], P.meta.push(C());
		}
		function oe(e) {
			P.meta.splice(e, 1);
		}
		function Y(e = null) {
			e && ee(e), A.value = !0;
		}
		function se(e) {
			ee(e, !1), A.value = !0;
		}
		return r({
			validate: () => k.value?.validate(),
			reset: () => k.value?.reset(),
			resetValidation: () => k.value?.resetValidation(),
			formData: P,
			open: Y,
			openCopy: se
		}), (r, o) => {
			let l = S("h-form-text"), p = S("h-form-textarea"), h = S("h-form-autocomplete"), g = S("h-form-combobox"), v = S("h-action-button"), y = S("h-form-field"), x = S("h-form-layout");
			return _(), n(x, {
				ref_key: "formRef",
				ref: k,
				modelValue: A.value,
				"onUpdate:modelValue": o[8] ||= (e) => A.value = e,
				loading: j.value,
				"bg-color": t.bgColor,
				"header-text": M.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": t.drawerWidth,
				"has-changes": F.value,
				onSubmit: W,
				onCancel: G
			}, {
				default: O(() => [
					c(l, {
						modelValue: P.key,
						"onUpdate:modelValue": o[0] ||= (e) => P.key = e,
						icon: "mdi:mdi-key",
						label: E(Z)("key"),
						rules: M.value ? [] : E(u)(!1),
						disabled: M.value,
						hint: E(Z)("option_key_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"disabled",
						"hint"
					]),
					c(l, {
						modelValue: P.name,
						"onUpdate:modelValue": o[1] ||= (e) => P.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: E(d),
						hint: E(Z)("option_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(l, {
						modelValue: P.value,
						"onUpdate:modelValue": o[2] ||= (e) => P.value = e,
						icon: "mdi:mdi-text-short",
						label: E(Z)("value"),
						rules: [...E(f)()],
						hint: E(Z)("option_value_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(p, {
						modelValue: P.description,
						"onUpdate:modelValue": o[3] ||= (e) => P.description = e,
						label: E(Z)("description"),
						hint: E(Z)("option_description_hint"),
						icon: "mdi:mdi-text",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3"
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(h, {
						modelValue: P.role,
						"onUpdate:modelValue": o[4] ||= (e) => P.role = e,
						icon: "mdi:mdi-account-key",
						label: E(Z)("roles"),
						items: E(L),
						loading: E(R),
						hint: E(Z)("option_role_hint"),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint"
					]),
					c(g, {
						modelValue: P.tag,
						"onUpdate:modelValue": o[5] ||= (e) => P.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						rules: [...E(f)()],
						hint: E(Z)("option_tag_hint"),
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						required: "",
						delimiters: [",", " "]
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(h, {
						modelValue: P.domain,
						"onUpdate:modelValue": o[6] ||= (e) => P.domain = e,
						icon: "mdi:mdi-domain",
						label: E(Z)("domains"),
						items: E(z),
						loading: E(B),
						hint: E(Z)("option_domain_hint"),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint"
					]),
					c(h, {
						modelValue: P.locale,
						"onUpdate:modelValue": o[7] ||= (e) => P.locale = e,
						icon: "mdi:mdi-translate",
						label: E(Z)("locales"),
						items: E(V),
						loading: E(H),
						hint: E(Z)("option_locale_hint"),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint"
					]),
					c(y, {
						icon: "mdi:mdi-database-cog",
						label: E(Z)("meta"),
						hint: E(Z)("option_meta_hint")
					}, {
						default: O(() => [c($, null, {
							default: O(() => [(_(!0), i(e, null, b(P.meta, (e, t) => (_(), n(Q, {
								key: t,
								cols: "12",
								class: "mb-2 ga-4 pa-6"
							}, {
								default: O(() => [c($, { class: "align-center" }, {
									default: O(() => [
										c(Q, {
											cols: "auto",
											class: "d-flex align-center"
										}, {
											default: O(() => [c(ze, {
												icon: "mdi:mdi-key-variant",
												class: "mr-2"
											}), a("span", xn, T(E(Z)("meta_item")) + " #" + T(t + 1), 1)]),
											_: 2
										}, 1024),
										c(be),
										c(Q, { cols: "auto" }, {
											default: O(() => [c(v, {
												icon: "mdi:mdi-delete",
												variant: "text",
												color: "error",
												onClick: (e) => oe(t)
											}, null, 8, ["onClick"])]),
											_: 2
										}, 1024)
									]),
									_: 2
								}, 1024), c($, { class: "d-flex flex-column ga-4" }, {
									default: O(() => [c(Q, { class: "d-flex flex-column pt-0" }, {
										default: O(() => [c(l, {
											modelValue: e.key,
											"onUpdate:modelValue": (t) => e.key = t,
											label: E(Z)("key"),
											rules: m
										}, null, 8, [
											"modelValue",
											"onUpdate:modelValue",
											"label"
										]), c(l, {
											modelValue: e.value,
											"onUpdate:modelValue": (t) => e.value = t,
											label: E(Z)("value")
										}, null, 8, [
											"modelValue",
											"onUpdate:modelValue",
											"label"
										])]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024))), 128)), c(Q, { cols: "12" }, {
								default: O(() => [c(v, {
									type: "primary",
									variant: "outlined",
									"prepend-icon": "mdi:mdi-plus",
									class: "mt-4",
									onClick: J
								}, {
									default: O(() => [s(T(E(Z)("add_meta")), 1)]),
									_: 1
								})]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}, 8, ["label", "hint"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, Cn = {
	__name: "admin-options",
	props: {},
	setup(n) {
		let { hHttpRequest: r } = Y(), { hAddAlert: a } = q(), { confirm: o } = ce();
		X(n, "HAdminOptions");
		let { formatDate: s } = fe(), { buildQueryParams: l } = de(), u = y(!0), d = y(null), f = {
			term: "",
			name: "",
			nameMatchType: "contains",
			value: "",
			valueMatchType: "contains",
			role: [],
			tag: [],
			domain: [],
			locale: [],
			modifieddatePreset: null,
			sortBy: "modifieddate",
			sortOrder: "desc",
			page: 1,
			pageSize: 25
		}, p = v({ ...f }), m = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "value",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("value_filter"),
					placeholder: Z("value_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-text",
					defaultMatchType: "contains"
				}
			},
			{
				key: "role",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("role_filter"),
					icon: "mdi:mdi-account-key"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "domain",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("domain_filter"),
					icon: "mdi:mdi-web"
				}
			},
			{
				key: "locale",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("locale_filter"),
					icon: "mdi:mdi-translate"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [{
					key: "modifieddate",
					type: "date",
					component: "h-filter-datetime",
					model: "modifieddatePreset",
					props: {
						label: Z("modifieddate_filter"),
						manualSync: !0
					}
				}]
			}
		] }, g = [
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 200,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0
			},
			{
				title: "value",
				key: "value",
				sortable: !0,
				width: 200,
				value: "value",
				nowrap: !1,
				translate: !0,
				filterOnClick: (e) => P("value", e.value, "exact"),
				isFilterActive: (e) => N("value", e.value, "exact")
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "role",
				key: "role",
				sortable: !0,
				width: 150,
				value: "role",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => F("role", e),
				isFilterActive: (e) => N("role", e)
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => F("tag", e),
				isFilterActive: (e) => N("tag", e)
			},
			{
				title: "locale",
				key: "locale",
				sortable: !0,
				width: 150,
				value: "locale",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => F("locale", e),
				isFilterActive: (e) => N("locale", e)
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 150,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => s(e)
			}
		], b = {
			pageKey: "options",
			pageTitle: Z("admin_options_title"),
			headerTitle: Z("options"),
			searchPlaceholder: Z("search_options"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("options"),
					text: Z("options")
				}
			]
		}, { data: x, loading: C, params: w, execute: T, totalResults: D } = G({
			url: "/admin/options",
			filters: p,
			additionalParams: {}
		}), O = Z("total_options"), k = t(() => ({ widgets: [{
			summary: !0,
			title: O,
			count: D.value,
			icon: "mdi:mdi-cog",
			color: "grey-lighten-3",
			iconColor: "grey-darken-4"
		}] }));
		function A() {
			j(!0);
		}
		function j(e = !1) {
			let { query: t, sort: n } = l(m.filters, p);
			w.query = t, w.sort = n, (e || u.value) && T();
		}
		let M = qe(j, 300), { isFilterActive: N, toggleFilter: P, toggleArrayFilter: F } = ue({
			filters: p,
			onFilterChange: M
		}), I = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					d.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					d.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await o({
						title: Z("delete_option"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = r({
							url: `/admin/options/${e.key}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							a({
								title: Z("error_occurred"),
								body: Z("option_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await T();
					}
				}
			}
		];
		function L() {
			return Object.assign(p, { ...f }), j(!0);
		}
		function R() {
			d.value?.open();
		}
		return h(async () => {
			J(p, M), j(), T();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": u.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => u.value = e,
				"page-configuration": b,
				"widgets-config": k.value,
				"filters-config": m,
				filters: p,
				"table-headers": g,
				"table-params": E(w),
				"table-data": E(x),
				"table-loading": E(C),
				"table-actions": I,
				"total-results": E(D),
				"open-form": R,
				onSearch: A,
				onClearFilters: L
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(Sn, {
				ref_key: "optionFormRef",
				ref: d,
				onSuccess: E(T)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, wn = { class: "text-headline-small" }, Tn = {
	__name: "settings-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 600
		}
	},
	emits: ["success", "cancel"],
	setup(o, { expose: l, emit: u }) {
		let { hAddAlert: d } = q(), { stringKeyRules: f, valueRules: p, typeRules: m, objectValueRules: h, numberValueRules: g, categoryRules: x } = ie(), { save: C } = ae();
		X(o, "HSettingsForm");
		let w = {
			key: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			value: {
				type: [String, Boolean],
				default: ""
			},
			type: {
				type: String,
				default: "string"
			},
			category: {
				type: String,
				default: null
			},
			role: {
				type: Array,
				default: () => []
			},
			tag: {
				type: Array,
				default: () => []
			},
			public: {
				type: Boolean,
				default: !1
			},
			meta: {
				type: Array,
				default: () => []
			}
		}, k = {
			key: {
				type: String,
				default: ""
			},
			value: {
				type: String,
				default: ""
			}
		}, A = () => {
			let e = {};
			return Object.keys(w).forEach((t) => {
				let n = w[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, j = () => {
			let e = {};
			return Object.keys(k).forEach((t) => {
				let n = k[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, M = u, N = y(null), P = y(!1), F = y(!1), I = y(!1), L = y(!1), R = y(null), z = v(A()), B = y(!1), V = y({}), H = y("string"), U = [
			{
				title: Z("type_string"),
				value: "string"
			},
			{
				title: Z("type_number"),
				value: "number"
			},
			{
				title: Z("type_boolean"),
				value: "boolean"
			},
			{
				title: Z("type_object"),
				value: "object"
			},
			{
				title: Z("type_password"),
				value: "password"
			}
		], ee = [{
			title: Z("category_custom"),
			value: "custom"
		}], W = [], te = t(() => {
			if (L.value) return !1;
			let e = Array.isArray(z.role) && z.role.length > 0;
			return !!z.public && e;
		}), { data: ne, loading: re } = K({
			url: "/admin/roles",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		});
		D(P, (e) => {
			e || oe();
		}), D(z, () => {
			B.value = JSON.stringify(z) !== JSON.stringify(V.value);
		}, { deep: !0 }), D(() => z.type, (e) => {
			J(e);
		});
		let G = [
			"string",
			"number",
			"boolean",
			"object",
			"password"
		];
		function J(e) {
			if (!e || !G.includes(e)) return;
			let t = H.value, n = z.value;
			if (t !== e) {
				try {
					if (e === "string") t === "boolean" ? z.value = n ? "true" : "false" : t === "number" ? z.value = String(n) : z.value = n || "";
					else if (e === "number") if (t === "string") {
						let e = parseFloat(n);
						z.value = isNaN(e) ? "" : String(e);
					} else t === "boolean" ? z.value = n ? "1" : "0" : z.value = "";
					else if (e === "boolean") t === "string" ? z.value = n === "true" || n === "1" || n === "yes" : t === "number" ? z.value = parseFloat(n) !== 0 : z.value = !1;
					else if (e === "object") if (t === "string" && n) try {
						JSON.parse(n), z.value = n;
					} catch {
						z.value = JSON.stringify({ value: n }, null, 2);
					}
					else z.value = "{}";
					else e === "password" && (z.value = "");
				} catch {
					z.value = e === "boolean" ? !1 : "";
				}
				H.value = e;
			}
		}
		function oe() {
			let e = A();
			Object.keys(e).forEach((t) => {
				z[t] = e[t];
			}), V.value = JSON.parse(JSON.stringify(z)), I.value = !1, L.value = !1, R.value = null, B.value = !1, H.value = "string";
		}
		function Y(e, t = !0) {
			let n = e?.type || "string";
			H.value = n, Object.keys(w).forEach((t) => {
				let n = w[t], r = e?.[t], i = r != null;
				if (t === "meta") i && typeof r == "object" && !Array.isArray(r) ? z[t] = Object.entries(r).map(([e, t]) => ({
					key: e,
					value: t
				})) : z[t] = typeof n.default == "function" ? n.default() : n.default;
				else if (t === "value") {
					let n = e?.type || "string";
					n === "boolean" ? z[t] = i ? r === "true" || r === !0 : !1 : n === "number" ? z[t] = i ? String(r) : "" : n === "object" ? z[t] = i ? typeof r == "object" ? JSON.stringify(r, null, 2) : r : "" : z[t] = i ? String(r) : "";
				} else n.type === Array ? z[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : n.type === Boolean ? i && typeof r == "string" ? z[t] = r === "true" : z[t] = i ? !!r : typeof n.default == "function" ? n.default() : n.default : (n.type === String || n.type, z[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), t || (z.key = ""), V.value = JSON.parse(JSON.stringify(z)), I.value = t, L.value = t ? !!e?.system : !1, R.value = t && e?.key || null, H.value = n, B.value = !t;
		}
		async function se() {
			if (!(F.value || te.value) && !(!L.value && !((await N.value?.validate())?.valid ?? !0))) {
				F.value = !0;
				try {
					await ue(le()), M("success"), P.value = !1;
				} catch (e) {
					d({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					F.value = !1;
				}
			}
		}
		function ce(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) {
				if (n === "value") {
					t[n] = r === void 0 ? null : r;
					continue;
				}
				r === null || r === "" || Array.isArray(r) && r.length === 0 || (t[n] = r);
			}
			return t;
		}
		function le() {
			let e = (e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [], t = e(z.role, (e) => typeof e == "string" ? e.toLowerCase().trim() : e), n = e(z.tag), r = null;
			Array.isArray(z.meta) && z.meta.length > 0 && (r = {}, z.meta.forEach((e) => {
				e.key && e.key.trim() && (r[e.key.trim()] = e.value || "");
			}), Object.keys(r).length === 0 && (r = null));
			let i;
			if (z.type === "boolean") i = String(!!z.value);
			else if (z.type === "number") i = z.value ? String(parseFloat(z.value)) : null;
			else if (z.type === "object") try {
				i = z.value ? JSON.stringify(JSON.parse(z.value)) : null;
			} catch {
				i = null;
			}
			else i = z.type === "password" ? z.value || null : z.value?.trim() || null;
			return L.value ? ce({ value: i }) : ce({
				key: z.key?.trim() || null,
				name: z.name?.trim() || null,
				description: z.description?.trim() || null,
				value: i,
				type: z.type || null,
				category: z.category || null,
				role: t,
				tag: n,
				public: !!z.public,
				meta: r
			});
		}
		async function ue(e) {
			let t = I.value ? "update" : "create", n = {
				create: "/admin/config/settings",
				update: `/admin/config/settings/${R.value}`
			}, r = {
				create: "post",
				update: "put"
			}, i = {
				error: {
					create: "setting_create_error",
					update: "setting_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			}, a = t === "update" ? (({ key: e, ...t }) => t)(e) : e;
			if (!(await C({
				url: n[t],
				method: r[t],
				payload: a
			}))?.ok) throw Error(Z(i.error[t]));
			d({
				title: Z(i.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function de() {
			M("cancel"), P.value = !1;
		}
		function fe() {
			z.meta ||= [], z.meta.push(j());
		}
		function pe(e) {
			z.meta.splice(e, 1);
		}
		function me(e = null) {
			e && Y(e), P.value = !0;
		}
		function he(e) {
			Y(e, !1), P.value = !0;
		}
		return l({
			validate: () => N.value?.validate(),
			reset: () => N.value?.reset(),
			resetValidation: () => N.value?.resetValidation(),
			formData: z,
			open: me,
			openCopy: he
		}), (t, l) => {
			let u = S("h-form-text"), d = S("h-form-textarea"), v = S("h-form-select"), y = S("h-form-switch"), C = S("h-form-autocomplete"), w = S("h-form-combobox"), D = S("h-action-button"), k = S("h-form-field"), A = S("h-form-layout");
			return _(), n(A, {
				ref_key: "formRef",
				ref: N,
				modelValue: P.value,
				"onUpdate:modelValue": l[13] ||= (e) => P.value = e,
				loading: F.value,
				"bg-color": o.bgColor,
				"header-text": I.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": o.drawerWidth,
				"has-changes": B.value,
				"submit-disabled": te.value,
				onSubmit: se,
				onCancel: de
			}, {
				default: O(() => [
					c(u, {
						modelValue: z.key,
						"onUpdate:modelValue": l[0] ||= (e) => z.key = e,
						icon: "mdi:mdi-key",
						label: E(Z)("key"),
						required: !I.value,
						rules: I.value ? [] : E(f)(),
						hint: E(Z)("settings_key_hint"),
						disabled: I.value
					}, null, 8, [
						"modelValue",
						"label",
						"required",
						"rules",
						"hint",
						"disabled"
					]),
					c(u, {
						modelValue: z.name,
						"onUpdate:modelValue": l[1] ||= (e) => z.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: W,
						hint: E(Z)("settings_name_hint"),
						disabled: L.value
					}, null, 8, [
						"modelValue",
						"label",
						"hint",
						"disabled"
					]),
					c(d, {
						modelValue: z.description,
						"onUpdate:modelValue": l[2] ||= (e) => z.description = e,
						label: E(Z)("description"),
						icon: "mdi:mdi-text",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3",
						hint: E(Z)("settings_description_hint"),
						disabled: L.value
					}, null, 8, [
						"modelValue",
						"label",
						"hint",
						"disabled"
					]),
					c(v, {
						modelValue: z.type,
						"onUpdate:modelValue": l[3] ||= (e) => z.type = e,
						icon: "mdi:mdi-code-braces",
						label: E(Z)("type"),
						items: U,
						rules: E(m),
						required: "",
						hint: E(Z)("settings_type_hint"),
						disabled: L.value
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint",
						"disabled"
					]),
					z.type === "string" ? (_(), n(u, {
						key: 0,
						modelValue: z.value,
						"onUpdate:modelValue": l[4] ||= (e) => z.value = e,
						icon: "mdi:mdi-text-short",
						label: E(Z)("value"),
						rules: E(p)(I.value, !1),
						hint: E(Z)("settings_value_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					])) : z.type === "number" ? (_(), n(u, {
						key: 1,
						modelValue: z.value,
						"onUpdate:modelValue": l[5] ||= (e) => z.value = e,
						type: "number",
						icon: "mdi:mdi-numeric",
						label: E(Z)("value"),
						rules: [...E(p)(I.value, !1), ...E(g)],
						hint: E(Z)("settings_value_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					])) : z.type === "boolean" ? (_(), n(y, {
						key: 2,
						modelValue: z.value,
						"onUpdate:modelValue": l[6] ||= (e) => z.value = e,
						icon: "mdi:mdi-toggle-switch",
						label: E(Z)("value"),
						hint: E(Z)("settings_value_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					])) : z.type === "object" ? (_(), n(E(Ee), {
						key: 3,
						modelValue: z.value,
						"onUpdate:modelValue": l[7] ||= (e) => z.value = e,
						language: "json",
						icon: "mdi:mdi-code-json",
						label: E(Z)("value"),
						rules: [...E(p)(I.value, !1), ...E(h)],
						hint: E(Z)("settings_value_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					])) : z.type === "password" ? (_(), n(E(De), {
						key: 4,
						modelValue: z.value,
						"onUpdate:modelValue": l[8] ||= (e) => z.value = e,
						icon: "mdi:mdi-lock",
						label: E(Z)("password"),
						"allow-empty": !0,
						hint: E(Z)("settings_value_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					])) : r("", !0),
					c(v, {
						modelValue: z.category,
						"onUpdate:modelValue": l[9] ||= (e) => z.category = e,
						icon: "mdi:mdi-folder",
						label: E(Z)("category"),
						items: ee,
						rules: E(x),
						clearable: "",
						hint: E(Z)("settings_category_hint"),
						disabled: L.value
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint",
						"disabled"
					]),
					c(C, {
						modelValue: z.role,
						"onUpdate:modelValue": l[10] ||= (e) => z.role = e,
						icon: "mdi:mdi-account-key",
						label: E(Z)("roles"),
						items: E(ne),
						loading: E(re),
						multiple: "",
						chips: "",
						"closable-chips": "",
						hint: E(Z)("settings_role_hint"),
						disabled: L.value
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint",
						"disabled"
					]),
					c(w, {
						modelValue: z.tag,
						"onUpdate:modelValue": l[11] ||= (e) => z.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "],
						hint: E(Z)("settings_tag_hint"),
						disabled: L.value
					}, null, 8, [
						"modelValue",
						"label",
						"hint",
						"disabled"
					]),
					c(y, {
						modelValue: z.public,
						"onUpdate:modelValue": l[12] ||= (e) => z.public = e,
						icon: z.public ? "mdi:mdi-earth" : "mdi:mdi-lock",
						label: E(Z)("public"),
						hint: E(Z)("settings_public_hint"),
						disabled: L.value
					}, null, 8, [
						"modelValue",
						"icon",
						"label",
						"hint",
						"disabled"
					]),
					te.value ? (_(), n(Be, {
						key: 5,
						type: "warning",
						variant: "tonal",
						class: "mb-0"
					}, {
						default: O(() => [s(T(E(Z)("settings_mixed_visibility")), 1)]),
						_: 1
					})) : r("", !0),
					c(k, {
						icon: "mdi:mdi-database-cog",
						label: E(Z)("meta"),
						hint: E(Z)("settings_meta_hint"),
						disabled: L.value
					}, {
						default: O(() => [c($, null, {
							default: O(() => [(_(!0), i(e, null, b(z.meta, (e, t) => (_(), n(Q, {
								key: t,
								cols: "12",
								class: "mb-2 ga-4 pa-6"
							}, {
								default: O(() => [c($, { class: "align-center" }, {
									default: O(() => [
										c(Q, {
											cols: "auto",
											class: "d-flex align-center"
										}, {
											default: O(() => [c(ze, {
												icon: "mdi:mdi-key-variant",
												class: "mr-2"
											}), a("span", wn, T(E(Z)("meta_item")) + " #" + T(t + 1), 1)]),
											_: 2
										}, 1024),
										c(be),
										c(Q, { cols: "auto" }, {
											default: O(() => [c(D, {
												icon: "mdi:mdi-delete",
												variant: "text",
												color: "error",
												disabled: L.value,
												onClick: (e) => pe(t)
											}, null, 8, ["disabled", "onClick"])]),
											_: 2
										}, 1024)
									]),
									_: 2
								}, 1024), c($, { class: "d-flex flex-column" }, {
									default: O(() => [c(Q, { class: "d-flex flex-column pt-0" }, {
										default: O(() => [c(u, {
											modelValue: e.key,
											"onUpdate:modelValue": (t) => e.key = t,
											label: E(Z)("key")
										}, null, 8, [
											"modelValue",
											"onUpdate:modelValue",
											"label"
										]), c(u, {
											modelValue: e.value,
											"onUpdate:modelValue": (t) => e.value = t,
											label: E(Z)("value")
										}, null, 8, [
											"modelValue",
											"onUpdate:modelValue",
											"label"
										])]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024))), 128)), c(Q, { cols: "12" }, {
								default: O(() => [c(D, {
									type: "primary",
									variant: "outlined",
									"prepend-icon": "mdi:mdi-plus",
									class: "mt-4",
									disabled: L.value,
									onClick: fe
								}, {
									default: O(() => [s(T(E(Z)("add_meta")), 1)]),
									_: 1
								}, 8, ["disabled"])]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}, 8, [
						"label",
						"hint",
						"disabled"
					])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes",
				"submit-disabled"
			]);
		};
	}
}, En = [
	"title",
	"onClick",
	"onKeydown"
], Dn = {
	__name: "admin-settings",
	props: {},
	setup(a) {
		X(a, "HAdminSettings");
		let { buildQueryParams: o } = de(), { hHttpRequest: l } = Y(), { confirm: d } = ce(), { hAddAlert: p } = q(), m = y(!0), g = y(null), b = y({}), x = y(!1), C = y({}), w = t(() => ({
			title: Z("value"),
			key: C.value.key
		})), D = t(() => {
			let e = C.value.value;
			if (typeof e == "string") try {
				return JSON.stringify(JSON.parse(e), null, 2);
			} catch {
				return e;
			}
			return JSON.stringify(e, null, 2) ?? "";
		});
		function k(e) {
			C.value = e, x.value = !0;
		}
		let M = {
			term: "",
			key: "",
			keyMatchType: "contains",
			name: "",
			nameMatchType: "contains",
			category: "",
			categoryMatchType: "contains",
			tag: [],
			role: [],
			public: null,
			sortBy: "key",
			sortOrder: "asc",
			page: 1,
			pageSize: 25
		}, N = v({ ...M }), P = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "key",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("key_filter"),
					placeholder: Z("key_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-key",
					defaultMatchType: "contains"
				}
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "category",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("category_filter"),
					placeholder: Z("category_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-folder",
					defaultMatchType: "contains"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "role",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("role_filter"),
					icon: "mdi:mdi-account-key"
				}
			},
			{
				key: "public",
				type: "boolean",
				component: "h-filter-switch",
				props: {
					title: Z("public"),
					icon: "mdi:mdi-earth"
				}
			}
		] }, F = [
			{
				title: "key",
				key: "key",
				sortable: !0,
				width: 150,
				value: "key",
				nowrap: !0,
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 150,
				value: "name",
				nowrap: !0,
				customSortKey: "name.lower",
				translate: !0
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "value",
				key: "value",
				sortable: !0,
				width: 150,
				value: "value",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => {
					if (e == null) return "";
					let t = typeof e == "object" ? JSON.stringify(e) : String(e);
					return t.length > 200 ? `${t.slice(0, 200)}...` : t;
				}
			},
			{
				title: "type",
				key: "type",
				sortable: !0,
				width: 100,
				value: "type",
				nowrap: !0,
				translate: !0
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !1,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => ie("tag", e),
				isFilterActive: (e) => ne("tag", e)
			},
			{
				title: "role",
				key: "role",
				sortable: !0,
				width: 150,
				value: "role",
				nowrap: !1,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => ie("role", e),
				isFilterActive: (e) => ne("role", e)
			},
			{
				title: "category",
				key: "category",
				sortable: !0,
				width: 120,
				value: "category",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => re("category", e.category, "exact"),
				isFilterActive: (e) => ne("category", e.category, "exact")
			},
			{
				title: "public",
				key: "public",
				sortable: !0,
				width: 80,
				value: "public",
				nowrap: !0,
				translate: !0,
				component: "h-btn-table-cell",
				defaultValue: !1,
				componentProps: {
					getIcon: (e) => e.public ? "mdi:mdi-check-circle" : "mdi:mdi-minus-circle",
					getColor: (e) => e.public ? "success" : "grey"
				},
				filterOnClick: (e) => re("public", e.public),
				isFilterActive: (e) => ne("public", e.public)
			}
		], I = {
			pageKey: "settings",
			pageTitle: Z("admin_settings_title"),
			headerTitle: Z("admin_settings_title"),
			searchPlaceholder: Z("search_settings"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("settings"),
					text: Z("settings")
				}
			]
		}, { data: L, loading: R, params: z, execute: B, totalResults: V } = G({
			url: "/admin/config/settings",
			filters: N,
			additionalParams: {}
		}), H = Z("total_settings"), U = t(() => ({ widgets: [{
			summary: !0,
			title: H,
			count: V.value,
			icon: "mdi:mdi-database",
			color: "blue-grey-lighten-3",
			iconColor: "blue-grey-darken-4"
		}] }));
		function ee() {
			W(!0);
		}
		function W(e = !1) {
			let { query: t, sort: n } = o(P.filters, N);
			z.query = t, z.sort = n, (e || m.value) && B();
		}
		let te = qe(W, 300), { isFilterActive: ne, toggleFilter: re, toggleArrayFilter: ie } = ue({
			filters: N,
			onFilterChange: te
		}), ae = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					g.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					g.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await d({
						title: Z("delete_setting"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = l({
							url: `/admin/config/settings/${e.key}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							p({
								title: Z("error_occurred"),
								body: Z("setting_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await B();
					}
				}
			}
		];
		function K() {
			return Object.assign(N, { ...M }), W(!0);
		}
		function oe() {
			g.value?.open();
		}
		return h(async () => {
			J(N, te), W(), B();
		}), (t, a) => {
			let o = S("h-admin-template"), l = S("h-view-code-dialog");
			return _(), i(e, null, [
				c(o, {
					"auto-search-enabled": m.value,
					"onUpdate:autoSearchEnabled": a[0] ||= (e) => m.value = e,
					"page-configuration": I,
					"widgets-config": U.value,
					"filters-config": P,
					filters: N,
					"table-headers": F,
					"table-actions": ae,
					"table-params": E(z),
					"table-data": E(L),
					"table-loading": E(R),
					"total-results": E(V),
					"open-form": oe,
					onSearch: ee,
					onClearFilters: K
				}, {
					"item.value": O(({ item: e, header: t }) => [e.type === "object" || e.value !== null && typeof e.value == "object" ? (_(), n($e, {
						key: 0,
						location: "top"
					}, {
						activator: O(({ props: t }) => [c(Ue, u(t, {
							icon: "mdi:mdi-code-json",
							variant: "text",
							size: "small",
							"aria-label": E(Z)("click_to_view_value"),
							onClick: j((t) => k(e), ["stop"])
						}), null, 16, ["aria-label", "onClick"])]),
						default: O(() => [s(" " + T(E(Z)("click_to_view_value")), 1)]),
						_: 2
					}, 1024)) : t.formatCell(e.value) ? (_(), i("span", {
						key: 1,
						class: f(["h-datatable__cell-truncated", { "h-datatable__cell--expanded": b.value[e.key] }]),
						title: t.formatCell(e.value),
						style: { cursor: "pointer" },
						role: "button",
						tabindex: "0",
						onClick: (t) => b.value[e.key] = !b.value[e.key],
						onKeydown: [A((t) => b.value[e.key] = !b.value[e.key], ["enter"]), A(j((t) => b.value[e.key] = !b.value[e.key], ["prevent"]), ["space"])]
					}, T(t.formatCell(e.value)), 43, En)) : r("", !0)]),
					_: 1
				}, 8, [
					"auto-search-enabled",
					"widgets-config",
					"filters",
					"table-params",
					"table-data",
					"table-loading",
					"total-results"
				]),
				c(l, {
					modelValue: x.value,
					"onUpdate:modelValue": a[1] ||= (e) => x.value = e,
					item: w.value,
					"field-name": "key",
					"field-label": E(Z)("key")
				}, {
					"raw-json": O(() => [s(T(D.value), 1)]),
					_: 1
				}, 8, [
					"modelValue",
					"item",
					"field-label"
				]),
				c(Tn, {
					ref_key: "settingsFormRef",
					ref: g,
					onSuccess: E(B)
				}, null, 8, ["onSuccess"])
			], 64);
		};
	}
}, On = {
	__name: "shortcut-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 700
		}
	},
	emits: ["success", "cancel"],
	setup(e, { expose: i, emit: a }) {
		let { hAddAlert: o } = q(), { keyRules: s, nameRules: l, requiredRules: u, integerRules: d } = ie(), { save: f } = ae(), p = [...u(Z("title_required"))], m = d(), h = [{
			title: Z("placement_menu"),
			value: "menu"
		}, {
			title: Z("placement_workspace"),
			value: "workspace"
		}], g = [
			{
				title: "_blank",
				value: "_blank"
			},
			{
				title: "_self",
				value: "_self"
			},
			{
				title: "_top",
				value: "_top"
			},
			{
				title: "_modal",
				value: "_modal"
			},
			{
				title: "_window",
				value: "_window"
			}
		], b = [
			{
				title: Z("badge_type_totalresults"),
				value: "totalresults"
			},
			{
				title: Z("badge_type_hasresults"),
				value: "hasresults"
			},
			{
				title: Z("badge_type_noresult"),
				value: "noresult"
			}
		];
		X(e, "HShortcutForm");
		let x = {
			key: {
				type: String,
				default: ""
			},
			title: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			link: {
				type: String,
				default: ""
			},
			target: {
				type: String,
				default: ""
			},
			icon: {
				type: String,
				default: ""
			},
			placement: {
				type: Array,
				default: () => []
			},
			workspace: {
				type: Array,
				default: () => []
			},
			role: {
				type: Array,
				default: () => []
			},
			domain: {
				type: Array,
				default: () => []
			},
			tag: {
				type: Array,
				default: () => []
			},
			order: {
				type: Number,
				default: 100
			},
			shared: {
				type: Boolean,
				default: !0
			},
			badge: {
				type: Object,
				default: () => ({
					type: "",
					icon: "",
					description: "",
					url: ""
				})
			}
		}, C = () => {
			let e = {};
			return Object.keys(x).forEach((t) => {
				let n = x[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, w = a, T = y(null), k = y(!1), A = y(!1), j = y(!1), M = y(null), N = v(C()), P = y(!1), F = y({}), I = t(() => []), L = t(() => N.badge?.type === "hasresults" || N.badge?.type === "noresult" ? u(Z("icon_required")) : []), R = t(() => N.badge?.type ? u(Z("url_required")) : []), { data: z, loading: B } = K({
			url: "/admin/roles",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), { data: V, loading: H } = K({
			url: "/admin/domains",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), { data: U, loading: ee } = K({
			url: "/admin/workspaces",
			formatter: (e) => e.map((e) => ({
				title: e.name || e.title,
				value: e.slug,
				key: e.slug
			}))
		});
		D(k, (e) => {
			e || W();
		}), D(N, () => {
			P.value = JSON.stringify(N) !== JSON.stringify(F.value);
		}, { deep: !0 });
		function W() {
			let e = C();
			Object.keys(e).forEach((t) => {
				N[t] = e[t];
			}), F.value = JSON.parse(JSON.stringify(N)), j.value = !1, M.value = null, P.value = !1;
		}
		function te(e, t = !0) {
			Object.keys(x).forEach((t) => {
				let n = x[t], r = e?.[t], i = r != null;
				if (t === "badge") {
					let e = n.default();
					N[t] = i && typeof r == "object" ? {
						...e,
						...r
					} : e;
				} else n.type === Array ? N[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : n.type === Boolean ? N[t] = i ? !!r : typeof n.default == "function" ? n.default() : n.default : (n.type === String || n.type, N[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), t || (N.key = ""), F.value = JSON.parse(JSON.stringify(N)), j.value = t, M.value = t && e?.key || null, P.value = !t;
		}
		async function ne() {
			if (!A.value && ((await T.value?.validate())?.valid ?? !0)) {
				A.value = !0;
				try {
					await J(G()), w("success"), k.value = !1;
				} catch (e) {
					o({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					A.value = !1;
				}
			}
		}
		function re(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) if (!(r === null || r === "" || Array.isArray(r) && r.length === 0)) if (typeof r == "object" && !Array.isArray(r)) {
				let e = {};
				for (let [t, n] of Object.entries(r)) n !== null && n !== "" && !(Array.isArray(n) && n.length === 0) && (e[t] = n);
				Object.keys(e).length > 0 && (t[n] = e);
			} else t[n] = r;
			return t;
		}
		function G() {
			let e = (e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [], t = e(N.workspace), n = e(N.role), r = e(N.domain), i = e(N.tag), a = e(N.placement), o = null;
			return N.badge?.type && (o = {
				type: N.badge.type,
				url: N.badge.url?.trim() || "",
				...N.badge.icon && { icon: N.badge.icon.trim() },
				...N.badge.description && { description: N.badge.description.trim() }
			}), re({
				key: N.key?.trim() || null,
				title: N.title?.trim() || null,
				name: N.name?.trim() || null,
				description: N.description?.trim() || null,
				link: N.link?.trim() || null,
				target: N.target || null,
				icon: N.icon?.trim() || null,
				placement: a,
				workspace: t,
				role: n,
				domain: r,
				tag: i,
				order: N.order !== null && N.order !== void 0 && N.order !== "" ? Number(N.order) : 100,
				shared: N.shared ?? !0,
				badge: o
			});
		}
		async function J(e) {
			let t = j.value ? "update" : "create", n = {
				create: "/admin/shortcuts",
				update: `/admin/shortcuts/${M.value}`
			}, r = {
				create: "post",
				update: "put"
			}, i = {
				error: {
					create: "shortcut_create_error",
					update: "shortcut_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			}, a = t === "update" ? (({ key: e, ...t }) => t)(e) : e;
			if (!(await f({
				url: n[t],
				method: r[t],
				payload: a
			}))?.ok) throw Error(Z(i.error[t]));
			o({
				title: Z(i.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function oe() {
			w("cancel"), k.value = !1;
		}
		function Y(e = null) {
			e && te(e), k.value = !0;
		}
		function se(e) {
			te(e, !1), k.value = !0;
		}
		return i({
			validate: () => T.value?.validate(),
			reset: () => T.value?.reset(),
			resetValidation: () => T.value?.resetValidation(),
			formData: N,
			open: Y,
			openCopy: se
		}), (t, i) => {
			let a = S("h-form-text"), o = S("h-form-textarea"), d = S("h-form-select"), f = S("h-form-autocomplete"), v = S("h-form-combobox"), y = S("h-form-switch"), x = S("h-form-field"), C = S("h-form-layout");
			return _(), n(C, {
				ref_key: "formRef",
				ref: T,
				modelValue: k.value,
				"onUpdate:modelValue": i[18] ||= (e) => k.value = e,
				loading: A.value,
				"bg-color": e.bgColor,
				"header-text": j.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": e.drawerWidth,
				"has-changes": P.value,
				onSubmit: ne,
				onCancel: oe
			}, {
				default: O(() => [
					c(a, {
						modelValue: N.key,
						"onUpdate:modelValue": i[0] ||= (e) => N.key = e,
						icon: "mdi:mdi-key",
						label: E(Z)("key"),
						rules: j.value ? [] : E(s)(!1),
						disabled: j.value,
						hint: E(Z)("shortcut_key_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"disabled",
						"hint"
					]),
					c(a, {
						modelValue: N.title,
						"onUpdate:modelValue": i[1] ||= (e) => N.title = e,
						icon: "mdi:mdi-format-title",
						label: E(Z)("title"),
						rules: p,
						hint: E(Z)("shortcut_title_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(a, {
						modelValue: N.name,
						"onUpdate:modelValue": i[2] ||= (e) => N.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: E(l),
						hint: E(Z)("shortcut_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(o, {
						modelValue: N.description,
						"onUpdate:modelValue": i[3] ||= (e) => N.description = e,
						label: E(Z)("description"),
						hint: E(Z)("shortcut_description_hint"),
						icon: "mdi:mdi-text",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3"
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(a, {
						modelValue: N.link,
						"onUpdate:modelValue": i[4] ||= (e) => N.link = e,
						icon: "mdi:mdi-link",
						label: E(Z)("link"),
						rules: E(u)(E(Z)("link_required")),
						hint: E(Z)("shortcut_link_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(d, {
						modelValue: N.target,
						"onUpdate:modelValue": i[5] ||= (e) => N.target = e,
						icon: "mdi:mdi-open-in-new",
						label: E(Z)("target"),
						items: g,
						hint: E(Z)("shortcut_target_hint"),
						clearable: ""
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(a, {
						modelValue: N.icon,
						"onUpdate:modelValue": i[6] ||= (e) => N.icon = e,
						icon: "mdi:mdi-image-outline",
						label: E(Z)("icon"),
						hint: E(Z)("shortcut_icon_hint"),
						rules: E(u)(E(Z)("icon_required")),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"hint",
						"rules"
					]),
					c(d, {
						modelValue: N.placement,
						"onUpdate:modelValue": i[7] ||= (e) => N.placement = e,
						icon: "mdi:mdi-view-dashboard",
						label: E(Z)("placement"),
						items: h,
						hint: E(Z)("shortcut_placement_hint"),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(f, {
						modelValue: N.workspace,
						"onUpdate:modelValue": i[8] ||= (e) => N.workspace = e,
						icon: "mdi:mdi-briefcase",
						label: E(Z)("workspaces"),
						items: E(U),
						loading: E(ee),
						hint: E(Z)("shortcut_workspace_hint"),
						rules: I.value,
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint",
						"rules"
					]),
					c(f, {
						modelValue: N.role,
						"onUpdate:modelValue": i[9] ||= (e) => N.role = e,
						icon: "mdi:mdi-account-key",
						label: E(Z)("roles"),
						items: E(z),
						loading: E(B),
						hint: E(Z)("shortcut_role_hint"),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint"
					]),
					c(f, {
						modelValue: N.domain,
						"onUpdate:modelValue": i[10] ||= (e) => N.domain = e,
						icon: "mdi:mdi-domain",
						label: E(Z)("domains"),
						items: E(V),
						loading: E(H),
						hint: E(Z)("shortcut_domain_hint"),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint"
					]),
					c(v, {
						modelValue: N.tag,
						"onUpdate:modelValue": i[11] ||= (e) => N.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						hint: E(Z)("shortcut_tag_hint"),
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "]
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(a, {
						modelValue: N.order,
						"onUpdate:modelValue": i[12] ||= (e) => N.order = e,
						type: "number",
						icon: "mdi:mdi-order-numeric-ascending",
						label: E(Z)("order"),
						hint: E(Z)("shortcut_order_hint"),
						rules: E(m)
					}, null, 8, [
						"modelValue",
						"label",
						"hint",
						"rules"
					]),
					c(y, {
						modelValue: N.shared,
						"onUpdate:modelValue": i[13] ||= (e) => N.shared = e,
						icon: N.shared ? "mdi:mdi-share-variant" : "mdi:mdi-lock",
						label: E(Z)("shared"),
						hint: E(Z)("shortcut_shared_hint")
					}, null, 8, [
						"modelValue",
						"icon",
						"label",
						"hint"
					]),
					c(x, {
						icon: "mdi:mdi-badge-account",
						label: E(Z)("badge_settings"),
						indent: ""
					}, {
						default: O(() => [c($, null, {
							default: O(() => [
								c(Q, { cols: "12" }, {
									default: O(() => [c(d, {
										modelValue: N.badge.type,
										"onUpdate:modelValue": i[14] ||= (e) => N.badge.type = e,
										icon: "mdi:mdi-format-list-bulleted-type",
										label: E(Z)("badge_type"),
										items: b,
										hint: E(Z)("shortcut_badge_type_hint"),
										clearable: ""
									}, null, 8, [
										"modelValue",
										"label",
										"hint"
									])]),
									_: 1
								}),
								N.badge.type ? (_(), n(Q, {
									key: 0,
									cols: "12"
								}, {
									default: O(() => [c(a, {
										modelValue: N.badge.icon,
										"onUpdate:modelValue": i[15] ||= (e) => N.badge.icon = e,
										icon: "mdi:mdi-image-outline",
										label: E(Z)("icon"),
										hint: E(Z)("shortcut_badge_icon_hint"),
										rules: L.value,
										required: N.badge.type === "hasresults" || N.badge.type === "noresult"
									}, null, 8, [
										"modelValue",
										"label",
										"hint",
										"rules",
										"required"
									])]),
									_: 1
								})) : r("", !0),
								N.badge.type ? (_(), n(Q, {
									key: 1,
									cols: "12"
								}, {
									default: O(() => [c(o, {
										modelValue: N.badge.description,
										"onUpdate:modelValue": i[16] ||= (e) => N.badge.description = e,
										label: E(Z)("description"),
										hint: E(Z)("shortcut_badge_description_hint"),
										icon: "mdi:mdi-text",
										density: "comfortable",
										variant: "outlined",
										"bg-color": "white",
										"auto-grow": "",
										rows: "2"
									}, null, 8, [
										"modelValue",
										"label",
										"hint"
									])]),
									_: 1
								})) : r("", !0),
								N.badge.type ? (_(), n(Q, {
									key: 2,
									cols: "12"
								}, {
									default: O(() => [c(a, {
										modelValue: N.badge.url,
										"onUpdate:modelValue": i[17] ||= (e) => N.badge.url = e,
										icon: "mdi:mdi-link",
										label: E(Z)("url"),
										hint: E(Z)("shortcut_badge_url_hint"),
										rules: R.value,
										required: !!N.badge.type
									}, null, 8, [
										"modelValue",
										"label",
										"hint",
										"rules",
										"required"
									])]),
									_: 1
								})) : r("", !0)
							]),
							_: 1
						})]),
						_: 1
					}, 8, ["label"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, kn = {
	__name: "admin-shortcuts",
	props: {},
	setup(n) {
		X(n, "HAdminShortcuts");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { confirm: s } = ce(), { hAddAlert: l } = q(), u = y(!0), d = y(null), f = {
			term: "",
			title: "",
			titleMatchType: "contains",
			name: "",
			nameMatchType: "contains",
			role: [],
			domain: [],
			workspace: [],
			tag: [],
			shared: null,
			modifieddatePreset: null,
			sortBy: "modifieddate",
			sortOrder: "desc",
			page: 1,
			pageSize: 25
		}, p = v({ ...f }), m = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "shared",
				type: "boolean"
			},
			{
				key: "title",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("title_filter"),
					placeholder: Z("title_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-format-title",
					defaultMatchType: "contains"
				}
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "role",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("role_filter"),
					icon: "mdi:mdi-account-key"
				}
			},
			{
				key: "domain",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("domain_filter"),
					icon: "mdi:mdi-web"
				}
			},
			{
				key: "workspace",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("workspace_filter"),
					icon: "mdi:mdi-briefcase"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [{
					key: "modifieddate",
					type: "date",
					component: "h-filter-datetime",
					model: "modifieddatePreset",
					props: {
						label: Z("modifieddate_filter"),
						manualSync: !0
					}
				}]
			}
		] }, g = [
			{
				title: "title",
				key: "title",
				align: "start",
				sortable: !0,
				width: 200,
				value: "title",
				nowrap: !1,
				customSortKey: "title.lower",
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 150,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "role",
				key: "role",
				sortable: !0,
				width: 150,
				value: "role",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => P("role", e),
				isFilterActive: (e) => N("role", e)
			},
			{
				title: "workspace",
				key: "workspace",
				sortable: !0,
				width: 150,
				value: "workspace",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => P("workspace", e),
				isFilterActive: (e) => N("workspace", e)
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => P("tag", e),
				isFilterActive: (e) => N("tag", e)
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 150,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], b = {
			pageKey: "shortcuts",
			pageTitle: Z("admin_shortcuts_title"),
			headerTitle: Z("shortcuts"),
			searchPlaceholder: Z("search_shortcuts"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("shortcuts"),
					text: Z("shortcuts")
				}
			]
		}, { data: x, loading: C, params: w, execute: T, totalResults: D } = G({
			url: "/admin/shortcuts",
			filters: p,
			additionalParams: {}
		}), O = Z("total_shortcuts"), k = t(() => ({ widgets: [{
			summary: !0,
			title: O,
			count: D.value,
			icon: "mdi:mdi-link-variant",
			color: "grey-lighten-3",
			iconColor: "grey-darken-4"
		}] }));
		function A() {
			j(!0);
		}
		function j(e = !1) {
			let { query: t, sort: n } = a(m.filters, p);
			w.query = t, w.sort = n, (e || u.value) && T();
		}
		let M = qe(j, 300), { isFilterActive: N, toggleArrayFilter: P } = ue({
			filters: p,
			onFilterChange: M
		}), F = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					d.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					d.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await s({
						title: Z("delete_shortcut"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = o({
							url: `/admin/shortcuts/${e.key}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							l({
								title: Z("error_occurred"),
								body: Z("shortcut_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await T();
					}
				}
			}
		];
		function I() {
			return Object.assign(p, { ...f }), j(!0);
		}
		function L() {
			d.value?.open();
		}
		return h(async () => {
			J(p, M), j(), T();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": u.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => u.value = e,
				"page-configuration": b,
				"widgets-config": k.value,
				"filters-config": m,
				filters: p,
				"table-headers": g,
				"table-actions": F,
				"table-params": E(w),
				"table-data": E(x),
				"table-loading": E(C),
				"total-results": E(D),
				"open-form": L,
				onSearch: A,
				onClearFilters: I
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(On, {
				ref_key: "shortcutFormRef",
				ref: d,
				onSuccess: E(T)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, An = {
	__name: "role-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 500
		}
	},
	emits: ["success", "cancel"],
	setup(e, { expose: t, emit: r }) {
		let { hAddAlert: i } = q(), { keyRules: a, nameRules: o } = ie(), { save: s } = ae();
		X(e, "HRoleForm");
		let l = {
			key: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			tag: {
				type: Array,
				default: () => []
			},
			domain: {
				type: Array,
				default: () => []
			}
		}, u = () => {
			let e = {};
			return Object.keys(l).forEach((t) => {
				let n = l[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, d = r, f = y(null), p = y(!1), m = y(!1), h = y(!1), g = y(null), b = v(u()), x = y(!1), C = y({}), { data: w, loading: T } = K({
			url: "/admin/domains",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		});
		D(p, (e) => {
			e || k();
		}), D(b, () => {
			x.value = JSON.stringify(b) !== JSON.stringify(C.value);
		}, { deep: !0 });
		function k() {
			let e = u();
			Object.keys(e).forEach((t) => {
				b[t] = e[t];
			}), C.value = JSON.parse(JSON.stringify(b)), h.value = !1, g.value = null, x.value = !1;
		}
		function A(e, t = !0) {
			Object.keys(l).forEach((t) => {
				let n = l[t], r = e?.[t], i = r != null;
				n.type === Array ? b[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : (n.type, b[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), t || (b.key = ""), C.value = JSON.parse(JSON.stringify(b)), h.value = t, g.value = t && e?.key || null, x.value = !t;
		}
		async function j() {
			if (!m.value && ((await f.value?.validate())?.valid ?? !0)) {
				m.value = !0;
				try {
					await P(N()), d("success"), p.value = !1;
				} catch (e) {
					i({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					m.value = !1;
				}
			}
		}
		function M(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) r === null || r === "" || Array.isArray(r) && r.length === 0 || (t[n] = r);
			return t;
		}
		function N() {
			let e = (e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [], t = e(b.tag), n = e(b.domain);
			return M({
				key: b.key?.trim().toLowerCase() || null,
				name: b.name?.trim() || null,
				tag: t,
				domain: n
			});
		}
		async function P(e) {
			let t = h.value ? "update" : "create", n = {
				create: "/admin/roles",
				update: `/admin/roles/${g.value}`
			}, r = {
				create: "post",
				update: "put"
			}, a = {
				error: {
					create: "role_create_error",
					update: "role_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			}, o = t === "update" ? (({ key: e, ...t }) => t)(e) : e;
			if (!(await s({
				url: n[t],
				method: r[t],
				payload: o
			}))?.ok) throw Error(Z(a.error[t]));
			i({
				title: Z(a.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function F() {
			d("cancel"), p.value = !1;
		}
		function I(e = null) {
			e && A(e), p.value = !0;
		}
		function L(e) {
			A(e, !1), p.value = !0;
		}
		return t({
			validate: () => f.value?.validate(),
			reset: () => f.value?.reset(),
			resetValidation: () => f.value?.resetValidation(),
			formData: b,
			open: I,
			openCopy: L
		}), (t, r) => {
			let i = S("h-form-text"), s = S("h-form-combobox"), l = S("h-form-autocomplete"), u = S("h-form-layout");
			return _(), n(u, {
				ref_key: "formRef",
				ref: f,
				modelValue: p.value,
				"onUpdate:modelValue": r[4] ||= (e) => p.value = e,
				loading: m.value,
				"bg-color": e.bgColor,
				"header-text": h.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": e.drawerWidth,
				"has-changes": x.value,
				onSubmit: j,
				onCancel: F
			}, {
				default: O(() => [
					c(i, {
						modelValue: b.key,
						"onUpdate:modelValue": r[0] ||= (e) => b.key = e,
						icon: "mdi:mdi-key",
						label: E(Z)("key"),
						rules: h.value ? [] : E(a)(!1),
						disabled: h.value,
						hint: E(Z)("role_key_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"disabled",
						"hint"
					]),
					c(i, {
						modelValue: b.name,
						"onUpdate:modelValue": r[1] ||= (e) => b.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: E(o),
						hint: E(Z)("role_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(s, {
						modelValue: b.tag,
						"onUpdate:modelValue": r[2] ||= (e) => b.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						hint: E(Z)("role_tag_hint"),
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "]
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(l, {
						modelValue: b.domain,
						"onUpdate:modelValue": r[3] ||= (e) => b.domain = e,
						icon: "mdi:mdi-domain",
						label: E(Z)("domains"),
						items: E(w),
						loading: E(T),
						hint: E(Z)("role_domain_hint"),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint"
					])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, jn = {
	__name: "admin-roles",
	props: {},
	setup(n) {
		X(n, "HAdminRoles");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { confirm: s } = ce(), { hAddAlert: l } = q(), u = y(!0), d = y(null), f = {
			term: "",
			name: "",
			nameMatchType: "contains",
			key: "",
			keyMatchType: "contains",
			status: null,
			tag: [],
			domain: [],
			sortBy: "createdate",
			sortOrder: "desc",
			page: 1,
			pageSize: 25,
			createdatePreset: null,
			modifieddatePreset: null
		}, p = v({ ...f }), m = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: "Filter by name...",
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "key",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("key_filter"),
					placeholder: "Filter by key...",
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-key",
					defaultMatchType: "contains"
				}
			},
			{
				key: "domain",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("domains_filter"),
					icon: "mdi:mdi-domain"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tags_filter"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					controlsSync: !0
				},
				filters: [{
					key: "createdate",
					type: "date",
					component: "h-filter-datetime",
					model: "createdatePreset",
					props: {
						label: Z("createdate_filter"),
						manualSync: !0
					}
				}, {
					key: "modifieddate",
					type: "date",
					component: "h-filter-datetime",
					model: "modifieddatePreset",
					props: {
						label: Z("modifieddate_filter"),
						minDatePresetFilter: p.createdatePreset,
						manualSync: !0
					}
				}]
			}
		] }, g = [
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0
			},
			{
				title: "key",
				key: "key",
				sortable: !1,
				value: "key",
				nowrap: !1,
				customSortKey: "key",
				translate: !0
			},
			{
				title: "tags",
				key: "tag",
				sortable: !0,
				width: 200,
				value: "tag",
				nowrap: !1,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => w("tag", e),
				isFilterActive: (e) => C("tag", e)
			},
			{
				title: "createdate",
				key: "createdate",
				sortable: !0,
				value: "createdate",
				width: 100,
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				value: "modifieddate",
				width: 100,
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], b = {
			pageKey: "roles",
			pageTitle: Z("roles_page_title"),
			headerTitle: Z("roles"),
			searchPlaceholder: Z("search_roles"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("roles"),
					text: Z("roles")
				}
			]
		}, x = qe(P, 300), { isFilterActive: C, toggleArrayFilter: w } = ue({
			filters: p,
			onFilterChange: x
		}), { data: T, loading: D, params: O, execute: k, totalResults: A } = G({
			url: "/admin/roles",
			filters: p
		}), j = Z("total_roles"), M = t(() => ({ widgets: [{
			summary: !0,
			title: j,
			count: A.value,
			icon: "mdi:mdi-database",
			color: "blue-grey-lighten-3",
			iconColor: "blue-grey-darken-4"
		}] }));
		function N() {
			P(!0);
		}
		function P(e = !1) {
			let { query: t, sort: n } = a(m.filters, p);
			O.query = t, O.sort = n, (e || u.value) && k();
		}
		let F = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					d.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					d.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await s({
						title: Z("delete_role"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = o({
							url: `/admin/roles/${e.key}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							l({
								title: Z("error_occurred"),
								body: Z("role_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await k();
					}
				}
			}
		];
		function I() {
			return Object.assign(p, { ...f }), P(!0);
		}
		function L() {
			d.value?.open();
		}
		return h(async () => {
			J(p, x), P(), k();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": u.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => u.value = e,
				"page-configuration": b,
				"widgets-config": M.value,
				"filters-config": m,
				filters: p,
				"table-headers": g,
				"table-actions": F,
				"table-params": E(O),
				"table-data": E(T),
				"table-loading": E(D),
				"total-results": E(A),
				"open-form": L,
				onSearch: N,
				onClearFilters: I
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(An, {
				ref_key: "roleFormRef",
				ref: d,
				onSuccess: E(k)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, Mn = {
	__name: "locale-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 500
		}
	},
	emits: ["success", "cancel"],
	setup(e, { expose: t, emit: r }) {
		let { hAddAlert: i } = q(), { keyRules: a, nameRules: o } = ie(), { save: s } = ae();
		X(e, "HLocaleForm");
		let l = {
			key: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			}
		}, u = () => {
			let e = {};
			return Object.keys(l).forEach((t) => {
				let n = l[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, d = r, f = y(null), p = y(!1), m = y(!1), h = y(!1), g = y(null), b = v(u()), x = y(!1), C = y({});
		D(p, (e) => {
			e || w();
		}), D(b, () => {
			x.value = JSON.stringify(b) !== JSON.stringify(C.value);
		}, { deep: !0 });
		function w() {
			let e = u();
			Object.keys(e).forEach((t) => {
				b[t] = e[t];
			}), C.value = JSON.parse(JSON.stringify(b)), h.value = !1, g.value = null, x.value = !1;
		}
		function T(e) {
			Object.keys(l).forEach((t) => {
				let n = l[t];
				b[t] = e?.[t] ?? (typeof n.default == "function" ? n.default() : n.default);
			}), C.value = JSON.parse(JSON.stringify(b)), h.value = !0, g.value = e?.key || null, x.value = !1;
		}
		async function k() {
			if (!m.value && ((await f.value?.validate())?.valid ?? !0)) {
				m.value = !0;
				try {
					await j(A()), d("success"), p.value = !1;
				} catch (e) {
					i({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					m.value = !1;
				}
			}
		}
		function A() {
			let e = { name: b.name?.trim() || null };
			return h.value || (e.key = b.key?.trim() || null), Object.fromEntries(Object.entries(e).filter(([e, t]) => t !== null));
		}
		async function j(e) {
			let t = h.value ? "update" : "create", n = {
				create: "/admin/locales",
				update: `/admin/locales/${g.value}`
			}, r = {
				create: "post",
				update: "put"
			}, a = {
				error: {
					create: "locale_create_error",
					update: "locale_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			};
			if (!(await s({
				url: n[t],
				method: r[t],
				payload: e
			}))?.ok) throw Error(Z(a.error[t]));
			i({
				title: Z(a.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function M() {
			d("cancel"), p.value = !1;
		}
		function N(e = null) {
			e && T(e), p.value = !0;
		}
		return t({
			validate: () => f.value?.validate(),
			reset: () => f.value?.reset(),
			resetValidation: () => f.value?.resetValidation(),
			formData: b,
			open: N
		}), (t, r) => {
			let i = S("h-form-text"), s = S("h-form-layout");
			return _(), n(s, {
				ref_key: "formRef",
				ref: f,
				modelValue: p.value,
				"onUpdate:modelValue": r[2] ||= (e) => p.value = e,
				loading: m.value,
				"bg-color": e.bgColor,
				"header-text": h.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": e.drawerWidth,
				"has-changes": x.value,
				onSubmit: k,
				onCancel: M
			}, {
				default: O(() => [c(i, {
					modelValue: b.key,
					"onUpdate:modelValue": r[0] ||= (e) => b.key = e,
					icon: "mdi:mdi-key",
					label: E(Z)("key"),
					rules: h.value ? [] : E(a)(!1),
					disabled: h.value
				}, null, 8, [
					"modelValue",
					"label",
					"rules",
					"disabled"
				]), c(i, {
					modelValue: b.name,
					"onUpdate:modelValue": r[1] ||= (e) => b.name = e,
					icon: "mdi:mdi-form-textbox",
					label: E(Z)("name"),
					rules: E(o),
					required: ""
				}, null, 8, [
					"modelValue",
					"label",
					"rules"
				])]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, Nn = {
	__name: "admin-locales",
	props: {},
	setup(n) {
		X(n, "HAdminLocales");
		let { buildQueryParams: r } = de(), { hHttpRequest: a } = Y(), { confirm: o } = ce(), { hAddAlert: s } = q(), l = y(!0), u = y(null), d = {
			term: "",
			name: "",
			nameMatchType: "contains",
			key: "",
			keyMatchType: "contains",
			sortBy: "name.lower",
			sortOrder: "asc",
			page: 1,
			pageSize: 25
		}, f = v({ ...d }), p = {
			pageKey: "locales",
			pageTitle: Z("locales_page_title"),
			headerTitle: Z("locales"),
			searchPlaceholder: Z("search_locales"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("locales"),
					text: Z("locales")
				}
			]
		}, m = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "key",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("key_filter"),
					placeholder: Z("key_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-key",
					defaultMatchType: "contains"
				}
			}
		] }, g = [{
			title: "name",
			key: "name",
			align: "start",
			sortable: !0,
			width: 250,
			value: "name",
			nowrap: !1,
			customSortKey: "name.lower",
			translate: !0
		}, {
			title: "key",
			key: "key",
			sortable: !0,
			width: 250,
			value: "key",
			nowrap: !1,
			customSortKey: "key.lower",
			translate: !0
		}], { data: b, loading: x, params: C, execute: w, totalResults: T } = G({
			url: "/admin/locales",
			filters: f
		}), D = Z("total_locales"), O = t(() => ({ widgets: [{
			summary: !0,
			title: D,
			count: T.value,
			icon: "mdi:mdi-translate",
			color: "grey-lighten-3",
			iconColor: "grey-darken-4"
		}] }));
		function k() {
			A(!0);
		}
		function A(e = !1) {
			let { query: t, sort: n } = r(m.filters, f);
			C.query = t, C.sort = n, (e || l.value) && w();
		}
		let j = qe(A, 300);
		ue({
			filters: f,
			onFilterChange: j
		});
		let M = [{
			label: Z("edit"),
			icon: "mdi:mdi-pencil",
			color: "neutral-70",
			action: (e) => {
				u.value?.open(e);
			}
		}, {
			label: Z("delete"),
			icon: "mdi:mdi-delete",
			color: "neutral-70",
			action: async (e) => {
				if ((await o({
					title: Z("delete_locale"),
					message: Z("delete_confirmation"),
					confirmText: Z("delete"),
					cancelText: Z("cancel")
				})).confirmed) {
					let { execute: t } = a({
						url: `/admin/locales/${e.key}`,
						method: "delete",
						immediate: !1
					});
					if (!(await t())?.ok) {
						s({
							title: Z("error_occurred"),
							body: Z("locale_delete_error"),
							type: "error",
							timeout: 5e3
						});
						return;
					}
					await w();
				}
			}
		}];
		function N() {
			return Object.assign(f, { ...d }), A(!0);
		}
		function P() {
			u.value?.open();
		}
		return h(async () => {
			J(f, j), A(), w();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": l.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => l.value = e,
				"page-configuration": p,
				"widgets-config": O.value,
				"filters-config": m,
				filters: f,
				"table-headers": g,
				"table-actions": M,
				"table-params": E(C),
				"table-data": E(b),
				"table-loading": E(x),
				"total-results": E(T),
				"open-form": P,
				onSearch: k,
				onClearFilters: N
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(Mn, {
				ref_key: "localeFormRef",
				ref: u,
				onSuccess: E(w)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, Pn = { class: "text-headline-small" }, Fn = {
	__name: "string-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 600
		}
	},
	emits: ["success", "cancel"],
	setup(r, { expose: o, emit: l }) {
		let { hAddAlert: d } = q(), { requiredRules: f, stringKeyRules: p, localeKeyRules: m } = ie(), { save: h } = ae();
		X(r, "HStringForm");
		let g = {
			key: {
				type: String,
				default: ""
			},
			string: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			tag: {
				type: Array,
				default: () => []
			},
			translation: {
				type: Array,
				default: () => []
			}
		}, x = {
			locale: {
				type: String,
				default: ""
			},
			string: {
				type: String,
				default: ""
			},
			custom: {
				type: String,
				default: ""
			},
			readonly: {
				type: Boolean,
				default: !1
			}
		}, C = () => {
			let e = {};
			return Object.keys(g).forEach((t) => {
				let n = g[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, w = () => {
			let e = {};
			return Object.keys(x).forEach((t) => {
				let n = x[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, k = l, A = y(null), j = y(!1), M = y(!1), N = y(!1), P = y(!1), F = y(null), I = v(C()), L = y(!1), R = y({}), { data: z, loading: B } = K({
			url: "/admin/locales",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), V = t(() => {
			if (!z.value) return [];
			let e = I.translation?.map((e) => e.locale) || [];
			return z.value.filter((t) => !e.includes(t.key));
		});
		D(j, (e) => {
			e || H();
		}), D(I, () => {
			L.value = JSON.stringify(I) !== JSON.stringify(R.value);
		}, { deep: !0 });
		function H() {
			let e = C();
			Object.keys(e).forEach((t) => {
				I[t] = e[t];
			}), R.value = JSON.parse(JSON.stringify(I)), N.value = !1, P.value = !1, F.value = null, L.value = !1;
		}
		function U(e, t = !0) {
			Object.keys(g).forEach((t) => {
				let n = g[t], r = e?.[t], i = r != null;
				t === "translation" ? i && typeof r == "object" && !Array.isArray(r) ? I[t] = Object.entries(r).map(([e, t]) => ({
					locale: e,
					string: t?.string || I.string || "",
					custom: t?.custom || "",
					readonly: !0
				})) : I[t] = typeof n.default == "function" ? n.default() : n.default : n.type === Array ? I[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : (n.type, I[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), t || (I.key = ""), R.value = JSON.parse(JSON.stringify(I)), N.value = t, P.value = t ? !!e?.system : !1, F.value = t && e?.key || null, L.value = !t;
		}
		async function ee() {
			if (!M.value && !(!P.value && !((await A.value?.validate())?.valid ?? !0))) {
				M.value = !0;
				try {
					await ne(te()), k("success"), j.value = !1;
				} catch (e) {
					d({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					M.value = !1;
				}
			}
		}
		function W(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) r === null || r === "" || Array.isArray(r) && r.length === 0 || (t[n] = r);
			return t;
		}
		function te() {
			let e = ((e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [])(I.tag), t = null;
			return Array.isArray(I.translation) && I.translation.length > 0 && (t = {}, I.translation.forEach((e) => {
				e.locale && e.locale.trim() && (t[e.locale.trim()] = { custom: e.custom || "" });
			}), Object.keys(t).length === 0 && (t = null)), P.value ? W({ translation: t }) : W({
				key: I.key?.toLowerCase().trim() || null,
				string: I.string?.trim() || null,
				description: I.description?.trim() || null,
				tag: e,
				translation: t
			});
		}
		async function ne(e) {
			let t = N.value ? "update" : "create", n = {
				create: "/admin/strings",
				update: `/admin/strings/${F.value}`
			}, r = {
				create: "post",
				update: "put"
			}, i = {
				error: {
					create: "string_create_error",
					update: "string_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			}, a = t === "update" ? (({ key: e, ...t }) => t)(e) : e;
			if (!(await h({
				url: n[t],
				method: r[t],
				payload: a
			}))?.ok) throw Error(Z(i.error[t]));
			d({
				title: Z(i.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function re() {
			k("cancel"), j.value = !1;
		}
		function G(e) {
			I.translation ||= [];
			let t = w();
			t.locale = e, t.string = I.string || "", I.translation.push(t);
		}
		function J(e) {
			I.translation.splice(e, 1);
		}
		function oe(e = null) {
			e && U(e), j.value = !0;
		}
		function Y(e) {
			U(e, !1), j.value = !0;
		}
		return o({
			validate: () => A.value?.validate(),
			reset: () => A.value?.reset(),
			resetValidation: () => A.value?.resetValidation(),
			formData: I,
			open: oe,
			openCopy: Y
		}), (t, o) => {
			let l = S("h-form-text"), d = S("h-form-textarea"), h = S("h-form-combobox"), g = S("h-action-button"), v = S("h-form-field"), y = S("h-form-layout");
			return _(), n(y, {
				ref_key: "formRef",
				ref: A,
				modelValue: j.value,
				"onUpdate:modelValue": o[4] ||= (e) => j.value = e,
				loading: M.value,
				"bg-color": r.bgColor,
				"header-text": N.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": r.drawerWidth,
				"has-changes": L.value,
				onSubmit: ee,
				onCancel: re
			}, {
				default: O(() => [
					c(l, {
						modelValue: I.key,
						"onUpdate:modelValue": o[0] ||= (e) => I.key = e,
						icon: "mdi:mdi-key",
						label: E(Z)("key"),
						required: !N.value,
						rules: E(p)(N.value, { allowUppercase: !0 }),
						disabled: N.value,
						hint: E(Z)("string_key_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"required",
						"rules",
						"disabled",
						"hint"
					]),
					c(d, {
						modelValue: I.string,
						"onUpdate:modelValue": o[1] ||= (e) => I.string = e,
						label: E(Z)("string_value"),
						rules: [...E(f)()],
						hint: E(Z)("string_value_hint"),
						icon: "mdi:mdi-text",
						required: "",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3",
						disabled: P.value
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint",
						"disabled"
					]),
					c(d, {
						modelValue: I.description,
						"onUpdate:modelValue": o[2] ||= (e) => I.description = e,
						label: E(Z)("description"),
						hint: E(Z)("string_description_hint"),
						icon: "mdi:mdi-text-long",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3",
						disabled: P.value
					}, null, 8, [
						"modelValue",
						"label",
						"hint",
						"disabled"
					]),
					c(h, {
						modelValue: I.tag,
						"onUpdate:modelValue": o[3] ||= (e) => I.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						hint: E(Z)("string_tag_hint"),
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "],
						disabled: P.value
					}, null, 8, [
						"modelValue",
						"label",
						"hint",
						"disabled"
					]),
					c(v, {
						icon: "mdi:mdi-translate",
						label: E(Z)("translations"),
						hint: E(Z)("string_translation_hint")
					}, {
						default: O(() => [c($, null, {
							default: O(() => [(_(!0), i(e, null, b(I.translation, (e, t) => (_(), n(Q, {
								key: t,
								cols: "12",
								class: "mb-2 ga-4 pa-6"
							}, {
								default: O(() => [c($, { class: "align-center" }, {
									default: O(() => [
										c(Q, {
											cols: "auto",
											class: "d-flex align-center"
										}, {
											default: O(() => [c(ze, {
												icon: "mdi:mdi-translate-variant",
												class: "mr-2"
											}), a("span", Pn, T(E(Z)("translation_item")) + " #" + T(t + 1), 1)]),
											_: 2
										}, 1024),
										c(be),
										c(Q, { cols: "auto" }, {
											default: O(() => [c(g, {
												icon: "mdi:mdi-delete",
												variant: "text",
												color: "error",
												disabled: P.value,
												onClick: (e) => J(t)
											}, null, 8, ["disabled", "onClick"])]),
											_: 2
										}, 1024)
									]),
									_: 2
								}, 1024), c($, { class: "d-flex flex-column" }, {
									default: O(() => [c(Q, { class: "d-flex flex-column pt-0" }, {
										default: O(() => [
											c(l, {
												modelValue: e.locale,
												"onUpdate:modelValue": (t) => e.locale = t,
												label: E(Z)("locale"),
												rules: E(m),
												hint: E(Z)("string_translation_locale_hint"),
												disabled: N.value && e.readonly
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"rules",
												"hint",
												"disabled"
											]),
											c(l, {
												modelValue: e.string,
												"onUpdate:modelValue": (t) => e.string = t,
												label: E(Z)("original_string"),
												hint: E(Z)("string_translation_original_hint"),
												disabled: ""
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"hint"
											]),
											c(d, {
												modelValue: e.custom,
												"onUpdate:modelValue": (t) => e.custom = t,
												label: E(Z)("custom_translation"),
												hint: E(Z)("string_translation_custom_hint"),
												density: "comfortable",
												variant: "outlined",
												"bg-color": "white",
												"auto-grow": "",
												rows: "2"
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"hint"
											])
										]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024))), 128)), c(Q, { cols: "12" }, {
								default: O(() => [c(nt, null, {
									activator: O(({ props: e }) => [c(g, u(e, {
										type: "primary",
										variant: "outlined",
										"prepend-icon": "mdi:mdi-plus",
										"append-icon": "mdi:mdi-chevron-down",
										class: "mt-4",
										loading: E(B),
										disabled: V.value.length === 0
									}), {
										default: O(() => [s(T(E(Z)("add_translation")), 1)]),
										_: 1
									}, 16, ["loading", "disabled"])]),
									default: O(() => [c(et, null, {
										default: O(() => [(_(!0), i(e, null, b(V.value, (e) => (_(), n(tt, {
											key: e.key,
											title: e.title,
											subtitle: e.key,
											onClick: (t) => G(e.key)
										}, null, 8, [
											"title",
											"subtitle",
											"onClick"
										]))), 128))]),
										_: 1
									})]),
									_: 1
								})]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}, 8, ["label", "hint"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, In = {
	__name: "admin-strings",
	props: {},
	setup(a) {
		let { hHttpRequest: o } = Y(), { hAddAlert: l } = q(), { confirm: d } = ce();
		X(a, "HAdminStrings");
		let { buildQueryParams: f } = de(), p = y(!0), m = y(null), g = y(!1), b = y({}), x = t(() => ({
			title: Z("translation"),
			key: b.value.key
		})), C = t(() => JSON.stringify(b.value.translation, null, 2) ?? "");
		function w(e) {
			b.value = e, g.value = !0;
		}
		let D = {
			term: "",
			key: "",
			keyMatchType: "contains",
			string: "",
			stringMatchType: "contains",
			tag: [],
			sortBy: "string.lower",
			sortOrder: "asc",
			page: 1,
			pageSize: 25
		}, k = v({ ...D }), A = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "key",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("key_filter"),
					placeholder: Z("key_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-key",
					defaultMatchType: "contains"
				}
			},
			{
				key: "string",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("string_filter"),
					placeholder: Z("string_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-text",
					defaultMatchType: "contains"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			}
		] }, M = [
			{
				title: "key",
				key: "key",
				sortable: !0,
				width: 200,
				value: "key",
				nowrap: !0,
				translate: !0
			},
			{
				title: "string",
				key: "string",
				align: "start",
				sortable: !0,
				width: 250,
				value: "string",
				nowrap: !1,
				customSortKey: "string.lower",
				translate: !0
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => W("tag", e),
				isFilterActive: (e) => ee("tag", e)
			},
			{
				title: "translation",
				key: "translation",
				sortable: !1,
				width: 350,
				value: "translation",
				nowrap: !1,
				translate: !0
			}
		], N = {
			pageKey: "strings",
			pageTitle: Z("admin_strings_title"),
			headerTitle: Z("strings"),
			searchPlaceholder: Z("search_strings"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("strings"),
					text: Z("strings")
				}
			]
		}, { data: P, loading: F, params: I, execute: L, totalResults: R } = G({
			url: "/admin/strings",
			filters: k,
			additionalParams: {}
		}), z = Z("total_strings"), B = t(() => ({ widgets: [{
			summary: !0,
			title: z,
			count: R.value,
			icon: "mdi:mdi-text",
			color: "blue-grey-lighten-3",
			iconColor: "blue-grey-darken-4"
		}] }));
		function V() {
			H(!0);
		}
		function H(e = !1) {
			let { query: t, sort: n } = f(A.filters, k);
			I.query = t, I.sort = n, (e || p.value) && L();
		}
		let U = qe(H, 300), { isFilterActive: ee, toggleArrayFilter: W } = ue({
			filters: k,
			onFilterChange: U
		}), te = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					m.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					m.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				hidden: (e) => e.system === !0,
				action: async (e) => {
					if ((await d({
						title: Z("delete_string"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = o({
							url: `/admin/strings/${e.key}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							l({
								title: Z("error_occurred"),
								body: Z("string_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await L();
					}
				}
			}
		];
		function ne() {
			return Object.assign(k, { ...D }), H(!0);
		}
		function re() {
			m.value?.open();
		}
		return h(async () => {
			J(k, U), H(), L();
		}), (t, a) => {
			let o = S("h-admin-template"), l = S("h-view-code-dialog");
			return _(), i(e, null, [
				c(o, {
					"auto-search-enabled": p.value,
					"onUpdate:autoSearchEnabled": a[0] ||= (e) => p.value = e,
					"page-configuration": N,
					"widgets-config": B.value,
					"filters-config": A,
					filters: k,
					"table-headers": M,
					"table-params": E(I),
					"table-data": E(P),
					"table-loading": E(F),
					"table-actions": te,
					"total-results": E(R),
					"open-form": re,
					onSearch: V,
					onClearFilters: ne
				}, {
					"item.translation": O(({ item: e }) => [e.translation == null ? r("", !0) : (_(), n($e, {
						key: 0,
						location: "top"
					}, {
						activator: O(({ props: t }) => [c(Ue, u(t, {
							icon: "mdi:mdi-code-json",
							variant: "text",
							size: "small",
							"aria-label": E(Z)("click_to_view_translation"),
							onClick: j((t) => w(e), ["stop"])
						}), null, 16, ["aria-label", "onClick"])]),
						default: O(() => [s(" " + T(E(Z)("click_to_view_translation")), 1)]),
						_: 2
					}, 1024))]),
					_: 1
				}, 8, [
					"auto-search-enabled",
					"widgets-config",
					"filters",
					"table-params",
					"table-data",
					"table-loading",
					"total-results"
				]),
				c(l, {
					modelValue: g.value,
					"onUpdate:modelValue": a[1] ||= (e) => g.value = e,
					item: x.value,
					"field-name": "key",
					"field-label": E(Z)("key")
				}, {
					"raw-json": O(() => [s(T(C.value), 1)]),
					_: 1
				}, 8, [
					"modelValue",
					"item",
					"field-label"
				]),
				c(Fn, {
					ref_key: "stringFormRef",
					ref: m,
					onSuccess: E(L)
				}, null, 8, ["onSuccess"])
			], 64);
		};
	}
}, Ln = {
	__name: "agent-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 500
		}
	},
	emits: ["success", "cancel"],
	setup(e, { expose: t, emit: r }) {
		let { nameRules: i } = ie(), { hAddAlert: a } = q(), { save: o } = ae(), s = [(e) => {
			if (!Array.isArray(e) || e.length < 2) return !0;
			let t = e.map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : e);
			return new Set(t).size === t.length || Z("resources_unique");
		}];
		X(e, "HAgentForm");
		let l = {
			name: {
				type: String,
				default: ""
			},
			tag: {
				type: Array,
				default: () => []
			},
			role: {
				type: Array,
				default: () => []
			},
			domain: {
				type: Array,
				default: () => []
			},
			resources: {
				type: Array,
				default: () => []
			}
		}, u = () => {
			let e = {};
			return Object.keys(l).forEach((t) => {
				let n = l[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, d = r, f = y(null), p = y(!1), m = y(!1), h = y(!1), g = y(null), b = v(u()), x = y(!1), C = y({}), { data: w, loading: T } = K({
			url: "/admin/roles",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), { data: k, loading: A } = K({
			url: "/admin/domains",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		});
		D(p, (e) => {
			e || j();
		}), D(b, () => {
			x.value = JSON.stringify(b) !== JSON.stringify(C.value);
		}, { deep: !0 });
		function j() {
			let e = u();
			Object.keys(e).forEach((t) => {
				b[t] = e[t];
			}), C.value = JSON.parse(JSON.stringify(b)), h.value = !1, g.value = null, x.value = !1;
		}
		function M(e, t = !0) {
			Object.keys(l).forEach((t) => {
				let n = l[t], r = e?.[t], i = r != null;
				n.type === Array ? b[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : (n.type, b[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), C.value = JSON.parse(JSON.stringify(b)), h.value = t, g.value = t && e?.id || null, x.value = !t;
		}
		async function N() {
			if (!m.value && ((await f.value?.validate())?.valid ?? !0)) {
				m.value = !0;
				try {
					await I(F()), d("success"), p.value = !1;
				} catch (e) {
					a({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					m.value = !1;
				}
			}
		}
		function P(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) r === null || r === "" || Array.isArray(r) && r.length === 0 || (t[n] = r);
			return t;
		}
		function F() {
			let e = (e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : e).filter(Boolean) : [];
			return P({
				name: b.name?.trim() || null,
				tag: e(b.tag),
				role: e(b.role),
				domain: e(b.domain),
				resources: e(b.resources)
			});
		}
		async function I(e) {
			let t = h.value ? "update" : "create", n = {
				create: "/admin/agents",
				update: `/admin/agents/${g.value}`
			}, r = {
				create: "post",
				update: "put"
			}, i = {
				error: {
					create: "agent_create_error",
					update: "agent_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			};
			if (!(await o({
				url: n[t],
				method: r[t],
				payload: e
			}))?.ok) throw Error(Z(i.error[t]));
			a({
				title: Z(i.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function L() {
			d("cancel"), p.value = !1;
		}
		function R(e = null) {
			e && M(e), p.value = !0;
		}
		function z(e) {
			M(e, !1), p.value = !0;
		}
		return t({
			validate: () => f.value?.validate(),
			reset: () => f.value?.reset(),
			resetValidation: () => f.value?.resetValidation(),
			formData: b,
			open: R,
			openCopy: z
		}), (t, r) => {
			let a = S("h-form-text"), o = S("h-form-combobox"), l = S("h-form-autocomplete"), u = S("h-form-layout");
			return _(), n(u, {
				ref_key: "formRef",
				ref: f,
				modelValue: p.value,
				"onUpdate:modelValue": r[5] ||= (e) => p.value = e,
				loading: m.value || E(T) || E(A),
				"bg-color": e.bgColor,
				"header-text": h.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": e.drawerWidth,
				"has-changes": x.value,
				onSubmit: N,
				onCancel: L
			}, {
				default: O(() => [c($, { "no-gutters": "" }, {
					default: O(() => [
						c(Q, { cols: "12" }, {
							default: O(() => [c(a, {
								modelValue: b.name,
								"onUpdate:modelValue": r[0] ||= (e) => b.name = e,
								label: E(Z)("name"),
								hint: E(Z)("agent_name_hint"),
								rules: E(i)
							}, null, 8, [
								"modelValue",
								"label",
								"hint",
								"rules"
							])]),
							_: 1
						}),
						c(Q, { cols: "12" }, {
							default: O(() => [c(o, {
								modelValue: b.tag,
								"onUpdate:modelValue": r[1] ||= (e) => b.tag = e,
								label: E(Z)("tag"),
								hint: E(Z)("agent_tag_hint"),
								multiple: "",
								chips: "",
								"closable-chips": ""
							}, null, 8, [
								"modelValue",
								"label",
								"hint"
							])]),
							_: 1
						}),
						c(Q, { cols: "12" }, {
							default: O(() => [c(l, {
								modelValue: b.role,
								"onUpdate:modelValue": r[2] ||= (e) => b.role = e,
								items: E(w),
								loading: E(T),
								label: E(Z)("role"),
								hint: E(Z)("agent_role_hint"),
								"item-title": "title",
								"item-value": "value",
								multiple: "",
								chips: "",
								"closable-chips": ""
							}, null, 8, [
								"modelValue",
								"items",
								"loading",
								"label",
								"hint"
							])]),
							_: 1
						}),
						c(Q, { cols: "12" }, {
							default: O(() => [c(l, {
								modelValue: b.domain,
								"onUpdate:modelValue": r[3] ||= (e) => b.domain = e,
								items: E(k),
								loading: E(A),
								label: E(Z)("domain"),
								hint: E(Z)("agent_domain_hint"),
								"item-title": "title",
								"item-value": "value",
								multiple: "",
								chips: "",
								"closable-chips": ""
							}, null, 8, [
								"modelValue",
								"items",
								"loading",
								"label",
								"hint"
							])]),
							_: 1
						}),
						c(Q, { cols: "12" }, {
							default: O(() => [c(o, {
								modelValue: b.resources,
								"onUpdate:modelValue": r[4] ||= (e) => b.resources = e,
								label: E(Z)("resources"),
								hint: E(Z)("agent_resources_hint"),
								rules: s,
								multiple: "",
								chips: "",
								"closable-chips": ""
							}, null, 8, [
								"modelValue",
								"label",
								"hint"
							])]),
							_: 1
						})
					]),
					_: 1
				})]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, Rn = {
	__name: "admin-agents",
	props: {},
	setup(n) {
		let { hHttpRequest: r } = Y(), { confirm: a } = ce(), { hAddAlert: o } = q();
		X(n, "HAdminAgents");
		let { formatDate: s } = fe(), { buildQueryParams: l } = de(), u = y(null), d = y(!0), f = {
			term: "",
			name: "",
			nameMatchType: "contains",
			tag: [],
			role: [],
			domain: [],
			lastactivePreset: null,
			sortBy: "lastactive",
			sortOrder: "desc",
			page: 1,
			pageSize: 25
		}, p = v({ ...f }), m = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: "Filter by name...",
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-format-title",
					defaultMatchType: "contains"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tags"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "role",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("roles"),
					icon: "mdi:mdi-shield-account"
				}
			},
			{
				key: "domain",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("domains"),
					icon: "mdi:mdi-domain"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					controlsSync: !0
				},
				filters: [{
					key: "lastactive",
					type: "date",
					component: "h-filter-datetime",
					model: "lastactivePreset",
					props: {
						label: Z("lastactive"),
						manualSync: !0
					}
				}]
			}
		] }, g = [
			{
				title: "id",
				key: "id",
				sortable: !0,
				value: "id",
				width: 80,
				nowrap: !0,
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0
			},
			{
				title: "tags",
				key: "tag",
				sortable: !0,
				width: 100,
				value: "tag",
				nowrap: !1,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => w("tag", e),
				isFilterActive: (e) => C("tag", e)
			},
			{
				title: "roles",
				key: "role",
				sortable: !1,
				width: 100,
				value: "role",
				nowrap: !1,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => w("role", e),
				isFilterActive: (e) => C("role", e)
			},
			{
				title: "resources",
				key: "resources",
				sortable: !1,
				width: 150,
				value: "resources",
				nowrap: !1,
				translate: !0,
				component: "h-chip-group-table-cell",
				componentProps: { column: !0 }
			},
			{
				title: "lastactive",
				key: "lastactive",
				sortable: !0,
				value: "lastactive",
				width: 100,
				nowrap: !1,
				translate: !0,
				formatCell: (e) => s(e)
			}
		], b = {
			pageKey: "agents",
			pageTitle: Z("agents_page_title"),
			headerTitle: Z("agents"),
			searchPlaceholder: Z("search_agents"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("agents"),
					text: Z("agents")
				}
			]
		}, x = qe(F, 300), { isFilterActive: C, toggleArrayFilter: w } = ue({
			filters: p,
			onFilterChange: x
		}), { data: T, loading: D, params: O, execute: k, totalResults: A } = G({
			url: "/admin/agents",
			filters: p
		}), j = Z("total_agents"), M = t(() => ({ widgets: [{
			summary: !0,
			title: j,
			count: A.value,
			icon: "mdi:mdi-robot",
			color: "blue-grey-lighten-3",
			iconColor: "blue-grey-darken-4"
		}] })), N = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					u.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					u.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await a({
						title: Z("delete_agent"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = r({
							url: `/admin/agents/${e.id}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							o({
								title: Z("error_occurred"),
								body: Z("agent_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await k();
					}
				}
			}
		];
		function P() {
			F(!0);
		}
		function F(e = !1) {
			let { query: t, sort: n } = l(m.filters, p);
			O.query = t, O.sort = n, (e || d.value) && k();
		}
		function I() {
			return Object.assign(p, { ...f }), F(!0);
		}
		function L() {
			u.value?.open();
		}
		return h(async () => {
			J(p, x), F(), k();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": d.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => d.value = e,
				"page-configuration": b,
				"widgets-config": M.value,
				"filters-config": m,
				filters: p,
				"table-headers": g,
				"table-params": E(O),
				"table-data": E(T),
				"table-loading": E(D),
				"total-results": E(A),
				"table-actions": N,
				"open-form": L,
				onSearch: P,
				onClearFilters: I
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(Ln, {
				ref_key: "agentFormRef",
				ref: u,
				onSuccess: E(k)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, zn = {
	__name: "user-form",
	props: {
		bgColor: {
			type: String,
			default: "white"
		},
		drawerWidth: {
			type: Number,
			default: 600
		}
	},
	emits: ["success"],
	setup(e, { expose: i, emit: a }) {
		X(e, "HUserForm");
		let o = a, { hAddAlert: s } = q(), { requiredRules: l, noSpacesRules: u, nameRules: f, usernameRules: p, emailRules: m, objectValueRules: h, userSettingsRules: g } = ie(), b = [...h, (e) => {
			if (!e || String(e).trim() === "") return !0;
			try {
				let t = JSON.parse(e);
				return t === null || Array.isArray(t) || typeof t != "object" ? Z("json_object_required") : !0;
			} catch {
				return Z("json_invalid");
			}
		}], { save: x } = ae(), C = () => ({
			key: "",
			name: "",
			username: "",
			email: "",
			password: "",
			role: [],
			domain: "",
			tag: [],
			settings: {
				locale: "",
				defaultpage: {
					type: "",
					value: ""
				}
			},
			expiredate: null,
			custom: {},
			audit: !0
		}), w = y(null), T = y(null), k = y(null), A = y(null), j = y(!1), M = y(!1), N = y(!1), P = y(null), F = v(C()), I = y(!1), L = y({}), R = t({
			get: () => {
				try {
					return JSON.stringify(F.custom || {}, null, 2);
				} catch {
					return "{}";
				}
			},
			set: (e) => {
				try {
					F.custom = JSON.parse(e || "{}");
				} catch {
					F.custom = {};
				}
			}
		}), z = [
			{
				title: Z("workspace"),
				value: "workspace"
			},
			{
				title: Z("last_workspace"),
				value: "lastworkspace"
			},
			{
				title: Z("all_workspaces"),
				value: "allworkspaces"
			}
		], B = [], V = t(() => F.settings?.defaultpage?.type === "workspace" ? l(Z("default_workspace_required")) : []), H = t(() => N.value ? [] : [...u(), (e) => e ? String(e).toLowerCase() !== "system" || Z("key_reserved_system") : !0]), { data: U, loading: ee } = K({
			url: "/admin/roles",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key
			}))
		}), { data: W, loading: te } = K({
			url: "/admin/domains",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key
			}))
		}), { data: ne, loading: re } = K({
			url: "/admin/locales",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key
			}))
		}), { data: G, loading: J } = K({
			url: "/admin/workspaces",
			formatter: (e) => e.map((e) => ({
				title: e.title,
				value: e.slug
			}))
		});
		D(j, (e) => {
			e || oe();
		}), D(F, () => {
			I.value = JSON.stringify(F) !== JSON.stringify(L.value);
		}, { deep: !0 });
		function oe() {
			let e = C();
			Object.keys(e).forEach((t) => {
				F[t] = e[t];
			}), L.value = JSON.parse(JSON.stringify(F)), N.value = !1, P.value = null, I.value = !1;
		}
		function Y(e, t = !0) {
			let n = C();
			Object.keys(n).forEach((t) => {
				let r = e?.[t], i = r != null;
				if (t === "settings") {
					let e = i && typeof r == "object" ? r : {};
					F[t] = {
						...n[t],
						...e,
						defaultpage: {
							...n[t] && typeof n[t].defaultpage == "object" ? n[t].defaultpage : {},
							...e.defaultpage && typeof e.defaultpage == "object" ? e.defaultpage : {}
						}
					};
				} else Array.isArray(n[t]) ? F[t] = i && Array.isArray(r) ? [...r] : [...n[t]] : F[t] = i ? r : n[t];
			}), t || (F.key = ""), L.value = JSON.parse(JSON.stringify(F)), N.value = t, P.value = t && e?._id || null, I.value = !t;
		}
		function se() {
			let e = {}, t = L.value;
			return Object.keys(F).forEach((n) => {
				JSON.stringify(F[n]) !== JSON.stringify(t[n]) && (e[n] = F[n]);
			}), e;
		}
		function ce(e) {
			if (e == null || e === "") return null;
			let t = e instanceof Date ? e : new Date(e);
			return Number.isNaN(t.getTime()) ? null : t.toISOString();
		}
		function le(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) if (!(r == null || r === "" || Array.isArray(r) && r.length === 0)) {
				if (typeof r == "boolean") {
					t[n] = r;
					continue;
				}
				if (r instanceof Date) {
					t[n] = r;
					continue;
				}
				if (typeof r == "object" && !Array.isArray(r)) {
					let e = le(r);
					Object.keys(e).length > 0 && (t[n] = e);
				} else {
					if (typeof r == "string" && r.trim() === "") continue;
					t[n] = r;
				}
			}
			return t;
		}
		function ue() {
			let e = T.value?.getValue?.();
			e && (F.name = e);
			let t = k.value?.getValue?.();
			t && (F.username = t);
			let n = A.value?.getValue?.();
			n && (F.email = n);
		}
		async function de() {
			if (!M.value && (ue(), await d(), (await w.value?.validate())?.valid ?? !0)) {
				M.value = !0;
				try {
					let e = se(), t = { ...F };
					if (N.value) {
						if (delete t.key, Object.keys(e).length === 0) {
							o("success"), pe();
							return;
						}
						e.password || delete t.password;
					}
					let n = N.value && !!L.value?.expiredate && !F.expiredate;
					t = le(t), t.expiredate &&= ce(t.expiredate), n && (t.expiredate = null), N.value && !t.password && delete t.password, t.settings?.defaultpage?.type && t.settings.defaultpage.type !== "workspace" && delete t.settings.defaultpage.value;
					let r = N.value ? "put" : "post";
					if (!(await x({
						url: N.value ? `/admin/users/${F.key}` : "/admin/users",
						method: r,
						payload: t
					}))?.ok) throw Error(Z("user_save_error"));
					o("success"), pe();
				} catch {
					s({
						title: Z("error"),
						body: Z("user_save_error"),
						type: "error",
						timeout: 5e3
					});
				} finally {
					M.value = !1;
				}
			}
		}
		function fe() {
			pe();
		}
		function pe() {
			j.value = !1, d(() => {
				oe();
			});
		}
		function me(e = null) {
			e ? Y(e) : oe(), j.value = !0;
		}
		function he(e) {
			Y(e, !1), j.value = !0;
		}
		return i({
			open: me,
			openCopy: he,
			close: pe,
			formData: F
		}), D(() => F.settings?.defaultpage?.type, (e) => {
			e !== "workspace" && (F.settings.defaultpage.value = "");
		}), (t, i) => {
			let a = S("h-form-text"), o = S("h-form-autocomplete"), s = S("h-form-combobox"), l = S("h-form-select"), u = S("h-form-field"), d = S("h-form-date-time-picker"), h = S("h-form-switch"), v = S("h-form-code-editor"), y = S("h-form-layout");
			return _(), n(y, {
				ref_key: "formRef",
				ref: w,
				modelValue: j.value,
				"onUpdate:modelValue": i[14] ||= (e) => j.value = e,
				loading: M.value,
				"bg-color": e.bgColor,
				"header-text": N.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": e.drawerWidth,
				"has-changes": I.value,
				onSubmit: de,
				onCancel: fe
			}, {
				default: O(() => [
					c(a, {
						modelValue: F.key,
						"onUpdate:modelValue": i[0] ||= (e) => F.key = e,
						icon: "mdi:mdi-key",
						label: E(Z)("key"),
						rules: H.value,
						hint: E(Z)("user_key_hint"),
						disabled: N.value
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint",
						"disabled"
					]),
					c(a, {
						ref_key: "nameFieldRef",
						ref: T,
						modelValue: F.name,
						"onUpdate:modelValue": i[1] ||= (e) => F.name = e,
						icon: "mdi:mdi-account",
						label: E(Z)("name"),
						required: "",
						rules: E(f),
						hint: E(Z)("user_name_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(a, {
						ref_key: "usernameFieldRef",
						ref: k,
						modelValue: F.username,
						"onUpdate:modelValue": i[2] ||= (e) => F.username = e,
						icon: "mdi:mdi-account-circle",
						label: E(Z)("username"),
						required: "",
						rules: E(p),
						hint: E(Z)("user_username_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(a, {
						ref_key: "emailFieldRef",
						ref: A,
						modelValue: F.email,
						"onUpdate:modelValue": i[3] ||= (e) => F.email = e,
						icon: "mdi:mdi-email",
						type: "email",
						label: E(Z)("email"),
						rules: E(m)(!1),
						hint: E(Z)("user_email_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(E(De), {
						modelValue: F.password,
						"onUpdate:modelValue": i[4] ||= (e) => F.password = e,
						icon: "mdi:mdi-lock",
						label: E(Z)("password"),
						required: !1,
						"allow-empty": N.value,
						"disable-autofill": "",
						hint: N.value ? E(Z)("user_password_edit_hint") : E(Z)("user_password_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"allow-empty",
						"hint"
					]),
					c(o, {
						modelValue: F.role,
						"onUpdate:modelValue": i[5] ||= (e) => F.role = e,
						icon: "mdi:mdi-account-key",
						label: E(Z)("roles"),
						items: E(U),
						loading: E(ee),
						hint: E(Z)("user_roles_hint"),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint"
					]),
					c(o, {
						modelValue: F.domain,
						"onUpdate:modelValue": i[6] ||= (e) => F.domain = e,
						icon: "mdi:mdi-domain",
						label: E(Z)("domain"),
						items: E(W),
						loading: E(te),
						hint: E(Z)("user_domain_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint"
					]),
					c(s, {
						modelValue: F.tag,
						"onUpdate:modelValue": i[7] ||= (e) => F.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						hint: E(Z)("user_tags_hint"),
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "]
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(u, {
						icon: "mdi:mdi-cog",
						label: E(Z)("settings"),
						hint: E(Z)("user_settings_hint"),
						indent: ""
					}, {
						default: O(() => [c($, null, {
							default: O(() => [
								c(Q, {
									cols: "12",
									md: "12"
								}, {
									default: O(() => [c(o, {
										modelValue: F.settings.locale,
										"onUpdate:modelValue": i[8] ||= (e) => F.settings.locale = e,
										icon: "mdi:mdi-earth",
										label: E(Z)("locale"),
										items: E(ne),
										loading: E(re),
										hint: E(Z)("user_locale_hint"),
										rules: B
									}, null, 8, [
										"modelValue",
										"label",
										"items",
										"loading",
										"hint"
									])]),
									_: 1
								}),
								c(Q, {
									cols: "12",
									md: "12"
								}, {
									default: O(() => [c(l, {
										modelValue: F.settings.defaultpage.type,
										"onUpdate:modelValue": i[9] ||= (e) => F.settings.defaultpage.type = e,
										icon: "mdi:mdi-home",
										label: E(Z)("default_page_type"),
										items: z,
										rules: E(g).defaultPageType,
										hint: E(Z)("user_default_page_type_hint")
									}, null, 8, [
										"modelValue",
										"label",
										"rules",
										"hint"
									])]),
									_: 1
								}),
								F.settings.defaultpage.type === "workspace" ? (_(), n(Q, {
									key: 0,
									cols: "12",
									md: "12"
								}, {
									default: O(() => [c(o, {
										modelValue: F.settings.defaultpage.value,
										"onUpdate:modelValue": i[10] ||= (e) => F.settings.defaultpage.value = e,
										icon: "mdi:mdi-briefcase",
										label: E(Z)("default_workspace"),
										items: E(G),
										loading: E(J),
										hint: E(Z)("user_default_workspace_hint"),
										required: "",
										rules: V.value
									}, null, 8, [
										"modelValue",
										"label",
										"items",
										"loading",
										"hint",
										"rules"
									])]),
									_: 1
								})) : r("", !0)
							]),
							_: 1
						})]),
						_: 1
					}, 8, ["label", "hint"]),
					c(d, {
						modelValue: F.expiredate,
						"onUpdate:modelValue": i[11] ||= (e) => F.expiredate = e,
						icon: "mdi:mdi-calendar-clock",
						label: E(Z)("expire_date"),
						hint: E(Z)("user_expire_date_hint"),
						clearable: ""
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(h, {
						modelValue: F.audit,
						"onUpdate:modelValue": i[12] ||= (e) => F.audit = e,
						icon: "mdi:mdi-history",
						label: E(Z)("audit"),
						hint: E(Z)("user_audit_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(u, {
						icon: "mdi:mdi-code-json",
						label: E(Z)("custom_fields"),
						hint: E(Z)("user_custom_hint")
					}, {
						default: O(() => [c(v, {
							modelValue: R.value,
							"onUpdate:modelValue": i[13] ||= (e) => R.value = e,
							language: "json",
							hint: E(Z)("user_custom_json_hint"),
							rules: b
						}, null, 8, ["modelValue", "hint"])]),
						_: 1
					}, 8, ["label", "hint"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, Bn = {
	__name: "admin-users",
	props: {},
	setup(n) {
		X(n, "HAdminUsers");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { confirm: s } = ce(), { hAddAlert: l } = q(), u = y(!0), d = y(null), f = {
			term: "",
			name: "",
			nameMatchType: "contains",
			email: "",
			emailMatchType: "contains",
			username: "",
			usernameMatchType: "contains",
			role: [],
			tag: [],
			lastloginPreset: null,
			lastactivePreset: null,
			audit: null,
			sortBy: "lastlogin",
			sortOrder: "desc",
			page: 1,
			pageSize: 25
		}, p = v({ ...f }), m = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "audit",
				type: "boolean"
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-account",
					defaultMatchType: "contains"
				}
			},
			{
				key: "email",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("email_filter"),
					placeholder: Z("email_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-email",
					defaultMatchType: "contains"
				}
			},
			{
				key: "username",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("username_filter"),
					placeholder: Z("username_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-account-circle",
					defaultMatchType: "contains"
				}
			},
			{
				key: "role",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("role_filter_label"),
					icon: "mdi:mdi-account-key"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [{
					key: "lastlogin",
					type: "date",
					component: "h-filter-datetime",
					model: "lastloginPreset",
					props: {
						label: Z("lastlogin_filter"),
						manualSync: !0
					}
				}, {
					key: "lastactive",
					type: "date",
					component: "h-filter-datetime",
					model: "lastactivePreset",
					props: {
						label: Z("lastactive_filter"),
						manualSync: !0
					}
				}]
			}
		] }, g = [
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 200,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0
			},
			{
				title: "role",
				key: "role",
				sortable: !0,
				width: 150,
				value: "role",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => P("role", e),
				isFilterActive: (e) => N("role", e)
			},
			{
				title: "email",
				key: "email",
				sortable: !0,
				width: 200,
				value: "email",
				nowrap: !1,
				translate: !0
			},
			{
				title: "username",
				key: "username",
				sortable: !0,
				width: 150,
				value: "username",
				nowrap: !1,
				translate: !0
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => P("tag", e),
				isFilterActive: (e) => N("tag", e)
			},
			{
				title: "lastlogin",
				key: "lastlogin",
				sortable: !0,
				width: 150,
				value: "lastlogin",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			},
			{
				title: "lastactive",
				key: "lastactive",
				sortable: !0,
				width: 150,
				value: "lastactive",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], b = {
			pageKey: "users",
			pageTitle: Z("users_page_title"),
			headerTitle: Z("users"),
			searchPlaceholder: Z("search_users"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("users"),
					text: Z("users")
				}
			]
		}, { data: x, loading: C, params: w, execute: T, totalResults: D } = G({
			url: "/admin/users",
			filters: p,
			additionalParams: {}
		}), O = Z("total_users"), k = t(() => ({ widgets: [{
			summary: !0,
			title: O,
			count: D.value,
			icon: "mdi:mdi-account-group",
			color: "grey-lighten-3",
			iconColor: "grey-darken-4"
		}] }));
		function A() {
			j(!0);
		}
		function j(e = !1) {
			let { query: t, sort: n } = a(m.filters, p);
			w.query = t, w.sort = n, (e || u.value) && T();
		}
		let M = qe(j, 300), { isFilterActive: N, toggleArrayFilter: P } = ue({
			filters: p,
			onFilterChange: M
		}), F = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					d.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					d.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if (!e.key) {
						l({
							title: Z("error"),
							body: Z("user_delete_error_no_key"),
							type: "error"
						});
						return;
					}
					if ((await s({
						title: Z("delete"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) try {
						let { execute: t } = o({
							url: `/admin/users/${e.key}`,
							method: "delete",
							immediate: !1
						});
						await t(), await T(), l({
							title: Z("success"),
							body: Z("user_deleted_successfully"),
							type: "success"
						});
					} catch {
						l({
							title: Z("error"),
							body: Z("user_delete_error"),
							type: "error"
						});
					}
				}
			}
		];
		function I() {
			return Object.assign(p, { ...f }), j(!0);
		}
		function L() {
			d.value?.open();
		}
		return h(async () => {
			J(p, M), j(), T();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": u.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => u.value = e,
				"page-configuration": b,
				"widgets-config": k.value,
				"filters-config": m,
				filters: p,
				"table-headers": g,
				"table-actions": F,
				"table-params": E(w),
				"table-data": E(x),
				"table-loading": E(C),
				"total-results": E(D),
				"open-form": L,
				onSearch: A,
				onClearFilters: I
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(zn, {
				ref_key: "userFormRef",
				ref: d,
				onSuccess: E(T)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, Vn = { class: "text-headline-small" }, Hn = { class: "text-headline-small" }, Un = {
	__name: "workflow-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 700
		}
	},
	emits: ["success", "cancel"],
	setup(t, { expose: r, emit: o }) {
		let { hAddAlert: l } = q(), { keyRules: u, nameRules: d, requiredRules: f, objectValueRules: p, integerRules: m } = ie(), { save: h } = ae(), g = [(e) => !e || /^[a-z0-9_-]*$/.test(e) || Z("state_id_format")], x = m(), C = () => [...x];
		function w(e) {
			return typeof e == "number" || typeof e == "string" || e === null ? !0 : Array.isArray(e) ? e.every((e) => typeof e == "string" || typeof e == "number") : !1;
		}
		let k = [...p, (e) => {
			if (!e || String(e).trim() === "") return !0;
			try {
				let t = JSON.parse(e);
				if (t === null || Array.isArray(t) || typeof t != "object") return Z("json_object_required");
				for (let e of Object.values(t)) if (!w(e)) return Z("workflow_state_meta_value_invalid");
				return !0;
			} catch {
				return Z("json_invalid");
			}
		}], A = [(e) => !e || /^[a-z_][a-z0-9_-]*$/.test(e) || Z("meta_key_format")];
		X(t, "HWorkflowForm");
		let j = {
			key: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			bpmnresource: {
				type: String,
				default: ""
			},
			icon: {
				type: String,
				default: ""
			},
			tag: {
				type: Array,
				default: () => []
			},
			owner: {
				type: String,
				default: ""
			},
			role: {
				type: Array,
				default: () => []
			},
			impersonate: {
				type: String,
				default: ""
			},
			domain: {
				type: Array,
				default: () => []
			},
			nonpersistent: {
				type: Boolean,
				default: !1
			},
			state: {
				type: Array,
				default: () => []
			},
			meta: {
				type: Array,
				default: () => []
			}
		}, M = {
			order: {
				type: Number,
				default: 1
			},
			id: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			required: {
				type: Boolean,
				default: !1
			},
			meta: {
				type: String,
				default: ""
			}
		}, N = () => {
			let e = {};
			return Object.keys(j).forEach((t) => {
				let n = j[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, P = () => {
			let e = {};
			return Object.keys(M).forEach((t) => {
				let n = M[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, F = o, I = y(null), L = y(!1), R = y(!1), z = y(!1), B = y(null), V = v(N()), H = y(!1), U = y({}), { data: ee, loading: W } = K({
			url: "/admin/roles",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), { data: te, loading: ne } = K({
			url: "/admin/domains",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), { data: re, loading: G } = K({
			url: "/admin/users",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.username,
				key: e.username
			}))
		});
		D(L, (e) => {
			e || J();
		}), D(V, () => {
			H.value = JSON.stringify(V) !== JSON.stringify(U.value);
		}, { deep: !0 });
		function J() {
			let e = N();
			Object.keys(e).forEach((t) => {
				V[t] = e[t];
			}), U.value = JSON.parse(JSON.stringify(V)), z.value = !1, B.value = null, H.value = !1;
		}
		function oe(e, t = !0) {
			Object.keys(j).forEach((t) => {
				let n = j[t], r = e?.[t], i = r != null;
				t === "state" ? i && Array.isArray(r) ? V[t] = r.map((e) => ({
					...e,
					meta: e.meta ? JSON.stringify(e.meta, null, 2) : ""
				})) : V[t] = typeof n.default == "function" ? n.default() : n.default : t === "meta" ? i && typeof r == "object" && !Array.isArray(r) ? V[t] = Object.entries(r).map(([e, t]) => ({
					key: e,
					value: typeof t == "object" ? JSON.stringify(t) : String(t)
				})) : V[t] = typeof n.default == "function" ? n.default() : n.default : n.type === Array ? V[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : n.type === Boolean ? V[t] = i ? !!r : typeof n.default == "function" ? n.default() : n.default : (n.type === String || n.type, V[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), t || (V.key = ""), U.value = JSON.parse(JSON.stringify(V)), z.value = t, B.value = t && e?.key || null, H.value = !t;
		}
		async function Y() {
			if (!R.value && ((await I.value?.validate())?.valid ?? !0)) {
				R.value = !0;
				try {
					await le(ce()), F("success"), L.value = !1;
				} catch (e) {
					l({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					R.value = !1;
				}
			}
		}
		function se(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) if (!(r === null || r === "" || Array.isArray(r) && r.length === 0)) {
				if (n === "meta" && typeof r == "object" && !Array.isArray(r)) {
					t[n] = r;
					continue;
				}
				if (typeof r == "object" && !Array.isArray(r)) {
					let e = {};
					for (let [t, n] of Object.entries(r)) n !== null && n !== "" && !(Array.isArray(n) && n.length === 0) && (e[t] = n);
					Object.keys(e).length > 0 && (t[n] = e);
				} else t[n] = r;
			}
			return t;
		}
		function ce() {
			let e = (e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [], t = e(V.role), n = e(V.domain), r = e(V.tag), i = Array.isArray(V.state) ? V.state.filter((e) => e && typeof e == "object" && e.name).map((e) => {
				let t = { name: String(e.name || "").trim() };
				if (e.id && (t.id = String(e.id).trim()), e.description && (t.description = String(e.description).trim()), e.order !== null && e.order !== void 0 && e.order !== "" && (t.order = parseInt(e.order, 10)), e.required && (t.required = !!e.required), e.meta && e.meta.trim()) try {
					t.meta = JSON.parse(e.meta);
				} catch {}
				return t;
			}) : [], a = z.value ? {} : null;
			return Array.isArray(V.meta) && V.meta.length > 0 && (a = {}, V.meta.forEach((e) => {
				if (e.key && e.key.trim()) {
					let t = e.key.trim(), n = e.value;
					if (n != null && n !== "") try {
						a[t] = JSON.parse(n);
					} catch {
						a[t] = n;
					}
					else a[t] = "";
				}
			}), Object.keys(a).length === 0 && !z.value && (a = null)), se({
				key: V.key?.trim()?.toLowerCase() || null,
				name: V.name?.trim() || null,
				description: V.description?.trim() || null,
				bpmnresource: V.bpmnresource?.trim() || null,
				icon: V.icon?.trim() || null,
				tag: r,
				owner: V.owner?.trim ? V.owner.trim() : V.owner || null,
				role: t,
				impersonate: V.impersonate?.trim ? V.impersonate.trim() : V.impersonate || null,
				domain: n,
				nonpersistent: V.nonpersistent || !1,
				state: i,
				meta: a
			});
		}
		async function le(e) {
			let t = z.value ? "update" : "create", n = {
				create: "/admin/workflows",
				update: `/admin/workflows/${B.value}`
			}, r = {
				create: "post",
				update: "put"
			}, i = {
				error: {
					create: "workflow_create_error",
					update: "workflow_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			}, a = t === "update" ? (({ key: e, ...t }) => t)(e) : e;
			if (!(await h({
				url: n[t],
				method: r[t],
				payload: a
			}))?.ok) throw Error(Z(i.error[t]));
			l({
				title: Z(i.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function ue() {
			F("cancel"), L.value = !1;
		}
		function de() {
			V.state ||= [], V.state.push(P());
		}
		function fe(e) {
			V.state.splice(e, 1);
		}
		function pe() {
			V.meta ||= [], V.meta.push({
				key: "",
				value: ""
			});
		}
		function me(e) {
			V.meta.splice(e, 1);
		}
		function he(e = null) {
			e ? oe(e) : J(), L.value = !0;
		}
		function ge(e) {
			oe(e, !1), L.value = !0;
		}
		return r({
			validate: () => I.value?.validate(),
			reset: () => I.value?.reset(),
			resetValidation: () => I.value?.resetValidation(),
			formData: V,
			open: he,
			openCopy: ge
		}), (r, o) => {
			let l = S("h-form-text"), p = S("h-form-textarea"), m = S("h-form-autocomplete"), h = S("h-form-combobox"), v = S("h-form-switch"), y = S("h-action-button"), x = S("h-form-field"), w = S("h-form-layout");
			return _(), n(w, {
				ref_key: "formRef",
				ref: I,
				modelValue: L.value,
				"onUpdate:modelValue": o[11] ||= (e) => L.value = e,
				loading: R.value,
				"bg-color": t.bgColor,
				"header-text": z.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": t.drawerWidth,
				"has-changes": H.value,
				onSubmit: Y,
				onCancel: ue
			}, {
				default: O(() => [
					c(l, {
						modelValue: V.key,
						"onUpdate:modelValue": o[0] ||= (e) => V.key = e,
						icon: "mdi:mdi-key",
						label: E(Z)("key"),
						rules: z.value ? [] : E(u)(!1),
						hint: E(Z)("workflow_key_hint"),
						disabled: z.value
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint",
						"disabled"
					]),
					c(l, {
						modelValue: V.name,
						"onUpdate:modelValue": o[1] ||= (e) => V.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: E(d),
						hint: E(Z)("workflow_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(p, {
						modelValue: V.description,
						"onUpdate:modelValue": o[2] ||= (e) => V.description = e,
						label: E(Z)("description"),
						icon: "mdi:mdi-text",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3",
						hint: E(Z)("workflow_description_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(l, {
						modelValue: V.icon,
						"onUpdate:modelValue": o[3] ||= (e) => V.icon = e,
						icon: "mdi:mdi-image-outline",
						label: E(Z)("icon"),
						hint: E(Z)("workflow_icon_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(l, {
						modelValue: V.bpmnresource,
						"onUpdate:modelValue": o[4] ||= (e) => V.bpmnresource = e,
						icon: "mdi:mdi-file-code",
						label: E(Z)("bpmn_resource"),
						hint: E(Z)("workflow_bpmn_resource_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(m, {
						modelValue: V.owner,
						"onUpdate:modelValue": o[5] ||= (e) => V.owner = e,
						icon: "mdi:mdi-account",
						label: E(Z)("owner"),
						items: E(re),
						loading: E(G),
						clearable: "",
						hint: E(Z)("workflow_owner_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint"
					]),
					c(m, {
						modelValue: V.role,
						"onUpdate:modelValue": o[6] ||= (e) => V.role = e,
						icon: "mdi:mdi-account-key",
						label: E(Z)("roles"),
						items: E(ee),
						loading: E(W),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading"
					]),
					c(m, {
						modelValue: V.impersonate,
						"onUpdate:modelValue": o[7] ||= (e) => V.impersonate = e,
						icon: "mdi:mdi-account-switch",
						label: E(Z)("impersonate"),
						items: E(re),
						loading: E(G),
						clearable: "",
						hint: E(Z)("workflow_impersonate_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint"
					]),
					c(m, {
						modelValue: V.domain,
						"onUpdate:modelValue": o[8] ||= (e) => V.domain = e,
						icon: "mdi:mdi-domain",
						label: E(Z)("domains"),
						items: E(te),
						loading: E(ne),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading"
					]),
					c(h, {
						modelValue: V.tag,
						"onUpdate:modelValue": o[9] ||= (e) => V.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "]
					}, null, 8, ["modelValue", "label"]),
					c(v, {
						modelValue: V.nonpersistent,
						"onUpdate:modelValue": o[10] ||= (e) => V.nonpersistent = e,
						icon: V.nonpersistent ? "mdi:mdi-database-off" : "mdi:mdi-database",
						label: E(Z)("nonpersistent"),
						hint: E(Z)("workflow_nonpersistent_hint")
					}, null, 8, [
						"modelValue",
						"icon",
						"label",
						"hint"
					]),
					c(x, {
						icon: "mdi:mdi-state-machine",
						label: E(Z)("states"),
						hint: E(Z)("workflow_states_hint")
					}, {
						default: O(() => [c($, null, {
							default: O(() => [(_(!0), i(e, null, b(V.state, (e, t) => (_(), n(Q, {
								key: t,
								cols: "12",
								class: "mb-2 ga-4 pa-6"
							}, {
								default: O(() => [c($, { class: "align-center" }, {
									default: O(() => [
										c(Q, {
											cols: "auto",
											class: "d-flex align-center"
										}, {
											default: O(() => [c(ze, {
												icon: "mdi:mdi-state-machine",
												class: "mr-2"
											}), a("span", Vn, T(E(Z)("workflow_state")) + " #" + T(t + 1), 1)]),
											_: 2
										}, 1024),
										c(be),
										c(Q, { cols: "auto" }, {
											default: O(() => [c(y, {
												icon: "mdi:mdi-delete",
												variant: "text",
												color: "error",
												onClick: (e) => fe(t)
											}, null, 8, ["onClick"])]),
											_: 2
										}, 1024)
									]),
									_: 2
								}, 1024), c($, null, {
									default: O(() => [c(Q, { class: "d-flex flex-column pt-0 ga-4" }, {
										default: O(() => [
											c(l, {
												modelValue: e.id,
												"onUpdate:modelValue": (t) => e.id = t,
												label: E(Z)("id"),
												rules: g,
												hint: E(Z)("workflow_state_id_hint")
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"hint"
											]),
											c(l, {
												modelValue: e.name,
												"onUpdate:modelValue": (t) => e.name = t,
												label: E(Z)("name"),
												rules: E(f)(E(Z)("state_name_required")),
												required: "",
												hint: E(Z)("workflow_state_name_hint")
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"rules",
												"hint"
											]),
											c(p, {
												modelValue: e.description,
												"onUpdate:modelValue": (t) => e.description = t,
												label: E(Z)("description"),
												density: "comfortable",
												variant: "outlined",
												"bg-color": "white",
												"auto-grow": "",
												rows: "2",
												hint: E(Z)("workflow_state_description_hint")
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"hint"
											]),
											c(l, {
												modelValue: e.order,
												"onUpdate:modelValue": (t) => e.order = t,
												label: E(Z)("order"),
												type: "number",
												rules: C(),
												hint: E(Z)("workflow_state_order_hint")
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"rules",
												"hint"
											]),
											c(v, {
												modelValue: e.required,
												"onUpdate:modelValue": (t) => e.required = t,
												icon: (e.required, "mdi:mdi-asterisk"),
												label: E(Z)("required"),
												hint: E(Z)("workflow_state_required_hint")
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"icon",
												"label",
												"hint"
											]),
											c(E(Ee), {
												modelValue: e.meta,
												"onUpdate:modelValue": (t) => e.meta = t,
												language: "json",
												icon: "mdi:mdi-code-json",
												label: E(Z)("meta"),
												rules: k,
												hint: E(Z)("workflow_state_meta_hint")
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"hint"
											])
										]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024))), 128)), c(Q, { cols: "12" }, {
								default: O(() => [c(y, {
									type: "primary",
									variant: "outlined",
									"prepend-icon": "mdi:mdi-plus",
									class: "mt-4",
									onClick: de
								}, {
									default: O(() => [s(T(E(Z)("add_state")), 1)]),
									_: 1
								})]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}, 8, ["label", "hint"]),
					c(x, {
						icon: "mdi:mdi-database-cog",
						label: E(Z)("meta"),
						hint: E(Z)("workflow_meta_hint")
					}, {
						default: O(() => [c($, null, {
							default: O(() => [(_(!0), i(e, null, b(V.meta, (e, t) => (_(), n(Q, {
								key: t,
								cols: "12",
								class: "mb-2 ga-4 pa-6"
							}, {
								default: O(() => [c($, { class: "align-center" }, {
									default: O(() => [
										c(Q, {
											cols: "auto",
											class: "d-flex align-center"
										}, {
											default: O(() => [c(ze, {
												icon: "mdi:mdi-key-variant",
												class: "mr-2"
											}), a("span", Hn, T(E(Z)("meta_item")) + " #" + T(t + 1), 1)]),
											_: 2
										}, 1024),
										c(be),
										c(Q, { cols: "auto" }, {
											default: O(() => [c(y, {
												icon: "mdi:mdi-delete",
												variant: "text",
												color: "error",
												onClick: (e) => me(t)
											}, null, 8, ["onClick"])]),
											_: 2
										}, 1024)
									]),
									_: 2
								}, 1024), c($, { class: "d-flex flex-column ga-2" }, {
									default: O(() => [c(Q, { class: "d-flex flex-column pt-0" }, {
										default: O(() => [c(l, {
											modelValue: e.key,
											"onUpdate:modelValue": (t) => e.key = t,
											label: E(Z)("key"),
											rules: A,
											hint: E(Z)("workflow_meta_key_hint")
										}, null, 8, [
											"modelValue",
											"onUpdate:modelValue",
											"label",
											"hint"
										]), c(l, {
											modelValue: e.value,
											"onUpdate:modelValue": (t) => e.value = t,
											label: E(Z)("value")
										}, null, 8, [
											"modelValue",
											"onUpdate:modelValue",
											"label"
										])]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024))), 128)), c(Q, { cols: "12" }, {
								default: O(() => [c(y, {
									type: "primary",
									variant: "outlined",
									"prepend-icon": "mdi:mdi-plus",
									class: "mt-4",
									onClick: pe
								}, {
									default: O(() => [s(T(E(Z)("add_meta")), 1)]),
									_: 1
								})]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}, 8, ["label", "hint"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, Wn = {
	__name: "admin-workflows",
	props: {},
	setup(n) {
		X(n, "HAdminWorkflows");
		let { formatDate: r } = fe(), { locale: a } = me(), { buildQueryParams: o } = de(), { hHttpRequest: s } = Y(), { confirm: l } = ce(), { hAddAlert: u } = q(), d = Ze(), f = y(!0), p = y(null), m = {
			term: "",
			key: "",
			keyMatchType: "contains",
			name: "",
			nameMatchType: "contains",
			owner: "",
			ownerMatchType: "contains",
			impersonate: "",
			impersonateMatchType: "contains",
			role: [],
			tag: [],
			domain: [],
			nonpersistent: null,
			modifieddatePreset: null,
			sortBy: "modifieddate",
			sortOrder: "desc",
			page: 1,
			pageSize: 25
		}, g = v({ ...m }), b = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "nonpersistent",
				type: "boolean"
			},
			{
				key: "key",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("key_filter"),
					placeholder: Z("key_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-key",
					defaultMatchType: "contains"
				}
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "owner",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("owner_filter"),
					placeholder: Z("owner_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-account-circle",
					defaultMatchType: "contains"
				}
			},
			{
				key: "impersonate",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("impersonate_filter"),
					placeholder: Z("impersonate_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-account-switch",
					defaultMatchType: "contains"
				}
			},
			{
				key: "role",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("role_filter"),
					icon: "mdi:mdi-account-key"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "domain",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("domain_filter"),
					icon: "mdi:mdi-web"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [{
					key: "modifieddate",
					type: "date",
					component: "h-filter-datetime",
					model: "modifieddatePreset",
					props: {
						label: Z("modifieddate_filter"),
						manualSync: !0
					}
				}]
			}
		] }, x = [
			{
				title: "key",
				key: "key",
				sortable: !0,
				width: 200,
				value: "key",
				nowrap: !0,
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 200,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "role",
				key: "role",
				sortable: !0,
				width: 150,
				value: "role",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => L("role", e),
				isFilterActive: (e) => I("role", e)
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => L("tag", e),
				isFilterActive: (e) => I("tag", e)
			},
			{
				title: "schedule",
				key: "scheduled",
				sortable: !1,
				width: 180,
				value: "scheduled",
				nowrap: !0,
				translate: !0,
				formatCell: (e, t) => C(t.scheduled?.timer)
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 150,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		];
		function C(e) {
			if (e == null || e === "") return "";
			let t = String(e).trim();
			if (!t) return "";
			let n = z(t, a.value);
			return n === t ? t : `${n} (${t})`;
		}
		let w = {
			pageKey: "workflows",
			pageTitle: Z("admin_workflows_title"),
			headerTitle: Z("workflows"),
			searchPlaceholder: Z("search_workflows"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("workflows"),
					text: Z("workflows")
				}
			]
		}, { data: T, loading: D, params: O, execute: k, totalResults: A } = G({
			url: "/admin/workflows",
			filters: g,
			additionalParams: {}
		}), j = Z("total_workflows"), M = t(() => ({ widgets: [{
			summary: !0,
			title: j,
			count: A.value,
			icon: "mdi:mdi-sitemap",
			color: "blue-grey-lighten-3",
			iconColor: "blue-grey-darken-4"
		}] }));
		function N() {
			P(!0);
		}
		function P(e = !1) {
			let { query: t, sort: n } = o(b.filters, g);
			O.query = t, O.sort = n, (e || f.value) && k();
		}
		let F = qe(P, 300), { isFilterActive: I, toggleArrayFilter: L } = ue({
			filters: g,
			onFilterChange: F
		}), R = [
			{
				label: Z("start_process"),
				icon: "mdi:mdi-play-circle",
				color: "neutral-70",
				action: async (e) => {
					let { execute: t } = s({
						url: `/admin/processes/start/${e.key}`,
						method: "post",
						payload: { title: e.name },
						immediate: !1
					}), n = await t();
					n?.ok ? u({
						title: Z("process_started_successfully"),
						type: "success",
						timeout: 3e3
					}) : u({
						title: Z("error_occurred"),
						body: n?.data?.message || Z("start_process_error"),
						type: "error",
						timeout: 5e3
					});
				}
			},
			{
				label: Z("list_running_processes_for_this_workflow"),
				icon: "mdi:mdi-view-list",
				color: "neutral-70",
				action: (e) => {
					let t = d.resolve({
						path: "/admin/processes",
						query: { term: `workflow:${e.key}` }
					});
					window.open(t.href, "_blank", "noopener,noreferrer");
				}
			},
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					p.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					p.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await l({
						title: Z("delete_workflow"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = s({
							url: `/admin/workflows/${e.key}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							u({
								title: Z("error_occurred"),
								body: Z("workflow_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await k();
					}
				}
			}
		];
		function B() {
			return Object.assign(g, { ...m }), P(!0);
		}
		function V() {
			p.value?.open();
		}
		return h(async () => {
			J(g, F), P(), k();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": f.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => f.value = e,
				"page-configuration": w,
				"widgets-config": M.value,
				"filters-config": b,
				filters: g,
				"table-headers": x,
				"table-actions": R,
				"table-params": E(O),
				"table-data": E(T),
				"table-loading": E(D),
				"total-results": E(A),
				"open-form": V,
				onSearch: N,
				onClearFilters: B
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(Un, {
				ref_key: "workflowFormRef",
				ref: p,
				onSuccess: E(k)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, Gn = {
	__name: "workspace-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 700
		}
	},
	emits: ["success", "cancel"],
	setup(e, { expose: t, emit: i }) {
		let { hAddAlert: a } = q(), { nameRules: o, requiredRules: s, slugRules: l, integerRules: u } = ie(), { save: d } = ae(), f = [(e) => !!e || Z("title_required")], p = u();
		X(e, "HWorkspaceForm");
		let m = {
			slug: {
				type: String,
				default: ""
			},
			title: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			icon: {
				type: String,
				default: ""
			},
			color: {
				type: String,
				default: ""
			},
			role: {
				type: Array,
				default: () => []
			},
			domain: {
				type: Array,
				default: () => []
			},
			tag: {
				type: Array,
				default: () => []
			},
			startpage: {
				type: String,
				default: ""
			},
			query: {
				type: String,
				default: ""
			},
			aggregations: {
				type: String,
				default: ""
			},
			order: {
				type: Number,
				default: 100
			},
			hide: {
				type: Boolean,
				default: !1
			},
			shared: {
				type: Boolean,
				default: !0
			},
			owner: {
				type: String,
				default: ""
			},
			export: {
				type: Object,
				default: () => ({
					enabled: !1,
					exclude: "",
					role: []
				})
			},
			fields: {
				type: Object,
				default: () => ({
					includes: [],
					excludes: []
				})
			},
			help: {
				type: Object,
				default: () => ({
					menulink: "",
					searchtext: []
				})
			}
		}, h = () => {
			let e = {};
			return Object.keys(m).forEach((t) => {
				let n = m[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, g = i, b = y(null), x = y(!1), C = y(!1), w = y(!1), T = y(null), k = v(h()), A = y(!1), j = y({}), { data: M, loading: N } = K({
			url: "/admin/roles",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), { data: P, loading: F } = K({
			url: "/admin/domains",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), { data: I, loading: L } = K({
			url: "/admin/users",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.username,
				key: e.username
			}))
		});
		D(x, (e) => {
			e || R();
		}), D(k, () => {
			A.value = JSON.stringify(k) !== JSON.stringify(j.value);
		}, { deep: !0 });
		function R() {
			let e = h();
			Object.keys(e).forEach((t) => {
				k[t] = e[t];
			}), j.value = JSON.parse(JSON.stringify(k)), w.value = !1, T.value = null, A.value = !1;
		}
		function z(e, t = !0) {
			Object.keys(m).forEach((t) => {
				let n = m[t], r = e?.[t], i = r != null;
				if (t === "export") {
					let e = n.default();
					k[t] = i && typeof r == "object" ? {
						...e,
						...r
					} : e;
				} else if (t === "fields") {
					let e = n.default();
					k[t] = i && typeof r == "object" ? {
						...e,
						...r
					} : e;
				} else if (t === "help") {
					let e = n.default();
					k[t] = i && typeof r == "object" ? {
						...e,
						...r
					} : e;
				} else n.type === Array ? k[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : n.type === Boolean ? k[t] = i ? !!r : typeof n.default == "function" ? n.default() : n.default : (n.type === String || n.type, k[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), t || (k.slug = ""), j.value = JSON.parse(JSON.stringify(k)), w.value = t, T.value = t && e?.slug || null, A.value = !t;
		}
		async function B() {
			if (!C.value && ((await b.value?.validate())?.valid ?? !0)) {
				C.value = !0;
				try {
					await U(H()), g("success"), x.value = !1;
				} catch (e) {
					a({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					C.value = !1;
				}
			}
		}
		function V(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) if (!(r === null || r === "" || Array.isArray(r) && r.length === 0)) if (typeof r == "object" && !Array.isArray(r)) {
				let e = {};
				for (let [t, n] of Object.entries(r)) n !== null && n !== "" && !(Array.isArray(n) && n.length === 0) && (e[t] = n);
				Object.keys(e).length > 0 && (t[n] = e);
			} else t[n] = r;
			return t;
		}
		function H() {
			let e = (e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [], t = e(k.role), n = e(k.domain), r = e(k.tag), i = null;
			k.export?.enabled && (i = {
				enabled: !0,
				...k.export.exclude && { exclude: k.export.exclude.trim() },
				...k.export.role?.length && { role: e(k.export.role) }
			});
			let a = null;
			(k.fields?.includes?.length || k.fields?.excludes?.length) && (a = {
				...k.fields.includes?.length && { includes: e(k.fields.includes) },
				...k.fields.excludes?.length && { excludes: e(k.fields.excludes) }
			});
			let o = null;
			(k.help?.menulink || k.help?.searchtext?.length) && (o = {
				...k.help.menulink && { menulink: k.help.menulink.trim() },
				...k.help.searchtext?.length && { searchtext: e(k.help.searchtext) }
			});
			let s = null;
			if (k.query) try {
				s = k.query.trim(), JSON.parse(s);
			} catch {
				s = null;
			}
			let c = null;
			if (k.aggregations) try {
				c = k.aggregations.trim(), JSON.parse(c);
			} catch {
				c = null;
			}
			return V({
				slug: k.slug?.trim() || null,
				title: k.title?.trim() || null,
				name: k.name?.trim() || null,
				description: k.description?.trim() || null,
				icon: k.icon?.trim() || null,
				color: k.color?.trim() || null,
				role: t,
				domain: n,
				tag: r,
				startpage: k.startpage?.trim() || null,
				query: s,
				aggregations: c,
				order: k.order === null || k.order === void 0 || k.order === "" ? 100 : Number(k.order),
				hide: k.hide || !1,
				shared: k.shared ?? !0,
				owner: k.owner?.trim() || null,
				export: i,
				fields: a,
				help: o
			});
		}
		async function U(e) {
			let t = w.value ? "update" : "create", n = {
				create: "/admin/workspaces",
				update: `/admin/workspaces/${T.value}`
			}, r = {
				create: "post",
				update: "put"
			}, i = {
				error: {
					create: "workspace_create_error",
					update: "workspace_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			}, o = t === "update" ? (({ slug: e, ...t }) => t)(e) : e;
			if (!(await d({
				url: n[t],
				method: r[t],
				payload: o
			}))?.ok) throw Error(Z(i.error[t]));
			a({
				title: Z(i.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function ee() {
			g("cancel"), x.value = !1;
		}
		function W(e = null) {
			e && z(e), x.value = !0;
		}
		function te(e) {
			z(e, !1), x.value = !0;
		}
		return t({
			validate: () => b.value?.validate(),
			reset: () => b.value?.reset(),
			resetValidation: () => b.value?.resetValidation(),
			formData: k,
			open: W,
			openCopy: te
		}), (t, i) => {
			let a = S("h-form-text"), u = S("h-form-textarea"), d = S("h-form-autocomplete"), m = S("h-form-combobox"), h = S("h-form-switch"), g = S("h-form-field"), v = S("h-form-layout");
			return _(), n(v, {
				ref_key: "formRef",
				ref: b,
				modelValue: x.value,
				"onUpdate:modelValue": i[23] ||= (e) => x.value = e,
				loading: C.value,
				"bg-color": e.bgColor,
				"header-text": w.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": e.drawerWidth,
				"has-changes": A.value,
				onSubmit: B,
				onCancel: ee
			}, {
				default: O(() => [
					c(a, {
						modelValue: k.slug,
						"onUpdate:modelValue": i[0] ||= (e) => k.slug = e,
						icon: "mdi:mdi-link",
						label: E(Z)("slug"),
						rules: w.value ? [] : E(l)(!1),
						disabled: w.value,
						hint: E(Z)("workspace_slug_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"disabled",
						"hint"
					]),
					c(a, {
						modelValue: k.title,
						"onUpdate:modelValue": i[1] ||= (e) => k.title = e,
						icon: "mdi:mdi-format-title",
						label: E(Z)("title"),
						rules: f,
						hint: E(Z)("workspace_title_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(a, {
						modelValue: k.name,
						"onUpdate:modelValue": i[2] ||= (e) => k.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: E(o),
						hint: E(Z)("workspace_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(u, {
						modelValue: k.description,
						"onUpdate:modelValue": i[3] ||= (e) => k.description = e,
						label: E(Z)("description"),
						rules: E(s)(E(Z)("description_required")),
						hint: E(Z)("workspace_description_hint"),
						icon: "mdi:mdi-text",
						required: "",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3"
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(a, {
						modelValue: k.icon,
						"onUpdate:modelValue": i[4] ||= (e) => k.icon = e,
						icon: "mdi:mdi-image-outline",
						label: E(Z)("icon"),
						hint: E(Z)("workspace_icon_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(a, {
						modelValue: k.color,
						"onUpdate:modelValue": i[5] ||= (e) => k.color = e,
						icon: "mdi:mdi-palette",
						label: E(Z)("color"),
						hint: E(Z)("workspace_color_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(d, {
						modelValue: k.role,
						"onUpdate:modelValue": i[6] ||= (e) => k.role = e,
						icon: "mdi:mdi-account-key",
						label: E(Z)("roles"),
						items: E(M),
						loading: E(N),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading"
					]),
					c(d, {
						modelValue: k.domain,
						"onUpdate:modelValue": i[7] ||= (e) => k.domain = e,
						icon: "mdi:mdi-domain",
						label: E(Z)("domains"),
						items: E(P),
						loading: E(F),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading"
					]),
					c(m, {
						modelValue: k.tag,
						"onUpdate:modelValue": i[8] ||= (e) => k.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "]
					}, null, 8, ["modelValue", "label"]),
					c(a, {
						modelValue: k.startpage,
						"onUpdate:modelValue": i[9] ||= (e) => k.startpage = e,
						icon: "mdi:mdi-home",
						label: E(Z)("start_page"),
						hint: E(Z)("workspace_start_page_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(E(Ee), {
						modelValue: k.query,
						"onUpdate:modelValue": i[10] ||= (e) => k.query = e,
						language: "json",
						icon: "mdi:mdi-database-search",
						label: E(Z)("query"),
						hint: E(Z)("workspace_query_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(E(Ee), {
						modelValue: k.aggregations,
						"onUpdate:modelValue": i[11] ||= (e) => k.aggregations = e,
						language: "json",
						icon: "mdi:mdi-chart-box",
						label: E(Z)("aggregations"),
						hint: E(Z)("workspace_aggregations_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(a, {
						modelValue: k.order,
						"onUpdate:modelValue": i[12] ||= (e) => k.order = e,
						type: "number",
						icon: "mdi:mdi-order-numeric-ascending",
						label: E(Z)("order"),
						hint: E(Z)("workspace_order_hint"),
						rules: E(p)
					}, null, 8, [
						"modelValue",
						"label",
						"hint",
						"rules"
					]),
					c(h, {
						modelValue: k.hide,
						"onUpdate:modelValue": i[13] ||= (e) => k.hide = e,
						icon: k.hide ? "mdi:mdi-eye-off" : "mdi:mdi-eye",
						label: E(Z)("workspace_hide_workspace"),
						hint: E(Z)("workspace_hide_workspace_hint")
					}, null, 8, [
						"modelValue",
						"icon",
						"label",
						"hint"
					]),
					c(h, {
						modelValue: k.shared,
						"onUpdate:modelValue": i[14] ||= (e) => k.shared = e,
						icon: k.shared ? "mdi:mdi-share-variant" : "mdi:mdi-lock",
						label: E(Z)("shared"),
						hint: E(Z)("workspace_shared_hint")
					}, null, 8, [
						"modelValue",
						"icon",
						"label",
						"hint"
					]),
					c(d, {
						modelValue: k.owner,
						"onUpdate:modelValue": i[15] ||= (e) => k.owner = e,
						icon: "mdi:mdi-account",
						label: E(Z)("owner"),
						items: E(I),
						loading: E(L),
						clearable: ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading"
					]),
					c(g, {
						icon: "mdi:mdi-export",
						label: E(Z)("export_settings"),
						indent: ""
					}, {
						default: O(() => [c($, null, {
							default: O(() => [
								c(Q, { cols: "12" }, {
									default: O(() => [c(h, {
										modelValue: k.export.enabled,
										"onUpdate:modelValue": i[16] ||= (e) => k.export.enabled = e,
										icon: k.export.enabled ? "mdi:mdi-export" : "mdi:mdi-download-off",
										label: E(Z)("enable_export"),
										hint: E(Z)("workspace_enable_export_hint")
									}, null, 8, [
										"modelValue",
										"icon",
										"label",
										"hint"
									])]),
									_: 1
								}),
								k.export.enabled ? (_(), n(Q, {
									key: 0,
									cols: "12"
								}, {
									default: O(() => [c(a, {
										modelValue: k.export.exclude,
										"onUpdate:modelValue": i[17] ||= (e) => k.export.exclude = e,
										icon: "mdi:mdi-minus-circle",
										label: E(Z)("exclude_fields"),
										hint: E(Z)("workspace_export_exclude_hint")
									}, null, 8, [
										"modelValue",
										"label",
										"hint"
									])]),
									_: 1
								})) : r("", !0),
								k.export.enabled ? (_(), n(Q, {
									key: 1,
									cols: "12"
								}, {
									default: O(() => [c(d, {
										modelValue: k.export.role,
										"onUpdate:modelValue": i[18] ||= (e) => k.export.role = e,
										icon: "mdi:mdi-account-key",
										label: E(Z)("export_roles"),
										items: E(M),
										loading: E(N),
										multiple: "",
										chips: "",
										"closable-chips": "",
										hint: E(Z)("workspace_export_roles_hint")
									}, null, 8, [
										"modelValue",
										"label",
										"items",
										"loading",
										"hint"
									])]),
									_: 1
								})) : r("", !0)
							]),
							_: 1
						})]),
						_: 1
					}, 8, ["label"]),
					c(g, {
						icon: "mdi:mdi-view-column",
						label: E(Z)("field_settings"),
						indent: ""
					}, {
						default: O(() => [c($, null, {
							default: O(() => [c(Q, { cols: "12" }, {
								default: O(() => [c(m, {
									modelValue: k.fields.includes,
									"onUpdate:modelValue": i[19] ||= (e) => k.fields.includes = e,
									icon: "mdi:mdi-plus-circle",
									label: E(Z)("include_fields"),
									items: [],
									"hide-no-data": "",
									multiple: "",
									chips: "",
									"closable-chips": "",
									delimiters: [",", " "],
									hint: E(Z)("workspace_include_fields_hint")
								}, null, 8, [
									"modelValue",
									"label",
									"hint"
								])]),
								_: 1
							}), c(Q, { cols: "12" }, {
								default: O(() => [c(m, {
									modelValue: k.fields.excludes,
									"onUpdate:modelValue": i[20] ||= (e) => k.fields.excludes = e,
									icon: "mdi:mdi-minus-circle",
									label: E(Z)("exclude_fields"),
									items: [],
									"hide-no-data": "",
									multiple: "",
									chips: "",
									"closable-chips": "",
									delimiters: [",", " "],
									hint: E(Z)("workspace_exclude_fields_hint")
								}, null, 8, [
									"modelValue",
									"label",
									"hint"
								])]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}, 8, ["label"]),
					c(g, {
						icon: "mdi:mdi-help-circle",
						label: E(Z)("help_settings"),
						indent: ""
					}, {
						default: O(() => [c($, null, {
							default: O(() => [c(Q, { cols: "12" }, {
								default: O(() => [c(a, {
									modelValue: k.help.menulink,
									"onUpdate:modelValue": i[21] ||= (e) => k.help.menulink = e,
									icon: "mdi:mdi-link",
									label: E(Z)("help_menu_link"),
									hint: E(Z)("workspace_help_menu_link_hint")
								}, null, 8, [
									"modelValue",
									"label",
									"hint"
								])]),
								_: 1
							}), c(Q, { cols: "12" }, {
								default: O(() => [c(m, {
									modelValue: k.help.searchtext,
									"onUpdate:modelValue": i[22] ||= (e) => k.help.searchtext = e,
									icon: "mdi:mdi-text-search",
									label: E(Z)("help_search_text"),
									items: [],
									"hide-no-data": "",
									multiple: "",
									chips: "",
									"closable-chips": "",
									delimiters: [",", " "],
									hint: E(Z)("workspace_help_search_text_hint")
								}, null, 8, [
									"modelValue",
									"label",
									"hint"
								])]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}, 8, ["label"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, Kn = {
	__name: "admin-workspaces",
	props: {},
	setup(n) {
		X(n, "HAdminWorkspaces");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { confirm: s } = ce(), { hAddAlert: l } = q(), u = y(!0), d = y(null), f = {
			term: "",
			slug: "",
			slugMatchType: "contains",
			title: "",
			titleMatchType: "contains",
			name: "",
			nameMatchType: "contains",
			description: "",
			descriptionMatchType: "contains",
			tag: [],
			role: [],
			domain: [],
			hide: null,
			shared: null,
			modifieddatePreset: null,
			createdatePreset: null,
			sortBy: "name",
			sortOrder: "asc",
			page: 1,
			pageSize: 25
		}, p = v({ ...f }), m = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "slug",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("slug_filter"),
					placeholder: "Filter by slug...",
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-link",
					defaultMatchType: "contains"
				}
			},
			{
				key: "title",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("title_filter"),
					placeholder: Z("title_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-format-title",
					defaultMatchType: "contains"
				}
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "description",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("description_filter"),
					placeholder: Z("description_filter_placeholder"),
					icon: "mdi:mdi-text"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "role",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("role_filter"),
					icon: "mdi:mdi-account-key"
				}
			},
			{
				key: "domain",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("domain_filter"),
					icon: "mdi:mdi-domain"
				}
			},
			{
				key: "hide",
				type: "boolean",
				component: "h-filter-switch",
				props: {
					title: Z("hidden_filter"),
					icon: "mdi:mdi-eye-off"
				}
			},
			{
				key: "shared",
				type: "boolean",
				component: "h-filter-switch",
				props: {
					title: Z("shared_filter"),
					icon: "mdi:mdi-share-variant"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [{
					key: "createdate",
					type: "date",
					component: "h-filter-datetime",
					model: "createdatePreset",
					props: {
						label: Z("createdate_filter"),
						manualSync: !0
					}
				}, {
					key: "modifieddate",
					type: "date",
					component: "h-filter-datetime",
					model: "modifieddatePreset",
					props: {
						label: Z("modifieddate_filter"),
						minDatePresetFilter: p.createdatePreset,
						manualSync: !0
					}
				}]
			}
		] }, g = [
			{
				title: "slug",
				key: "slug",
				sortable: !0,
				width: 150,
				value: "slug",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => P("slug", e.slug),
				isFilterActive: (e) => N("slug", e.slug)
			},
			{
				title: "title",
				key: "title",
				align: "start",
				sortable: !0,
				width: 200,
				value: "title",
				nowrap: !1,
				customSortKey: "title.lower",
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 200,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => F("tag", e),
				isFilterActive: (e) => N("tag", e)
			},
			{
				title: "role",
				key: "role",
				sortable: !0,
				width: 150,
				value: "role",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => F("role", e),
				isFilterActive: (e) => N("role", e)
			},
			{
				title: "hide",
				key: "hide",
				sortable: !0,
				width: 40,
				value: "hide",
				nowrap: !0,
				translate: !0,
				component: "h-btn-table-cell",
				defaultValue: !1,
				componentProps: {
					getIcon: (e) => e.hide ? "mdi:mdi-eye-off" : "mdi:mdi-eye",
					getColor: (e) => e.hide ? "grey" : "primary"
				},
				filterOnClick: (e) => P("hide", e.hide),
				isFilterActive: (e) => N("hide", e.hide)
			},
			{
				title: "shared",
				key: "shared",
				sortable: !0,
				width: 40,
				value: "shared",
				nowrap: !0,
				translate: !0,
				component: "h-btn-table-cell",
				defaultValue: !1,
				componentProps: {
					getIcon: (e) => e.shared ? "mdi:mdi-share-variant" : "mdi:mdi-lock",
					getColor: (e) => e.shared ? "primary" : "grey"
				},
				filterOnClick: (e) => P("shared", e.shared),
				isFilterActive: (e) => N("shared", e.shared)
			},
			{
				title: "order",
				key: "order",
				sortable: !0,
				width: 80,
				value: "order",
				nowrap: !0,
				translate: !0
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 150,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], b = {
			pageKey: "workspaces",
			pageTitle: Z("admin_workspaces_title"),
			headerTitle: Z("workspaces"),
			searchPlaceholder: Z("search_workspaces"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("workspaces"),
					text: Z("workspaces")
				}
			]
		}, { data: x, loading: C, params: w, execute: T, totalResults: D } = G({
			url: "/admin/workspaces",
			filters: p,
			additionalParams: {}
		}), O = Z("total_workspaces"), k = t(() => ({ widgets: [{
			summary: !0,
			title: O,
			count: D.value,
			icon: "mdi:mdi-briefcase",
			color: "blue-grey-lighten-3",
			iconColor: "blue-grey-darken-4"
		}] }));
		function A() {
			j(!0);
		}
		function j(e = !1) {
			let { query: t, sort: n } = a(m.filters, p);
			w.query = t, w.sort = n, (e || u.value) && T();
		}
		let M = qe(j, 300), { isFilterActive: N, toggleFilter: P, toggleArrayFilter: F } = ue({
			filters: p,
			onFilterChange: M
		}), I = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					d.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					d.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await s({
						title: Z("delete_workspace"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = o({
							url: `/admin/workspaces/${e.slug}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							l({
								title: Z("error_occurred"),
								body: Z("workspace_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await T();
					}
				}
			}
		];
		function L() {
			return Object.assign(p, { ...f }), j(!0);
		}
		function R() {
			d.value?.open();
		}
		return h(async () => {
			J(p, M), j(), T();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": u.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => u.value = e,
				"page-configuration": b,
				"widgets-config": k.value,
				"filters-config": m,
				filters: p,
				"table-headers": g,
				"table-actions": I,
				"table-params": E(w),
				"table-data": E(x),
				"table-loading": E(C),
				"total-results": E(D),
				"open-form": R,
				onSearch: A,
				onClearFilters: L
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(Gn, {
				ref_key: "workspaceFormRef",
				ref: d,
				onSuccess: E(T)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, qn = {
	key: 0,
	class: "d-flex justify-center pa-2"
}, Jn = "h-admin-system-logs", Yn = 3e4, Xn = 300, Zn = "/tools/logs", Qn = 50, $n = {
	__name: "admin-system-logs",
	props: {},
	setup(e) {
		X(e, "HAdminSystemLogs");
		let { formatDate: o } = fe(), { buildQueryParams: l } = de(), { hHttpRequest: u } = Y(), p = y(!0), m = /* @__PURE__ */ new Set([
			300,
			1800,
			3600,
			14400,
			28800,
			86400,
			259200
		]), b = null, x = null, C = 0, w = 0, D = 0, k = 0, A = Xn, j = y(null), M = y(!1), N = y(!1), P = y(null), F = {
			term: "",
			fromDate: Xn,
			level: [],
			source: [],
			sortBy: "@timestamp",
			sortOrder: "desc"
		}, I = v({ ...F }), L = [
			{
				label: Z("log_level_error"),
				value: "ERROR",
				icon: "mdi:mdi-alert-circle",
				color: "error"
			},
			{
				label: Z("log_level_warn"),
				value: "WARN",
				icon: "mdi:mdi-alert",
				color: "warning"
			},
			{
				label: Z("log_level_info"),
				value: "INFO",
				icon: "mdi:mdi-information",
				color: "info"
			},
			{
				label: Z("log_level_debug"),
				value: "DEBUG",
				icon: "mdi:mdi-bug",
				color: "success"
			},
			{
				label: Z("log_level_trace"),
				value: "TRACE",
				icon: "mdi:mdi-magnify",
				color: "primary"
			}
		], R = L.reduce((e, t) => (e[t.value] = t, e), {}), z = [{
			label: Z("log_source_api"),
			value: "api",
			icon: "mdi:mdi-progress-wrench",
			color: "blue"
		}, {
			label: Z("log_source_worker"),
			value: "worker",
			icon: "mdi:mdi-progress-clock",
			color: "green"
		}], B = z.reduce((e, t) => (e[t.value] = t, e), {}), V = (e) => {
			let t = R[e?.toUpperCase()];
			return t ? t.color : "grey";
		}, H = (e) => {
			let t = R[e?.toUpperCase()];
			return t ? t.icon : "mdi:mdi-help-circle";
		}, U = (e) => {
			let t = B[e?.toLowerCase()];
			return t ? t.color : "grey";
		}, ee = (e) => {
			let t = B[e?.toLowerCase()];
			return t ? t.icon : "mdi:mdi-help-circle";
		}, W = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "fromDate",
				type: "range",
				component: "h-admin-logs-from-date-options"
			},
			{
				key: "level",
				type: "array",
				arrayOperator: "OR",
				component: "h-filter-multiselect",
				queryParamKey: "log.level",
				props: {
					title: Z("level_filter"),
					icon: "mdi:mdi-tag",
					showAsChips: !0,
					options: L
				}
			},
			{
				key: "source",
				type: "array",
				arrayOperator: "OR",
				component: "h-filter-multiselect",
				queryParamKey: "name",
				props: {
					title: Z("source_filter"),
					icon: "mdi:mdi-database-outline",
					showAsChips: !0,
					options: z
				}
			}
		] }, te = [
			{
				title: "message_table",
				key: "message",
				align: "start",
				sortable: !1,
				value: "message",
				nowrap: !1,
				translate: !0
			},
			{
				title: "timestamp_table",
				key: "@timestamp",
				sortable: !0,
				width: 180,
				value: "@timestamp",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => o(e)
			},
			{
				title: "level_table",
				key: "log.level",
				sortable: !0,
				width: 120,
				value: "log.level",
				translate: !0,
				component: "h-chip-table-cell",
				componentProps: {
					getColor: (e) => V(e),
					getIcon: (e) => H(e)
				},
				formatCell: (e) => e?.toUpperCase() || "",
				filterOnClick: (e) => G("level", e["log.level"]?.toUpperCase()),
				isFilterActive: (e) => ie("level", e["log.level"]?.toUpperCase())
			},
			{
				title: "source_table",
				key: "name",
				sortable: !0,
				width: 120,
				value: "name",
				translate: !0,
				component: "h-chip-table-cell",
				componentProps: {
					getColor: (e) => U(e),
					getIcon: (e) => ee(e)
				},
				formatCell: (e) => e || "",
				filterOnClick: (e) => G("source", e.name?.toLowerCase()),
				isFilterActive: (e) => ie("source", e.name?.toLowerCase())
			}
		], ne = {
			pageKey: "system-logs",
			pageTitle: Z("admin_system_logs_title"),
			headerTitle: Z("admin_system_logs_title"),
			searchPlaceholder: Z("search_system_logs"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("system_logs"),
					text: Z("system_logs")
				}
			],
			itemActions: [{
				label: Z("view_code"),
				icon: "mdi:mdi-code-tags",
				action: "viewCode"
			}]
		}, re = qe(be, 300), { isFilterActive: ie, toggleArrayFilter: G } = ue({
			filters: I,
			onFilterChange: re
		}), ae = Math.min(Qn * 4, 200), { params: K, execute: q } = u({
			url: Zn,
			method: "get",
			params: {
				pagination: "cursor",
				pagesize: Qn,
				fromdate: void 0,
				query: void 0,
				sort: void 0
			},
			isLive: !1,
			immediate: !1
		}, { throwHttpErrors: !1 }), oe = y(), se = t(() => oe.value?.meta?.totalresults ?? 0), ce = t(() => oe.value?.records?.length ?? 0), le = t(() => se.value ? `${ce.value}/${se.value}` : String(ce.value)), pe = t(() => N.value || M.value);
		function me(e) {
			let t = typeof e == "number" || typeof e == "string" && e.trim() !== "" ? Number(e) : NaN;
			return Number.isFinite(t) && m.has(t) ? t : Xn;
		}
		function he() {
			return (/* @__PURE__ */ new Date(Date.now() - A * 1e3)).toISOString();
		}
		function ge(e, t) {
			let n = new URLSearchParams({
				pagination: "cursor",
				pagesize: String(e),
				fromdate: he()
			});
			return t && n.set("cursor", t), K.query && n.set("query", K.query), K.sort && [].concat(K.sort).forEach((e) => n.append("sort", e)), n;
		}
		async function _e(e) {
			N.value = !0, K.fromdate = he();
			try {
				let t = await (await q())?.clone().json();
				if (e !== C || !Array.isArray(t?.records)) return;
				oe.value = t, P.value = t.meta?.nextCursor ?? null, w += 1;
			} finally {
				e === C && (N.value = !1);
			}
		}
		async function ve() {
			if (!P.value || M.value) return;
			let e = P.value, t = C, n = w, r = ++k, i = ge(Qn, e);
			M.value = !0;
			try {
				let a = await (await u({
					url: `${Zn}?${i.toString()}`,
					method: "get",
					immediate: !1
				}, { throwHttpErrors: !1 }).execute())?.clone().json();
				if (t !== C || n !== w || r !== k || e !== P.value || !Array.isArray(a?.records)) return;
				oe.value = {
					...a,
					records: (oe.value?.records ?? []).concat(a.records)
				}, P.value = a.meta?.nextCursor ?? null, w += 1;
			} finally {
				r === k && (M.value = !1);
			}
		}
		async function ye() {
			if (N.value) return;
			let e = C, t = ++D, { execute: n } = u({
				url: `${Zn}?${ge(ae).toString()}`,
				method: "get",
				immediate: !1
			}, { throwHttpErrors: !1 }), r = await (await n())?.clone().json();
			e !== C || t !== D || !Array.isArray(r?.records) || (oe.value = r, P.value = r.meta?.nextCursor ?? null, k += 1, M.value = !1, w += 1);
		}
		function Q() {
			let e = ++C;
			return D += 1, k += 1, w += 1, P.value = null, oe.value = null, M.value = !1, _e(e);
		}
		function $() {
			be(!0);
		}
		function be(e = !1) {
			I.fromDate = me(I.fromDate);
			let { query: t, sort: n } = l(W.filters, I);
			!e && !p.value || (A = I.fromDate, K.query = t, K.sort = n && !I.sortBy.includes("@timestamp") ? [n, "@timestamp,desc"] : n, Q());
		}
		function xe() {
			return Object.assign(I, { ...F }), be(!0);
		}
		function Se() {
			!j.value || typeof IntersectionObserver > "u" || (x = new IntersectionObserver((e) => {
				e[0]?.isIntersecting && P.value && !M.value && ve();
			}, { threshold: .1 }), x.observe(j.value));
		}
		return h(async () => {
			let e = !0;
			J(I, () => {
				e || re();
			}), be(), await d(), e = !1, b = setInterval(ye, Yn), await d(), Se();
		}), g(() => {
			b &&= (clearInterval(b), null), x &&= (x.disconnect(), null);
		}), (e, t) => {
			let o = S("h-admin-template");
			return _(), n(o, {
				"auto-search-enabled": p.value,
				"onUpdate:autoSearchEnabled": t[0] ||= (e) => p.value = e,
				"page-configuration": ne,
				"filters-config": W,
				filters: I,
				"table-headers": te,
				"table-params": E(K),
				"table-pagination": !1,
				"table-data": oe.value,
				"table-loading": pe.value,
				"total-results": se.value,
				class: f(`${Jn}-main-template`),
				onSearch: $,
				onClearFilters: xe
			}, {
				"filter-results": O(() => [s(T(E(Z)("admin_filter_results", { results: le.value })), 1)]),
				bottom: O(() => [a("div", {
					ref_key: "bottomSentinel",
					ref: j,
					class: f(`${Jn}__bottom-sentinel`),
					style: { height: "1px" }
				}, null, 2), M.value ? (_(), i("div", qn, [c(rt, {
					indeterminate: "",
					color: "primary",
					size: "24"
				})])) : r("", !0)]),
				_: 1
			}, 8, [
				"auto-search-enabled",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results",
				"class"
			]);
		};
	}
}, er = { class: "pa-3" }, tr = {
	key: 0,
	class: "d-flex justify-center pa-2"
}, nr = { class: "text-body-small font-weight-bold text-medium-emphasis mb-2" }, rr = { class: "d-flex align-start mb-1" }, ir = {
	class: "text-body-small text-medium-emphasis",
	style: { "min-width": "70px" }
}, ar = ["href"], or = {
	key: 1,
	class: "text-body-small text-medium-emphasis"
}, sr = { class: "d-flex align-start mb-1" }, cr = {
	class: "text-body-small text-medium-emphasis",
	style: { "min-width": "70px" }
}, lr = { class: "text-body-small" }, ur = { class: "d-flex align-start mb-1" }, dr = {
	class: "text-body-small text-medium-emphasis",
	style: { "min-width": "70px" }
}, fr = { class: "text-body-small" }, pr = { class: "d-flex align-start" }, mr = {
	class: "text-body-small text-medium-emphasis",
	style: { "min-width": "70px" }
}, hr = ["title"], gr = {
	key: 2,
	class: "text-body-small text-medium-emphasis text-center pa-2"
}, _r = { class: "d-flex ga-2 pa-3" }, vr = /*#__PURE__*/ xt({
	__name: "admin-resources",
	props: {},
	setup(r) {
		X(r, "HAdminResources");
		let { hSetTitle: o, hUpdateHead: l } = he();
		o(Z("admin_resources_title")), l();
		let { hHttpRequest: u } = Y(), { hAddAlert: d } = q(), { hubApiPath: f } = se(), p = [{
			title: Z("admin"),
			text: Z("admin"),
			href: "/admin/dashboard"
		}, {
			title: Z("admin_resources_title"),
			text: Z("admin_resources_title")
		}], m = y([]), g = y(!1), b = y(null), x = y(!1), C = y(""), w = y(""), D = y(""), k = y(!1), A = y(!1), j = y(!1), M = v({
			activeDirectory: "",
			isDirectoryOpen: !1,
			openFile: ""
		});
		function N(e) {
			if (!e) return [];
			let t = e.split("/").filter(Boolean), n = [];
			for (let e = 1; e < t.length; e++) n.push("/" + t.slice(0, e).join("/"));
			return n;
		}
		function P(e) {
			if (!e) return "";
			let t = e.lastIndexOf("/");
			return t > 0 ? e.substring(0, t) : "";
		}
		function F(e, t) {
			if (!e || !t) return null;
			for (let n of e) {
				if (n.path === t) return n;
				if (n.children) {
					let e = F(n.children, t);
					if (e) return e;
				}
			}
			return null;
		}
		let I = t(() => {
			let e = /* @__PURE__ */ new Set();
			return M.activeDirectory && (N(M.activeDirectory).forEach((t) => e.add(t)), M.isDirectoryOpen && e.add(M.activeDirectory)), M.openFile && N(M.openFile).forEach((t) => e.add(t)), [...e];
		});
		async function L() {
			g.value = !0;
			try {
				let { data: e, execute: t } = u({
					url: "/admin/resources",
					method: "get",
					params: { tree: !0 },
					immediate: !1
				});
				await t(), m.value = e.value || [];
			} catch {} finally {
				g.value = !1;
			}
		}
		function R(e) {
			if (!e) return e;
			try {
				let t = new URL(e);
				return new URL(t.pathname, t.origin).toString();
			} catch {
				return e;
			}
		}
		function z(e) {
			if (e) try {
				let t = new URL(e).pathname.split("/").filter(Boolean);
				return t.length >= 2 ? t[0] : void 0;
			} catch {
				return;
			}
		}
		async function B() {
			x.value = !0;
			try {
				let [e, t, n] = await Promise.all([
					(async () => {
						try {
							let { data: e, execute: t } = u({
								url: "/admin/config/settings/resources_git_url",
								method: "get",
								immediate: !1
							});
							return await t(), e.value;
						} catch {
							return null;
						}
					})(),
					(async () => {
						try {
							let { data: e, execute: t } = u({
								url: "/admin/config/settings/resources_git_branch",
								method: "get",
								immediate: !1
							});
							return await t(), e.value;
						} catch {
							return null;
						}
					})(),
					(async () => {
						try {
							let { data: e, execute: t } = u({
								url: "/admin/resources/history",
								method: "get",
								immediate: !1
							});
							return await t(), e.value;
						} catch {
							return null;
						}
					})()
				]), r = R(e?.value), i = t?.value, a = Array.isArray(n) ? n[0] : null;
				b.value = {
					repo: r,
					branch: i,
					org: z(r),
					lastCommitId: a?.commitid,
					user: a?.user?.replace("ò", "").trim()
				};
			} catch {
				b.value = null;
			} finally {
				x.value = !1;
			}
		}
		function V(e) {
			try {
				return decodeURIComponent(atob(e).split("").map((e) => "%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2)).join(""));
			} catch {
				try {
					return atob(e);
				} catch {
					return e;
				}
			}
		}
		function H(e) {
			try {
				return JSON.stringify(JSON.parse(e), null, 2);
			} catch {
				return e;
			}
		}
		async function U(e) {
			C.value = e, M.openFile = e, M.activeDirectory = P(e), M.isDirectoryOpen = !0, w.value = "", D.value = "", k.value = !0;
			try {
				let t = e.split(".").pop()?.toLowerCase();
				if ([
					"png",
					"jpg",
					"jpeg",
					"gif",
					"svg",
					"webp",
					"ico",
					"bmp",
					"avif",
					"tif",
					"tiff",
					"apng",
					"pdf"
				].includes(t)) {
					D.value = `${f}/admin/resources/file?path=${encodeURIComponent(e)}&stream=true`;
					return;
				}
				let { data: n, execute: r } = u({
					url: "/admin/resources/file",
					method: "get",
					params: { path: e },
					immediate: !1
				});
				await r();
				let i = typeof n.value == "string" ? n.value : n.value?.content || "";
				if ([
					"woff",
					"woff2",
					"ttf",
					"otf",
					"eot",
					"zip",
					"tar",
					"gz",
					"mp3",
					"mp4",
					"wav"
				].includes(t)) w.value = i;
				else {
					let e = V(i);
					t === "json" && (e = H(e)), w.value = e;
				}
			} catch {
				w.value = "";
			} finally {
				k.value = !1;
			}
		}
		async function ee() {
			A.value = !0;
			try {
				let { data: e, execute: t } = u({
					url: "/admin/resources/status",
					method: "get",
					immediate: !1
				});
				if (!await t()) return;
				let n = e.value?.resourceOutOfSync;
				d({
					title: Z(n ? "admin_resources_updates_available" : "admin_resources_up_to_date"),
					type: n ? "warning" : "success"
				});
			} catch {} finally {
				A.value = !1;
			}
		}
		async function W() {
			j.value = !0;
			try {
				let { execute: e } = u({
					url: "/admin/resources/sync",
					method: "post",
					immediate: !1
				});
				if (!await e()) return;
				d({
					title: Z("admin_resources_sync_success"),
					type: "success"
				}), await Promise.all([L(), B()]);
			} catch {} finally {
				j.value = !1;
			}
		}
		function te(e) {
			return e ? e.substring(0, 7) : "—";
		}
		return h(async () => {
			J(M), await L(), B(), M.openFile && (F(m.value, M.openFile) ? await U(M.openFile) : (d({
				title: Z("admin_resources_file_not_found"),
				type: "warning"
			}), M.openFile = "", M.activeDirectory = "", M.isDirectoryOpen = !1));
		}), (t, r) => {
			let o = S("h-resource-view"), l = S("h-admin-layout");
			return _(), n(l, {
				class: "h-admin-resources",
				"page-key": "resources",
				"page-title": E(Z)("admin_resources_title"),
				"header-title": E(Z)("admin_resources_title"),
				"breadcrumb-items": p
			}, {
				default: O(() => [c(o, {
					class: "h-admin-resources__browser",
					items: m.value,
					"tree-loading": g.value,
					"selected-path": C.value,
					"expanded-paths": I.value,
					content: w.value,
					"content-url": D.value,
					"content-loading": k.value,
					onSelect: U
				}, {
					"sidebar-info": O(() => [a("div", er, [x.value ? (_(), i("div", tr, [c(rt, {
						indeterminate: "",
						size: "20",
						width: "2"
					})])) : b.value ? (_(), i(e, { key: 1 }, [
						a("div", nr, [c(ze, {
							icon: "mdi:mdi-git",
							size: "16",
							class: "mr-1"
						}), s(" " + T(E(Z)("admin_resources_git_information")), 1)]),
						a("div", rr, [a("span", ir, T(E(Z)("admin_resources_git_repo")), 1), b.value.repo ? (_(), i("a", {
							key: 0,
							href: b.value.repo,
							target: "_blank",
							rel: "noopener noreferrer",
							class: "text-body-small text-primary text-truncate"
						}, T(b.value.repo), 9, ar)) : (_(), i("span", or, "—"))]),
						a("div", sr, [a("span", cr, T(E(Z)("admin_resources_git_branch")), 1), a("span", lr, T(b.value.branch || "—"), 1)]),
						a("div", ur, [a("span", dr, T(E(Z)("admin_resources_git_org_user")), 1), a("span", fr, T(b.value.org || b.value.user || "—"), 1)]),
						a("div", pr, [a("span", mr, T(E(Z)("admin_resources_git_commit")), 1), a("span", {
							class: "text-body-small font-weight-medium",
							title: b.value.lastCommitId
						}, T(te(b.value.lastCommitId)), 9, hr)])
					], 64)) : (_(), i("div", gr, T(E(Z)("admin_resources_no_git_info")), 1))])]),
					"sidebar-actions": O(() => [a("div", _r, [c(Ue, {
						variant: "outlined",
						size: "small",
						"prepend-icon": "mdi:mdi-cloud-check-outline",
						loading: A.value,
						disabled: j.value,
						onClick: ee
					}, {
						default: O(() => [s(T(E(Z)("admin_resources_check")), 1)]),
						_: 1
					}, 8, ["loading", "disabled"]), c(Ue, {
						variant: "outlined",
						size: "small",
						"prepend-icon": "mdi:mdi-cloud-sync-outline",
						loading: j.value,
						disabled: A.value,
						onClick: W
					}, {
						default: O(() => [s(T(E(Z)("admin_resources_sync")), 1)]),
						_: 1
					}, 8, ["loading", "disabled"])])]),
					_: 1
				}, 8, [
					"items",
					"tree-loading",
					"selected-path",
					"expanded-paths",
					"content",
					"content-url",
					"content-loading"
				])]),
				_: 1
			}, 8, ["page-title", "header-title"]);
		};
	}
}, [["__scopeId", "data-v-41105bf3"]]), yr = { class: "text-body-large font-weight-medium" }, br = {
	__name: "pipeline-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 700
		}
	},
	emits: ["success", "cancel"],
	setup(t, { expose: o, emit: l }) {
		let { hAddAlert: u } = q(), { keyRules: d, nameRules: f, requiredRules: p } = ie(), { save: m } = ae();
		X(t, "HPipelineForm");
		let h = [
			{
				title: Z("task_type_reader"),
				value: "reader"
			},
			{
				title: Z("task_type_transform"),
				value: "transform"
			},
			{
				title: Z("task_type_script"),
				value: "script"
			},
			{
				title: Z("task_type_index"),
				value: "index"
			},
			{
				title: Z("task_type_purge"),
				value: "purge"
			}
		], g = {
			key: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			tag: {
				type: Array,
				default: () => []
			},
			role: {
				type: Array,
				default: () => []
			},
			tasks: {
				type: Array,
				default: () => []
			}
		}, x = {
			id: {
				type: String,
				default: ""
			},
			tasktype: {
				type: String,
				default: ""
			},
			task: {
				type: String,
				default: ""
			},
			order: {
				type: Number,
				default: null
			},
			required: {
				type: Boolean,
				default: !0
			}
		}, C = () => {
			let e = {};
			return Object.keys(g).forEach((t) => {
				let n = g[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e.tasks = [w()], e;
		}, w = () => {
			let e = {};
			return Object.keys(x).forEach((t) => {
				let n = x[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, k = l, A = y(null), j = y(!1), M = y(!1), N = y(!1), P = y(null), F = v(C()), I = y(!1), L = y({}), { data: R, loading: z } = K({
			url: "/admin/roles",
			formatter: (e) => e.map((e) => ({
				title: e.name,
				value: e.key,
				key: e.key
			}))
		}), B = v({
			reader: [],
			transform: [],
			script: [],
			index: [],
			purge: []
		}), V = v({
			reader: !1,
			transform: !1,
			script: !1,
			index: !1,
			purge: !1
		}), { data: H, loading: U } = K({
			url: "/admin/connector/tasks/reader",
			formatter: (e) => e.map((e) => ({
				title: e.name || e.id,
				value: e.id,
				key: e.id
			}))
		}), { data: ee, loading: W } = K({
			url: "/admin/connector/tasks/transform",
			formatter: (e) => e.map((e) => ({
				title: e.name || e.id,
				value: e.id,
				key: e.id
			}))
		}), { data: te, loading: ne } = K({
			url: "/admin/connector/tasks/script",
			formatter: (e) => e.map((e) => ({
				title: e.name || e.id,
				value: e.id,
				key: e.id
			}))
		}), { data: re, loading: G } = K({
			url: "/admin/connector/tasks/index",
			formatter: (e) => e.map((e) => ({
				title: e.name || e.id,
				value: e.id,
				key: e.id
			}))
		}), { data: J, loading: oe } = K({
			url: "/admin/connector/tasks/purge",
			formatter: (e) => e.map((e) => ({
				title: e.name || e.id,
				value: e.id,
				key: e.id
			}))
		});
		D(H, (e) => B.reader = e || [], { immediate: !0 }), D(ee, (e) => B.transform = e || [], { immediate: !0 }), D(te, (e) => B.script = e || [], { immediate: !0 }), D(re, (e) => B.index = e || [], { immediate: !0 }), D(J, (e) => B.purge = e || [], { immediate: !0 }), D(U, (e) => V.reader = e, { immediate: !0 }), D(W, (e) => V.transform = e, { immediate: !0 }), D(ne, (e) => V.script = e, { immediate: !0 }), D(G, (e) => V.index = e, { immediate: !0 }), D(oe, (e) => V.purge = e, { immediate: !0 });
		function Y(e) {
			return e && B[e] || [];
		}
		D(j, (e) => {
			e || se();
		}), D(F, () => {
			I.value = JSON.stringify(F) !== JSON.stringify(L.value);
		}, { deep: !0 });
		function se() {
			let e = C();
			Object.keys(e).forEach((t) => {
				F[t] = e[t];
			}), L.value = JSON.parse(JSON.stringify(F)), N.value = !1, P.value = null, I.value = !1;
		}
		function ce(e, t = !0) {
			Object.keys(g).forEach((t) => {
				let n = g[t], r = e?.[t], i = r != null;
				t === "tasks" ? i && Array.isArray(r) && r.length > 0 ? F[t] = r.map((e) => {
					let t = w();
					return Object.keys(x).forEach((n) => {
						let r = x[n], i = e?.[n], a = i != null;
						r.type === Boolean ? t[n] = a ? !!i : r.default : (r.type, t[n] = a ? i : r.default);
					}), t;
				}) : F[t] = [w()] : n.type === Array ? F[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : (n.type, F[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), t || (F.key = ""), L.value = JSON.parse(JSON.stringify(F)), N.value = t, P.value = t && e?.key || null, I.value = !t;
		}
		function le() {
			F.tasks.push(w());
		}
		function ue(e) {
			F.tasks.length > 1 && F.tasks.splice(e, 1);
		}
		function de(e) {
			if (e > 0) {
				let t = F.tasks[e];
				F.tasks[e] = F.tasks[e - 1], F.tasks[e - 1] = t;
			}
		}
		function fe(e) {
			if (e < F.tasks.length - 1) {
				let t = F.tasks[e];
				F.tasks[e] = F.tasks[e + 1], F.tasks[e + 1] = t;
			}
		}
		async function pe() {
			if (!M.value && ((await A.value?.validate())?.valid ?? !0)) {
				M.value = !0;
				try {
					await ge(he()), k("success"), j.value = !1;
				} catch (e) {
					u({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					M.value = !1;
				}
			}
		}
		function me(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) if (!(r === null || r === "" || Array.isArray(r) && r.length === 0)) if (typeof r == "object" && !Array.isArray(r)) {
				let e = {};
				for (let [t, n] of Object.entries(r)) n !== null && n !== "" && !(Array.isArray(n) && n.length === 0) && (e[t] = n);
				Object.keys(e).length > 0 && (t[n] = e);
			} else t[n] = r;
			return t;
		}
		function he() {
			let e = (e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [], t = e(F.tag), n = e(F.role), r = F.tasks.filter((e) => e.tasktype && e.task).map((e, t) => {
				let n = {
					tasktype: e.tasktype,
					task: typeof e.task == "object" ? e.task.value || e.task.key : e.task,
					order: e.order !== null && e.order !== "" ? Number(e.order) : t,
					required: e.required !== !1
				};
				return e.id && (n.id = e.id), n;
			});
			return me({
				key: F.key?.trim() || null,
				name: F.name?.trim() || null,
				description: F.description?.trim() || null,
				tag: t,
				role: n,
				tasks: r
			});
		}
		async function ge(e) {
			let t = N.value ? "update" : "create", n = {
				create: "/admin/connector/pipelines",
				update: `/admin/connector/pipelines/${encodeURIComponent(P.value)}`
			}, r = {
				create: "post",
				update: "put"
			}, i = {
				error: {
					create: "pipeline_create_error",
					update: "pipeline_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			}, a = t === "update" ? (({ key: e, ...t }) => t)(e) : e;
			if (!(await m({
				url: n[t],
				method: r[t],
				payload: a
			}))?.ok) throw Error(Z(i.error[t]));
			u({
				title: Z(i.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function _e() {
			k("cancel"), j.value = !1;
		}
		function ve(e = null) {
			e && ce(e), j.value = !0;
		}
		function ye(e) {
			ce(e, !1), j.value = !0;
		}
		return o({
			validate: () => A.value?.validate(),
			reset: () => A.value?.reset(),
			resetValidation: () => A.value?.resetValidation(),
			formData: F,
			open: ve,
			openCopy: ye
		}), (o, l) => {
			let u = S("h-form-text"), m = S("h-form-textarea"), g = S("h-form-combobox"), v = S("h-form-autocomplete"), y = S("h-action-button"), x = S("h-form-select"), C = S("h-form-switch"), w = S("h-form-field"), D = S("h-form-layout");
			return _(), n(D, {
				ref_key: "formRef",
				ref: A,
				modelValue: j.value,
				"onUpdate:modelValue": l[5] ||= (e) => j.value = e,
				loading: M.value,
				"bg-color": t.bgColor,
				"header-text": N.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": t.drawerWidth,
				"has-changes": I.value,
				onSubmit: pe,
				onCancel: _e
			}, {
				default: O(() => [
					c(u, {
						modelValue: F.key,
						"onUpdate:modelValue": l[0] ||= (e) => F.key = e,
						icon: "mdi:mdi-key",
						label: E(Z)("key"),
						rules: E(d)(!1),
						disabled: N.value,
						hint: E(Z)("pipeline_key_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"disabled",
						"hint"
					]),
					c(u, {
						modelValue: F.name,
						"onUpdate:modelValue": l[1] ||= (e) => F.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: E(f),
						hint: E(Z)("pipeline_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(m, {
						modelValue: F.description,
						"onUpdate:modelValue": l[2] ||= (e) => F.description = e,
						label: E(Z)("description"),
						hint: E(Z)("pipeline_description_hint"),
						icon: "mdi:mdi-text",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3"
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(g, {
						modelValue: F.tag,
						"onUpdate:modelValue": l[3] ||= (e) => F.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						hint: E(Z)("pipeline_tag_hint"),
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "]
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(v, {
						modelValue: F.role,
						"onUpdate:modelValue": l[4] ||= (e) => F.role = e,
						icon: "mdi:mdi-account-key",
						label: E(Z)("roles"),
						items: E(R),
						loading: E(z),
						hint: E(Z)("pipeline_role_hint"),
						multiple: "",
						chips: "",
						"closable-chips": ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"loading",
						"hint"
					]),
					c(w, {
						icon: "mdi:mdi-format-list-checks",
						label: E(Z)("tasks"),
						hint: E(Z)("pipeline_tasks_hint")
					}, {
						default: O(() => [c($, null, {
							default: O(() => [(_(!0), i(e, null, b(F.tasks, (e, t) => (_(), n(Q, {
								key: t,
								cols: "12",
								class: "mb-4"
							}, {
								default: O(() => [c(Fe, {
									variant: "outlined",
									class: "pa-4"
								}, {
									default: O(() => [c($, { class: "align-center mb-2" }, {
										default: O(() => [
											c(Q, {
												cols: "auto",
												class: "d-flex align-center"
											}, {
												default: O(() => [c(ze, {
													icon: "mdi:mdi-cog",
													class: "mr-2"
												}), a("span", yr, T(E(Z)("task")) + " #" + T(t + 1), 1)]),
												_: 2
											}, 1024),
											c(be),
											c(Q, {
												cols: "auto",
												class: "d-flex ga-1"
											}, {
												default: O(() => [
													t > 0 ? (_(), n(y, {
														key: 0,
														icon: "mdi:mdi-arrow-up",
														variant: "text",
														color: "grey",
														size: "small",
														onClick: (e) => de(t)
													}, null, 8, ["onClick"])) : r("", !0),
													t < F.tasks.length - 1 ? (_(), n(y, {
														key: 1,
														icon: "mdi:mdi-arrow-down",
														variant: "text",
														color: "grey",
														size: "small",
														onClick: (e) => fe(t)
													}, null, 8, ["onClick"])) : r("", !0),
													c(y, {
														icon: "mdi:mdi-delete",
														variant: "text",
														color: "error",
														size: "small",
														onClick: (e) => ue(t)
													}, null, 8, ["onClick"])
												]),
												_: 2
											}, 1024)
										]),
										_: 2
									}, 1024), c($, { class: "d-flex flex-column" }, {
										default: O(() => [c(Q, { class: "d-flex flex-column ga-4 pt-0" }, {
											default: O(() => [
												c(x, {
													modelValue: e.tasktype,
													"onUpdate:modelValue": (t) => e.tasktype = t,
													label: E(Z)("task_type"),
													items: h,
													rules: E(p)(E(Z)("task_type_required")),
													hint: E(Z)("pipeline_task_type_hint"),
													required: ""
												}, null, 8, [
													"modelValue",
													"onUpdate:modelValue",
													"label",
													"rules",
													"hint"
												]),
												c(v, {
													modelValue: e.task,
													"onUpdate:modelValue": (t) => e.task = t,
													label: E(Z)("task"),
													items: Y(e.tasktype),
													loading: V[e.tasktype],
													rules: E(p)(E(Z)("task_required")),
													hint: E(Z)("pipeline_task_hint"),
													disabled: !e.tasktype,
													required: ""
												}, null, 8, [
													"modelValue",
													"onUpdate:modelValue",
													"label",
													"items",
													"loading",
													"rules",
													"hint",
													"disabled"
												]),
												c(u, {
													modelValue: e.order,
													"onUpdate:modelValue": (t) => e.order = t,
													label: E(Z)("order"),
													hint: E(Z)("pipeline_task_order_hint"),
													type: "number"
												}, null, 8, [
													"modelValue",
													"onUpdate:modelValue",
													"label",
													"hint"
												]),
												c(C, {
													modelValue: e.required,
													"onUpdate:modelValue": (t) => e.required = t,
													icon: e.required ? "mdi:mdi-check-circle" : "mdi:mdi-circle-outline",
													label: E(Z)("required"),
													hint: E(Z)("pipeline_task_required_hint")
												}, null, 8, [
													"modelValue",
													"onUpdate:modelValue",
													"icon",
													"label",
													"hint"
												])
											]),
											_: 2
										}, 1024)]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024))), 128)), c(Q, { cols: "12" }, {
								default: O(() => [c(y, {
									type: "primary",
									variant: "outlined",
									"prepend-icon": "mdi:mdi-plus",
									class: "mt-2",
									onClick: le
								}, {
									default: O(() => [s(T(E(Z)("add_task")), 1)]),
									_: 1
								})]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}, 8, ["label", "hint"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, xr = {
	__name: "admin-pipelines",
	props: {},
	setup(n) {
		X(n, "HAdminConnectorPipelines");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { confirm: s } = ce(), { hAddAlert: l } = q(), u = y(!0), d = y(null), f = {
			term: "",
			key: "",
			keyMatchType: "contains",
			name: "",
			nameMatchType: "contains",
			description: "",
			descriptionMatchType: "contains",
			tag: [],
			role: [],
			modifieddatePreset: null,
			createdatePreset: null,
			sortBy: "name",
			sortOrder: "asc",
			page: 1,
			pageSize: 25
		}, p = v({ ...f }), m = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "key",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("key_filter"),
					placeholder: Z("key_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-key",
					defaultMatchType: "contains"
				}
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "description",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("description_filter"),
					placeholder: Z("description_filter_placeholder"),
					icon: "mdi:mdi-text"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "role",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("role_filter"),
					icon: "mdi:mdi-account-key"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [{
					key: "createdate",
					type: "date",
					component: "h-filter-datetime",
					model: "createdatePreset",
					props: {
						label: Z("createdate_filter"),
						manualSync: !0
					}
				}, {
					key: "modifieddate",
					type: "date",
					component: "h-filter-datetime",
					model: "modifieddatePreset",
					props: {
						label: Z("modifieddate_filter"),
						minDatePresetFilter: p.createdatePreset,
						manualSync: !0
					}
				}]
			}
		] }, g = [
			{
				title: "key",
				key: "key",
				sortable: !0,
				width: 150,
				value: "key",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => P("key", e.key, "exact"),
				isFilterActive: (e) => N("key", e.key, "exact")
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 200,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0,
				filterOnClick: (e) => P("name", e.name, "exact"),
				isFilterActive: (e) => N("name", e.name, "exact")
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => F("tag", e),
				isFilterActive: (e) => N("tag", e)
			},
			{
				title: "role",
				key: "role",
				sortable: !0,
				width: 150,
				value: "role",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => F("role", e),
				isFilterActive: (e) => N("role", e)
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 150,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], b = {
			pageKey: "connector-pipelines",
			pageTitle: Z("admin_connector_pipelines_title"),
			headerTitle: Z("pipelines"),
			searchPlaceholder: Z("search_pipelines"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("connector"),
					text: Z("connector")
				},
				{
					title: Z("pipelines"),
					text: Z("pipelines")
				}
			]
		}, { data: x, loading: C, params: w, execute: T, totalResults: D } = G({
			url: "/admin/connector/pipelines",
			filters: p,
			additionalParams: {}
		}), O = Z("total_pipelines"), k = t(() => ({ widgets: [{
			summary: !0,
			title: O,
			count: D.value,
			icon: "mdi:mdi-pipe",
			color: "blue-grey-lighten-3",
			iconColor: "blue-grey-darken-4"
		}] }));
		function A() {
			j(!0);
		}
		function j(e = !1) {
			let { query: t, sort: n } = a(m.filters, p);
			w.query = t, w.sort = n, (e || u.value) && T();
		}
		let M = qe(j, 300), { isFilterActive: N, toggleFilter: P, toggleArrayFilter: F } = ue({
			filters: p,
			onFilterChange: M
		}), I = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					d.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					d.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await s({
						title: Z("delete_pipeline"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = o({
							url: `/admin/connector/pipelines/${encodeURIComponent(e.key)}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							l({
								title: Z("error_occurred"),
								body: Z("pipeline_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await T();
					}
				}
			}
		];
		function L() {
			return Object.assign(p, { ...f }), j(!0);
		}
		function R() {
			d.value?.open();
		}
		return h(async () => {
			J(p, M), j(), T();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": u.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => u.value = e,
				"page-configuration": b,
				"widgets-config": k.value,
				"filters-config": m,
				filters: p,
				"table-headers": g,
				"table-actions": I,
				"table-params": E(w),
				"table-data": E(x),
				"table-loading": E(C),
				"total-results": E(D),
				"open-form": R,
				onSearch: A,
				onClearFilters: L
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(br, {
				ref_key: "pipelineFormRef",
				ref: d,
				onSuccess: E(T)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, Sr = {
	__name: "datasource-file-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 600
		}
	},
	emits: ["success", "cancel"],
	setup(e, { expose: t, emit: i }) {
		let { hAddAlert: a } = q(), { nameRules: o, requiredRules: s } = ie(), { save: l } = ae();
		X(e, "HDatasourceFileForm");
		let u = {
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			filetype: {
				type: String,
				default: "json"
			},
			delimiter: {
				type: String,
				default: ";"
			},
			filename: {
				type: String,
				default: ""
			},
			encoding: {
				type: String,
				default: "utf8"
			},
			tag: {
				type: Array,
				default: () => []
			}
		}, d = () => {
			let e = {};
			return Object.keys(u).forEach((t) => {
				let n = u[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, f = i, p = y(null), m = y(!1), h = y(!1), g = y(!1), b = y(null), x = v(d()), C = y(!1), w = y({}), T = [{
			title: "JSON",
			value: "json"
		}, {
			title: "CSV",
			value: "csv"
		}], k = [
			{
				title: "UTF-8",
				value: "utf8"
			},
			{
				title: "Unicode",
				value: "unicode"
			},
			{
				title: "ASCII",
				value: "ascii"
			}
		], A = [(e) => !!e || Z("delimiter_required")];
		D(x, () => {
			C.value = JSON.stringify(x) !== JSON.stringify(w.value);
		}, { deep: !0 }), D(m, (e) => {
			e || j();
		}), D(() => x.filetype, (e) => {
			e === "csv" ? x.delimiter ||= ";" : x.delimiter = "";
		});
		function j() {
			let e = d();
			Object.keys(e).forEach((t) => {
				x[t] = e[t];
			}), w.value = JSON.parse(JSON.stringify(x)), g.value = !1, b.value = null, C.value = !1;
		}
		function M(e, t = !0) {
			Object.keys(u).forEach((t) => {
				let n = u[t], r = e?.[t], i = r != null;
				n.type === Array ? x[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : (n.type, x[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), w.value = JSON.parse(JSON.stringify(x)), g.value = t, b.value = t && e?.id || null, C.value = !t;
		}
		async function N() {
			if (!h.value && ((await p.value?.validate())?.valid ?? !0)) {
				h.value = !0;
				try {
					await I(F()), f("success"), m.value = !1;
				} catch (e) {
					a({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					h.value = !1;
				}
			}
		}
		function P(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) r === null || r === "" || Array.isArray(r) && r.length === 0 || (t[n] = r);
			return t;
		}
		function F() {
			let e = ((e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [])(x.tag), t = {
				name: x.name?.trim() || null,
				description: x.description?.trim() || null,
				filetype: x.filetype || null,
				filename: x.filename?.trim() || null,
				encoding: x.encoding || "utf8",
				tag: e
			};
			return x.filetype === "csv" && (t.delimiter = x.delimiter?.trim() || null), P(t);
		}
		async function I(e) {
			let t = g.value ? "update" : "create", n = {
				create: "/admin/connector/datasource/file?refresh=true",
				update: `/admin/connector/datasource/file/${encodeURIComponent(b.value)}?refresh=true`
			}, r = {
				create: "post",
				update: "put"
			}, i = {
				error: {
					create: "datasource_file_create_error",
					update: "datasource_file_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			}, o = t === "update" ? (({ name: e, ...t }) => t)(e) : e;
			if (!(await l({
				url: n[t],
				method: r[t],
				payload: o
			}))?.ok) throw Error(Z(i.error[t]));
			a({
				title: Z(i.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function L() {
			f("cancel"), m.value = !1;
		}
		function R(e = null) {
			e && M(e), m.value = !0;
		}
		function z(e) {
			M(e, !1), m.value = !0;
		}
		return t({
			validate: () => p.value?.validate(),
			reset: () => p.value?.reset(),
			resetValidation: () => p.value?.resetValidation(),
			formData: x,
			open: R,
			openCopy: z
		}), (t, i) => {
			let a = S("h-form-text"), l = S("h-form-textarea"), u = S("h-form-select"), d = S("h-form-combobox"), f = S("h-form-layout");
			return _(), n(f, {
				ref_key: "formRef",
				ref: p,
				modelValue: m.value,
				"onUpdate:modelValue": i[7] ||= (e) => m.value = e,
				loading: h.value,
				"bg-color": e.bgColor,
				"header-text": g.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": e.drawerWidth,
				"has-changes": C.value,
				onSubmit: N,
				onCancel: L
			}, {
				default: O(() => [
					c(a, {
						modelValue: x.name,
						"onUpdate:modelValue": i[0] ||= (e) => x.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: E(o),
						hint: E(Z)("datasource_file_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(l, {
						modelValue: x.description,
						"onUpdate:modelValue": i[1] ||= (e) => x.description = e,
						label: E(Z)("description"),
						hint: E(Z)("datasource_file_description_hint"),
						icon: "mdi:mdi-text",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3"
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(u, {
						modelValue: x.filetype,
						"onUpdate:modelValue": i[2] ||= (e) => x.filetype = e,
						icon: "mdi:mdi-file-document",
						label: E(Z)("filetype"),
						items: T,
						rules: E(s)(E(Z)("filetype_required")),
						hint: E(Z)("datasource_file_filetype_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					x.filetype === "csv" ? (_(), n(a, {
						key: 0,
						modelValue: x.delimiter,
						"onUpdate:modelValue": i[3] ||= (e) => x.delimiter = e,
						icon: "mdi:mdi-format-columns",
						label: E(Z)("delimiter"),
						rules: A,
						hint: E(Z)("datasource_file_delimiter_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					])) : r("", !0),
					c(a, {
						modelValue: x.filename,
						"onUpdate:modelValue": i[4] ||= (e) => x.filename = e,
						icon: "mdi:mdi-file",
						label: E(Z)("filename"),
						rules: E(s)(E(Z)("filename_required")),
						hint: E(Z)("datasource_file_filename_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(u, {
						modelValue: x.encoding,
						"onUpdate:modelValue": i[5] ||= (e) => x.encoding = e,
						icon: "mdi:mdi-translate",
						label: E(Z)("encoding"),
						items: k,
						rules: E(s)(E(Z)("encoding_required")),
						hint: E(Z)("datasource_file_encoding_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(d, {
						modelValue: x.tag,
						"onUpdate:modelValue": i[6] ||= (e) => x.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "]
					}, null, 8, ["modelValue", "label"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, Cr = {
	__name: "admin-datasource-file",
	props: {},
	setup(n) {
		X(n, "HAdminConnectorDatasourceFile");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { confirm: s } = ce(), { hAddAlert: l } = q(), u = y(!0), d = y(null), f = [{
			label: "JSON",
			value: "json"
		}, {
			label: "CSV",
			value: "csv"
		}], p = [
			{
				label: "UTF-8",
				value: "utf8"
			},
			{
				label: "Unicode",
				value: "unicode"
			},
			{
				label: "ASCII",
				value: "ascii"
			}
		], m = {
			term: "",
			name: "",
			nameMatchType: "contains",
			description: "",
			descriptionMatchType: "contains",
			filetype: [],
			filename: "",
			filenameMatchType: "contains",
			encoding: [],
			tag: [],
			modifieddatePreset: null,
			createdatePreset: null,
			sortBy: "name",
			sortOrder: "asc",
			page: 1,
			pageSize: 25
		}, g = v({ ...m }), b = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "description",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("description_filter"),
					placeholder: Z("description_filter_placeholder"),
					icon: "mdi:mdi-text"
				}
			},
			{
				key: "filetype",
				type: "array",
				component: "h-filter-multiselect",
				props: {
					title: Z("filetype_filter"),
					icon: "mdi:mdi-file-document",
					options: f
				}
			},
			{
				key: "filename",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("filename_filter"),
					placeholder: Z("filename_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-file",
					defaultMatchType: "contains"
				}
			},
			{
				key: "encoding",
				type: "array",
				component: "h-filter-multiselect",
				props: {
					title: Z("encoding_filter"),
					icon: "mdi:mdi-format-text",
					options: p
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [{
					key: "createdate",
					type: "date",
					component: "h-filter-datetime",
					model: "createdatePreset",
					props: {
						label: Z("createdate_filter"),
						manualSync: !0
					}
				}, {
					key: "modifieddate",
					type: "date",
					component: "h-filter-datetime",
					model: "modifieddatePreset",
					props: {
						label: Z("modifieddate_filter"),
						minDatePresetFilter: g.createdatePreset,
						manualSync: !0
					}
				}]
			}
		] }, x = [
			{
				title: "id",
				key: "id",
				align: "start",
				sortable: !0,
				width: 150,
				value: "id",
				nowrap: !0,
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 200,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0,
				filterOnClick: (e) => I("name", e.name, "exact"),
				isFilterActive: (e) => F("name", e.name, "exact")
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "filetype",
				key: "filetype",
				sortable: !0,
				width: 100,
				value: "filetype",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => L("filetype", e.filetype),
				isFilterActive: (e) => F("filetype", e.filetype)
			},
			{
				title: "filename",
				key: "filename",
				sortable: !0,
				width: 200,
				value: "filename",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => I("filename", e.filename, "exact"),
				isFilterActive: (e) => F("filename", e.filename, "exact")
			},
			{
				title: "encoding",
				key: "encoding",
				sortable: !0,
				width: 100,
				value: "encoding",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => L("encoding", e.encoding),
				isFilterActive: (e) => F("encoding", e.encoding)
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => L("tag", e),
				isFilterActive: (e) => F("tag", e)
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 150,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], C = {
			pageKey: "connector-datasource-file",
			pageTitle: Z("admin_connector_datasource_file_title"),
			headerTitle: Z("datasource_file"),
			searchPlaceholder: Z("search_datasource_files"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("connector"),
					text: Z("connector")
				},
				{
					title: Z("datasource"),
					text: Z("datasource")
				},
				{
					title: Z("file"),
					text: Z("file")
				}
			]
		}, { data: w, loading: T, params: D, execute: O, totalResults: k } = G({
			url: "/admin/connector/datasource/file",
			filters: g,
			additionalParams: {}
		}), A = Z("total_datasource_files"), j = t(() => ({ widgets: [{
			summary: !0,
			title: A,
			count: k.value,
			icon: "mdi:mdi-file-multiple",
			color: "blue-grey-lighten-3",
			iconColor: "blue-grey-darken-4"
		}] }));
		function M() {
			N(!0);
		}
		function N(e = !1) {
			let { query: t, sort: n } = a(b.filters, g);
			D.query = t, D.sort = n, (e || u.value) && O();
		}
		let P = qe(N, 300), { isFilterActive: F, toggleFilter: I, toggleArrayFilter: L } = ue({
			filters: g,
			onFilterChange: P
		}), R = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					d.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					d.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await s({
						title: Z("delete_datasource_file"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = o({
							url: `/admin/connector/datasource/file/${encodeURIComponent(e.id)}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							l({
								title: Z("error_occurred"),
								body: Z("datasource_file_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await O();
					}
				}
			}
		];
		function z() {
			return Object.assign(g, { ...m }), N(!0);
		}
		function B() {
			d.value?.open();
		}
		return h(async () => {
			J(g, P), N(), O();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": u.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => u.value = e,
				"page-configuration": C,
				"widgets-config": j.value,
				"filters-config": b,
				filters: g,
				"table-headers": x,
				"table-actions": R,
				"table-params": E(D),
				"table-data": E(w),
				"table-loading": E(T),
				"total-results": E(k),
				"open-form": B,
				onSearch: M,
				onClearFilters: z
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(Sr, {
				ref_key: "datasourceFileFormRef",
				ref: d,
				onSuccess: E(O)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, wr = {
	__name: "datasource-ldap-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 600
		}
	},
	emits: ["success", "cancel"],
	setup(e, { expose: t, emit: r }) {
		let { hAddAlert: i } = q(), { nameRules: a, requiredRules: o } = ie(), { save: s } = ae();
		X(e, "HDatasourceLdapForm");
		let l = {
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			server: {
				type: String,
				default: ""
			},
			port: {
				type: Number,
				default: 389
			},
			timeout: {
				type: Number,
				default: 30
			},
			searchbase: {
				type: String,
				default: ""
			},
			searchscope: {
				type: String,
				default: "subtree"
			},
			username: {
				type: String,
				default: ""
			},
			password: {
				type: String,
				default: ""
			},
			tag: {
				type: Array,
				default: () => []
			}
		}, u = () => {
			let e = {};
			return Object.keys(l).forEach((t) => {
				let n = l[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, d = r, f = y(null), p = y(!1), m = y(!1), h = y(!1), g = y(null), b = v(u()), x = y(!1), C = y({}), w = [
			{
				title: "Base",
				value: "base"
			},
			{
				title: "One Level",
				value: "onelevel"
			},
			{
				title: "Subtree",
				value: "subtree"
			}
		];
		D(b, () => {
			x.value = JSON.stringify(b) !== JSON.stringify(C.value);
		}, { deep: !0 }), D(p, (e) => {
			e || T();
		});
		function T() {
			let e = u();
			Object.keys(e).forEach((t) => {
				b[t] = e[t];
			}), C.value = JSON.parse(JSON.stringify(b)), h.value = !1, g.value = null, x.value = !1;
		}
		function k(e, t = !0) {
			Object.keys(l).forEach((t) => {
				let n = l[t], r = e?.[t], i = r != null;
				n.type === Array ? b[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : n.type === Number ? b[t] = i ? Number(r) : typeof n.default == "function" ? n.default() : n.default : (n.type, b[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), t || (b.password = ""), t && (b.password = ""), C.value = JSON.parse(JSON.stringify(b)), h.value = t, g.value = t && e?.id || null, x.value = !t;
		}
		async function A() {
			if (!m.value && ((await f.value?.validate())?.valid ?? !0)) {
				m.value = !0;
				try {
					await N(M()), d("success"), p.value = !1;
				} catch (e) {
					i({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					m.value = !1;
				}
			}
		}
		function j(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) r === null || r === "" || Array.isArray(r) && r.length === 0 || (t[n] = r);
			return t;
		}
		function M() {
			let e = ((e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [])(b.tag);
			return j({
				name: b.name?.trim() || null,
				description: b.description?.trim() || null,
				server: b.server?.trim() || null,
				port: b.port || 389,
				timeout: b.timeout || 30,
				searchbase: b.searchbase?.trim() || null,
				searchscope: b.searchscope || "subtree",
				username: b.username?.trim() || null,
				password: b.password || null,
				tag: e
			});
		}
		async function N(e) {
			let t = h.value ? "update" : "create", n = {
				create: "/admin/connector/datasource/ldap?refresh=true",
				update: `/admin/connector/datasource/ldap/${encodeURIComponent(g.value)}?refresh=true`
			}, r = {
				create: "post",
				update: "put"
			}, a = {
				error: {
					create: "datasource_ldap_create_error",
					update: "datasource_ldap_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			}, o = t === "update" ? (({ name: e, ...t }) => t)(e) : e;
			if (!(await s({
				url: n[t],
				method: r[t],
				payload: o
			}))?.ok) throw Error(Z(a.error[t]));
			i({
				title: Z(a.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function P() {
			d("cancel"), p.value = !1;
		}
		function F(e = null) {
			e && k(e), p.value = !0;
		}
		function I(e) {
			k(e, !1), p.value = !0;
		}
		return t({
			validate: () => f.value?.validate(),
			reset: () => f.value?.reset(),
			resetValidation: () => f.value?.resetValidation(),
			formData: b,
			open: F,
			openCopy: I
		}), (t, r) => {
			let i = S("h-form-text"), s = S("h-form-textarea"), l = S("h-form-select"), u = S("h-form-password"), d = S("h-form-combobox"), g = S("h-form-layout");
			return _(), n(g, {
				ref_key: "formRef",
				ref: f,
				modelValue: p.value,
				"onUpdate:modelValue": r[10] ||= (e) => p.value = e,
				loading: m.value,
				"bg-color": e.bgColor,
				"header-text": h.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": e.drawerWidth,
				"has-changes": x.value,
				onSubmit: A,
				onCancel: P
			}, {
				default: O(() => [
					c(i, {
						modelValue: b.name,
						"onUpdate:modelValue": r[0] ||= (e) => b.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: E(a),
						hint: E(Z)("datasource_ldap_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(s, {
						modelValue: b.description,
						"onUpdate:modelValue": r[1] ||= (e) => b.description = e,
						label: E(Z)("description"),
						hint: E(Z)("datasource_ldap_description_hint"),
						icon: "mdi:mdi-text",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3"
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(i, {
						modelValue: b.server,
						"onUpdate:modelValue": r[2] ||= (e) => b.server = e,
						icon: "mdi:mdi-server",
						label: E(Z)("server"),
						rules: E(o)(E(Z)("server_required")),
						hint: E(Z)("datasource_ldap_server_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(i, {
						modelValue: b.port,
						"onUpdate:modelValue": r[3] ||= (e) => b.port = e,
						modelModifiers: { number: !0 },
						icon: "mdi:mdi-ethernet",
						label: E(Z)("port"),
						type: "number",
						hint: E(Z)("datasource_ldap_port_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(i, {
						modelValue: b.timeout,
						"onUpdate:modelValue": r[4] ||= (e) => b.timeout = e,
						modelModifiers: { number: !0 },
						icon: "mdi:mdi-timer-outline",
						label: E(Z)("timeout"),
						type: "number",
						hint: E(Z)("datasource_ldap_timeout_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(i, {
						modelValue: b.searchbase,
						"onUpdate:modelValue": r[5] ||= (e) => b.searchbase = e,
						icon: "mdi:mdi-folder-search",
						label: E(Z)("searchbase"),
						rules: E(o)(E(Z)("searchbase_required")),
						hint: E(Z)("datasource_ldap_searchbase_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(l, {
						modelValue: b.searchscope,
						"onUpdate:modelValue": r[6] ||= (e) => b.searchscope = e,
						icon: "mdi:mdi-magnify-scan",
						label: E(Z)("searchscope"),
						items: w,
						hint: E(Z)("datasource_ldap_searchscope_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(i, {
						modelValue: b.username,
						"onUpdate:modelValue": r[7] ||= (e) => b.username = e,
						icon: "mdi:mdi-account",
						label: E(Z)("username"),
						rules: E(o)(E(Z)("username_required")),
						hint: E(Z)("datasource_ldap_username_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(u, {
						modelValue: b.password,
						"onUpdate:modelValue": r[8] ||= (e) => b.password = e,
						icon: "mdi:mdi-lock",
						label: E(Z)("password"),
						hint: E(Z)("datasource_ldap_password_hint"),
						required: !h.value,
						"allow-empty": h.value,
						"min-password-length": 2
					}, null, 8, [
						"modelValue",
						"label",
						"hint",
						"required",
						"allow-empty"
					]),
					c(d, {
						modelValue: b.tag,
						"onUpdate:modelValue": r[9] ||= (e) => b.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "]
					}, null, 8, ["modelValue", "label"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, Tr = {
	__name: "admin-datasource-ldap",
	props: {},
	setup(n) {
		X(n, "HAdminConnectorDatasourceLdap");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { confirm: s } = ce(), { hAddAlert: l } = q(), u = y(!0), d = y(null), f = [
			{
				label: "Base",
				value: "base"
			},
			{
				label: "One Level",
				value: "onelevel"
			},
			{
				label: "Subtree",
				value: "subtree"
			}
		], p = {
			term: "",
			name: "",
			nameMatchType: "contains",
			description: "",
			descriptionMatchType: "contains",
			server: "",
			serverMatchType: "contains",
			searchbase: "",
			searchbaseMatchType: "contains",
			searchscope: [],
			tag: [],
			modifieddatePreset: null,
			createdatePreset: null,
			sortBy: "name",
			sortOrder: "asc",
			page: 1,
			pageSize: 25
		}, m = v({ ...p }), g = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "description",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("description_filter"),
					placeholder: Z("description_filter_placeholder"),
					icon: "mdi:mdi-text"
				}
			},
			{
				key: "server",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("server_filter"),
					placeholder: Z("server_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-server",
					defaultMatchType: "contains"
				}
			},
			{
				key: "searchbase",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("searchbase_filter"),
					placeholder: Z("searchbase_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-folder-search",
					defaultMatchType: "contains"
				}
			},
			{
				key: "searchscope",
				type: "array",
				component: "h-filter-multiselect",
				props: {
					title: Z("searchscope_filter"),
					options: f
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [{
					key: "createdate",
					type: "date",
					component: "h-filter-datetime",
					model: "createdatePreset",
					props: {
						label: Z("createdate_filter"),
						manualSync: !0
					}
				}, {
					key: "modifieddate",
					type: "date",
					component: "h-filter-datetime",
					model: "modifieddatePreset",
					props: {
						label: Z("modifieddate_filter"),
						minDatePresetFilter: m.createdatePreset,
						manualSync: !0
					}
				}]
			}
		] }, b = [
			{
				title: "id",
				key: "id",
				align: "start",
				sortable: !0,
				width: 150,
				value: "id",
				nowrap: !0,
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 200,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0,
				filterOnClick: (e) => F("name", e.name, "exact"),
				isFilterActive: (e) => P("name", e.name, "exact")
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "server",
				key: "server",
				sortable: !0,
				width: 200,
				value: "server",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => F("server", e.server, "exact"),
				isFilterActive: (e) => P("server", e.server, "exact")
			},
			{
				title: "port",
				key: "port",
				sortable: !0,
				width: 80,
				value: "port",
				nowrap: !0,
				translate: !0
			},
			{
				title: "timeout",
				key: "timeout",
				sortable: !0,
				width: 80,
				value: "timeout",
				nowrap: !0,
				translate: !0
			},
			{
				title: "searchbase",
				key: "searchbase",
				sortable: !0,
				width: 250,
				value: "searchbase",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => F("searchbase", e.searchbase, "exact"),
				isFilterActive: (e) => P("searchbase", e.searchbase, "exact")
			},
			{
				title: "searchscope",
				key: "searchscope",
				sortable: !0,
				width: 100,
				value: "searchscope",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => I("searchscope", e.searchscope),
				isFilterActive: (e) => P("searchscope", e.searchscope)
			},
			{
				title: "username",
				key: "username",
				sortable: !0,
				width: 150,
				value: "username",
				nowrap: !0,
				translate: !0
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => I("tag", e),
				isFilterActive: (e) => P("tag", e)
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 150,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], x = {
			pageKey: "connector-datasource-ldap",
			pageTitle: Z("admin_connector_datasource_ldap_title"),
			headerTitle: Z("datasource_ldap"),
			searchPlaceholder: Z("search_datasource_ldap"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("connector"),
					text: Z("connector")
				},
				{
					title: Z("datasource"),
					text: Z("datasource")
				},
				{
					title: Z("ldap"),
					text: Z("ldap")
				}
			]
		}, { data: C, loading: w, params: T, execute: D, totalResults: O } = G({
			url: "/admin/connector/datasource/ldap",
			filters: m,
			additionalParams: {}
		}), k = Z("total_datasource_ldap"), A = t(() => ({ widgets: [{
			summary: !0,
			title: k,
			count: O.value,
			icon: "mdi:mdi-folder-network",
			color: "blue-grey-lighten-3",
			iconColor: "blue-grey-darken-4"
		}] }));
		function j() {
			M(!0);
		}
		function M(e = !1) {
			let { query: t, sort: n } = a(g.filters, m);
			T.query = t, T.sort = n, (e || u.value) && D();
		}
		let N = qe(M, 300), { isFilterActive: P, toggleFilter: F, toggleArrayFilter: I } = ue({
			filters: m,
			onFilterChange: N
		}), L = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					d.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					d.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await s({
						title: Z("delete_datasource_ldap"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = o({
							url: `/admin/connector/datasource/ldap/${encodeURIComponent(e.id)}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							l({
								title: Z("error_occurred"),
								body: Z("datasource_ldap_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await D();
					}
				}
			}
		];
		function R() {
			return Object.assign(m, { ...p }), M(!0);
		}
		function z() {
			d.value?.open();
		}
		return h(async () => {
			J(m, N), M(), D();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": u.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => u.value = e,
				"page-configuration": x,
				"widgets-config": A.value,
				"filters-config": g,
				filters: m,
				"table-headers": b,
				"table-actions": L,
				"table-params": E(T),
				"table-data": E(C),
				"table-loading": E(w),
				"total-results": E(O),
				"open-form": z,
				onSearch: j,
				onClearFilters: R
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(wr, {
				ref_key: "datasourceLdapFormRef",
				ref: d,
				onSuccess: E(D)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, Er = { class: "text-headline-small" }, Dr = {
	__name: "datasource-rest-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 600
		}
	},
	emits: ["success", "cancel"],
	setup(t, { expose: o, emit: l }) {
		let { hAddAlert: u } = q(), { nameRules: d, requiredRules: f } = ie(), { save: p } = ae();
		X(t, "HDatasourceRestForm");
		let m = {
			id: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			host: {
				type: String,
				default: ""
			},
			scheme: {
				type: String,
				default: "https"
			},
			timeout: {
				type: Number,
				default: 30
			},
			method: {
				type: String,
				default: "get"
			},
			pagination: {
				type: Object,
				default: () => ({
					paginationtype: "none",
					offsetparam: "",
					nexturlfield: "",
					totalfield: ""
				})
			},
			headers: {
				type: Array,
				default: () => []
			},
			bodyJson: {
				type: String,
				default: ""
			},
			recordspath: {
				type: String,
				default: ""
			},
			tag: {
				type: Array,
				default: () => []
			}
		}, h = () => {
			let e = {};
			return Object.keys(m).forEach((t) => {
				let n = m[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, g = l, x = y(null), C = y(!1), w = y(!1), k = y(!1), A = y(null), j = v(h()), M = y(!1), N = y({}), P = [{
			title: "HTTPS",
			value: "https"
		}, {
			title: "HTTP",
			value: "http"
		}], F = [
			{
				title: "GET",
				value: "get"
			},
			{
				title: "POST",
				value: "post"
			},
			{
				title: "PUT",
				value: "put"
			}
		], I = [
			{
				title: Z("pagination_none"),
				value: "none"
			},
			{
				title: Z("pagination_nexturl"),
				value: "nexturl"
			},
			{
				title: Z("pagination_offset"),
				value: "offset"
			}
		], L = [(e) => {
			if (!e || e.trim() === "") return !0;
			try {
				return JSON.parse(e), !0;
			} catch {
				return Z("json_invalid");
			}
		}];
		D(j, () => {
			M.value = JSON.stringify(j) !== JSON.stringify(N.value);
		}, { deep: !0 }), D(C, (e) => {
			e || R();
		}), D(() => j.pagination.paginationtype, (e) => {
			e !== "offset" && (j.pagination.offsetparam = "", j.pagination.totalfield = ""), e !== "nexturl" && (j.pagination.nexturlfield = "");
		});
		function R() {
			let e = h();
			Object.keys(e).forEach((t) => {
				t === "pagination" ? j[t] = { ...e[t] } : j[t] = e[t];
			}), N.value = JSON.parse(JSON.stringify(j)), k.value = !1, A.value = null, M.value = !1;
		}
		function z(e, t = !0) {
			Object.keys(m).forEach((t) => {
				let n = m[t], r = e?.[t], i = r != null;
				if (t === "pagination") j[t] = i ? {
					paginationtype: r.paginationtype || "none",
					offsetparam: r.offsetparam || "",
					nexturlfield: r.nexturlfield || "",
					totalfield: r.totalfield || ""
				} : { ...n.default() };
				else if (t === "bodyJson") {
					let n = e?.body;
					j[t] = n ? JSON.stringify(n, null, 2) : "";
				} else n.type === Array ? j[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : n.type === Number ? j[t] = i ? Number(r) : typeof n.default == "function" ? n.default() : n.default : (n.type, j[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), t || (j.id = ""), N.value = JSON.parse(JSON.stringify(j)), k.value = t, A.value = t && e?.id || null, M.value = !t;
		}
		async function B() {
			if (!w.value && ((await x.value?.validate())?.valid ?? !0)) {
				w.value = !0;
				try {
					await U(H()), g("success"), C.value = !1;
				} catch (e) {
					u({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					w.value = !1;
				}
			}
		}
		function V(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) r === null || r === "" || Array.isArray(r) && r.length === 0 || (t[n] = r);
			return t;
		}
		function H() {
			let e = ((e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [])(j.tag), t = { paginationtype: j.pagination.paginationtype || "none" };
			j.pagination.paginationtype === "offset" ? (t.offsetparam = j.pagination.offsetparam?.trim() || null, t.totalfield = j.pagination.totalfield?.trim() || null) : j.pagination.paginationtype === "nexturl" && (t.nexturlfield = j.pagination.nexturlfield?.trim() || null);
			let n = null;
			if (j.bodyJson && j.bodyJson.trim()) try {
				n = JSON.parse(j.bodyJson);
			} catch {}
			let r = j.headers.filter((e) => e.key && e.value).map((e) => {
				let t = {
					key: e.key?.trim(),
					value: e.value?.trim()
				};
				return e.id?.trim() && (t.id = e.id.trim()), t;
			});
			return V({
				id: j.id?.trim() || null,
				name: j.name?.trim() || null,
				description: j.description?.trim() || null,
				host: j.host?.trim() || null,
				scheme: j.scheme || "https",
				timeout: j.timeout || 30,
				method: j.method || "get",
				pagination: t,
				headers: r.length > 0 ? r : null,
				body: n,
				recordspath: j.recordspath?.trim() || null,
				tag: e
			});
		}
		async function U(e) {
			let t = k.value ? "update" : "create", n = {
				create: "/admin/connector/datasource/rest?refresh=true",
				update: `/admin/connector/datasource/rest/${encodeURIComponent(A.value)}?refresh=true`
			}, r = {
				create: "post",
				update: "put"
			}, i = {
				error: {
					create: "datasource_rest_create_error",
					update: "datasource_rest_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			}, a = t === "update" ? (({ id: e, ...t }) => t)(e) : e;
			if (!(await p({
				url: n[t],
				method: r[t],
				payload: a
			}))?.ok) throw Error(Z(i.error[t]));
			u({
				title: Z(i.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function ee() {
			g("cancel"), C.value = !1;
		}
		function W() {
			j.headers ||= [], j.headers.push({
				id: "",
				key: "",
				value: ""
			});
		}
		function te(e) {
			j.headers.splice(e, 1);
		}
		function ne(e = null) {
			e && z(e), C.value = !0;
		}
		function re(e) {
			z(e, !1), C.value = !0;
		}
		return o({
			validate: () => x.value?.validate(),
			reset: () => x.value?.reset(),
			resetValidation: () => x.value?.resetValidation(),
			formData: j,
			open: ne,
			openCopy: re
		}), (o, l) => {
			let u = S("h-form-text"), p = S("h-form-textarea"), m = S("h-form-select"), h = S("h-form-field"), g = S("h-action-button"), v = S("h-form-code-editor"), y = S("h-form-combobox"), D = S("h-form-layout");
			return _(), n(D, {
				ref_key: "formRef",
				ref: x,
				modelValue: C.value,
				"onUpdate:modelValue": l[14] ||= (e) => C.value = e,
				loading: w.value,
				"bg-color": t.bgColor,
				"header-text": k.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": t.drawerWidth,
				"has-changes": M.value,
				onSubmit: B,
				onCancel: ee
			}, {
				default: O(() => [
					c(u, {
						modelValue: j.id,
						"onUpdate:modelValue": l[0] ||= (e) => j.id = e,
						icon: "mdi:mdi-identifier",
						label: E(Z)("id"),
						disabled: k.value,
						hint: E(Z)("datasource_rest_id_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"disabled",
						"hint"
					]),
					c(u, {
						modelValue: j.name,
						"onUpdate:modelValue": l[1] ||= (e) => j.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: E(d),
						hint: E(Z)("datasource_rest_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(p, {
						modelValue: j.description,
						"onUpdate:modelValue": l[2] ||= (e) => j.description = e,
						label: E(Z)("description"),
						hint: E(Z)("datasource_rest_description_hint"),
						icon: "mdi:mdi-text",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3"
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(u, {
						modelValue: j.host,
						"onUpdate:modelValue": l[3] ||= (e) => j.host = e,
						icon: "mdi:mdi-web",
						label: E(Z)("host"),
						rules: E(f)(E(Z)("host_required")),
						hint: E(Z)("datasource_rest_host_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(m, {
						modelValue: j.scheme,
						"onUpdate:modelValue": l[4] ||= (e) => j.scheme = e,
						icon: "mdi:mdi-lock",
						label: E(Z)("scheme"),
						items: P,
						hint: E(Z)("datasource_rest_scheme_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(u, {
						modelValue: j.timeout,
						"onUpdate:modelValue": l[5] ||= (e) => j.timeout = e,
						modelModifiers: { number: !0 },
						icon: "mdi:mdi-timer-outline",
						label: E(Z)("timeout"),
						type: "number",
						hint: E(Z)("datasource_rest_timeout_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(m, {
						modelValue: j.method,
						"onUpdate:modelValue": l[6] ||= (e) => j.method = e,
						icon: "mdi:mdi-swap-horizontal",
						label: E(Z)("method"),
						items: F,
						hint: E(Z)("datasource_rest_method_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(h, {
						icon: "mdi:mdi-page-next",
						label: E(Z)("pagination"),
						indent: ""
					}, {
						default: O(() => [c($, null, {
							default: O(() => [
								c(Q, { cols: "12" }, {
									default: O(() => [c(m, {
										modelValue: j.pagination.paginationtype,
										"onUpdate:modelValue": l[7] ||= (e) => j.pagination.paginationtype = e,
										icon: "mdi:mdi-page-next",
										label: E(Z)("paginationtype"),
										items: I,
										hint: E(Z)("datasource_rest_paginationtype_hint")
									}, null, 8, [
										"modelValue",
										"label",
										"hint"
									])]),
									_: 1
								}),
								j.pagination.paginationtype === "offset" ? (_(), n(Q, {
									key: 0,
									cols: "12"
								}, {
									default: O(() => [c(u, {
										modelValue: j.pagination.offsetparam,
										"onUpdate:modelValue": l[8] ||= (e) => j.pagination.offsetparam = e,
										icon: "mdi:mdi-numeric",
										label: E(Z)("offsetparam"),
										rules: E(f)(E(Z)("offsetparam_required")),
										hint: E(Z)("datasource_rest_offsetparam_hint"),
										required: ""
									}, null, 8, [
										"modelValue",
										"label",
										"rules",
										"hint"
									])]),
									_: 1
								})) : r("", !0),
								j.pagination.paginationtype === "offset" ? (_(), n(Q, {
									key: 1,
									cols: "12"
								}, {
									default: O(() => [c(u, {
										modelValue: j.pagination.totalfield,
										"onUpdate:modelValue": l[9] ||= (e) => j.pagination.totalfield = e,
										icon: "mdi:mdi-counter",
										label: E(Z)("totalfield"),
										rules: E(f)(E(Z)("totalfield_required")),
										hint: E(Z)("datasource_rest_totalfield_hint"),
										required: ""
									}, null, 8, [
										"modelValue",
										"label",
										"rules",
										"hint"
									])]),
									_: 1
								})) : r("", !0),
								j.pagination.paginationtype === "nexturl" ? (_(), n(Q, {
									key: 2,
									cols: "12"
								}, {
									default: O(() => [c(u, {
										modelValue: j.pagination.nexturlfield,
										"onUpdate:modelValue": l[10] ||= (e) => j.pagination.nexturlfield = e,
										icon: "mdi:mdi-link",
										label: E(Z)("nexturlfield"),
										rules: E(f)(E(Z)("nexturlfield_required")),
										hint: E(Z)("datasource_rest_nexturlfield_hint"),
										required: ""
									}, null, 8, [
										"modelValue",
										"label",
										"rules",
										"hint"
									])]),
									_: 1
								})) : r("", !0)
							]),
							_: 1
						})]),
						_: 1
					}, 8, ["label"]),
					c(u, {
						modelValue: j.recordspath,
						"onUpdate:modelValue": l[11] ||= (e) => j.recordspath = e,
						icon: "mdi:mdi-code-json",
						label: E(Z)("recordspath"),
						hint: E(Z)("datasource_rest_recordspath_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(h, {
						icon: "mdi:mdi-format-list-bulleted",
						label: E(Z)("headers"),
						hint: E(Z)("datasource_rest_headers_hint")
					}, {
						default: O(() => [c($, null, {
							default: O(() => [(_(!0), i(e, null, b(j.headers, (e, t) => (_(), n(Q, {
								key: e.id,
								cols: "12",
								class: "ga-4 pa-2"
							}, {
								default: O(() => [c($, { class: "align-center" }, {
									default: O(() => [
										c(Q, {
											cols: "auto",
											class: "d-flex align-center"
										}, {
											default: O(() => [c(ze, {
												icon: "mdi:mdi-web",
												class: "mr-2"
											}), a("span", Er, T(E(Z)("header")) + " #" + T(t + 1), 1)]),
											_: 2
										}, 1024),
										c(be),
										c(Q, { cols: "auto" }, {
											default: O(() => [c(g, {
												icon: "mdi:mdi-delete",
												variant: "text",
												color: "error",
												onClick: (e) => te(t)
											}, null, 8, ["onClick"])]),
											_: 2
										}, 1024)
									]),
									_: 2
								}, 1024), c($, { class: "d-flex flex-column" }, {
									default: O(() => [c(Q, { class: "d-flex flex-column pt-0" }, {
										default: O(() => [
											c(u, {
												modelValue: e.id,
												"onUpdate:modelValue": (t) => e.id = t,
												label: E(Z)("id"),
												hint: E(Z)("datasource_rest_header_id_hint")
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"hint"
											]),
											c(u, {
												modelValue: e.key,
												"onUpdate:modelValue": (t) => e.key = t,
												label: E(Z)("header_key"),
												rules: E(f)(E(Z)("header_key_required")),
												required: ""
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"rules"
											]),
											c(u, {
												modelValue: e.value,
												"onUpdate:modelValue": (t) => e.value = t,
												label: E(Z)("header_value"),
												rules: E(f)(E(Z)("header_value_required")),
												required: ""
											}, null, 8, [
												"modelValue",
												"onUpdate:modelValue",
												"label",
												"rules"
											])
										]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024))), 128)), c(Q, { cols: "12" }, {
								default: O(() => [c(g, {
									type: "primary",
									variant: "outlined",
									"prepend-icon": "mdi:mdi-plus",
									class: "mt-4",
									onClick: W
								}, {
									default: O(() => [s(T(E(Z)("add_header")), 1)]),
									_: 1
								})]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}, 8, ["label", "hint"]),
					c(v, {
						modelValue: j.bodyJson,
						"onUpdate:modelValue": l[12] ||= (e) => j.bodyJson = e,
						language: "json",
						icon: "mdi:mdi-code-braces",
						label: E(Z)("body"),
						hint: E(Z)("datasource_rest_body_hint"),
						rules: L
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(y, {
						modelValue: j.tag,
						"onUpdate:modelValue": l[13] ||= (e) => j.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "]
					}, null, 8, ["modelValue", "label"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, Or = {
	__name: "admin-datasource-rest",
	props: {},
	setup(n) {
		X(n, "HAdminConnectorDatasourceRest");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { confirm: s } = ce(), { hAddAlert: l } = q(), u = y(!0), d = y(null), f = [{
			label: "HTTPS",
			value: "https"
		}, {
			label: "HTTP",
			value: "http"
		}], p = [
			{
				label: "GET",
				value: "get"
			},
			{
				label: "POST",
				value: "post"
			},
			{
				label: "PUT",
				value: "put"
			}
		], m = {
			term: "",
			name: "",
			nameMatchType: "contains",
			description: "",
			descriptionMatchType: "contains",
			host: "",
			hostMatchType: "contains",
			scheme: [],
			method: [],
			tag: [],
			modifieddatePreset: null,
			createdatePreset: null,
			sortBy: "name",
			sortOrder: "asc",
			page: 1,
			pageSize: 25
		}, g = v({ ...m }), b = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "description",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("description_filter"),
					placeholder: Z("description_filter_placeholder"),
					icon: "mdi:mdi-text"
				}
			},
			{
				key: "host",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("host_filter"),
					placeholder: Z("host_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-web",
					defaultMatchType: "contains"
				}
			},
			{
				key: "scheme",
				type: "array",
				component: "h-filter-multiselect",
				props: {
					title: Z("scheme_filter"),
					icon: "mdi:mdi-shield-lock",
					options: f
				}
			},
			{
				key: "method",
				type: "array",
				component: "h-filter-multiselect",
				props: {
					title: Z("method_filter"),
					icon: "mdi:mdi-swap-horizontal",
					options: p
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [{
					key: "createdate",
					type: "date",
					component: "h-filter-datetime",
					model: "createdatePreset",
					props: {
						label: Z("createdate_filter"),
						manualSync: !0
					}
				}, {
					key: "modifieddate",
					type: "date",
					component: "h-filter-datetime",
					model: "modifieddatePreset",
					props: {
						label: Z("modifieddate_filter"),
						minDatePresetFilter: g.createdatePreset,
						manualSync: !0
					}
				}]
			}
		] }, x = [
			{
				title: "id",
				key: "id",
				align: "start",
				sortable: !0,
				width: 150,
				value: "id",
				nowrap: !0,
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 200,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0,
				filterOnClick: (e) => I("name", e.name, "exact"),
				isFilterActive: (e) => F("name", e.name, "exact")
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "host",
				key: "host",
				sortable: !0,
				width: 200,
				value: "host",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => I("host", e.host, "exact"),
				isFilterActive: (e) => F("host", e.host, "exact")
			},
			{
				title: "scheme",
				key: "scheme",
				sortable: !0,
				width: 80,
				value: "scheme",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => L("scheme", e.scheme),
				isFilterActive: (e) => F("scheme", e.scheme)
			},
			{
				title: "method",
				key: "method",
				sortable: !0,
				width: 80,
				value: "method",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => L("method", e.method),
				isFilterActive: (e) => F("method", e.method)
			},
			{
				title: "timeout",
				key: "timeout",
				sortable: !0,
				width: 80,
				value: "timeout",
				nowrap: !0,
				translate: !0
			},
			{
				title: "recordspath",
				key: "recordspath",
				sortable: !0,
				width: 150,
				value: "recordspath",
				nowrap: !0,
				translate: !0
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => L("tag", e),
				isFilterActive: (e) => F("tag", e)
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 150,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], C = {
			pageKey: "connector-datasource-rest",
			pageTitle: Z("admin_connector_datasource_rest_title"),
			headerTitle: Z("datasource_rest"),
			searchPlaceholder: Z("search_datasource_rest"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("connector"),
					text: Z("connector")
				},
				{
					title: Z("datasource"),
					text: Z("datasource")
				},
				{
					title: Z("rest"),
					text: Z("rest")
				}
			]
		}, { data: w, loading: T, params: D, execute: O, totalResults: k } = G({
			url: "/admin/connector/datasource/rest",
			filters: g,
			additionalParams: {}
		}), A = Z("total_datasource_rest"), j = t(() => ({ widgets: [{
			summary: !0,
			title: A,
			count: k.value,
			icon: "mdi:mdi-api",
			color: "blue-grey-lighten-3",
			iconColor: "blue-grey-darken-4"
		}] }));
		function M() {
			N(!0);
		}
		function N(e = !1) {
			let { query: t, sort: n } = a(b.filters, g);
			D.query = t, D.sort = n, (e || u.value) && O();
		}
		let P = qe(N, 300), { isFilterActive: F, toggleFilter: I, toggleArrayFilter: L } = ue({
			filters: g,
			onFilterChange: P
		}), R = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					d.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					d.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await s({
						title: Z("delete_datasource_rest"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = o({
							url: `/admin/connector/datasource/rest/${encodeURIComponent(e.id)}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							l({
								title: Z("error_occurred"),
								body: Z("datasource_rest_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await O();
					}
				}
			}
		];
		function z() {
			return Object.assign(g, { ...m }), N(!0);
		}
		function B() {
			d.value?.open();
		}
		return h(async () => {
			J(g, P), N(), O();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": u.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => u.value = e,
				"page-configuration": C,
				"widgets-config": j.value,
				"filters-config": b,
				filters: g,
				"table-headers": x,
				"table-actions": R,
				"table-params": E(D),
				"table-data": E(w),
				"table-loading": E(T),
				"total-results": E(k),
				"open-form": B,
				onSearch: M,
				onClearFilters: z
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(Dr, {
				ref_key: "datasourceRestFormRef",
				ref: d,
				onSuccess: E(O)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, kr = {
	__name: "datasource-sql-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 600
		}
	},
	emits: ["success", "cancel"],
	setup(e, { expose: r, emit: i }) {
		let { hAddAlert: a } = q(), { nameRules: o, requiredRules: s } = ie(), { save: l } = ae();
		X(e, "HDatasourceSqlForm");
		let u = {
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			host: {
				type: String,
				default: ""
			},
			sqltype: {
				type: String,
				default: "mssql"
			},
			database: {
				type: String,
				default: ""
			},
			port: {
				type: Number,
				default: null
			},
			timeout: {
				type: Number,
				default: 30
			},
			encrypt: {
				type: Boolean,
				default: !1
			},
			username: {
				type: String,
				default: ""
			},
			password: {
				type: String,
				default: ""
			},
			tag: {
				type: Array,
				default: () => []
			}
		}, d = () => {
			let e = {};
			return Object.keys(u).forEach((t) => {
				let n = u[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, f = i, p = y(null), m = y(!1), h = y(!1), g = y(!1), b = y(null), x = v(d()), C = y(!1), w = y({}), T = [{
			title: "MSSQL",
			value: "mssql"
		}, {
			title: "MySQL",
			value: "mysql"
		}], k = t(() => x.sqltype === "mysql" ? s(Z("username_required")) : []);
		D(x, () => {
			C.value = JSON.stringify(x) !== JSON.stringify(w.value);
		}, { deep: !0 }), D(m, (e) => {
			e || A();
		});
		function A() {
			let e = d();
			Object.keys(e).forEach((t) => {
				x[t] = e[t];
			}), w.value = JSON.parse(JSON.stringify(x)), g.value = !1, b.value = null, C.value = !1;
		}
		function j(e, t = !0) {
			Object.keys(u).forEach((t) => {
				let n = u[t], r = e?.[t], i = r != null;
				n.type === Array ? x[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : n.type === Number ? x[t] = i ? Number(r) : typeof n.default == "function" ? n.default() : n.default : n.type === Boolean ? x[t] = i ? !!r : typeof n.default == "function" ? n.default() : n.default : (n.type, x[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), t || (x.password = ""), t && (x.password = ""), w.value = JSON.parse(JSON.stringify(x)), g.value = t, b.value = t && e?.id || null, C.value = !t;
		}
		async function M() {
			if (!h.value && ((await p.value?.validate())?.valid ?? !0)) {
				h.value = !0;
				try {
					await F(P()), f("success"), m.value = !1;
				} catch (e) {
					a({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					h.value = !1;
				}
			}
		}
		function N(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) r === null || r === "" || Array.isArray(r) && r.length === 0 || (t[n] = r);
			return t;
		}
		function P() {
			let e = ((e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [])(x.tag);
			return N({
				name: x.name?.trim() || null,
				description: x.description?.trim() || null,
				host: x.host?.trim() || null,
				sqltype: x.sqltype || "mssql",
				database: x.database?.trim() || null,
				port: x.port || null,
				timeout: x.timeout || 30,
				encrypt: x.encrypt || !1,
				username: x.username?.trim() || null,
				password: x.password || null,
				tag: e
			});
		}
		async function F(e) {
			let t = g.value ? "update" : "create", n = {
				create: "/admin/connector/datasource/sql?refresh=true",
				update: `/admin/connector/datasource/sql/${encodeURIComponent(b.value)}?refresh=true`
			}, r = {
				create: "post",
				update: "put"
			}, i = {
				error: {
					create: "datasource_sql_create_error",
					update: "datasource_sql_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			}, o = t === "update" ? (({ name: e, ...t }) => t)(e) : e;
			if (!(await l({
				url: n[t],
				method: r[t],
				payload: o
			}))?.ok) throw Error(Z(i.error[t]));
			a({
				title: Z(i.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function I() {
			f("cancel"), m.value = !1;
		}
		function L(e = null) {
			e && j(e), m.value = !0;
		}
		function R(e) {
			j(e, !1), m.value = !0;
		}
		return r({
			validate: () => p.value?.validate(),
			reset: () => p.value?.reset(),
			resetValidation: () => p.value?.resetValidation(),
			formData: x,
			open: L,
			openCopy: R
		}), (t, r) => {
			let i = S("h-form-text"), a = S("h-form-textarea"), l = S("h-form-select"), u = S("h-form-switch"), d = S("h-form-password"), f = S("h-form-combobox"), v = S("h-form-layout");
			return _(), n(v, {
				ref_key: "formRef",
				ref: p,
				modelValue: m.value,
				"onUpdate:modelValue": r[11] ||= (e) => m.value = e,
				loading: h.value,
				"bg-color": e.bgColor,
				"header-text": g.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": e.drawerWidth,
				"has-changes": C.value,
				onSubmit: M,
				onCancel: I
			}, {
				default: O(() => [
					c(i, {
						modelValue: x.name,
						"onUpdate:modelValue": r[0] ||= (e) => x.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: E(o),
						hint: E(Z)("datasource_sql_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(a, {
						modelValue: x.description,
						"onUpdate:modelValue": r[1] ||= (e) => x.description = e,
						label: E(Z)("description"),
						hint: E(Z)("datasource_sql_description_hint"),
						icon: "mdi:mdi-text",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3"
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(i, {
						modelValue: x.host,
						"onUpdate:modelValue": r[2] ||= (e) => x.host = e,
						icon: "mdi:mdi-server",
						label: E(Z)("host"),
						rules: E(s)(E(Z)("host_required")),
						hint: E(Z)("datasource_sql_host_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(l, {
						modelValue: x.sqltype,
						"onUpdate:modelValue": r[3] ||= (e) => x.sqltype = e,
						icon: "mdi:mdi-database-cog",
						label: E(Z)("sqltype"),
						items: T,
						rules: E(s)(E(Z)("sqltype_required")),
						hint: E(Z)("datasource_sql_sqltype_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(i, {
						modelValue: x.database,
						"onUpdate:modelValue": r[4] ||= (e) => x.database = e,
						icon: "mdi:mdi-database",
						label: E(Z)("database"),
						rules: E(s)(E(Z)("database_required")),
						hint: E(Z)("datasource_sql_database_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(i, {
						modelValue: x.port,
						"onUpdate:modelValue": r[5] ||= (e) => x.port = e,
						modelModifiers: { number: !0 },
						icon: "mdi:mdi-ethernet",
						label: E(Z)("port"),
						type: "number",
						hint: E(Z)("datasource_sql_port_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(i, {
						modelValue: x.timeout,
						"onUpdate:modelValue": r[6] ||= (e) => x.timeout = e,
						modelModifiers: { number: !0 },
						icon: "mdi:mdi-timer-outline",
						label: E(Z)("timeout"),
						type: "number",
						hint: E(Z)("datasource_sql_timeout_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(u, {
						modelValue: x.encrypt,
						"onUpdate:modelValue": r[7] ||= (e) => x.encrypt = e,
						icon: x.encrypt ? "mdi:mdi-lock" : "mdi:mdi-lock-open-variant",
						label: E(Z)("encrypt"),
						hint: E(Z)("datasource_sql_encrypt_hint")
					}, null, 8, [
						"modelValue",
						"icon",
						"label",
						"hint"
					]),
					c(i, {
						modelValue: x.username,
						"onUpdate:modelValue": r[8] ||= (e) => x.username = e,
						icon: "mdi:mdi-account",
						label: E(Z)("username"),
						rules: k.value,
						hint: E(Z)("datasource_sql_username_hint"),
						required: x.sqltype === "mysql"
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint",
						"required"
					]),
					c(d, {
						modelValue: x.password,
						"onUpdate:modelValue": r[9] ||= (e) => x.password = e,
						icon: "mdi:mdi-lock",
						label: E(Z)("password"),
						hint: E(Z)("datasource_sql_password_hint"),
						required: x.sqltype === "mysql" && !g.value,
						"allow-empty": g.value,
						"min-password-length": 2
					}, null, 8, [
						"modelValue",
						"label",
						"hint",
						"required",
						"allow-empty"
					]),
					c(f, {
						modelValue: x.tag,
						"onUpdate:modelValue": r[10] ||= (e) => x.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "]
					}, null, 8, ["modelValue", "label"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, Ar = {
	__name: "admin-datasource-sql",
	props: {},
	setup(n) {
		X(n, "HAdminConnectorDatasourceSql");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { confirm: s } = ce(), { hAddAlert: l } = q(), u = y(!0), d = y(null), f = [{
			label: "MSSQL",
			value: "mssql"
		}, {
			label: "MySQL",
			value: "mysql"
		}], p = {
			term: "",
			name: "",
			nameMatchType: "contains",
			description: "",
			descriptionMatchType: "contains",
			host: "",
			hostMatchType: "contains",
			sqltype: [],
			database: "",
			databaseMatchType: "contains",
			tag: [],
			modifieddatePreset: null,
			createdatePreset: null,
			sortBy: "name",
			sortOrder: "asc",
			page: 1,
			pageSize: 25
		}, m = v({ ...p }), g = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "description",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("description_filter"),
					placeholder: Z("description_filter_placeholder"),
					icon: "mdi:mdi-text"
				}
			},
			{
				key: "host",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("host_filter"),
					placeholder: Z("host_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-server",
					defaultMatchType: "contains"
				}
			},
			{
				key: "sqltype",
				type: "array",
				component: "h-filter-multiselect",
				props: {
					title: Z("sqltype_filter"),
					icon: "mdi:mdi-database-cog",
					options: f
				}
			},
			{
				key: "database",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("database_filter"),
					placeholder: Z("database_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-database",
					defaultMatchType: "contains"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [{
					key: "createdate",
					type: "date",
					component: "h-filter-datetime",
					model: "createdatePreset",
					props: {
						label: Z("createdate_filter"),
						manualSync: !0
					}
				}, {
					key: "modifieddate",
					type: "date",
					component: "h-filter-datetime",
					model: "modifieddatePreset",
					props: {
						label: Z("modifieddate_filter"),
						minDatePresetFilter: m.createdatePreset,
						manualSync: !0
					}
				}]
			}
		] }, b = [
			{
				title: "id",
				key: "id",
				align: "start",
				sortable: !0,
				width: 150,
				value: "id",
				nowrap: !0,
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 200,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0,
				filterOnClick: (e) => F("name", e.name, "exact"),
				isFilterActive: (e) => P("name", e.name, "exact")
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "host",
				key: "host",
				sortable: !0,
				width: 200,
				value: "host",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => F("host", e.host, "exact"),
				isFilterActive: (e) => P("host", e.host, "exact")
			},
			{
				title: "sqltype",
				key: "sqltype",
				sortable: !0,
				width: 100,
				value: "sqltype",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => I("sqltype", e.sqltype),
				isFilterActive: (e) => P("sqltype", e.sqltype)
			},
			{
				title: "database",
				key: "database",
				sortable: !0,
				width: 200,
				value: "database",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => F("database", e.database, "exact"),
				isFilterActive: (e) => P("database", e.database, "exact")
			},
			{
				title: "port",
				key: "port",
				sortable: !0,
				width: 80,
				value: "port",
				nowrap: !0,
				translate: !0
			},
			{
				title: "timeout",
				key: "timeout",
				sortable: !0,
				width: 80,
				value: "timeout",
				nowrap: !0,
				translate: !0
			},
			{
				title: "encrypt",
				key: "encrypt",
				sortable: !0,
				width: 80,
				value: "encrypt",
				nowrap: !0,
				translate: !0,
				component: "h-btn-table-cell",
				defaultValue: !1,
				componentProps: {
					getIcon: (e) => e.encrypt ? "mdi:mdi-lock" : "mdi:mdi-lock-open-variant",
					getColor: (e) => e.encrypt ? "success" : "grey"
				}
			},
			{
				title: "username",
				key: "username",
				sortable: !0,
				width: 150,
				value: "username",
				nowrap: !0,
				translate: !0
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => I("tag", e),
				isFilterActive: (e) => P("tag", e)
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 150,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], x = {
			pageKey: "connector-datasource-sql",
			pageTitle: Z("admin_connector_datasource_sql_title"),
			headerTitle: Z("datasource_sql"),
			searchPlaceholder: Z("search_datasource_sql"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("connector"),
					text: Z("connector")
				},
				{
					title: Z("datasource"),
					text: Z("datasource")
				},
				{
					title: Z("sql"),
					text: Z("sql")
				}
			]
		}, { data: C, loading: w, params: T, execute: D, totalResults: O } = G({
			url: "/admin/connector/datasource/sql",
			filters: m,
			additionalParams: {}
		}), k = Z("total_datasource_sql"), A = t(() => ({ widgets: [{
			summary: !0,
			title: k,
			count: O.value,
			icon: "mdi:mdi-database",
			color: "blue-grey-lighten-3",
			iconColor: "blue-grey-darken-4"
		}] }));
		function j() {
			M(!0);
		}
		function M(e = !1) {
			let { query: t, sort: n } = a(g.filters, m);
			T.query = t, T.sort = n, (e || u.value) && D();
		}
		let N = qe(M, 300), { isFilterActive: P, toggleFilter: F, toggleArrayFilter: I } = ue({
			filters: m,
			onFilterChange: N
		}), L = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					d.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					d.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await s({
						title: Z("delete_datasource_sql"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = o({
							url: `/admin/connector/datasource/sql/${encodeURIComponent(e.id)}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							l({
								title: Z("error_occurred"),
								body: Z("datasource_sql_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await D();
					}
				}
			}
		];
		function R() {
			return Object.assign(m, { ...p }), M(!0);
		}
		function z() {
			d.value?.open();
		}
		return h(async () => {
			J(m, N), M(), D();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": u.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => u.value = e,
				"page-configuration": x,
				"widgets-config": A.value,
				"filters-config": g,
				filters: m,
				"table-headers": b,
				"table-actions": L,
				"table-params": E(T),
				"table-data": E(C),
				"table-loading": E(w),
				"total-results": E(O),
				"open-form": z,
				onSearch: j,
				onClearFilters: R
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(kr, {
				ref_key: "datasourceSqlFormRef",
				ref: d,
				onSuccess: E(D)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, jr = {
	__name: "connector-index-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 600
		}
	},
	emits: ["success", "cancel"],
	setup(e, { expose: i, emit: a }) {
		let { hAddAlert: o } = q(), { nameRules: s, requiredRules: l, idRules: u } = ie(), { save: d } = ae();
		X(e, "HConnectorIndexForm");
		let f = {
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			endpointtype: {
				type: String,
				default: "item"
			},
			indexmethod: {
				type: String,
				default: "post"
			},
			keyfield: {
				type: String,
				default: ""
			},
			invariable: {
				type: String,
				default: ""
			},
			alwaysupdate: {
				type: Boolean,
				default: !1
			},
			tag: {
				type: Array,
				default: () => []
			}
		}, p = () => {
			let e = {};
			return Object.keys(f).forEach((t) => {
				let n = f[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, m = a, h = y(null), g = y(!1), b = y(!1), x = y(!1), C = y(null), w = v(p()), T = y(!1), k = y({}), A = [
			{
				title: "Item",
				value: "item"
			},
			{
				title: "User",
				value: "user"
			},
			{
				title: "Option",
				value: "option"
			},
			{
				title: "Event",
				value: "event"
			},
			{
				title: "Role",
				value: "role"
			}
		], j = t(() => w.endpointtype === "event" ? [{
			title: "POST",
			value: "post"
		}] : [
			{
				title: "POST",
				value: "post"
			},
			{
				title: "PUT",
				value: "put"
			},
			{
				title: "PATCH",
				value: "patch"
			}
		]), M = t(() => w.endpointtype === "item" && ["put", "patch"].includes(w.indexmethod)), N = [...l(Z("invariable_required")), ...u(Z("invariable_format"))];
		D(() => w.endpointtype, (e) => {
			e === "event" && (w.indexmethod = "post"), e !== "item" && (w.keyfield = "");
		}), D(() => w.indexmethod, (e) => {
			["put", "patch"].includes(e) || (w.keyfield = "");
		}), D(w, () => {
			T.value = JSON.stringify(w) !== JSON.stringify(k.value);
		}, { deep: !0 }), D(g, (e) => {
			e || P();
		});
		function P() {
			let e = p();
			Object.keys(e).forEach((t) => {
				w[t] = e[t];
			}), k.value = JSON.parse(JSON.stringify(w)), x.value = !1, C.value = null, T.value = !1;
		}
		function F(e, t = !0) {
			Object.keys(f).forEach((t) => {
				let n = f[t], r = e?.[t], i = r != null;
				n.type === Array ? w[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : n.type === Number ? w[t] = i ? Number(r) : typeof n.default == "function" ? n.default() : n.default : n.type === Boolean ? w[t] = i ? !!r : typeof n.default == "function" ? n.default() : n.default : (n.type, w[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), k.value = JSON.parse(JSON.stringify(w)), x.value = t, C.value = t && e?.id || null, T.value = !t;
		}
		async function I() {
			if (!b.value && ((await h.value?.validate())?.valid ?? !0)) {
				b.value = !0;
				try {
					await z(R()), m("success"), g.value = !1;
				} catch (e) {
					o({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					b.value = !1;
				}
			}
		}
		function L(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) r === null || r === "" || Array.isArray(r) && r.length === 0 || (t[n] = r);
			return t;
		}
		function R() {
			let e = ((e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [])(w.tag), t = {
				name: w.name?.trim() || null,
				description: w.description?.trim() || null,
				endpointtype: w.endpointtype || null,
				indexmethod: w.indexmethod || null,
				invariable: w.invariable?.trim() || null,
				alwaysupdate: w.alwaysupdate || !1,
				tag: e
			};
			return M.value && w.keyfield?.trim() && (t.keyfield = w.keyfield.trim()), L(t);
		}
		async function z(e) {
			let t = x.value ? "update" : "create", n = {
				create: "/admin/connector/tasks/index?refresh=true",
				update: `/admin/connector/tasks/index/${encodeURIComponent(C.value)}?refresh=true`
			}, r = {
				create: "post",
				update: "put"
			}, i = {
				error: {
					create: "connector_index_create_error",
					update: "connector_index_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			};
			if (!(await d({
				url: n[t],
				method: r[t],
				payload: e
			}))?.ok) throw Error(Z(i.error[t]));
			o({
				title: Z(i.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function B() {
			m("cancel"), g.value = !1;
		}
		function V(e = null) {
			e && F(e), g.value = !0;
		}
		function H(e) {
			F(e, !1), g.value = !0;
		}
		return i({
			validate: () => h.value?.validate(),
			reset: () => h.value?.reset(),
			resetValidation: () => h.value?.resetValidation(),
			formData: w,
			open: V,
			openCopy: H
		}), (t, i) => {
			let a = S("h-form-text"), o = S("h-form-textarea"), u = S("h-form-select"), d = S("h-form-switch"), f = S("h-form-combobox"), p = S("h-form-layout");
			return _(), n(p, {
				ref_key: "formRef",
				ref: h,
				modelValue: g.value,
				"onUpdate:modelValue": i[8] ||= (e) => g.value = e,
				loading: b.value,
				"bg-color": e.bgColor,
				"header-text": x.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": e.drawerWidth,
				"has-changes": T.value,
				onSubmit: I,
				onCancel: B
			}, {
				default: O(() => [
					c(a, {
						modelValue: w.name,
						"onUpdate:modelValue": i[0] ||= (e) => w.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: E(s),
						hint: E(Z)("connector_index_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(o, {
						modelValue: w.description,
						"onUpdate:modelValue": i[1] ||= (e) => w.description = e,
						label: E(Z)("description"),
						hint: E(Z)("connector_index_description_hint"),
						icon: "mdi:mdi-text",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3"
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(u, {
						modelValue: w.endpointtype,
						"onUpdate:modelValue": i[2] ||= (e) => w.endpointtype = e,
						icon: "mdi:mdi-api",
						label: E(Z)("endpointtype"),
						items: A,
						rules: E(l)(E(Z)("endpointtype_required")),
						hint: E(Z)("connector_index_endpointtype_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(u, {
						modelValue: w.indexmethod,
						"onUpdate:modelValue": i[3] ||= (e) => w.indexmethod = e,
						icon: "mdi:mdi-swap-horizontal",
						label: E(Z)("indexmethod"),
						items: j.value,
						rules: E(l)(E(Z)("indexmethod_required")),
						hint: E(Z)("connector_index_indexmethod_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"rules",
						"hint"
					]),
					M.value ? (_(), n(a, {
						key: 0,
						modelValue: w.keyfield,
						"onUpdate:modelValue": i[4] ||= (e) => w.keyfield = e,
						icon: "mdi:mdi-key",
						label: E(Z)("keyfield"),
						hint: E(Z)("connector_index_keyfield_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					])) : r("", !0),
					c(a, {
						modelValue: w.invariable,
						"onUpdate:modelValue": i[5] ||= (e) => w.invariable = e,
						icon: "mdi:mdi-variable",
						label: E(Z)("invariable"),
						rules: N,
						hint: E(Z)("connector_index_invariable_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(d, {
						modelValue: w.alwaysupdate,
						"onUpdate:modelValue": i[6] ||= (e) => w.alwaysupdate = e,
						icon: "mdi:mdi-refresh",
						label: E(Z)("alwaysupdate"),
						hint: E(Z)("connector_index_alwaysupdate_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(f, {
						modelValue: w.tag,
						"onUpdate:modelValue": i[7] ||= (e) => w.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "]
					}, null, 8, ["modelValue", "label"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, Mr = {
	__name: "admin-connector-index",
	props: {},
	setup(n) {
		X(n, "HAdminConnectorIndex");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { confirm: s } = ce(), { hAddAlert: l } = q(), u = y(!0), d = y(null), f = [
			{
				label: "Item",
				value: "item"
			},
			{
				label: "User",
				value: "user"
			},
			{
				label: "Option",
				value: "option"
			},
			{
				label: "Event",
				value: "event"
			},
			{
				label: "Role",
				value: "role"
			}
		], p = [
			{
				label: "POST",
				value: "post"
			},
			{
				label: "PUT",
				value: "put"
			},
			{
				label: "PATCH",
				value: "patch"
			}
		], m = {
			term: "",
			name: "",
			nameMatchType: "contains",
			description: "",
			descriptionMatchType: "contains",
			endpointtype: [],
			indexmethod: [],
			invariable: "",
			invariableMatchType: "contains",
			tag: [],
			modifieddatePreset: null,
			createdatePreset: null,
			sortBy: "name",
			sortOrder: "asc",
			page: 1,
			pageSize: 25
		}, g = v({ ...m }), b = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "description",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("description_filter"),
					placeholder: Z("description_filter_placeholder"),
					icon: "mdi:mdi-text"
				}
			},
			{
				key: "endpointtype",
				type: "array",
				component: "h-filter-multiselect",
				props: {
					title: Z("endpointtype_filter"),
					icon: "mdi:mdi-api",
					options: f
				}
			},
			{
				key: "indexmethod",
				type: "array",
				component: "h-filter-multiselect",
				props: {
					title: Z("indexmethod_filter"),
					icon: "mdi:mdi-database-sync",
					options: p
				}
			},
			{
				key: "invariable",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("invariable_filter"),
					placeholder: Z("invariable_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-variable",
					defaultMatchType: "contains"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [{
					key: "createdate",
					type: "date",
					component: "h-filter-datetime",
					model: "createdatePreset",
					props: {
						label: Z("createdate_filter"),
						manualSync: !0
					}
				}, {
					key: "modifieddate",
					type: "date",
					component: "h-filter-datetime",
					model: "modifieddatePreset",
					props: {
						label: Z("modifieddate_filter"),
						minDatePresetFilter: g.createdatePreset,
						manualSync: !0
					}
				}]
			}
		] }, x = [
			{
				title: "id",
				key: "id",
				align: "start",
				sortable: !0,
				width: 150,
				value: "id",
				nowrap: !0,
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 200,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0,
				filterOnClick: (e) => I("name", e.name, "exact"),
				isFilterActive: (e) => F("name", e.name, "exact")
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "endpointtype",
				key: "endpointtype",
				sortable: !0,
				width: 120,
				value: "endpointtype",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => L("endpointtype", e.endpointtype),
				isFilterActive: (e) => F("endpointtype", e.endpointtype)
			},
			{
				title: "indexmethod",
				key: "indexmethod",
				sortable: !0,
				width: 100,
				value: "indexmethod",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => L("indexmethod", e.indexmethod),
				isFilterActive: (e) => F("indexmethod", e.indexmethod)
			},
			{
				title: "invariable",
				key: "invariable",
				sortable: !0,
				width: 200,
				value: "invariable",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => I("invariable", e.invariable, "exact"),
				isFilterActive: (e) => F("invariable", e.invariable, "exact")
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => L("tag", e),
				isFilterActive: (e) => F("tag", e)
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 150,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], C = {
			pageKey: "connector-index",
			pageTitle: Z("admin_connector_index_title"),
			headerTitle: Z("connector_index"),
			searchPlaceholder: Z("search_connector_index"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("connector"),
					text: Z("connector")
				},
				{
					title: Z("tasks"),
					text: Z("tasks")
				},
				{
					title: Z("index"),
					text: Z("index")
				}
			]
		}, { data: w, loading: T, params: D, execute: O, totalResults: k } = G({
			url: "/admin/connector/tasks/index",
			filters: g,
			additionalParams: {}
		}), A = Z("total_connector_index"), j = t(() => ({ widgets: [{
			summary: !0,
			title: A,
			count: k.value,
			icon: "mdi:mdi-database-import",
			color: "blue-grey-lighten-3",
			iconColor: "blue-grey-darken-4"
		}] }));
		function M() {
			N(!0);
		}
		function N(e = !1) {
			let { query: t, sort: n } = a(b.filters, g);
			D.query = t, D.sort = n, (e || u.value) && O();
		}
		let P = qe(N, 300), { isFilterActive: F, toggleFilter: I, toggleArrayFilter: L } = ue({
			filters: g,
			onFilterChange: P
		}), R = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					d.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					d.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await s({
						title: Z("delete_connector_index"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = o({
							url: `/admin/connector/tasks/index/${encodeURIComponent(e.id)}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							l({
								title: Z("error_occurred"),
								body: Z("connector_index_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await O();
					}
				}
			}
		];
		function z() {
			return Object.assign(g, { ...m }), N(!0);
		}
		function B() {
			d.value?.open();
		}
		return h(async () => {
			J(g, P), N(), O();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": u.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => u.value = e,
				"page-configuration": C,
				"widgets-config": j.value,
				"filters-config": b,
				filters: g,
				"table-headers": x,
				"table-actions": R,
				"table-params": E(D),
				"table-data": E(w),
				"table-loading": E(T),
				"total-results": E(k),
				"open-form": B,
				onSearch: M,
				onClearFilters: z
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(jr, {
				ref_key: "connectorIndexFormRef",
				ref: d,
				onSuccess: E(O)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, Nr = {
	__name: "connector-purge-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 600
		}
	},
	emits: ["success", "cancel"],
	setup(e, { expose: t, emit: r }) {
		let { hAddAlert: i } = q(), { nameRules: a, requiredRules: o } = ie(), { save: s } = ae();
		X(e, "HConnectorPurgeForm");
		let l = {
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			endpointtype: {
				type: String,
				default: "item"
			},
			query: {
				type: String,
				default: ""
			},
			tag: {
				type: Array,
				default: () => []
			}
		}, u = () => {
			let e = {};
			return Object.keys(l).forEach((t) => {
				let n = l[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, d = r, f = y(null), p = y(!1), m = y(!1), h = y(!1), g = y(null), b = v(u()), x = y(!1), C = y({}), w = [
			{
				title: "Item",
				value: "item"
			},
			{
				title: "User",
				value: "user"
			},
			{
				title: "Option",
				value: "option"
			},
			{
				title: "Event",
				value: "event"
			},
			{
				title: "Role",
				value: "role"
			}
		];
		D(b, () => {
			x.value = JSON.stringify(b) !== JSON.stringify(C.value);
		}, { deep: !0 }), D(p, (e) => {
			e || T();
		});
		function T() {
			let e = u();
			Object.keys(e).forEach((t) => {
				b[t] = e[t];
			}), C.value = JSON.parse(JSON.stringify(b)), h.value = !1, g.value = null, x.value = !1;
		}
		function k(e, t = !0) {
			Object.keys(l).forEach((t) => {
				let n = l[t], r = e?.[t], i = r != null;
				n.type === Array ? b[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : (n.type, b[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), C.value = JSON.parse(JSON.stringify(b)), h.value = t, g.value = t && e?.id || null, x.value = !t;
		}
		async function A() {
			if (!m.value && ((await f.value?.validate())?.valid ?? !0)) {
				m.value = !0;
				try {
					await N(M()), d("success"), p.value = !1;
				} catch (e) {
					i({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					m.value = !1;
				}
			}
		}
		function j(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) r === null || r === "" || Array.isArray(r) && r.length === 0 || (t[n] = r);
			return t;
		}
		function M() {
			let e = ((e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [])(b.tag);
			return j({
				name: b.name?.trim() || null,
				description: b.description?.trim() || null,
				endpointtype: b.endpointtype || null,
				query: b.query?.trim() || null,
				tag: e
			});
		}
		async function N(e) {
			let t = h.value ? "update" : "create", n = {
				create: "/admin/connector/tasks/purge?refresh=true",
				update: `/admin/connector/tasks/purge/${encodeURIComponent(g.value)}?refresh=true`
			}, r = {
				create: "post",
				update: "put"
			}, a = {
				error: {
					create: "connector_purge_create_error",
					update: "connector_purge_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			};
			if (!(await s({
				url: n[t],
				method: r[t],
				payload: e
			}))?.ok) throw Error(Z(a.error[t]));
			i({
				title: Z(a.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function P() {
			d("cancel"), p.value = !1;
		}
		function F(e = null) {
			e && k(e), p.value = !0;
		}
		function I(e) {
			k(e, !1), p.value = !0;
		}
		return t({
			validate: () => f.value?.validate(),
			reset: () => f.value?.reset(),
			resetValidation: () => f.value?.resetValidation(),
			formData: b,
			open: F,
			openCopy: I
		}), (t, r) => {
			let i = S("h-form-text"), s = S("h-form-textarea"), l = S("h-form-select"), u = S("h-form-combobox"), d = S("h-form-layout");
			return _(), n(d, {
				ref_key: "formRef",
				ref: f,
				modelValue: p.value,
				"onUpdate:modelValue": r[5] ||= (e) => p.value = e,
				loading: m.value,
				"bg-color": e.bgColor,
				"header-text": h.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": e.drawerWidth,
				"has-changes": x.value,
				onSubmit: A,
				onCancel: P
			}, {
				default: O(() => [
					c(i, {
						modelValue: b.name,
						"onUpdate:modelValue": r[0] ||= (e) => b.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: E(a),
						hint: E(Z)("connector_purge_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(s, {
						modelValue: b.description,
						"onUpdate:modelValue": r[1] ||= (e) => b.description = e,
						label: E(Z)("description"),
						hint: E(Z)("connector_purge_description_hint"),
						icon: "mdi:mdi-text",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3"
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(l, {
						modelValue: b.endpointtype,
						"onUpdate:modelValue": r[2] ||= (e) => b.endpointtype = e,
						icon: "mdi:mdi-api",
						label: E(Z)("endpointtype"),
						items: w,
						rules: E(o)(E(Z)("endpointtype_required")),
						hint: E(Z)("connector_purge_endpointtype_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(i, {
						modelValue: b.query,
						"onUpdate:modelValue": r[3] ||= (e) => b.query = e,
						icon: "mdi:mdi-magnify",
						label: E(Z)("query"),
						rules: E(o)(E(Z)("query_required")),
						hint: E(Z)("connector_purge_query_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(u, {
						modelValue: b.tag,
						"onUpdate:modelValue": r[4] ||= (e) => b.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "]
					}, null, 8, ["modelValue", "label"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, Pr = {
	__name: "admin-connector-purge",
	props: {},
	setup(n) {
		X(n, "HAdminConnectorPurge");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { confirm: s } = ce(), { hAddAlert: l } = q(), u = y(!0), d = y(null), f = [
			{
				label: "Item",
				value: "item"
			},
			{
				label: "User",
				value: "user"
			},
			{
				label: "Option",
				value: "option"
			},
			{
				label: "Event",
				value: "event"
			},
			{
				label: "Role",
				value: "role"
			}
		], p = {
			term: "",
			name: "",
			nameMatchType: "contains",
			description: "",
			descriptionMatchType: "contains",
			endpointtype: [],
			query: "",
			queryMatchType: "contains",
			tag: [],
			modifieddatePreset: null,
			createdatePreset: null,
			sortBy: "name",
			sortOrder: "asc",
			page: 1,
			pageSize: 25
		}, m = v({ ...p }), g = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "description",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("description_filter"),
					placeholder: Z("description_filter_placeholder"),
					icon: "mdi:mdi-text"
				}
			},
			{
				key: "endpointtype",
				type: "array",
				component: "h-filter-multiselect",
				props: {
					title: Z("endpointtype_filter"),
					options: f
				}
			},
			{
				key: "query",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("query_filter"),
					placeholder: Z("query_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-magnify",
					defaultMatchType: "contains"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [{
					key: "createdate",
					type: "date",
					component: "h-filter-datetime",
					model: "createdatePreset",
					props: {
						label: Z("createdate_filter"),
						manualSync: !0
					}
				}, {
					key: "modifieddate",
					type: "date",
					component: "h-filter-datetime",
					model: "modifieddatePreset",
					props: {
						label: Z("modifieddate_filter"),
						minDatePresetFilter: m.createdatePreset,
						manualSync: !0
					}
				}]
			}
		] }, b = [
			{
				title: "id",
				key: "id",
				align: "start",
				sortable: !0,
				width: 150,
				value: "id",
				nowrap: !0,
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 200,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0,
				filterOnClick: (e) => F("name", e.name, "exact"),
				isFilterActive: (e) => P("name", e.name, "exact")
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "endpointtype",
				key: "endpointtype",
				sortable: !0,
				width: 120,
				value: "endpointtype",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => I("endpointtype", e.endpointtype),
				isFilterActive: (e) => P("endpointtype", e.endpointtype)
			},
			{
				title: "query",
				key: "query",
				sortable: !0,
				width: 250,
				value: "query",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => F("query", e.query, "exact"),
				isFilterActive: (e) => P("query", e.query, "exact")
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => I("tag", e),
				isFilterActive: (e) => P("tag", e)
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 150,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], x = {
			pageKey: "connector-purge",
			pageTitle: Z("admin_connector_purge_title"),
			headerTitle: Z("connector_purge"),
			searchPlaceholder: Z("search_connector_purge"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("connector"),
					text: Z("connector")
				},
				{
					title: Z("tasks"),
					text: Z("tasks")
				},
				{
					title: Z("purge"),
					text: Z("purge")
				}
			]
		}, { data: C, loading: w, params: T, execute: D, totalResults: O } = G({
			url: "/admin/connector/tasks/purge",
			filters: m,
			additionalParams: {}
		}), k = Z("total_connector_purge"), A = t(() => ({ widgets: [{
			summary: !0,
			title: k,
			count: O.value,
			icon: "mdi:mdi-delete-sweep",
			color: "blue-grey-lighten-3",
			iconColor: "blue-grey-darken-4"
		}] }));
		function j() {
			M(!0);
		}
		function M(e = !1) {
			let { query: t, sort: n } = a(g.filters, m);
			T.query = t, T.sort = n, (e || u.value) && D();
		}
		let N = qe(M, 300), { isFilterActive: P, toggleFilter: F, toggleArrayFilter: I } = ue({
			filters: m,
			onFilterChange: N
		}), L = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					d.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					d.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await s({
						title: Z("delete_connector_purge"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = o({
							url: `/admin/connector/tasks/purge/${encodeURIComponent(e.id)}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							l({
								title: Z("error_occurred"),
								body: Z("connector_purge_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await D();
					}
				}
			}
		];
		function R() {
			return Object.assign(m, { ...p }), M(!0);
		}
		function z() {
			d.value?.open();
		}
		return h(async () => {
			J(m, N), M(), D();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": u.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => u.value = e,
				"page-configuration": x,
				"widgets-config": A.value,
				"filters-config": g,
				filters: m,
				"table-headers": b,
				"table-actions": L,
				"table-params": E(T),
				"table-data": E(C),
				"table-loading": E(w),
				"total-results": E(O),
				"open-form": z,
				onSearch: j,
				onClearFilters: R
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(Nr, {
				ref_key: "connectorPurgeFormRef",
				ref: d,
				onSuccess: E(D)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, Fr = {
	__name: "connector-reader-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 600
		}
	},
	emits: ["success", "cancel"],
	setup(e, { expose: i, emit: a }) {
		let { hAddAlert: o } = q(), { nameRules: s, requiredRules: l, idRules: u } = ie(), { save: f } = ae(), { hHttpRequest: p } = Y();
		X(e, "HConnectorReaderForm");
		let m = {
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			datasourcetype: {
				type: String,
				default: "file"
			},
			datasource: {
				type: String,
				default: ""
			},
			query: {
				type: String,
				default: ""
			},
			outvariable: {
				type: String,
				default: ""
			},
			loop: {
				type: Boolean,
				default: !1
			},
			loopvariable: {
				type: String,
				default: ""
			},
			loopsleep: {
				type: Number,
				default: 0
			},
			tag: {
				type: Array,
				default: () => []
			}
		}, h = () => {
			let e = {};
			return Object.keys(m).forEach((t) => {
				let n = m[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, g = a, b = y(null), x = y(!1), C = y(!1), w = y(!1), T = y(null), k = v(h()), A = y(!1), j = y({}), M = y(!1), N = [
			{
				title: "File",
				value: "file"
			},
			{
				title: "SQL",
				value: "sql"
			},
			{
				title: "REST",
				value: "rest"
			},
			{
				title: "LDAP",
				value: "ldap"
			}
		], P = t(() => ["sql", "rest"].includes(k.datasourcetype)), F = t(() => P.value ? l(Z("query_required")) : []), I = [...l(Z("outvariable_required")), ...u(Z("outvariable_format"))], L = y([]), R = y(!1);
		async function z(e) {
			if (!e) {
				L.value = [];
				return;
			}
			R.value = !0;
			try {
				let { data: t, execute: n } = p({
					url: `/admin/connector/datasource/${e}`,
					method: "get",
					params: {
						pagesize: 200,
						query: "*"
					},
					immediate: !1
				});
				await n(), L.value = (t.value?.records || []).map((e) => ({
					title: e.name || e.id,
					value: e.id
				}));
			} catch {
				L.value = [];
			} finally {
				R.value = !1;
			}
		}
		D(() => k.datasourcetype, (e) => {
			M.value || (k.datasource = "", z(e));
		}), D(() => k.loop, (e) => {
			e || (k.loopvariable = "", k.loopsleep = 0);
		}), D(k, () => {
			A.value = JSON.stringify(k) !== JSON.stringify(j.value);
		}, { deep: !0 }), D(x, (e) => {
			e || B();
		});
		function B() {
			let e = h();
			Object.keys(e).forEach((t) => {
				k[t] = e[t];
			}), j.value = JSON.parse(JSON.stringify(k)), w.value = !1, T.value = null, A.value = !1;
		}
		function V(e, t = !0) {
			Object.keys(m).forEach((t) => {
				let n = m[t], r = e?.[t], i = r != null;
				n.type === Array ? k[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : n.type === Number ? k[t] = i ? Number(r) : typeof n.default == "function" ? n.default() : n.default : n.type === Boolean ? k[t] = i ? !!r : typeof n.default == "function" ? n.default() : n.default : (n.type, k[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), j.value = JSON.parse(JSON.stringify(k)), w.value = t, T.value = t && e?.id || null, A.value = !t;
		}
		async function H() {
			if (!C.value && ((await b.value?.validate())?.valid ?? !0)) {
				C.value = !0;
				try {
					await W(ee()), g("success"), x.value = !1;
				} catch (e) {
					o({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					C.value = !1;
				}
			}
		}
		function U(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) r === null || r === "" || Array.isArray(r) && r.length === 0 || (t[n] = r);
			return t;
		}
		function ee() {
			let e = ((e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [])(k.tag), t = {
				name: k.name?.trim() || null,
				description: k.description?.trim() || null,
				datasourcetype: k.datasourcetype || null,
				datasource: k.datasource?.trim() || null,
				query: k.query?.trim() || null,
				outvariable: k.outvariable?.trim() || null,
				loop: k.loop || !1,
				tag: e
			};
			return k.loop && (t.loopvariable = k.loopvariable?.trim() || null, t.loopsleep = k.loopsleep || 0), U(t);
		}
		async function W(e) {
			let t = w.value ? "update" : "create", n = {
				create: "/admin/connector/tasks/reader?refresh=true",
				update: `/admin/connector/tasks/reader/${encodeURIComponent(T.value)}?refresh=true`
			}, r = {
				create: "post",
				update: "put"
			}, i = {
				error: {
					create: "connector_reader_create_error",
					update: "connector_reader_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			};
			if (!(await f({
				url: n[t],
				method: r[t],
				payload: e
			}))?.ok) throw Error(Z(i.error[t]));
			o({
				title: Z(i.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function te() {
			g("cancel"), x.value = !1;
		}
		async function ne(e = null) {
			e ? (M.value = !0, V(e), await d(), M.value = !1, z(e.datasourcetype)) : z(k.datasourcetype), x.value = !0;
		}
		async function re(e) {
			M.value = !0, V(e, !1), await d(), M.value = !1, z(e.datasourcetype), x.value = !0;
		}
		return i({
			validate: () => b.value?.validate(),
			reset: () => b.value?.reset(),
			resetValidation: () => b.value?.resetValidation(),
			formData: k,
			open: ne,
			openCopy: re
		}), (t, i) => {
			let a = S("h-form-text"), o = S("h-form-textarea"), u = S("h-form-select"), d = S("h-form-code-editor"), f = S("h-form-switch"), p = S("h-form-combobox"), m = S("h-form-layout");
			return _(), n(m, {
				ref_key: "formRef",
				ref: b,
				modelValue: x.value,
				"onUpdate:modelValue": i[10] ||= (e) => x.value = e,
				loading: C.value,
				"bg-color": e.bgColor,
				"header-text": w.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": e.drawerWidth,
				"has-changes": A.value,
				onSubmit: H,
				onCancel: te
			}, {
				default: O(() => [
					c(a, {
						modelValue: k.name,
						"onUpdate:modelValue": i[0] ||= (e) => k.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: E(s),
						hint: E(Z)("connector_reader_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(o, {
						modelValue: k.description,
						"onUpdate:modelValue": i[1] ||= (e) => k.description = e,
						label: E(Z)("description"),
						hint: E(Z)("connector_reader_description_hint"),
						icon: "mdi:mdi-text",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3"
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(u, {
						modelValue: k.datasourcetype,
						"onUpdate:modelValue": i[2] ||= (e) => k.datasourcetype = e,
						icon: "mdi:mdi-database-cog",
						label: E(Z)("datasourcetype"),
						items: N,
						rules: E(l)(E(Z)("datasourcetype_required")),
						hint: E(Z)("connector_reader_datasourcetype_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(u, {
						modelValue: k.datasource,
						"onUpdate:modelValue": i[3] ||= (e) => k.datasource = e,
						icon: "mdi:mdi-database",
						label: E(Z)("datasource"),
						items: L.value,
						rules: E(l)(E(Z)("datasource_required")),
						hint: E(Z)("connector_reader_datasource_hint"),
						loading: R.value,
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"items",
						"rules",
						"hint",
						"loading"
					]),
					c(d, {
						modelValue: k.query,
						"onUpdate:modelValue": i[4] ||= (e) => k.query = e,
						language: "text",
						icon: "mdi:mdi-magnify",
						label: E(Z)("query"),
						rules: F.value,
						hint: E(Z)("connector_reader_query_hint"),
						required: P.value
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint",
						"required"
					]),
					c(a, {
						modelValue: k.outvariable,
						"onUpdate:modelValue": i[5] ||= (e) => k.outvariable = e,
						icon: "mdi:mdi-variable",
						label: E(Z)("outvariable"),
						rules: I,
						hint: E(Z)("connector_reader_outvariable_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(f, {
						modelValue: k.loop,
						"onUpdate:modelValue": i[6] ||= (e) => k.loop = e,
						icon: "mdi:mdi-repeat",
						label: E(Z)("loop"),
						hint: E(Z)("connector_reader_loop_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					k.loop ? (_(), n(a, {
						key: 0,
						modelValue: k.loopvariable,
						"onUpdate:modelValue": i[7] ||= (e) => k.loopvariable = e,
						icon: "mdi:mdi-variable-box",
						label: E(Z)("loopvariable"),
						rules: E(l)(E(Z)("loopvariable_required")),
						hint: E(Z)("connector_reader_loopvariable_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					])) : r("", !0),
					k.loop ? (_(), n(a, {
						key: 1,
						modelValue: k.loopsleep,
						"onUpdate:modelValue": i[8] ||= (e) => k.loopsleep = e,
						modelModifiers: { number: !0 },
						icon: "mdi:mdi-timer-sand",
						label: E(Z)("loopsleep"),
						type: "number",
						hint: E(Z)("connector_reader_loopsleep_hint")
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					])) : r("", !0),
					c(p, {
						modelValue: k.tag,
						"onUpdate:modelValue": i[9] ||= (e) => k.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "]
					}, null, 8, ["modelValue", "label"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, Ir = {
	__name: "admin-connector-reader",
	props: {},
	setup(n) {
		X(n, "HAdminConnectorReader");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { confirm: s } = ce(), { hAddAlert: l } = q(), u = y(!0), d = y(null), f = [
			{
				label: "File",
				value: "file"
			},
			{
				label: "SQL",
				value: "sql"
			},
			{
				label: "REST",
				value: "rest"
			},
			{
				label: "LDAP",
				value: "ldap"
			}
		], p = {
			term: "",
			name: "",
			nameMatchType: "contains",
			description: "",
			descriptionMatchType: "contains",
			datasourcetype: [],
			outvariable: "",
			outvariableMatchType: "contains",
			tag: [],
			modifieddatePreset: null,
			createdatePreset: null,
			sortBy: "name",
			sortOrder: "asc",
			page: 1,
			pageSize: 25
		}, m = v({ ...p }), g = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "description",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("description_filter"),
					placeholder: Z("description_filter_placeholder"),
					icon: "mdi:mdi-text"
				}
			},
			{
				key: "datasourcetype",
				type: "array",
				component: "h-filter-multiselect",
				props: {
					title: Z("datasourcetype_filter"),
					icon: "mdi:mdi-database-arrow-right",
					options: f
				}
			},
			{
				key: "outvariable",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("outvariable_filter"),
					placeholder: Z("outvariable_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-variable",
					defaultMatchType: "contains"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [{
					key: "createdate",
					type: "date",
					component: "h-filter-datetime",
					model: "createdatePreset",
					props: {
						label: Z("createdate_filter"),
						manualSync: !0
					}
				}, {
					key: "modifieddate",
					type: "date",
					component: "h-filter-datetime",
					model: "modifieddatePreset",
					props: {
						label: Z("modifieddate_filter"),
						minDatePresetFilter: m.createdatePreset,
						manualSync: !0
					}
				}]
			}
		] }, b = [
			{
				title: "id",
				key: "id",
				align: "start",
				sortable: !0,
				width: 150,
				value: "id",
				nowrap: !0,
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 200,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0,
				filterOnClick: (e) => F("name", e.name, "exact"),
				isFilterActive: (e) => P("name", e.name, "exact")
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "datasourcetype",
				key: "datasourcetype",
				sortable: !0,
				width: 120,
				value: "datasourcetype",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => I("datasourcetype", e.datasourcetype),
				isFilterActive: (e) => P("datasourcetype", e.datasourcetype)
			},
			{
				title: "query",
				key: "query",
				sortable: !1,
				width: 200,
				value: "query",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "outvariable",
				key: "outvariable",
				sortable: !0,
				width: 200,
				value: "outvariable",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => F("outvariable", e.outvariable, "exact"),
				isFilterActive: (e) => P("outvariable", e.outvariable, "exact")
			},
			{
				title: "loop",
				key: "loop",
				sortable: !1,
				width: 80,
				value: "loop",
				nowrap: !0,
				translate: !0,
				component: "h-btn-table-cell",
				defaultValue: !1,
				componentProps: {
					getIcon: (e) => e.loop ? "mdi:mdi-check-circle" : "mdi:mdi-close-circle",
					getColor: (e) => e.loop ? "success" : "grey"
				}
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => I("tag", e),
				isFilterActive: (e) => P("tag", e)
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 150,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], x = {
			pageKey: "connector-reader",
			pageTitle: Z("admin_connector_reader_title"),
			headerTitle: Z("connector_reader"),
			searchPlaceholder: Z("search_connector_reader"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("connector"),
					text: Z("connector")
				},
				{
					title: Z("tasks"),
					text: Z("tasks")
				},
				{
					title: Z("reader"),
					text: Z("reader")
				}
			]
		}, { data: C, loading: w, params: T, execute: D, totalResults: O } = G({
			url: "/admin/connector/tasks/reader",
			filters: m,
			additionalParams: {}
		}), k = Z("total_connector_reader"), A = t(() => ({ widgets: [{
			summary: !0,
			title: k,
			count: O.value,
			icon: "mdi:mdi-book-open-page-variant",
			color: "blue-grey-lighten-3",
			iconColor: "blue-grey-darken-4"
		}] }));
		function j() {
			M(!0);
		}
		function M(e = !1) {
			let { query: t, sort: n } = a(g.filters, m);
			T.query = t, T.sort = n, (e || u.value) && D();
		}
		let N = qe(M, 300), { isFilterActive: P, toggleFilter: F, toggleArrayFilter: I } = ue({
			filters: m,
			onFilterChange: N
		}), L = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					d.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					d.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await s({
						title: Z("delete_connector_reader"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = o({
							url: `/admin/connector/tasks/reader/${encodeURIComponent(e.id)}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							l({
								title: Z("error_occurred"),
								body: Z("connector_reader_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await D();
					}
				}
			}
		];
		function R() {
			return Object.assign(m, { ...p }), M(!0);
		}
		function z() {
			d.value?.open();
		}
		return h(async () => {
			J(m, N), M(), D();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": u.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => u.value = e,
				"page-configuration": x,
				"widgets-config": A.value,
				"filters-config": g,
				filters: m,
				"table-headers": b,
				"table-actions": L,
				"table-params": E(T),
				"table-data": E(C),
				"table-loading": E(w),
				"total-results": E(O),
				"open-form": z,
				onSearch: j,
				onClearFilters: R
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(Fr, {
				ref_key: "connectorReaderFormRef",
				ref: d,
				onSuccess: E(D)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, Lr = {
	__name: "connector-script-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 600
		}
	},
	emits: ["success", "cancel"],
	setup(e, { expose: t, emit: r }) {
		let { hAddAlert: i } = q(), { nameRules: a, requiredRules: o } = ie(), { save: s } = ae();
		X(e, "HConnectorScriptForm");
		let l = {
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			scriptsource: {
				type: String,
				default: "file"
			},
			script: {
				type: String,
				default: ""
			},
			tag: {
				type: Array,
				default: () => []
			}
		}, u = () => {
			let e = {};
			return Object.keys(l).forEach((t) => {
				let n = l[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, d = r, f = y(null), p = y(!1), m = y(!1), h = y(!1), g = y(null), b = v(u()), x = y(!1), C = y({}), w = [{
			title: "File",
			value: "file"
		}, {
			title: "Inline",
			value: "inline"
		}];
		D(b, () => {
			x.value = JSON.stringify(b) !== JSON.stringify(C.value);
		}, { deep: !0 }), D(p, (e) => {
			e || T();
		});
		function T() {
			let e = u();
			Object.keys(e).forEach((t) => {
				b[t] = e[t];
			}), C.value = JSON.parse(JSON.stringify(b)), h.value = !1, g.value = null, x.value = !1;
		}
		function k(e, t = !0) {
			Object.keys(l).forEach((t) => {
				let n = l[t], r = e?.[t], i = r != null;
				n.type === Array ? b[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : (n.type, b[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), C.value = JSON.parse(JSON.stringify(b)), h.value = t, g.value = t && e?.id || null, x.value = !t;
		}
		async function A() {
			if (!m.value && ((await f.value?.validate())?.valid ?? !0)) {
				m.value = !0;
				try {
					await N(M()), d("success"), p.value = !1;
				} catch (e) {
					i({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					m.value = !1;
				}
			}
		}
		function j(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) r === null || r === "" || Array.isArray(r) && r.length === 0 || (t[n] = r);
			return t;
		}
		function M() {
			let e = ((e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [])(b.tag);
			return j({
				name: b.name?.trim() || null,
				description: b.description?.trim() || null,
				scriptsource: b.scriptsource || null,
				script: b.script?.trim() || null,
				tag: e
			});
		}
		async function N(e) {
			let t = h.value ? "update" : "create", n = {
				create: "/admin/connector/tasks/script?refresh=true",
				update: `/admin/connector/tasks/script/${encodeURIComponent(g.value)}?refresh=true`
			}, r = {
				create: "post",
				update: "put"
			}, a = {
				error: {
					create: "connector_script_create_error",
					update: "connector_script_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			};
			if (!(await s({
				url: n[t],
				method: r[t],
				payload: e
			}))?.ok) throw Error(Z(a.error[t]));
			i({
				title: Z(a.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function P() {
			d("cancel"), p.value = !1;
		}
		function F(e = null) {
			e && k(e), p.value = !0;
		}
		function I(e) {
			k(e, !1), p.value = !0;
		}
		return t({
			validate: () => f.value?.validate(),
			reset: () => f.value?.reset(),
			resetValidation: () => f.value?.resetValidation(),
			formData: b,
			open: F,
			openCopy: I
		}), (t, r) => {
			let i = S("h-form-text"), s = S("h-form-textarea"), l = S("h-form-select"), u = S("h-form-code-editor"), d = S("h-form-combobox"), g = S("h-form-layout");
			return _(), n(g, {
				ref_key: "formRef",
				ref: f,
				modelValue: p.value,
				"onUpdate:modelValue": r[5] ||= (e) => p.value = e,
				loading: m.value,
				"bg-color": e.bgColor,
				"header-text": h.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": e.drawerWidth,
				"has-changes": x.value,
				onSubmit: A,
				onCancel: P
			}, {
				default: O(() => [
					c(i, {
						modelValue: b.name,
						"onUpdate:modelValue": r[0] ||= (e) => b.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: E(a),
						hint: E(Z)("connector_script_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(s, {
						modelValue: b.description,
						"onUpdate:modelValue": r[1] ||= (e) => b.description = e,
						label: E(Z)("description"),
						hint: E(Z)("connector_script_description_hint"),
						icon: "mdi:mdi-text",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3"
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(l, {
						modelValue: b.scriptsource,
						"onUpdate:modelValue": r[2] ||= (e) => b.scriptsource = e,
						icon: "mdi:mdi-file-code",
						label: E(Z)("scriptsource"),
						items: w,
						rules: E(o)(E(Z)("scriptsource_required")),
						hint: E(Z)("connector_script_scriptsource_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(u, {
						modelValue: b.script,
						"onUpdate:modelValue": r[3] ||= (e) => b.script = e,
						language: "text",
						icon: "mdi:mdi-powershell",
						label: E(Z)("script"),
						rules: E(o)(E(Z)("script_required")),
						hint: E(Z)("connector_script_script_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(d, {
						modelValue: b.tag,
						"onUpdate:modelValue": r[4] ||= (e) => b.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "]
					}, null, 8, ["modelValue", "label"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, Rr = {
	__name: "admin-connector-script",
	props: {},
	setup(n) {
		X(n, "HAdminConnectorScript");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { confirm: s } = ce(), { hAddAlert: l } = q(), u = y(!0), d = y(null), f = [{
			label: "File",
			value: "file"
		}, {
			label: "Inline",
			value: "inline"
		}], p = {
			term: "",
			name: "",
			nameMatchType: "contains",
			description: "",
			descriptionMatchType: "contains",
			scriptsource: [],
			tag: [],
			modifieddatePreset: null,
			createdatePreset: null,
			sortBy: "name",
			sortOrder: "asc",
			page: 1,
			pageSize: 25
		}, m = v({ ...p }), g = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "description",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("description_filter"),
					placeholder: Z("description_filter_placeholder"),
					icon: "mdi:mdi-text"
				}
			},
			{
				key: "scriptsource",
				type: "array",
				component: "h-filter-multiselect",
				props: {
					title: Z("scriptsource_filter"),
					icon: "mdi:mdi-script-text",
					options: f
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [{
					key: "createdate",
					type: "date",
					component: "h-filter-datetime",
					model: "createdatePreset",
					props: {
						label: Z("createdate_filter"),
						manualSync: !0
					}
				}, {
					key: "modifieddate",
					type: "date",
					component: "h-filter-datetime",
					model: "modifieddatePreset",
					props: {
						label: Z("modifieddate_filter"),
						minDatePresetFilter: m.createdatePreset,
						manualSync: !0
					}
				}]
			}
		] }, b = [
			{
				title: "id",
				key: "id",
				align: "start",
				sortable: !0,
				width: 150,
				value: "id",
				nowrap: !0,
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 200,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0,
				filterOnClick: (e) => F("name", e.name, "exact"),
				isFilterActive: (e) => P("name", e.name, "exact")
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "scriptsource",
				key: "scriptsource",
				sortable: !0,
				width: 120,
				value: "scriptsource",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => I("scriptsource", e.scriptsource),
				isFilterActive: (e) => P("scriptsource", e.scriptsource)
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => I("tag", e),
				isFilterActive: (e) => P("tag", e)
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 150,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], x = {
			pageKey: "connector-script",
			pageTitle: Z("admin_connector_script_title"),
			headerTitle: Z("connector_script"),
			searchPlaceholder: Z("search_connector_script"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("connector"),
					text: Z("connector")
				},
				{
					title: Z("tasks"),
					text: Z("tasks")
				},
				{
					title: Z("script"),
					text: Z("script")
				}
			]
		}, { data: C, loading: w, params: T, execute: D, totalResults: O } = G({
			url: "/admin/connector/tasks/script",
			filters: m,
			additionalParams: {}
		}), k = Z("total_connector_script"), A = t(() => ({ widgets: [{
			summary: !0,
			title: k,
			count: O.value,
			icon: "mdi:mdi-powershell",
			color: "blue-grey-lighten-3",
			iconColor: "blue-grey-darken-4"
		}] }));
		function j() {
			M(!0);
		}
		function M(e = !1) {
			let { query: t, sort: n } = a(g.filters, m);
			T.query = t, T.sort = n, (e || u.value) && D();
		}
		let N = qe(M, 300), { isFilterActive: P, toggleFilter: F, toggleArrayFilter: I } = ue({
			filters: m,
			onFilterChange: N
		}), L = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					d.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					d.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await s({
						title: Z("delete_connector_script"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = o({
							url: `/admin/connector/tasks/script/${encodeURIComponent(e.id)}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							l({
								title: Z("error_occurred"),
								body: Z("connector_script_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await D();
					}
				}
			}
		];
		function R() {
			return Object.assign(m, { ...p }), M(!0);
		}
		function z() {
			d.value?.open();
		}
		return h(async () => {
			J(m, N), M(), D();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": u.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => u.value = e,
				"page-configuration": x,
				"widgets-config": A.value,
				"filters-config": g,
				filters: m,
				"table-headers": b,
				"table-actions": L,
				"table-params": E(T),
				"table-data": E(C),
				"table-loading": E(w),
				"total-results": E(O),
				"open-form": z,
				onSearch: j,
				onClearFilters: R
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(Lr, {
				ref_key: "connectorScriptFormRef",
				ref: d,
				onSuccess: E(D)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, zr = {
	__name: "connector-transform-form",
	props: {
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		drawerWidth: {
			type: Number,
			default: 600
		}
	},
	emits: ["success", "cancel"],
	setup(e, { expose: t, emit: r }) {
		let { hAddAlert: i } = q(), { nameRules: a, requiredRules: o, idRules: s } = ie(), { save: l } = ae();
		X(e, "HConnectorTransformForm");
		let u = {
			name: {
				type: String,
				default: ""
			},
			description: {
				type: String,
				default: ""
			},
			endpointtype: {
				type: String,
				default: "item"
			},
			invariable: {
				type: String,
				default: ""
			},
			mapping: {
				type: String,
				default: ""
			},
			outvariable: {
				type: String,
				default: ""
			},
			tag: {
				type: Array,
				default: () => []
			}
		}, d = () => {
			let e = {};
			return Object.keys(u).forEach((t) => {
				let n = u[t];
				e[t] = typeof n.default == "function" ? n.default() : n.default;
			}), e;
		}, f = r, p = y(null), m = y(!1), h = y(!1), g = y(!1), b = y(null), x = v(d()), C = y(!1), w = y({}), T = [
			{
				title: "Item",
				value: "item"
			},
			{
				title: "User",
				value: "user"
			},
			{
				title: "Option",
				value: "option"
			},
			{
				title: "Event",
				value: "event"
			},
			{
				title: "Role",
				value: "role"
			}
		], k = [...o(Z("invariable_required")), ...s(Z("invariable_format"))], A = [...o(Z("outvariable_required")), ...s(Z("outvariable_format"))];
		D(x, () => {
			C.value = JSON.stringify(x) !== JSON.stringify(w.value);
		}, { deep: !0 }), D(m, (e) => {
			e || j();
		});
		function j() {
			let e = d();
			Object.keys(e).forEach((t) => {
				x[t] = e[t];
			}), w.value = JSON.parse(JSON.stringify(x)), g.value = !1, b.value = null, C.value = !1;
		}
		function M(e, t = !0) {
			Object.keys(u).forEach((t) => {
				let n = u[t], r = e?.[t], i = r != null;
				n.type === Array ? x[t] = i && Array.isArray(r) ? [...r] : typeof n.default == "function" ? n.default() : n.default : (n.type, x[t] = i ? r : typeof n.default == "function" ? n.default() : n.default);
			}), w.value = JSON.parse(JSON.stringify(x)), g.value = t, b.value = t && e?.id || null, C.value = !t;
		}
		async function N() {
			if (!h.value && ((await p.value?.validate())?.valid ?? !0)) {
				h.value = !0;
				try {
					await I(F()), f("success"), m.value = !1;
				} catch (e) {
					i({
						title: Z("error_occurred"),
						body: e.message,
						type: "error",
						timeout: 5e3
					});
				} finally {
					h.value = !1;
				}
			}
		}
		function P(e) {
			let t = {};
			for (let [n, r] of Object.entries(e)) r === null || r === "" || Array.isArray(r) && r.length === 0 || (t[n] = r);
			return t;
		}
		function F() {
			let e = ((e, t = (e) => e) => Array.isArray(e) ? e.filter((e) => e != null).map((e) => typeof e == "object" ? e.raw || e.value || e.title || e.key || e.name : t(e)).filter(Boolean) : [])(x.tag);
			return P({
				name: x.name?.trim() || null,
				description: x.description?.trim() || null,
				endpointtype: x.endpointtype || null,
				invariable: x.invariable?.trim() || null,
				mapping: x.mapping?.trim() || null,
				outvariable: x.outvariable?.trim() || null,
				tag: e
			});
		}
		async function I(e) {
			let t = g.value ? "update" : "create", n = {
				create: "/admin/connector/tasks/transform?refresh=true",
				update: `/admin/connector/tasks/transform/${encodeURIComponent(b.value)}?refresh=true`
			}, r = {
				create: "post",
				update: "put"
			}, a = {
				error: {
					create: "connector_transform_create_error",
					update: "connector_transform_update_error"
				},
				success: {
					create: "created_success",
					update: "updated_success"
				}
			};
			if (!(await l({
				url: n[t],
				method: r[t],
				payload: e
			}))?.ok) throw Error(Z(a.error[t]));
			i({
				title: Z(a.success[t]),
				type: "success",
				timeout: 3e3
			});
		}
		function L() {
			f("cancel"), m.value = !1;
		}
		function R(e = null) {
			e && M(e), m.value = !0;
		}
		function z(e) {
			M(e, !1), m.value = !0;
		}
		return t({
			validate: () => p.value?.validate(),
			reset: () => p.value?.reset(),
			resetValidation: () => p.value?.resetValidation(),
			formData: x,
			open: R,
			openCopy: z
		}), (t, r) => {
			let i = S("h-form-text"), s = S("h-form-textarea"), l = S("h-form-select"), u = S("h-form-code-editor"), d = S("h-form-combobox"), f = S("h-form-layout");
			return _(), n(f, {
				ref_key: "formRef",
				ref: p,
				modelValue: m.value,
				"onUpdate:modelValue": r[7] ||= (e) => m.value = e,
				loading: h.value,
				"bg-color": e.bgColor,
				"header-text": g.value ? E(Z)("edit") : E(Z)("create"),
				"drawer-width": e.drawerWidth,
				"has-changes": C.value,
				onSubmit: N,
				onCancel: L
			}, {
				default: O(() => [
					c(i, {
						modelValue: x.name,
						"onUpdate:modelValue": r[0] ||= (e) => x.name = e,
						icon: "mdi:mdi-form-textbox",
						label: E(Z)("name"),
						rules: E(a),
						hint: E(Z)("connector_transform_name_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(s, {
						modelValue: x.description,
						"onUpdate:modelValue": r[1] ||= (e) => x.description = e,
						label: E(Z)("description"),
						hint: E(Z)("connector_transform_description_hint"),
						icon: "mdi:mdi-text",
						density: "comfortable",
						variant: "outlined",
						"bg-color": "white",
						"auto-grow": "",
						rows: "3"
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(l, {
						modelValue: x.endpointtype,
						"onUpdate:modelValue": r[2] ||= (e) => x.endpointtype = e,
						icon: "mdi:mdi-api",
						label: E(Z)("endpointtype"),
						items: T,
						rules: E(o)(E(Z)("endpointtype_required")),
						hint: E(Z)("connector_transform_endpointtype_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(i, {
						modelValue: x.invariable,
						"onUpdate:modelValue": r[3] ||= (e) => x.invariable = e,
						icon: "mdi:mdi-variable",
						label: E(Z)("invariable"),
						rules: k,
						hint: E(Z)("connector_transform_invariable_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(u, {
						modelValue: x.mapping,
						"onUpdate:modelValue": r[4] ||= (e) => x.mapping = e,
						language: "json",
						icon: "mdi:mdi-code-json",
						label: E(Z)("mapping"),
						rules: E(o)(E(Z)("mapping_required")),
						hint: E(Z)("connector_transform_mapping_hint"),
						placeholder: "{}",
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"rules",
						"hint"
					]),
					c(i, {
						modelValue: x.outvariable,
						"onUpdate:modelValue": r[5] ||= (e) => x.outvariable = e,
						icon: "mdi:mdi-variable-box",
						label: E(Z)("outvariable"),
						rules: A,
						hint: E(Z)("connector_transform_outvariable_hint"),
						required: ""
					}, null, 8, [
						"modelValue",
						"label",
						"hint"
					]),
					c(d, {
						modelValue: x.tag,
						"onUpdate:modelValue": r[6] ||= (e) => x.tag = e,
						icon: "mdi:mdi-tag",
						label: E(Z)("tags"),
						items: [],
						"hide-no-data": "",
						multiple: "",
						chips: "",
						"closable-chips": "",
						delimiters: [",", " "]
					}, null, 8, ["modelValue", "label"])
				]),
				_: 1
			}, 8, [
				"modelValue",
				"loading",
				"bg-color",
				"header-text",
				"drawer-width",
				"has-changes"
			]);
		};
	}
}, Br = {
	__name: "admin-connector-transform",
	props: {},
	setup(n) {
		X(n, "HAdminConnectorTransform");
		let { formatDate: r } = fe(), { buildQueryParams: a } = de(), { hHttpRequest: o } = Y(), { confirm: s } = ce(), { hAddAlert: l } = q(), u = y(!0), d = y(null), f = [
			{
				label: "Item",
				value: "item"
			},
			{
				label: "User",
				value: "user"
			},
			{
				label: "Option",
				value: "option"
			},
			{
				label: "Event",
				value: "event"
			},
			{
				label: "Role",
				value: "role"
			}
		], p = {
			term: "",
			name: "",
			nameMatchType: "contains",
			description: "",
			descriptionMatchType: "contains",
			endpointtype: [],
			invariable: "",
			invariableMatchType: "contains",
			outvariable: "",
			outvariableMatchType: "contains",
			tag: [],
			modifieddatePreset: null,
			createdatePreset: null,
			sortBy: "name",
			sortOrder: "asc",
			page: 1,
			pageSize: 25
		}, m = v({ ...p }), g = { filters: [
			{
				key: "term",
				type: "text",
				default: "*"
			},
			{
				key: "name",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("name_filter"),
					placeholder: Z("name_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-alpha-n",
					defaultMatchType: "contains"
				}
			},
			{
				key: "description",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("description_filter"),
					placeholder: Z("description_filter_placeholder"),
					icon: "mdi:mdi-text"
				}
			},
			{
				key: "endpointtype",
				type: "array",
				component: "h-filter-multiselect",
				props: {
					title: Z("endpointtype_filter"),
					icon: "mdi:mdi-api",
					options: f
				}
			},
			{
				key: "invariable",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("invariable_filter"),
					placeholder: Z("invariable_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-variable",
					defaultMatchType: "contains"
				}
			},
			{
				key: "outvariable",
				type: "text",
				component: "h-filter-string",
				props: {
					title: Z("outvariable_filter"),
					placeholder: Z("outvariable_filter_placeholder"),
					showMatchTypeSelector: !0,
					icon: "mdi:mdi-variable-box",
					defaultMatchType: "contains"
				}
			},
			{
				key: "tag",
				type: "array",
				component: "h-filter-multistring",
				props: {
					label: Z("tag_filter_label"),
					icon: "mdi:mdi-tag"
				}
			},
			{
				key: "group_dates",
				type: "group",
				component: "h-filter-group",
				props: {
					title: Z("date"),
					icon: "mdi:mdi-calendar",
					controlsSync: !0
				},
				filters: [{
					key: "createdate",
					type: "date",
					component: "h-filter-datetime",
					model: "createdatePreset",
					props: {
						label: Z("createdate_filter"),
						manualSync: !0
					}
				}, {
					key: "modifieddate",
					type: "date",
					component: "h-filter-datetime",
					model: "modifieddatePreset",
					props: {
						label: Z("modifieddate_filter"),
						minDatePresetFilter: m.createdatePreset,
						manualSync: !0
					}
				}]
			}
		] }, b = [
			{
				title: "id",
				key: "id",
				align: "start",
				sortable: !0,
				width: 150,
				value: "id",
				nowrap: !0,
				translate: !0
			},
			{
				title: "name",
				key: "name",
				align: "start",
				sortable: !0,
				width: 200,
				value: "name",
				nowrap: !1,
				customSortKey: "name.lower",
				translate: !0,
				filterOnClick: (e) => F("name", e.name, "exact"),
				isFilterActive: (e) => P("name", e.name, "exact")
			},
			{
				title: "description",
				key: "description",
				sortable: !1,
				width: 200,
				value: "description",
				nowrap: !1,
				translate: !0,
				component: "h-description-table-cell"
			},
			{
				title: "endpointtype",
				key: "endpointtype",
				sortable: !0,
				width: 120,
				value: "endpointtype",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => I("endpointtype", e.endpointtype),
				isFilterActive: (e) => P("endpointtype", e.endpointtype)
			},
			{
				title: "invariable",
				key: "invariable",
				sortable: !0,
				width: 200,
				value: "invariable",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => F("invariable", e.invariable, "exact"),
				isFilterActive: (e) => P("invariable", e.invariable, "exact")
			},
			{
				title: "outvariable",
				key: "outvariable",
				sortable: !0,
				width: 200,
				value: "outvariable",
				nowrap: !0,
				translate: !0,
				filterOnClick: (e) => F("outvariable", e.outvariable, "exact"),
				isFilterActive: (e) => P("outvariable", e.outvariable, "exact")
			},
			{
				title: "tag",
				key: "tag",
				sortable: !0,
				width: 150,
				value: "tag",
				nowrap: !0,
				translate: !0,
				component: "h-chip-group-table-cell",
				filterOnClick: (e) => I("tag", e),
				isFilterActive: (e) => P("tag", e)
			},
			{
				title: "modifieddate",
				key: "modifieddate",
				sortable: !0,
				width: 150,
				value: "modifieddate",
				nowrap: !1,
				translate: !0,
				formatCell: (e) => r(e)
			}
		], x = {
			pageKey: "connector-transform",
			pageTitle: Z("admin_connector_transform_title"),
			headerTitle: Z("connector_transform"),
			searchPlaceholder: Z("search_connector_transform"),
			breadcrumbItems: [
				{
					title: Z("home"),
					text: Z("home")
				},
				{
					title: Z("admin"),
					text: Z("admin")
				},
				{
					title: Z("connector"),
					text: Z("connector")
				},
				{
					title: Z("tasks"),
					text: Z("tasks")
				},
				{
					title: Z("transform"),
					text: Z("transform")
				}
			]
		}, { data: C, loading: w, params: T, execute: D, totalResults: O } = G({
			url: "/admin/connector/tasks/transform",
			filters: m,
			additionalParams: {}
		}), k = Z("total_connector_transform"), A = t(() => ({ widgets: [{
			summary: !0,
			title: k,
			count: O.value,
			icon: "mdi:mdi-swap-horizontal-bold",
			color: "blue-grey-lighten-3",
			iconColor: "blue-grey-darken-4"
		}] }));
		function j() {
			M(!0);
		}
		function M(e = !1) {
			let { query: t, sort: n } = a(g.filters, m);
			T.query = t, T.sort = n, (e || u.value) && D();
		}
		let N = qe(M, 300), { isFilterActive: P, toggleFilter: F, toggleArrayFilter: I } = ue({
			filters: m,
			onFilterChange: N
		}), L = [
			{
				label: Z("copy"),
				icon: "mdi:mdi-content-copy",
				color: "neutral-70",
				action: (e) => {
					d.value?.openCopy(e);
				}
			},
			{
				label: Z("edit"),
				icon: "mdi:mdi-pencil",
				color: "neutral-70",
				action: (e) => {
					d.value?.open(e);
				}
			},
			{
				label: Z("delete"),
				icon: "mdi:mdi-delete",
				color: "neutral-70",
				action: async (e) => {
					if ((await s({
						title: Z("delete_connector_transform"),
						message: Z("delete_confirmation"),
						confirmText: Z("delete"),
						cancelText: Z("cancel")
					})).confirmed) {
						let { execute: t } = o({
							url: `/admin/connector/tasks/transform/${encodeURIComponent(e.id)}`,
							method: "delete",
							immediate: !1
						});
						if (!(await t())?.ok) {
							l({
								title: Z("error_occurred"),
								body: Z("connector_transform_delete_error"),
								type: "error",
								timeout: 5e3
							});
							return;
						}
						await D();
					}
				}
			}
		];
		function R() {
			return Object.assign(m, { ...p }), M(!0);
		}
		function z() {
			d.value?.open();
		}
		return h(async () => {
			J(m, N), M(), D();
		}), (t, n) => {
			let r = S("h-admin-template");
			return _(), i(e, null, [c(r, {
				"auto-search-enabled": u.value,
				"onUpdate:autoSearchEnabled": n[0] ||= (e) => u.value = e,
				"page-configuration": x,
				"widgets-config": A.value,
				"filters-config": g,
				filters: m,
				"table-headers": b,
				"table-actions": L,
				"table-params": E(T),
				"table-data": E(C),
				"table-loading": E(w),
				"total-results": E(O),
				"open-form": z,
				onSearch: j,
				onClearFilters: R
			}, null, 8, [
				"auto-search-enabled",
				"widgets-config",
				"filters",
				"table-params",
				"table-data",
				"table-loading",
				"total-results"
			]), c(zr, {
				ref_key: "connectorTransformFormRef",
				ref: d,
				onSuccess: E(D)
			}, null, 8, ["onSuccess"])], 64);
		};
	}
}, Vr = { class: "h-user-settings" }, Hr = { class: "h-user-settings__actions" }, Ur = "default", Wr = {
	__name: "user-settings",
	emits: ["success", "close"],
	setup(e, { emit: o }) {
		let l = le(), u = y(), d = o, { user_settings_select_language: f, user_settings_select_startpage: p, user_settings_select_theme: m, default_theme: h } = ve(), g = ye(), { oUserSettings: b } = it(g), { data: x } = l({ url: P.LOCALES }), { data: S } = l({ url: P.MY_WORKSPACES }), C = [
			{
				title: Z("workspace"),
				value: "workspace"
			},
			{
				title: Z("last_workspace"),
				value: "lastworkspace"
			},
			{
				title: Z("all_workspaces"),
				value: "allworkspaces"
			},
			{
				title: Z("system_default"),
				value: Ur
			}
		], w = v({
			locale: b.value?.settings?.locale,
			theme: b.value?.settings?.theme,
			defaultpage: {
				type: b.value?.settings?.defaultpage?.type,
				value: b.value?.settings?.defaultpage?.value
			}
		}), k = t(() => w.defaultpage.type === "workspace"), { execute: A, loading: M } = l({
			url: "/my/settings",
			method: "post",
			payload: { settings: w },
			immediate: !1
		}), { hThemePacksDict: N, hSetThemePack: F } = ge(), { hSetLocale: I } = me(), L = t(() => [{
			key: "default",
			title: Z("system_default")
		}].concat(Object.entries(N).map(([e, t]) => ({
			title: t.title,
			key: e
		}))));
		D(() => w.theme, () => {
			N[w.theme] ? F(w.theme) : F(h);
		}), D(() => w.locale, () => {
			I(w.locale);
		});
		async function R() {
			w.defaultpage.type === Ur && (w.defaultpage.value = Ur), (await A()).status === 200 && (g.oRefetchUserSettings(), d("success"));
		}
		function z() {
			f.value && I(b.value?.settings?.locale), m.value && F(b.value?.settings?.theme), d("close");
		}
		return (e, t) => (_(), i("div", Vr, [c(at, {
			id: "settingsForm",
			ref_key: "settingsFormRef",
			ref: u,
			class: "h-user-settings__form",
			type: "form",
			onSubmit: j(R, ["prevent"])
		}, {
			default: O(() => [
				c($, {
					id: "row-locale",
					class: "h-user-settings__row"
				}, {
					default: O(() => [E(f) ? (_(), n(ot, {
						key: 0,
						modelValue: w.locale,
						"onUpdate:modelValue": t[0] ||= (e) => w.locale = e,
						class: "h-user-settings-language-select",
						type: "select",
						label: E(Z)("language"),
						"item-title": "name",
						"item-value": "key",
						items: E(x)
					}, null, 8, [
						"modelValue",
						"label",
						"items"
					])) : r("", !0)]),
					_: 1
				}),
				c($, { class: "h-user-settings__row ga-4" }, {
					default: O(() => [c(Q, { class: "px-0 h-user-settings-col" }, {
						default: O(() => [E(p) ? (_(), n(ot, {
							key: 0,
							id: "select-start-page",
							modelValue: w.defaultpage.type,
							"onUpdate:modelValue": t[1] ||= (e) => w.defaultpage.type = e,
							class: "h-user-settings-start-page-select",
							type: "select",
							label: E(Z)("start_page"),
							items: C
						}, null, 8, ["modelValue", "label"])) : r("", !0)]),
						_: 1
					}), c(Q, {
						class: "px-0 h-user-settings-col",
						cols: "6"
					}, {
						default: O(() => [k.value && E(p) ? (_(), n(ot, {
							key: 0,
							id: "select-workspace",
							modelValue: w.defaultpage.value,
							"onUpdate:modelValue": t[2] ||= (e) => w.defaultpage.value = e,
							class: "h-user-settings-workspace-select",
							type: "select",
							label: E(Z)("workspace"),
							"item-value": "slug",
							items: E(S),
							rules: [("hValidate" in e ? e.hValidate : E(H)).required]
						}, null, 8, [
							"modelValue",
							"label",
							"items",
							"rules"
						])) : r("", !0)]),
						_: 1
					})]),
					_: 1
				}),
				c($, {
					id: "row-theme",
					class: "h-user-settings__row"
				}, {
					default: O(() => [E(m) ? (_(), n(ot, {
						key: 0,
						modelValue: w.theme,
						"onUpdate:modelValue": t[3] ||= (e) => w.theme = e,
						class: "h-user-settings-theme-select",
						type: "select",
						label: E(Z)("theme"),
						"item-title": "title",
						"item-value": "key",
						items: L.value
					}, null, 8, [
						"modelValue",
						"label",
						"items"
					])) : r("", !0)]),
					_: 1
				}),
				a("div", Hr, [c(Ue, {
					class: "h-user-settings-close-btn",
					onClick: t[4] ||= (e) => z()
				}, {
					default: O(() => [s(T(E(Z)("close")), 1)]),
					_: 1
				}), c(Ue, {
					class: "h-user-settings-save-btn",
					type: "submit",
					color: "primary",
					loading: E(M),
					disabled: !u.value?.isValid
				}, {
					default: O(() => [s(T(E(Z)("save")), 1)]),
					_: 1
				}, 8, ["loading", "disabled"])])
			]),
			_: 1
		}, 512)]));
	}
}, Gr = "data:image/svg+xml,%3csvg%20preserveAspectRatio='none'%20overflow='visible'%20style='display:%20block;'%20width='1784.64'%20height='1844.91'%20viewBox='0%200%201784.64%201844.91'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20id='Vector'%20d='M1596.11%20969.492C1700.22%20969.492%201784.64%201056.85%201784.64%201164.58C1784.64%201272.32%201700.22%201359.68%201596.11%201359.68C1492%201359.68%201407.58%201272.32%201407.58%201164.58C1407.58%201056.85%201492%20969.492%201596.11%20969.492ZM658.202%20874.366C715.01%20874.366%20767.896%20891.853%20812.067%20921.909C844.131%20943.729%20871.592%20972.146%20892.678%201005.36C921.724%201051.07%20938.623%201105.76%20938.623%201164.55C938.623%201272.32%201023.04%201359.64%201127.15%201359.64C1183.96%201359.64%201236.81%201377.13%201280.98%201407.18C1313.08%201429%201340.54%201457.42%201361.59%201490.6C1390.68%201536.31%201407.58%201591.03%201407.58%201649.82C1407.58%201757.55%201491.96%201844.91%201596.11%201844.91C1700.26%201844.91%201784.6%201757.55%201784.6%201649.82C1784.6%201542.08%201700.22%201454.73%201596.11%201454.73C1539.3%201454.73%201486.41%201437.24%201442.24%201407.18C1410.18%201385.36%201382.68%201356.95%201361.59%201323.77C1332.55%201278.06%201315.65%201223.33%201315.65%201164.55C1315.65%201105.76%201332.55%201051.07%201361.59%201005.36C1382.68%20972.146%201410.18%20943.729%201442.24%20921.909C1486.41%20891.853%201539.3%20874.366%201596.11%20874.366C1700.22%20874.366%201784.6%20787.046%201784.6%20679.312C1784.6%20571.577%201700.22%20484.219%201596.11%20484.219C1492%20484.219%201407.58%20571.538%201407.58%20679.312C1407.58%20738.097%201390.68%20792.784%201361.59%20838.493C1340.54%20871.672%201313.08%20900.128%201280.98%20921.909C1236.81%20952.004%201183.96%20969.492%201127.15%20969.492C1070.35%20969.492%201017.46%20952.004%20973.289%20921.909C941.226%20900.128%20913.727%20871.672%20892.678%20838.493C863.633%20792.784%20846.733%20738.097%20846.733%20679.312C846.733%20571.538%20762.313%20484.219%20658.202%20484.219C554.09%20484.219%20469.67%20571.538%20469.67%20679.312C469.67%20787.085%20554.09%20874.366%20658.202%20874.366ZM1126.4%20485.273C1069.59%20485.273%201016.74%20467.786%20972.572%20437.729C940.509%20415.948%20913.01%20387.492%20891.961%20354.313C862.878%20308.604%20845.979%20253.878%20845.979%20195.093C845.979%2087.3585%20761.596%200%20657.447%200C553.298%200%20468.953%2087.3585%20468.953%20195.093C468.953%20253.878%20452.054%20308.604%20423.008%20354.313C401.922%20387.492%20374.461%20415.909%20342.36%20437.729C298.188%20467.786%20245.34%20485.273%20188.532%20485.273C84.3829%20485.273%200%20572.631%200%20680.366C0%20788.1%2084.3829%20875.458%20188.532%20875.458C245.34%20875.458%20298.188%20892.946%20342.36%20923.002C374.461%20944.822%20401.922%20973.239%20423.008%201006.42C452.054%201052.13%20468.953%201106.85%20468.953%201165.64C468.953%201273.37%20553.336%201360.69%20657.447%201360.69C761.558%201360.69%20845.979%201273.37%20845.979%201165.64C845.979%201057.9%20761.596%20970.546%20657.447%20970.546C600.639%20970.546%20547.791%20953.058%20503.619%20923.002C471.556%20901.221%20444.057%20872.765%20423.008%20839.586C393.925%20793.877%20377.026%20739.151%20377.026%20680.366C377.026%20621.58%20393.925%20566.854%20423.008%20521.145C444.057%20487.966%20471.556%20459.51%20503.619%20437.729C547.791%20407.673%20600.639%20390.186%20657.447%20390.186C714.256%20390.186%20767.141%20407.673%20811.313%20437.729C843.376%20459.549%20870.875%20487.966%20891.961%20521.145C921.007%20566.854%20937.906%20621.58%20937.906%20680.366C937.906%20788.1%201022.29%20875.458%201126.4%20875.458C1230.51%20875.458%201314.93%20788.1%201314.93%20680.366C1314.93%20572.631%201230.51%20485.273%201126.4%20485.273Z'%20fill='url(%23paint0_linear_0_1677)'%20fill-opacity='0.2'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_0_1677'%20x1='892.32'%20y1='0'%20x2='892.32'%20y2='1844.91'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'/%3e%3cstop%20offset='1'%20stop-color='%236F7979'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", Kr = "data:image/svg+xml,%3csvg%20preserveAspectRatio='none'%20overflow='visible'%20style='display:%20block;'%20width='1188.14'%20height='1435.49'%20viewBox='0%200%201188.14%201435.49'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Layer_1'%20opacity='0.2'%20clip-path='url(%23clip0_0_1506)'%3e%3cpath%20id='Vector'%20d='M841.4%20691.276C786.491%20691.276%20741.967%20646.752%20741.967%20591.843C741.967%20536.934%20786.491%20492.41%20841.4%20492.41C896.309%20492.41%20940.833%20536.934%20940.833%20591.843C940.833%20646.752%20896.309%20691.276%20841.4%20691.276ZM446.473%201086.2C446.473%201031.29%20401.949%20986.77%20347.04%20986.77C292.131%20986.77%20247.607%201031.29%20247.607%201086.2C247.607%201141.11%20292.131%201185.64%20347.04%201185.64C401.949%201185.64%20446.473%201141.11%20446.473%201086.2ZM1088.73%20494.658C1033.82%20494.658%20989.296%20539.182%20989.296%20594.091C989.296%20624.052%20980.384%20651.945%20965.065%20675.241C953.944%20692.152%20939.461%20706.635%20922.55%20717.756C899.254%20733.075%20871.362%20741.987%20841.4%20741.987C811.439%20741.987%20783.547%20733.075%20760.25%20717.756C743.34%20706.635%20728.857%20692.152%20717.736%20675.241C702.417%20651.945%20693.504%20624.052%20693.504%20594.091C693.504%20564.13%20702.417%20536.238%20717.736%20512.941C728.857%20496.031%20743.34%20481.548%20760.25%20470.427C783.547%20455.108%20811.439%20446.195%20841.4%20446.195C896.309%20446.195%20940.833%20401.671%20940.833%20346.762C940.833%20291.853%20896.309%20247.329%20841.4%20247.329C811.439%20247.329%20783.547%20238.416%20760.25%20223.098C743.34%20211.976%20728.857%20197.493%20717.736%20180.583C702.417%20157.286%20693.504%20129.394%20693.504%2099.4329C693.504%2044.5239%20648.98%20-0.000110024%20594.071%20-0.000110024C539.162%20-0.000110024%20494.638%2044.5239%20494.638%2099.4329C494.638%20129.394%20485.725%20157.286%20470.407%20180.583C459.286%20197.493%20444.802%20211.976%20427.892%20223.098C404.595%20238.416%20376.703%20247.329%20346.742%20247.329C316.781%20247.329%20288.889%20238.416%20265.592%20223.098C248.682%20211.976%20234.199%20197.493%20223.077%20180.583C207.759%20157.286%20198.846%20129.394%20198.846%2099.4329C198.846%2044.5239%20154.342%20-0.000110024%2099.4129%20-0.000110024C44.484%20-0.000110024%20-0.000244141%2044.5239%20-0.000244141%2099.4329C-0.000244141%20154.342%2044.5039%20198.866%2099.4129%20198.866C129.374%20198.866%20157.266%20207.779%20180.563%20223.098C197.473%20234.219%20211.976%20248.702%20223.077%20265.612C238.416%20288.909%20247.329%20316.801%20247.329%20346.762C247.329%20401.671%20291.833%20446.195%20346.742%20446.195C401.651%20446.195%20446.175%20401.671%20446.175%20346.762C446.175%20316.801%20455.088%20288.909%20470.407%20265.612C481.528%20248.702%20496.011%20234.219%20512.921%20223.098C536.218%20207.779%20564.11%20198.866%20594.071%20198.866C624.032%20198.866%20651.925%20207.779%20675.221%20223.098C692.131%20234.219%20706.615%20248.702%20717.736%20265.612C733.055%20288.909%20741.967%20316.801%20741.967%20346.762C741.967%20376.723%20733.055%20404.615%20717.736%20427.912C706.615%20444.822%20692.131%20459.306%20675.221%20470.427C651.925%20485.746%20624.032%20494.658%20594.071%20494.658C539.162%20494.658%20494.638%20539.182%20494.638%20594.091C494.638%20649%20539.162%20693.524%20594.071%20693.524C624.032%20693.524%20651.925%20702.437%20675.221%20717.756C692.131%20728.877%20706.615%20743.36%20717.736%20760.271C733.055%20783.567%20741.967%20811.459%20741.967%20841.42C741.967%20896.329%20786.491%20940.834%20841.4%20940.834C896.309%20940.834%20940.833%20896.329%20940.833%20841.42C940.833%20811.459%20949.746%20783.567%20965.065%20760.271C976.186%20743.36%20990.669%20728.877%201007.58%20717.756C1030.88%20702.437%201058.77%20693.524%201088.73%20693.524C1143.64%20693.524%201188.14%20649%201188.14%20594.091C1188.14%20539.182%201143.64%20494.658%201088.73%20494.658ZM1088.73%20741.987C1033.82%20741.987%20989.296%20786.492%20989.296%20841.42C989.296%20871.382%20980.384%20899.254%20965.065%20922.551C953.944%20939.481%20939.461%20953.964%20922.55%20965.085C899.254%20980.404%20871.362%20989.317%20841.4%20989.317C811.439%20989.317%20783.547%20980.404%20760.25%20965.085C743.34%20953.964%20728.857%20939.481%20717.736%20922.551C702.417%20899.254%20693.504%20871.382%20693.504%20841.42C693.504%20786.492%20648.98%20741.987%20594.071%20741.987C564.11%20741.987%20536.218%20733.075%20512.921%20717.756C496.011%20706.635%20481.528%20692.152%20470.407%20675.241C455.088%20651.945%20446.175%20624.052%20446.175%20594.091C446.175%20564.13%20455.088%20536.238%20470.407%20512.941C481.528%20496.031%20496.011%20481.548%20512.921%20470.427C536.218%20455.108%20564.11%20446.195%20594.071%20446.195C648.98%20446.195%20693.504%20401.671%20693.504%20346.762C693.504%20291.853%20648.98%20247.329%20594.071%20247.329C539.162%20247.329%20494.638%20291.853%20494.638%20346.762C494.638%20376.723%20485.725%20404.615%20470.407%20427.912C459.286%20444.822%20444.802%20459.306%20427.892%20470.427C404.595%20485.746%20376.703%20494.658%20346.742%20494.658C316.781%20494.658%20288.889%20485.746%20265.592%20470.427C248.682%20459.306%20234.199%20444.822%20223.077%20427.912C207.759%20404.615%20198.846%20376.723%20198.846%20346.762C198.846%20291.853%20154.342%20247.329%2099.4129%20247.329C44.484%20247.329%20-0.000244141%20291.853%20-0.000244141%20346.762C-0.000244141%20401.671%2044.5039%20446.195%2099.4129%20446.195C129.374%20446.195%20157.266%20455.108%20180.563%20470.427C197.473%20481.548%20211.976%20496.031%20223.077%20512.941C238.416%20536.238%20247.329%20564.13%20247.329%20594.091C247.329%20649%20291.833%20693.524%20346.742%20693.524C376.703%20693.524%20404.595%20702.437%20427.892%20717.756C444.802%20728.877%20459.286%20743.36%20470.407%20760.271C485.725%20783.567%20494.638%20811.459%20494.638%20841.42C494.638%20896.329%20539.162%20940.834%20594.071%20940.834C624.032%20940.834%20651.925%20949.746%20675.221%20965.085C692.131%20976.186%20706.635%20990.689%20717.736%201007.6C733.055%201030.9%20741.967%201058.77%20741.967%201088.73C741.967%201143.66%20786.491%201188.16%20841.4%201188.16C896.309%201188.16%20940.833%201143.66%20940.833%201088.73C940.833%201058.77%20949.746%201030.9%20965.065%201007.6C976.166%20990.689%20990.669%20976.186%201007.58%20965.085C1030.88%20949.746%201058.77%20940.834%201088.73%20940.834C1143.64%20940.834%201188.14%20896.329%201188.14%20841.42C1188.14%20786.511%201143.64%20741.987%201088.73%20741.987ZM1088.73%20247.329C1058.77%20247.329%201030.88%20238.416%201007.58%20223.098C990.669%20211.976%20976.186%20197.493%20965.065%20180.583C949.746%20157.286%20940.833%20129.394%20940.833%2099.4329C940.833%2044.5239%20896.309%20-0.000110024%20841.4%20-0.000110024C786.491%20-0.000110024%20741.967%2044.5239%20741.967%2099.4329C741.967%20154.342%20786.491%20198.866%20841.4%20198.866C871.362%20198.866%20899.254%20207.779%20922.55%20223.098C939.461%20234.219%20953.944%20248.702%20965.065%20265.612C980.384%20288.909%20989.296%20316.801%20989.296%20346.762C989.296%20401.671%201033.82%20446.195%201088.73%20446.195C1143.64%20446.195%201188.14%20401.671%201188.14%20346.762C1188.14%20291.853%201143.64%20247.329%201088.73%20247.329ZM594.071%20989.317C564.11%20989.317%20536.218%20980.404%20512.921%20965.085C496.011%20953.964%20481.528%20939.481%20470.407%20922.551C455.088%20899.254%20446.175%20871.382%20446.175%20841.42C446.175%20786.492%20401.651%20741.987%20346.742%20741.987C291.833%20741.987%20247.329%20786.492%20247.329%20841.42C247.329%20896.349%20291.833%20940.834%20346.742%20940.834C376.703%20940.834%20404.595%20949.746%20427.892%20965.085C444.802%20976.186%20459.305%20990.689%20470.407%201007.6C485.725%201030.9%20494.638%201058.77%20494.638%201088.73C494.638%201118.69%20485.725%201146.58%20470.407%201169.88C459.286%201186.79%20444.802%201201.29%20427.892%201212.41C404.595%201227.73%20376.703%201236.65%20346.742%201236.65C291.833%201236.65%20247.329%201281.15%20247.329%201336.06C247.329%201390.97%20291.833%201435.49%20346.742%201435.49C401.651%201435.49%20446.175%201390.97%20446.175%201336.06C446.175%201306.1%20455.088%201278.23%20470.407%201254.93C481.508%201238.02%20496.011%201223.52%20512.921%201212.41C536.218%201197.08%20564.11%201188.16%20594.071%201188.16C648.98%201188.16%20693.504%201143.66%20693.504%201088.73C693.504%201033.8%20648.98%20989.317%20594.071%20989.317Z'%20fill='%23FFD0C9'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_0_1506'%3e%3crect%20width='1188.14'%20height='1435.49'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", qr = {
	key: 0,
	class: "app-access-page__brand"
}, Jr = { class: "app-access-page__content" }, Yr = /*#__PURE__*/ xt({
	__name: "app-access-page",
	props: {
		logoSrc: String,
		logoAlt: {
			type: String,
			default: ""
		},
		backgroundSrc: String,
		error: Boolean
	},
	setup(e) {
		let t = st(e, "AppAccessPage");
		return (e, n) => {
			let o = S("h-onify-logo");
			return _(), i("div", {
				class: f(["app-access-page", {
					"app-access-page--standard": !E(t).logoSrc,
					"app-access-page--error": E(t).error,
					"app-access-page--custom-background": E(F).custom_login_background || E(ee).custom_login_background
				}]),
				style: p({
					"--app-access-theme-background": E(t).backgroundSrc ? `url(${JSON.stringify(E(t).backgroundSrc)})` : void 0,
					"--app-access-default-background": `url(${JSON.stringify(E(t).error ? E(Kr) : E(Gr))})`
				})
			}, [c(Fe, {
				class: "app-access-page__panel",
				elevation: "0"
			}, {
				default: O(() => [!E(t).error || E(t).logoSrc ? (_(), i("div", qr, [c(o, {
					"fallback-src": E(t).logoSrc,
					alt: E(t).logoAlt
				}, null, 8, ["fallback-src", "alt"])])) : r("", !0), a("div", Jr, [x(e.$slots, "default", {}, void 0, !0)])]),
				_: 3
			})], 6);
		};
	}
}, [["__scopeId", "data-v-0c04c595"]]), Xr = {
	id: "page-not-found__title",
	class: "page-not-found__title"
}, Zr = { class: "page-not-found__subtitle my-5" }, Qr = { class: "page-not-found__subtitle-text" }, $r = {
	id: "text-page-not-found__message",
	class: "page-not-found__message mt-2"
}, ei = { class: "page-not-found__actions mt-2" }, ti = {
	__name: "legacy-error-404",
	setup(e) {
		let t = Xe(), r = se();
		function i() {
			window.location = r.hubAppUrl;
		}
		function o() {
			history.back();
		}
		return (e, r) => {
			let l = S("h-page-head");
			return _(), n(Yr, {
				id: "error-404-legacy",
				error: "",
				class: "page-not-found text-center h-legacy-error-404-page-container"
			}, {
				default: O(() => [
					c(l, { "page-title": E(Z)("page_not_found") }, null, 8, ["page-title"]),
					a("h1", Xr, "404 " + T(E(Z)("error")), 1),
					a("p", Zr, [a("span", Qr, T(E(Z)("page_not_found")), 1)]),
					a("p", $r, T(E(Z)("page_does_not_exist", {
						page: E(t)?.path,
						titlelower: E(Z)("page").toLowerCase()
					})), 1),
					a("p", ei, [c(Ue, {
						class: "h-legacy-error-404-back-btn",
						variant: "outlined",
						"prepend-icon": "mdi:mdi-keyboard-backspace",
						onClick: r[0] ||= (e) => o()
					}, {
						default: O(() => [s(T(E(Z)("back")), 1)]),
						_: 1
					}), c(Ue, {
						id: "btn-start-page",
						class: "h-legacy-error-404-start-page-btn",
						variant: "outlined",
						"prepend-icon": "mdi:mdi-home",
						onClick: r[1] ||= (e) => i()
					}, {
						default: O(() => [s(T(E(Z)("start_page")), 1)]),
						_: 1
					})])
				]),
				_: 1
			});
		};
	}
}, ni = {
	id: "error-page__title",
	class: "error-page__title"
}, ri = { class: "error-page__subtitle my-5" }, ii = { class: "error-page__subtitle-text" }, ai = {
	id: "text-error-page__message",
	class: "error-page__message mt-2"
}, oi = { class: "error-page__actions mt-2" }, si = {
	__name: "legacy-error",
	setup(e) {
		let t = Xe(), r = se();
		function i() {
			window.location = r.hubAppUrl;
		}
		function o() {
			history.back();
		}
		return (e, r) => {
			let l = S("h-page-head"), u = C("dompurify-html");
			return _(), n(Yr, {
				id: "error-legacy",
				error: "",
				class: "error-page text-center h-legacy-error-page-container"
			}, {
				default: O(() => [
					c(l, { "page-title": E(Z)("error") }, null, 8, ["page-title"]),
					a("h1", ni, T(E(t).query?.code ?? 500) + " " + T(E(Z)("error")), 1),
					a("p", ri, [k(a("span", ii, null, 512), [[u, E(t).query?.title ?? E(Z)("something_went_wrong")]])]),
					k(a("p", ai, null, 512), [[u, E(t).query?.body ?? E(Z)("unexpected_error_occurred")]]),
					a("p", oi, [c(Ue, {
						class: "h-legacy-error-back-btn",
						variant: "outlined",
						"prepend-icon": "mdi:mdi-keyboard-backspace",
						onClick: r[0] ||= (e) => o()
					}, {
						default: O(() => [s(T(E(Z)("back")), 1)]),
						_: 1
					}), c(Ue, {
						id: "btn-start-page",
						class: "h-legacy-error-start-page-btn",
						variant: "outlined",
						"prepend-icon": "mdi:mdi-home",
						onClick: r[1] ||= (e) => i()
					}, {
						default: O(() => [s(T(E(Z)("start_page")), 1)]),
						_: 1
					})])
				]),
				_: 1
			});
		};
	}
}, ci = { class: "h-workspace h-content-container" }, li = { class: "h-content-container__wrapper" }, ui = { class: "h-content-container__col h-content-container__left" }, di = { class: "h-content-container__main p-3" }, fi = { class: "h-content-container__main-inner" }, pi = { class: "h-content-container__header" }, mi = { class: "text-headline-large text-5 font-weight-medium h-workspace__header" }, hi = { class: "text-body text-wrap h-workspace__description" }, gi = { class: "h-content-container__body" }, _i = { class: "h-content-container__body-content" }, vi = {
	key: 0,
	class: "h-app-container__shortcuts"
}, yi = { key: 2 }, bi = { class: "text-headline-small text-no-wrap mt-5" }, xi = {
	key: 1,
	class: "h-app-container__no-shortcuts"
}, Si = { class: "h-no-shortcuts__title text-headline-large mb-5" }, Ci = { class: "h-no-shortcuts__message text-headline-medium mb-15" }, wi = { class: "h-no-shortcuts__button" }, Ti = {
	key: 1,
	class: "h-app-container__shortcuts"
}, Ei = {
	key: 0,
	class: "h-content-container__col h-content-container__section h-content-container__right border-s p-2"
}, Di = { class: "h-updates-sidebar" }, Oi = {
	key: 0,
	class: "h-updates-sidebar__inner"
}, ki = { class: "text-headline-medium font-weight-medium" }, Ai = { class: "h-articles mt-4" }, ji = { class: "h-app-container__footer border-t" }, Mi = {
	__name: "workspace",
	props: {
		workspaceSlug: {
			type: String,
			required: !1
		},
		breadcrumbItems: {
			type: Array,
			required: !1
		},
		description: {
			type: String,
			required: !1
		},
		bulletinsTerm: {
			type: String,
			required: !1
		}
	},
	setup(o) {
		let l = X(o, "HWorkspace"), { hHttpRequest: u } = Y(), { oUser: d, oGetImage: p } = _e(), m = pe(), { baseUrl: g } = se(), v = Xe(), y = l.workspaceSlug ?? v?.params?.workspaceSlug, C = l.bulletinsTerm ?? v?.query?.bulletinsTerm, { no_workspace_shortcuts_link: D } = ve(), { bulletins: k, acknowledgeBulletin: A } = oe(y, C), { data: j, loading: M } = u({ url: `/my/workspaces/${y}` }), { data: N, loading: P } = u({ url: `/my/shortcuts/workspace/${y}?pagesize=50` }), F = t(() => P.value || M.value), { execute: I } = u({
			url: "/my/settings",
			method: "post",
			params: { refresh: !0 },
			payload: { lastworkspace: y },
			immediate: !1
		}), L = t(() => [
			{
				icon: "mdi:mdi-home-outline",
				href: V(m.value, g, !0),
				text: "Hem"
			},
			{
				text: "Workspaces",
				href: "/workspaces"
			},
			{ text: j?.value?.name }
		]);
		return h(() => {
			y != null && I();
		}), (t, o) => {
			let u = S("h-breadcrumbs"), m = S("h-shortcut"), h = S("h-action-link"), g = S("h-bulletin"), v = S("h-dialog"), C = S("h-page-head");
			return _(), n(C, {
				class: "h-page-head",
				"page-title": E(j)?.name,
				"page-prefix": ""
			}, {
				default: O(() => [a("div", ci, [a("div", li, [a("div", { class: f(["h-content-container__row h-workspace__main", { "h-workspace__main--no-bulletins": E(k).length === 0 }]) }, [a("div", ui, [a("div", di, [a("div", fi, [a("div", pi, [x(t.$slots, "header", {
					breadcrumbItems: L.value,
					workspace: E(j)
				}, () => [x(t.$slots, "breadcrumbs", {
					breadcrumbItems: L.value,
					workspace: E(j)
				}, () => [F.value ? (_(), n(xe, {
					key: 1,
					class: "mb-2 h-workspace-skeleton-loader",
					width: "200px",
					type: "table-row"
				})) : (_(), n(u, {
					key: 0,
					class: "text-primary h-workspace__breadcrumbs",
					items: L.value
				}, null, 8, ["items"]))])]), a("div", null, [F.value ? (_(), n(xe, {
					key: 1,
					class: "h-workspace-skeleton-loader",
					type: "sentences",
					width: "500px"
				})) : x(t.$slots, "header-text", { key: 0 }, () => [a("div", mi, [x(t.$slots, "header-title", {}, () => [s(T(t.$t("header_welcome")) + " " + T(E(d).name), 1)])]), a("div", hi, [x(t.$slots, "header-description", {}, () => [s(T(E(l).description ?? E(j)?.description), 1)])])])])]), a("div", gi, [x(t.$slots, "body", {
					workspace: E(y),
					shortcuts: E(N),
					isLoading: F.value
				}, () => [o[0] ||= a("div", { class: "h-content-container__bg-shape" }, null, -1), a("div", _i, [F.value ? (_(), i("div", Ti, [(_(), i(e, null, b(4, (e) => c(xe, {
					key: e,
					class: "h-app-container__shortcut-wrapper",
					type: "avatar, sentences",
					height: "160px"
				})), 64)), (_(), i(e, null, b(3, (e) => a("div", {
					key: e,
					class: "h-app-container__shortcut-wrapper h-app-container__shortcut-buffer"
				})), 64))])) : (_(), i(e, { key: 0 }, [E(N)?.length ? (_(), i("div", vi, [x(t.$slots, "shortcuts", {}, () => [(_(!0), i(e, null, b(E(N), (e) => (_(), n(m, {
					is: E(ut),
					key: e.key,
					shortcut: e,
					ripple: "",
					class: f(["pa-8 h-app-container__shortcut hover-effect", { [`h-shortcut__${e.key}`]: !!e.key }]),
					elevation: 1,
					"badge-props": e.badgeProps,
					"wrapper-class": "h-app-container__shortcut-wrapper",
					workspace: E(y)
				}, {
					avatar: O(({ icon: t, isImage: r }) => [c(He, {
						size: "56",
						class: "h-workspace__shortcut-avatar bg-gradient-shortcut-icon"
					}, {
						default: O(() => [!r && t ? (_(), n(ze, {
							key: 0,
							class: "h-workspace__shortcut-icon",
							size: "32",
							icon: t
						}, null, 8, ["icon"])) : r && t ? (_(), n(pt, {
							key: 1,
							class: "h-shortcut-item-avatar-image",
							height: "32",
							src: E(p)(t),
							alt: E(Z)("image_alt_shortcut_icon")
						}, null, 8, ["src", "alt"])) : (_(), i("span", yi, T(e.title[0]), 1))]),
						_: 2
					}, 1024)]),
					title: O(({ title: e }) => [a("div", bi, [a("span", null, T(e), 1), c(ze, {
						class: "h-shortcut__chevron",
						icon: "mdi:mdi-chevron-right"
					})])]),
					_: 2
				}, 1032, [
					"is",
					"shortcut",
					"class",
					"badge-props",
					"workspace"
				]))), 128)), (_(), i(e, null, b(3, (e) => a("div", {
					key: e,
					class: "h-app-container__shortcut-wrapper h-app-container__shortcut-buffer"
				})), 64))])])) : (_(), i("div", xi, [x(t.$slots, "no-shortcuts", {}, () => [c(mt, { class: "h-no-shortcuts" }, {
					default: O(() => [
						a("div", Si, T(E(Z)("no_workspace_shortcuts_title")), 1),
						a("div", Ci, T(E(Z)("no_workspace_shortcuts_message")), 1),
						a("div", wi, [c(h, {
							to: E(D),
							class: "h-workspace-action-link",
							target: "_blank"
						}, {
							default: O(() => [c(Ue, {
								class: "text-h7 h-workspace-action-btn",
								"append-icon": "mdi:mdi-arrow-top-right-thick",
								variant: "outlined",
								size: "large"
							}, {
								default: O(() => [s(T(E(Z)("no_workspace_shortcuts_link_text")), 1)]),
								_: 1
							})]),
							_: 1
						}, 8, ["to"])])
					]),
					_: 1
				})])]))], 64))])])])])])]), E(k).length > 0 ? (_(), i("div", Ei, [a("div", Di, [x(t.$slots, "sidebar-header", {
					workspaceSlug: E(y),
					bulletins: E(k),
					acknowledgeBulletin: E(A),
					workspace: E(j)
				}), x(t.$slots, "sidebar-content", {
					workspaceSlug: E(y),
					bulletins: E(k),
					acknowledgeBulletin: E(A),
					workspace: E(j)
				}, () => [E(k).length > 0 ? (_(), i("div", Oi, [
					a("div", ki, T(t.$t("header_bulletins")), 1),
					c(dt, { class: "my-3 h-workspace-divider" }),
					a("div", Ai, [
						x(t.$slots, "prepend-sidebar-content"),
						x(t.$slots, "main-sidebar-content", {}, () => [(_(!0), i(e, null, b(E(k), (e) => (_(), n(g, {
							is: E(ut),
							key: e.key,
							bulletin: e,
							class: "mb-4 hover-effect h-workspace__bulletin",
							onAcknowledgeBulletin: E(A)
						}, null, 8, [
							"is",
							"bulletin",
							"onAcknowledgeBulletin"
						]))), 128))]),
						x(t.$slots, "append-sidebar-content")
					]),
					c(v, null, {
						default: O(() => [(_(), n(w(t.dialogContent), { class: "dialog" }))]),
						_: 1
					})
				])) : r("", !0)])])])) : r("", !0)], 2), a("div", ji, [c(ft, {
					class: "h-app-container__footer-text py-3 text-body-small",
					height: "45",
					color: "workspace-footer"
				}, {
					default: O(() => [x(t.$slots, "footer")]),
					_: 3
				})])])])]),
				_: 3
			}, 8, ["page-title"]);
		};
	}
}, Ni = { class: "h-workspaces" }, Pi = { class: "h-workspaces__inner" }, Fi = { class: "h-workspaces__title" }, Ii = { class: "h-workspaces__subtitle" }, Li = { class: "h-workspaces__footer border-t" }, Ri = { class: "h-workspaces__footer-text py-3 text-body-small" }, zi = {
	__name: "workspaces-list",
	props: { link: {
		type: Function,
		default: (e) => `/workspaces/${e.slug}`
	} },
	setup(r) {
		let { hHttpRequest: o } = Y(), { data: s, loading: l } = o({ url: P.MY_WORKSPACES }), u = pe(), { baseUrl: d } = se(), f = t(() => [{
			icon: "mdi:mdi-home-outline",
			href: V(u.value, d, !0),
			text: "Hem"
		}, {
			text: "Workspaces",
			href: "/workspaces"
		}]);
		return (t, o) => {
			let u = S("h-breadcrumbs"), d = S("h-workspace-item"), p = S("h-page-head");
			return _(), n(p, {
				class: "h-page-head",
				"page-title": E(Z)("workspaces")
			}, {
				default: O(() => [a("div", Ni, [a("div", Pi, [
					c(u, {
						class: "text-primary h-workspaces-list-breadcrumbs",
						items: f.value
					}, null, 8, ["items"]),
					a("div", Fi, T(E(Z)("workspaces")), 1),
					a("div", Ii, T(E(Z)("workspace_greeting")), 1),
					c($, { class: "mt-4 h-workspaces-list-row" }, {
						default: O(() => [E(l) ? (_(), i(e, { key: 1 }, b(3, (e) => c(Q, {
							key: e,
							class: "h-workspaces-list-col",
							lg: "3",
							md: "4",
							sm: "6",
							cols: "12"
						}, {
							default: O(() => [(_(), n(xe, {
								key: e,
								class: "w-100 mb-2 h-workspaces-list-skeleton-loader",
								height: "146px",
								type: "avatar, sentences"
							}))]),
							_: 2
						}, 1024)), 64)) : (_(), i(e, { key: 0 }, [E(s)?.length > 3 ? (_(!0), i(e, { key: 0 }, b(E(s), (e) => (_(), n(Q, {
							key: e.slug,
							class: "h-workspaces-list-col",
							lg: "3",
							md: "4",
							sm: "6",
							cols: "12"
						}, {
							default: O(() => [c(d, {
								class: "h-workspaces-list-item",
								workspace: e,
								to: r.link(e)
							}, null, 8, ["workspace", "to"])]),
							_: 2
						}, 1024))), 128)) : (_(!0), i(e, { key: 1 }, b(E(s), (e) => (_(), n(Q, {
							key: e.slug,
							class: "h-workspaces-list-col",
							cols: "12"
						}, {
							default: O(() => [c(d, {
								class: "h-workspaces-list-item",
								workspace: e,
								to: r.link(e)
							}, null, 8, ["workspace", "to"])]),
							_: 2
						}, 1024))), 128))], 64))]),
						_: 1
					})
				]), a("div", Li, [a("div", Ri, [x(t.$slots, "footer")])])])]),
				_: 3
			}, 8, ["page-title"]);
		};
	}
}, Bi = { class: "h-themes-select" }, Vi = { class: "h-themes-select__select" }, Hi = { class: "h-themes-select__actions" }, Ui = {
	__name: "themes-select",
	emits: ["close"],
	setup(e, { emit: n }) {
		let r = n, { hThemePack: o, hThemePacksDict: l, hSetThemePack: u } = ge(), { default_theme: d } = ve(), f = t(() => Object.keys(l).map((e) => ({
			title: l[e].title,
			value: e
		})));
		f.value.push({
			title: Z("system_default"),
			value: d.value
		});
		let p = y(o.value?.name);
		function m() {
			u(p.value), r("close");
		}
		return (e, t) => (_(), i("div", Bi, [a("div", Vi, [c(ot, {
			modelValue: p.value,
			"onUpdate:modelValue": t[0] ||= (e) => p.value = e,
			class: "h-themes-select-dropdown",
			items: E(f)
		}, null, 8, ["modelValue", "items"])]), a("div", Hi, [c(Ue, {
			class: "h-themes-select-close-btn",
			onClick: t[1] ||= (e) => r("close")
		}, {
			default: O(() => [...t[2] ||= [s("Close", -1)]]),
			_: 1
		}), c(Ue, {
			class: "h-themes-select-save-btn",
			color: "primary",
			onClick: m
		}, {
			default: O(() => [...t[3] ||= [s("Save", -1)]]),
			_: 1
		})])]));
	}
}, Wi = "h-login-internal-autofill", Gi = /*#__PURE__*/ xt({
	__name: "login-internal",
	setup(e) {
		let t = le(), o = se(), l = y(null), u = y(""), d = y(""), f = y(!1), p = y(""), g = y(!1);
		function v() {
			let e = l.value;
			if (!e) return;
			let t = e.querySelector("input[name=\"username\"]"), n = e.querySelector("input[name=\"password\"]");
			t?.value && (u.value = t.value), n?.value && (d.value = n.value);
		}
		function b(e) {
			e.animationName?.includes(Wi) && v();
		}
		h(() => {
			let e = l.value;
			e && (e.addEventListener("input", v), e.addEventListener("change", v), e.addEventListener("animationstart", b));
		}), m(() => {
			let e = l.value;
			e?.removeEventListener("input", v), e?.removeEventListener("change", v), e?.removeEventListener("animationstart", b);
		});
		let x = async () => {
			if (v(), !u.value || !d.value) return;
			g.value = !0, p.value = "";
			let e = await t({
				url: "/my/login",
				method: "post",
				payload: {
					username: u.value,
					password: d.value
				},
				immediate: !1
			}, {
				headers: { "onify-set-auth-cookie": "true" },
				throwHttpErrors: !1
			}).response();
			if (e?.ok) {
				W(o.baseUrl || "/");
				return;
			}
			let n = await e?.json();
			n?.error?.locale?.key ? p.value = Z(n.error.locale.key) : n?.error?.message ? p.value = n.error.message : p.value = n?.message, g.value = !1;
		};
		return (e, t) => {
			let o = S("h-page-head");
			return _(), i("div", {
				ref_key: "pageEl",
				ref: l,
				class: "h-login-internal-page"
			}, [c(o, { "page-title": e.$t("login") }, null, 8, ["page-title"]), c(Yr, { class: "h-login-internal-container" }, {
				default: O(() => [a("h1", null, T(e.$t("welcome")), 1), c(at, {
					class: "app-access-form text-left",
					onSubmit: j(x, ["prevent"])
				}, {
					default: O(() => [
						c(Qe, {
							modelValue: u.value,
							"onUpdate:modelValue": t[0] ||= (e) => u.value = e,
							label: e.$t("username"),
							placeholder: " ",
							type: "text",
							name: "username",
							autocomplete: "username",
							variant: "outlined",
							"prepend-inner-icon": "mdi:mdi-account",
							"hide-details": "auto",
							disabled: g.value,
							required: ""
						}, null, 8, [
							"modelValue",
							"label",
							"disabled"
						]),
						c(Qe, {
							modelValue: d.value,
							"onUpdate:modelValue": t[2] ||= (e) => d.value = e,
							label: e.$t("password"),
							placeholder: " ",
							type: f.value ? "text" : "password",
							name: "password",
							autocomplete: "current-password",
							variant: "outlined",
							"prepend-inner-icon": "mdi:mdi-lock",
							"hide-details": "auto",
							disabled: g.value,
							required: ""
						}, {
							"append-inner": O(() => [c(Ue, {
								icon: f.value ? "mdi:mdi-eye-off-outline" : "mdi:mdi-eye-outline",
								"aria-label": e.$t("toggle_password_visibility"),
								"aria-pressed": f.value,
								variant: "text",
								size: "small",
								disabled: g.value,
								onClick: t[1] ||= (e) => f.value = !f.value
							}, null, 8, [
								"icon",
								"aria-label",
								"aria-pressed",
								"disabled"
							])]),
							_: 1
						}, 8, [
							"modelValue",
							"label",
							"type",
							"disabled"
						]),
						p.value ? (_(), n(Be, {
							key: 0,
							type: "error",
							variant: "tonal",
							class: "mb-4",
							closable: "",
							"onClick:close": t[3] ||= (e) => p.value = ""
						}, {
							default: O(() => [s(T(p.value), 1)]),
							_: 1
						})) : r("", !0),
						c(Ue, {
							class: "app-access-action",
							type: "submit",
							color: "primary",
							size: "large",
							"prepend-icon": "mdi:mdi-account-circle",
							"append-icon": "mdi:mdi-chevron-right",
							loading: g.value,
							disabled: g.value
						}, {
							default: O(() => [s(T(e.$t("login")), 1)]),
							_: 1
						}, 8, ["loading", "disabled"])
					]),
					_: 1
				})]),
				_: 1
			})], 512);
		};
	}
}, [["__scopeId", "data-v-6ea2a370"]]), Ki = { class: "h-logout-page" }, qi = {
	key: 0,
	class: "app-access-redirect",
	role: "status",
	"aria-live": "polite"
}, Ji = {
	__name: "logout",
	setup(e) {
		let r = le(), o = se(), l = y(null), u = t(() => !!l.value), d = null;
		h(async () => {
			await R();
			try {
				await L(B());
			} catch (e) {
				console.warn("[settings] Public settings restore after logout failed:", e);
			}
			let e = (await (await r({
				url: "/my/logoff",
				method: "get",
				immediate: !1
			}, {
				headers: { "onify-invalidate-auth-cookie": "true" },
				throwHttpErrors: !1
			}).response())?.json() ?? {}).signoutURL;
			typeof e == "string" && U(e) && e.startsWith("/") ? l.value = e : e && (console.warn("[settings] Ignoring invalid auth redirect \"signoutURL\" (path-only; never absolute):", e), l.value = null), l.value && (d = setTimeout(() => {
				window.location.href = l.value;
			}, 3e3));
		}), m(() => {
			d &&= (clearTimeout(d), null);
		});
		let f = () => {
			let e = o.baseUrl || "/", t = o.loginUrl;
			window.location.href = `${t}?redirect=${encodeURIComponent(e)}`;
		};
		return (e, t) => (_(), i("div", Ki, [c(Yr, { class: "h-logout-container" }, {
			default: O(() => [a("h1", null, T(e.$t("you_are_logged_out")), 1), u.value ? (_(), i("div", qi, [c(rt, {
				indeterminate: "",
				size: 84,
				width: 6,
				color: "primary",
				"aria-label": e.$t("we_are_redirecting_you")
			}, null, 8, ["aria-label"]), a("p", null, T(e.$t("we_are_redirecting_you")), 1)])) : (_(), n(Ue, {
				key: 1,
				class: "app-access-action",
				variant: "text",
				color: "primary",
				size: "default",
				"prepend-icon": "mdi:mdi-account-circle",
				"append-icon": "mdi:mdi-chevron-right",
				onClick: f
			}, {
				default: O(() => [s(T(e.$t("login_again")), 1)]),
				_: 1
			}))]),
			_: 1
		})]));
	}
}, Yi = {
	key: 0,
	class: "h-maintenance-page__bulletin text-left"
}, Xi = { class: "h-maintenance-page__bulletin-title" }, Zi = /*#__PURE__*/ xt({
	__name: "maintenance",
	setup(e) {
		let { hHttpRequest: o } = Y(), { maintenance_mode_bulletin: s } = ve(), l = t(() => {
			let e = s.value;
			return typeof e == "string" ? e.trim() : "";
		}), { data: u, execute: d } = o({
			url: () => `/my/bulletins/${l.value}`,
			precondition: () => !!l.value
		});
		D(l, (e) => {
			e && d();
		});
		let f = t(() => u.value ? {
			...u.value,
			sticky: !0
		} : null);
		return (e, t) => {
			let o = S("h-page-head"), s = S("h-bulletin"), l = C("dompurify-html");
			return _(), n(Yr, {
				id: "maintenance-page",
				class: "h-maintenance-page h-maintenance-container"
			}, {
				default: O(() => [
					c(o, { "page-title": e.$t("maintenance_mode") }, null, 8, ["page-title"]),
					a("h1", null, T(e.$t("maintenance_mode")), 1),
					f.value ? (_(), i("div", Yi, [c(s, {
						bulletin: f.value,
						class: "h-maintenance-bulletin mb-0"
					}, {
						header: O(() => [a("h2", Xi, T(f.value.title), 1)]),
						default: O(() => [k(a("div", null, null, 512), [[l, E(u).description]])]),
						_: 1
					}, 8, ["bulletin"])])) : r("", !0)
				]),
				_: 1
			});
		};
	}
}, [["__scopeId", "data-v-f3d0da08"]]), Qi = { class: "legacy-layout" }, $i = { class: "d-flex align-center ml-2" }, ea = { class: "mx-auto text-center" }, ta = { class: "text-headline-medium" }, na = {
	id: "label-user-email",
	class: "text-body-small mt-1"
}, ra = { class: "legacy-layout-body" }, ia = {
	id: "sidebar",
	class: "sidebar"
}, aa = "/my/workspaces", oa = "/my/processes", sa = /*#__PURE__*/ xt({
	__name: "legacy",
	setup(o) {
		let { user_settings: d } = ve(), { hPageTitle: f } = he(), p = se(), m = le(), { oUserSettings: h } = it(ye()), g = y(!1), v = Ye(g), { data: S } = m({ url: aa }), { data: C } = m({
			url: oa,
			params: {
				metaonly: !0,
				status: "running"
			}
		}), w = p.hubAppUrl.replace(/\/$/, ""), D = t(() => (h.value?.role ?? []).includes("admin")), k = t(() => [
			{
				route: "admin-dashboard",
				name: Z("admin_dashboard_title")
			},
			{
				route: "admin-settings",
				name: Z("admin_settings_title")
			},
			{
				route: "admin-processes",
				name: Z("admin_processes_title")
			},
			{
				route: "admin-users",
				name: Z("users_page_title")
			},
			{
				route: "admin-roles",
				name: Z("roles_page_title")
			},
			{
				route: "admin-workspaces",
				name: Z("admin_workspaces_title")
			},
			{
				route: "admin-bulletins",
				name: Z("bulletins_page_title")
			},
			{
				route: "admin-agents",
				name: Z("agents_page_title")
			},
			{
				route: "admin-domains",
				name: Z("admin_domains_title")
			},
			{
				route: "admin-items",
				name: Z("admin_items_title")
			},
			{
				route: "admin-options",
				name: Z("admin_options_title")
			},
			{
				route: "admin-shortcuts",
				name: Z("admin_shortcuts_title")
			},
			{
				route: "admin-forms",
				name: Z("admin_forms_title")
			},
			{
				route: "admin-guides",
				name: Z("admin_guides_title")
			},
			{
				route: "admin-workflows",
				name: Z("admin_workflows_title")
			},
			{
				route: "admin-dashboards",
				name: Z("admin_dashboards_title")
			},
			{
				route: "admin-strings",
				name: Z("admin_strings_title")
			},
			{
				route: "admin-locales",
				name: Z("locales_page_title")
			},
			{
				route: "admin-resources",
				name: Z("admin_resources_title")
			},
			{
				route: "admin-audit",
				name: Z("activity_log")
			},
			{
				route: "admin-system-logs",
				name: Z("admin_system_logs_title")
			},
			{
				route: "admin-connector-pipelines",
				name: Z("admin_connector_pipelines_title")
			},
			{
				route: "admin-connector-datasource-file",
				name: Z("admin_connector_datasource_file_title")
			},
			{
				route: "admin-connector-datasource-ldap",
				name: Z("admin_connector_datasource_ldap_title")
			},
			{
				route: "admin-connector-datasource-rest",
				name: Z("admin_connector_datasource_rest_title")
			},
			{
				route: "admin-connector-datasource-sql",
				name: Z("admin_connector_datasource_sql_title")
			},
			{
				route: "admin-connector-index",
				name: Z("admin_connector_index_title")
			},
			{
				route: "admin-connector-purge",
				name: Z("admin_connector_purge_title")
			},
			{
				route: "admin-connector-reader",
				name: Z("admin_connector_reader_title")
			},
			{
				route: "admin-connector-script",
				name: Z("admin_connector_script_title")
			},
			{
				route: "admin-connector-transform",
				name: Z("admin_connector_transform_title")
			}
		]), A = t(() => S?.value?.map((e) => ({
			name: e.name,
			link: `${w}/workspace/${e?.slug}`
		})) ?? []), M = t(() => C?.value?.meta?.totalresults ?? 0), [N, P] = Ye();
		async function F() {
			await R();
			let e = encodeURIComponent(window.location.href);
			window.location.href = `${p.logoutUrl}?redirect=${e}`;
		}
		return (t, o) => (_(), i("div", Qi, [
			c(Ke, {
				id: "dialog-user-settings",
				modelValue: g.value,
				"onUpdate:modelValue": o[2] ||= (e) => g.value = e,
				class: "h-legacy-layout-dialog",
				width: "700px"
			}, {
				default: O(() => [c(Fe, { class: "user-settings h-legacy-layout-card" }, {
					default: O(() => [c(Re, { class: "h-legacy-layout-card-title" }, {
						default: O(() => [s(T(E(Z)("user_settings")), 1)]),
						_: 1
					}), c(Le, { class: "h-legacy-layout-card-text" }, {
						default: O(() => [c(Wr, {
							class: "h-legacy-layout-user-settings",
							onClose: o[0] ||= (e) => E(v)(!1),
							onSuccess: o[1] ||= (e) => E(v)(t.close)
						})]),
						_: 1
					})]),
					_: 1
				})]),
				_: 1
			}, 8, ["modelValue"]),
			c(ht, {
				class: "legacy-layout-topbar",
				prominent: "",
				dark: "",
				elevation: 0,
				height: 60
			}, {
				default: O(() => [
					a("div", $i, [c(gt, {
						id: "btn-menu-icon",
						variant: "text",
						"aria-label": E(Z)("toggle_sidebar"),
						onClick: o[3] ||= j((e) => E(P)(), ["stop"])
					}, null, 8, ["aria-label"]), E(f) ? (_(), n(_t, {
						key: 0,
						class: "ml-2"
					}, {
						default: O(() => [s(T(E(f)), 1)]),
						_: 1
					})) : r("", !0)]),
					c(be),
					c(Ue, {
						id: "btn-home",
						icon: "fa fa-home",
						href: `${E(w)}/`,
						"aria-label": E(Z)("homepage")
					}, null, 8, ["href", "aria-label"]),
					c(nt, {
						"min-width": "200px",
						location: "bottom",
						rounded: ""
					}, {
						activator: O(({ props: e }) => [c(Ue, u({
							id: "btn-user-settings-icon",
							icon: "fa fa-user"
						}, e, { "aria-label": E(Z)("user_settings") }), null, 16, ["aria-label"])]),
						default: O(() => [c(Fe, { id: "user-settings-dropdown-menu" }, {
							default: O(() => [c(Le, null, {
								default: O(() => [a("div", ea, [
									c(He, { color: "brown" }, {
										default: O(() => [a("span", ta, T(E(h)?.name[0]), 1)]),
										_: 1
									}),
									a("h3", null, T(E(h)?.name), 1),
									a("p", na, T(E(h)?.email), 1),
									E(d) ? (_(), n(dt, {
										key: 0,
										class: "my-3"
									})) : r("", !0),
									E(d) ? (_(), n(Ue, {
										key: 1,
										id: "btn-user-settings",
										rounded: "",
										variant: "text",
										"aria-label": E(Z)("user_settings"),
										onClick: o[4] ||= (e) => E(v)(!0)
									}, {
										default: O(() => [s(T(E(Z)("settings")), 1)]),
										_: 1
									}, 8, ["aria-label"])) : r("", !0),
									c(dt, { class: "my-3" }),
									c(Ue, {
										id: "btn-user-logout",
										rounded: "",
										variant: "text",
										onClick: o[5] ||= (e) => F()
									}, {
										default: O(() => [s(T(E(Z)("logout")), 1)]),
										_: 1
									})
								])]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					})
				]),
				_: 1
			}),
			a("div", ra, [c(yt, {
				id: "navigation-drawer",
				modelValue: E(N),
				"onUpdate:modelValue": o[6] ||= (e) => l(N) ? N.value = e : null,
				class: "legacy-layout-sidebar text-left",
				temporary: "",
				scrim: !1,
				elevation: 0,
				width: 230
			}, {
				default: O(() => [a("div", ia, [
					D.value ? (_(), n(et, {
						key: 0,
						class: "sidebar__admin",
						density: "compact",
						"aria-label": E(Z)("administration")
					}, {
						default: O(() => [c(tt, {
							"prepend-icon": "fa fa-cogs",
							class: "sidebar-header"
						}, {
							default: O(() => [s(T(E(Z)("administration")), 1)]),
							_: 1
						}), (_(!0), i(e, null, b(k.value, (e, t) => (_(), n(tt, {
							id: `item-admin_${t}`,
							key: `workspace_${t}`,
							class: "siderbar-item",
							href: e.link,
							to: e.route ? { name: e.route } : void 0,
							role: "option"
						}, {
							default: O(() => [s(T(e.name), 1)]),
							_: 2
						}, 1032, [
							"id",
							"href",
							"to"
						]))), 128))]),
						_: 1
					}, 8, ["aria-label"])) : r("", !0),
					c(et, {
						class: "sidebar__admin",
						density: "compact",
						"aria-label": E(Z)("workspaces")
					}, {
						default: O(() => [c(tt, {
							"prepend-icon": "fa fa-th",
							class: "sidebar-header"
						}, {
							default: O(() => [s(T(E(Z)("workspaces")), 1)]),
							_: 1
						}), (_(!0), i(e, null, b(A.value, (e, t) => (_(), n(tt, {
							id: `workspace-admin_${t}`,
							key: `workspace_${t}`,
							class: "siderbar-item",
							href: e.link,
							role: "option"
						}, {
							default: O(() => [s(T(e.name), 1)]),
							_: 2
						}, 1032, ["id", "href"]))), 128))]),
						_: 1
					}, 8, ["aria-label"]),
					c(et, {
						class: "sidebar__processes",
						density: "compact",
						"aria-label": E(Z)("processes")
					}, {
						default: O(() => [
							c(tt, {
								"prepend-icon": "fa fa-tasks",
								class: "sidebar-header",
								href: `${E(w)}/processes?sort=modifieddate, desc`,
								role: "option"
							}, {
								default: O(() => [s(T(E(Z)("processes")), 1)]),
								_: 1
							}, 8, ["href"]),
							M.value ? (_(), n(tt, {
								key: 0,
								href: `${E(w)}/processes?sort=modifieddate,desc&status=running`,
								role: "option"
							}, {
								default: O(() => [s(T(E(Z)("running_processes", { total: M.value })), 1)]),
								_: 1
							}, 8, ["href"])) : r("", !0),
							c(tt, {
								class: "sidebar-item",
								href: `${E(w)}/processes?sort=modifieddate, desc`,
								role: "option"
							}, {
								default: O(() => [s(T(E(Z)("all_processes")), 1)]),
								_: 1
							}, 8, ["href"])
						]),
						_: 1
					}, 8, ["aria-label"])
				])]),
				_: 1
			}, 8, ["modelValue"])]),
			c(vt, { class: "legacy-layout-main h-100" }, {
				default: O(() => [x(t.$slots, "default", {}, void 0, !0)]),
				_: 3
			})
		]));
	}
}, [["__scopeId", "data-v-7db25573"]]), ca = { class: "basic-layout" }, la = { class: "d-flex align-center ml-5" }, ua = { key: 0 }, da = { class: "mx-auto text-center" }, fa = { class: "text-headline-medium" }, pa = { class: "text-body-small mt-1" }, ma = /*#__PURE__*/ xt({
	__name: "basic",
	setup(e) {
		let { hPageTitle: t } = he(), o = se(), { user_settings: l } = ve(), d = y(!1), f = Ye(d);
		async function p() {
			await R();
			let e = encodeURIComponent(window.location.href);
			window.location.href = `${o.logoutUrl}?redirect=${e}`;
		}
		let { oUserSettings: m } = it(ye());
		return (e, o) => {
			let h = S("h-menu");
			return _(), i("div", ca, [
				c(Ke, {
					modelValue: d.value,
					"onUpdate:modelValue": o[2] ||= (e) => d.value = e,
					class: "h-basic-layout-dialog",
					width: "500px"
				}, {
					default: O(() => [c(Fe, { class: "user-settings h-basic-layout-card" }, {
						default: O(() => [c(Re, { class: "h-basic-layout-card-title" }, {
							default: O(() => [s(T(E(Z)("user_settings")), 1)]),
							_: 1
						}), c(Le, { class: "h-basic-layout-card-text" }, {
							default: O(() => [c(Wr, {
								class: "h-basic-layout-user-settings",
								onClose: o[0] ||= (e) => E(f)(!1),
								onSuccess: o[1] ||= (t) => E(f)(e.close)
							})]),
							_: 1
						})]),
						_: 1
					})]),
					_: 1
				}, 8, ["modelValue"]),
				c(ht, {
					class: "basic-layout-topbar h-basic-layout-app-bar",
					prominent: "",
					dark: "",
					elevation: 0,
					height: 60
				}, {
					default: O(() => [
						a("div", la, [c(_t, null, {
							default: O(() => [E(t) ? (_(), i("div", ua, T(E(t)), 1)) : r("", !0)]),
							_: 1
						})]),
						c(be, { class: "h-basic-layout-spacer" }),
						c(h, {
							class: "h-basic-layout-menu",
							"min-width": "200px",
							location: "bottom",
							rounded: ""
						}, {
							activator: O(({ props: e }) => [c(Ue, u({
								class: "h-basic-layout-btn",
								icon: "fa fa-user"
							}, e, { "aria-label": "User Menu" }), null, 16)]),
							default: O(() => [c(Fe, { class: "h-basic-layout-user-card" }, {
								default: O(() => [c(Le, { class: "h-basic-layout-user-card-text" }, {
									default: O(() => [a("div", da, [
										c(He, {
											class: "h-basic-layout-user-avatar",
											color: "brown"
										}, {
											default: O(() => [a("span", fa, T(E(m)?.name[0]), 1)]),
											_: 1
										}),
										a("h3", null, T(E(m)?.name), 1),
										a("p", pa, T(E(m)?.email), 1),
										c(dt, { class: "my-3 h-basic-layout-user-divider" }),
										x(e.$slots, "prepend-menu-actions", {}, void 0, !0),
										E(l) ? (_(), n(Ue, {
											key: 0,
											class: "h-basic-layout-settings-btn",
											rounded: "",
											variant: "text",
											onClick: o[3] ||= (e) => E(f)(!0)
										}, {
											default: O(() => [s(T(E(Z)("settings")), 1)]),
											_: 1
										})) : r("", !0),
										E(l) ? (_(), n(dt, {
											key: 1,
											class: "my-3 h-basic-layout-user-divider"
										})) : r("", !0),
										c(Ue, {
											class: "h-basic-layout-logout-btn",
											rounded: "",
											variant: "text",
											onClick: o[4] ||= (e) => p()
										}, {
											default: O(() => [s(T(E(Z)("logout")), 1)]),
											_: 1
										}),
										x(e.$slots, "append-menu-actions", {}, void 0, !0)
									])]),
									_: 3
								})]),
								_: 3
							})]),
							_: 3
						})
					]),
					_: 3
				}),
				c(vt, { class: "basic-layout-main h-basic-layout-main" }, {
					default: O(() => [x(e.$slots, "default", {}, void 0, !0)]),
					_: 3
				})
			]);
		};
	}
}, [["__scopeId", "data-v-8bd25ad6"]]), ha = {};
function ga(e, t) {
	return _(), n(bt, { class: "h-embed-layout" }, {
		default: O(() => [c(vt, { class: "h-embed-layout-main" }, {
			default: O(() => [x(e.$slots, "default", {}, void 0, !0)]),
			_: 3
		})]),
		_: 3
	});
}
var _a = /*#__PURE__*/ xt(ha, [["render", ga], ["__scopeId", "data-v-1bc3008e"]]), va = {};
function ya(e, t) {
	return _(), n(vt, { class: "h-blank-layout" }, {
		default: O(() => [x(e.$slots, "default", {}, void 0, !0)]),
		_: 3
	});
}
var ba = /*#__PURE__*/ xt(va, [["render", ya], ["__scopeId", "data-v-c028723b"]]);
//#endregion
//#region ../../../node_modules/lodash-es/_listCacheClear.js
function xa() {
	this.__data__ = [], this.size = 0;
}
//#endregion
//#region ../../../node_modules/lodash-es/eq.js
function Sa(e, t) {
	return e === t || e !== e && t !== t;
}
//#endregion
//#region ../../../node_modules/lodash-es/_assocIndexOf.js
function Ca(e, t) {
	for (var n = e.length; n--;) if (Sa(e[n][0], t)) return n;
	return -1;
}
//#endregion
//#region ../../../node_modules/lodash-es/_listCacheDelete.js
var wa = Array.prototype.splice;
function Ta(e) {
	var t = this.__data__, n = Ca(t, e);
	return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : wa.call(t, n, 1), --this.size, !0);
}
//#endregion
//#region ../../../node_modules/lodash-es/_listCacheGet.js
function Ea(e) {
	var t = this.__data__, n = Ca(t, e);
	return n < 0 ? void 0 : t[n][1];
}
//#endregion
//#region ../../../node_modules/lodash-es/_listCacheHas.js
function Da(e) {
	return Ca(this.__data__, e) > -1;
}
//#endregion
//#region ../../../node_modules/lodash-es/_listCacheSet.js
function Oa(e, t) {
	var n = this.__data__, r = Ca(n, e);
	return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
//#endregion
//#region ../../../node_modules/lodash-es/_ListCache.js
function ka(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
ka.prototype.clear = xa, ka.prototype.delete = Ta, ka.prototype.get = Ea, ka.prototype.has = Da, ka.prototype.set = Oa;
//#endregion
//#region ../../../node_modules/lodash-es/_stackClear.js
function Aa() {
	this.__data__ = new ka(), this.size = 0;
}
//#endregion
//#region ../../../node_modules/lodash-es/_stackDelete.js
function ja(e) {
	var t = this.__data__, n = t.delete(e);
	return this.size = t.size, n;
}
//#endregion
//#region ../../../node_modules/lodash-es/_stackGet.js
function Ma(e) {
	return this.__data__.get(e);
}
//#endregion
//#region ../../../node_modules/lodash-es/_stackHas.js
function Na(e) {
	return this.__data__.has(e);
}
//#endregion
//#region ../../../node_modules/lodash-es/_freeGlobal.js
var Pa = typeof global == "object" && global && global.Object === Object && global, Fa = typeof self == "object" && self && self.Object === Object && self, Ia = Pa || Fa || Function("return this")(), La = Ia.Symbol, Ra = Object.prototype, za = Ra.hasOwnProperty, Ba = Ra.toString, Va = La ? La.toStringTag : void 0;
function Ha(e) {
	var t = za.call(e, Va), n = e[Va];
	try {
		e[Va] = void 0;
		var r = !0;
	} catch {}
	var i = Ba.call(e);
	return r && (t ? e[Va] = n : delete e[Va]), i;
}
//#endregion
//#region ../../../node_modules/lodash-es/_objectToString.js
var Ua = Object.prototype.toString;
function Wa(e) {
	return Ua.call(e);
}
//#endregion
//#region ../../../node_modules/lodash-es/_baseGetTag.js
var Ga = "[object Null]", Ka = "[object Undefined]", qa = La ? La.toStringTag : void 0;
function Ja(e) {
	return e == null ? e === void 0 ? Ka : Ga : qa && qa in Object(e) ? Ha(e) : Wa(e);
}
//#endregion
//#region ../../../node_modules/lodash-es/isObject.js
function Ya(e) {
	var t = typeof e;
	return e != null && (t == "object" || t == "function");
}
//#endregion
//#region ../../../node_modules/lodash-es/isFunction.js
var Xa = "[object AsyncFunction]", Za = "[object Function]", Qa = "[object GeneratorFunction]", $a = "[object Proxy]";
function eo(e) {
	if (!Ya(e)) return !1;
	var t = Ja(e);
	return t == Za || t == Qa || t == Xa || t == $a;
}
//#endregion
//#region ../../../node_modules/lodash-es/_coreJsData.js
var to = Ia["__core-js_shared__"], no = function() {
	var e = /[^.]+$/.exec(to && to.keys && to.keys.IE_PROTO || "");
	return e ? "Symbol(src)_1." + e : "";
}();
function ro(e) {
	return !!no && no in e;
}
//#endregion
//#region ../../../node_modules/lodash-es/_toSource.js
var io = Function.prototype.toString;
function ao(e) {
	if (e != null) {
		try {
			return io.call(e);
		} catch {}
		try {
			return e + "";
		} catch {}
	}
	return "";
}
//#endregion
//#region ../../../node_modules/lodash-es/_baseIsNative.js
var oo = /[\\^$.*+?()[\]{}|]/g, so = /^\[object .+?Constructor\]$/, co = Function.prototype, lo = Object.prototype, uo = co.toString, fo = lo.hasOwnProperty, po = RegExp("^" + uo.call(fo).replace(oo, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function mo(e) {
	return !Ya(e) || ro(e) ? !1 : (eo(e) ? po : so).test(ao(e));
}
//#endregion
//#region ../../../node_modules/lodash-es/_getValue.js
function ho(e, t) {
	return e?.[t];
}
//#endregion
//#region ../../../node_modules/lodash-es/_getNative.js
function go(e, t) {
	var n = ho(e, t);
	return mo(n) ? n : void 0;
}
//#endregion
//#region ../../../node_modules/lodash-es/_Map.js
var _o = go(Ia, "Map"), vo = go(Object, "create");
//#endregion
//#region ../../../node_modules/lodash-es/_hashClear.js
function yo() {
	this.__data__ = vo ? vo(null) : {}, this.size = 0;
}
//#endregion
//#region ../../../node_modules/lodash-es/_hashDelete.js
function bo(e) {
	var t = this.has(e) && delete this.__data__[e];
	return this.size -= +!!t, t;
}
//#endregion
//#region ../../../node_modules/lodash-es/_hashGet.js
var xo = "__lodash_hash_undefined__", So = Object.prototype.hasOwnProperty;
function Co(e) {
	var t = this.__data__;
	if (vo) {
		var n = t[e];
		return n === xo ? void 0 : n;
	}
	return So.call(t, e) ? t[e] : void 0;
}
//#endregion
//#region ../../../node_modules/lodash-es/_hashHas.js
var wo = Object.prototype.hasOwnProperty;
function To(e) {
	var t = this.__data__;
	return vo ? t[e] !== void 0 : wo.call(t, e);
}
//#endregion
//#region ../../../node_modules/lodash-es/_hashSet.js
var Eo = "__lodash_hash_undefined__";
function Do(e, t) {
	var n = this.__data__;
	return this.size += +!this.has(e), n[e] = vo && t === void 0 ? Eo : t, this;
}
//#endregion
//#region ../../../node_modules/lodash-es/_Hash.js
function Oo(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
Oo.prototype.clear = yo, Oo.prototype.delete = bo, Oo.prototype.get = Co, Oo.prototype.has = To, Oo.prototype.set = Do;
//#endregion
//#region ../../../node_modules/lodash-es/_mapCacheClear.js
function ko() {
	this.size = 0, this.__data__ = {
		hash: new Oo(),
		map: new (_o || ka)(),
		string: new Oo()
	};
}
//#endregion
//#region ../../../node_modules/lodash-es/_isKeyable.js
function Ao(e) {
	var t = typeof e;
	return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
//#endregion
//#region ../../../node_modules/lodash-es/_getMapData.js
function jo(e, t) {
	var n = e.__data__;
	return Ao(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
//#endregion
//#region ../../../node_modules/lodash-es/_mapCacheDelete.js
function Mo(e) {
	var t = jo(this, e).delete(e);
	return this.size -= +!!t, t;
}
//#endregion
//#region ../../../node_modules/lodash-es/_mapCacheGet.js
function No(e) {
	return jo(this, e).get(e);
}
//#endregion
//#region ../../../node_modules/lodash-es/_mapCacheHas.js
function Po(e) {
	return jo(this, e).has(e);
}
//#endregion
//#region ../../../node_modules/lodash-es/_mapCacheSet.js
function Fo(e, t) {
	var n = jo(this, e), r = n.size;
	return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
//#endregion
//#region ../../../node_modules/lodash-es/_MapCache.js
function Io(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
Io.prototype.clear = ko, Io.prototype.delete = Mo, Io.prototype.get = No, Io.prototype.has = Po, Io.prototype.set = Fo;
//#endregion
//#region ../../../node_modules/lodash-es/_stackSet.js
var Lo = 200;
function Ro(e, t) {
	var n = this.__data__;
	if (n instanceof ka) {
		var r = n.__data__;
		if (!_o || r.length < Lo - 1) return r.push([e, t]), this.size = ++n.size, this;
		n = this.__data__ = new Io(r);
	}
	return n.set(e, t), this.size = n.size, this;
}
//#endregion
//#region ../../../node_modules/lodash-es/_Stack.js
function zo(e) {
	var t = this.__data__ = new ka(e);
	this.size = t.size;
}
zo.prototype.clear = Aa, zo.prototype.delete = ja, zo.prototype.get = Ma, zo.prototype.has = Na, zo.prototype.set = Ro;
//#endregion
//#region ../../../node_modules/lodash-es/_arrayEach.js
function Bo(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1;);
	return e;
}
//#endregion
//#region ../../../node_modules/lodash-es/_defineProperty.js
var Vo = function() {
	try {
		var e = go(Object, "defineProperty");
		return e({}, "", {}), e;
	} catch {}
}();
//#endregion
//#region ../../../node_modules/lodash-es/_baseAssignValue.js
function Ho(e, t, n) {
	t == "__proto__" && Vo ? Vo(e, t, {
		configurable: !0,
		enumerable: !0,
		value: n,
		writable: !0
	}) : e[t] = n;
}
//#endregion
//#region ../../../node_modules/lodash-es/_assignValue.js
var Uo = Object.prototype.hasOwnProperty;
function Wo(e, t, n) {
	var r = e[t];
	(!(Uo.call(e, t) && Sa(r, n)) || n === void 0 && !(t in e)) && Ho(e, t, n);
}
//#endregion
//#region ../../../node_modules/lodash-es/_copyObject.js
function Go(e, t, n, r) {
	var i = !n;
	n ||= {};
	for (var a = -1, o = t.length; ++a < o;) {
		var s = t[a], c = r ? r(n[s], e[s], s, n, e) : void 0;
		c === void 0 && (c = e[s]), i ? Ho(n, s, c) : Wo(n, s, c);
	}
	return n;
}
//#endregion
//#region ../../../node_modules/lodash-es/_baseTimes.js
function Ko(e, t) {
	for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
	return r;
}
//#endregion
//#region ../../../node_modules/lodash-es/isObjectLike.js
function qo(e) {
	return typeof e == "object" && !!e;
}
//#endregion
//#region ../../../node_modules/lodash-es/_baseIsArguments.js
var Jo = "[object Arguments]";
function Yo(e) {
	return qo(e) && Ja(e) == Jo;
}
//#endregion
//#region ../../../node_modules/lodash-es/isArguments.js
var Xo = Object.prototype, Zo = Xo.hasOwnProperty, Qo = Xo.propertyIsEnumerable, $o = Yo(function() {
	return arguments;
}()) ? Yo : function(e) {
	return qo(e) && Zo.call(e, "callee") && !Qo.call(e, "callee");
}, es = Array.isArray;
//#endregion
//#region ../../../node_modules/lodash-es/stubFalse.js
function ts() {
	return !1;
}
//#endregion
//#region ../../../node_modules/lodash-es/isBuffer.js
var ns = typeof exports == "object" && exports && !exports.nodeType && exports, rs = ns && typeof module == "object" && module && !module.nodeType && module, is = rs && rs.exports === ns ? Ia.Buffer : void 0, as = (is ? is.isBuffer : void 0) || ts, os = 9007199254740991, ss = /^(?:0|[1-9]\d*)$/;
function cs(e, t) {
	var n = typeof e;
	return t ??= os, !!t && (n == "number" || n != "symbol" && ss.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
//#endregion
//#region ../../../node_modules/lodash-es/isLength.js
var ls = 9007199254740991;
function us(e) {
	return typeof e == "number" && e > -1 && e % 1 == 0 && e <= ls;
}
//#endregion
//#region ../../../node_modules/lodash-es/_baseIsTypedArray.js
var ds = "[object Arguments]", fs = "[object Array]", ps = "[object Boolean]", ms = "[object Date]", hs = "[object Error]", gs = "[object Function]", _s = "[object Map]", vs = "[object Number]", ys = "[object Object]", bs = "[object RegExp]", xs = "[object Set]", Ss = "[object String]", Cs = "[object WeakMap]", ws = "[object ArrayBuffer]", Ts = "[object DataView]", Es = "[object Float32Array]", Ds = "[object Float64Array]", Os = "[object Int8Array]", ks = "[object Int16Array]", As = "[object Int32Array]", js = "[object Uint8Array]", Ms = "[object Uint8ClampedArray]", Ns = "[object Uint16Array]", Ps = "[object Uint32Array]", Fs = {};
Fs[Es] = Fs[Ds] = Fs[Os] = Fs[ks] = Fs[As] = Fs[js] = Fs[Ms] = Fs[Ns] = Fs[Ps] = !0, Fs[ds] = Fs[fs] = Fs[ws] = Fs[ps] = Fs[Ts] = Fs[ms] = Fs[hs] = Fs[gs] = Fs[_s] = Fs[vs] = Fs[ys] = Fs[bs] = Fs[xs] = Fs[Ss] = Fs[Cs] = !1;
function Is(e) {
	return qo(e) && us(e.length) && !!Fs[Ja(e)];
}
//#endregion
//#region ../../../node_modules/lodash-es/_baseUnary.js
function Ls(e) {
	return function(t) {
		return e(t);
	};
}
//#endregion
//#region ../../../node_modules/lodash-es/_nodeUtil.js
var Rs = typeof exports == "object" && exports && !exports.nodeType && exports, zs = Rs && typeof module == "object" && module && !module.nodeType && module, Bs = zs && zs.exports === Rs && Pa.process, Vs = function() {
	try {
		return zs && zs.require && zs.require("util").types || Bs && Bs.binding && Bs.binding("util");
	} catch {}
}(), Hs = Vs && Vs.isTypedArray, Us = Hs ? Ls(Hs) : Is, Ws = Object.prototype.hasOwnProperty;
function Gs(e, t) {
	var n = es(e), r = !n && $o(e), i = !n && !r && as(e), a = !n && !r && !i && Us(e), o = n || r || i || a, s = o ? Ko(e.length, String) : [], c = s.length;
	for (var l in e) (t || Ws.call(e, l)) && !(o && (l == "length" || i && (l == "offset" || l == "parent") || a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || cs(l, c))) && s.push(l);
	return s;
}
//#endregion
//#region ../../../node_modules/lodash-es/_isPrototype.js
var Ks = Object.prototype;
function qs(e) {
	var t = e && e.constructor;
	return e === (typeof t == "function" && t.prototype || Ks);
}
//#endregion
//#region ../../../node_modules/lodash-es/_overArg.js
function Js(e, t) {
	return function(n) {
		return e(t(n));
	};
}
//#endregion
//#region ../../../node_modules/lodash-es/_nativeKeys.js
var Ys = Js(Object.keys, Object), Xs = Object.prototype.hasOwnProperty;
function Zs(e) {
	if (!qs(e)) return Ys(e);
	var t = [];
	for (var n in Object(e)) Xs.call(e, n) && n != "constructor" && t.push(n);
	return t;
}
//#endregion
//#region ../../../node_modules/lodash-es/isArrayLike.js
function Qs(e) {
	return e != null && us(e.length) && !eo(e);
}
//#endregion
//#region ../../../node_modules/lodash-es/keys.js
function $s(e) {
	return Qs(e) ? Gs(e) : Zs(e);
}
//#endregion
//#region ../../../node_modules/lodash-es/_baseAssign.js
function ec(e, t) {
	return e && Go(t, $s(t), e);
}
//#endregion
//#region ../../../node_modules/lodash-es/_nativeKeysIn.js
function tc(e) {
	var t = [];
	if (e != null) for (var n in Object(e)) t.push(n);
	return t;
}
//#endregion
//#region ../../../node_modules/lodash-es/_baseKeysIn.js
var nc = Object.prototype.hasOwnProperty;
function rc(e) {
	if (!Ya(e)) return tc(e);
	var t = qs(e), n = [];
	for (var r in e) r == "constructor" && (t || !nc.call(e, r)) || n.push(r);
	return n;
}
//#endregion
//#region ../../../node_modules/lodash-es/keysIn.js
function ic(e) {
	return Qs(e) ? Gs(e, !0) : rc(e);
}
//#endregion
//#region ../../../node_modules/lodash-es/_baseAssignIn.js
function ac(e, t) {
	return e && Go(t, ic(t), e);
}
//#endregion
//#region ../../../node_modules/lodash-es/_cloneBuffer.js
var oc = typeof exports == "object" && exports && !exports.nodeType && exports, sc = oc && typeof module == "object" && module && !module.nodeType && module, cc = sc && sc.exports === oc ? Ia.Buffer : void 0, lc = cc ? cc.allocUnsafe : void 0;
function uc(e, t) {
	if (t) return e.slice();
	var n = e.length, r = lc ? lc(n) : new e.constructor(n);
	return e.copy(r), r;
}
//#endregion
//#region ../../../node_modules/lodash-es/_copyArray.js
function dc(e, t) {
	var n = -1, r = e.length;
	for (t ||= Array(r); ++n < r;) t[n] = e[n];
	return t;
}
//#endregion
//#region ../../../node_modules/lodash-es/_arrayFilter.js
function fc(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r;) {
		var o = e[n];
		t(o, n, e) && (a[i++] = o);
	}
	return a;
}
//#endregion
//#region ../../../node_modules/lodash-es/stubArray.js
function pc() {
	return [];
}
//#endregion
//#region ../../../node_modules/lodash-es/_getSymbols.js
var mc = Object.prototype.propertyIsEnumerable, hc = Object.getOwnPropertySymbols, gc = hc ? function(e) {
	return e == null ? [] : (e = Object(e), fc(hc(e), function(t) {
		return mc.call(e, t);
	}));
} : pc;
//#endregion
//#region ../../../node_modules/lodash-es/_copySymbols.js
function _c(e, t) {
	return Go(e, gc(e), t);
}
//#endregion
//#region ../../../node_modules/lodash-es/_arrayPush.js
function vc(e, t) {
	for (var n = -1, r = t.length, i = e.length; ++n < r;) e[i + n] = t[n];
	return e;
}
//#endregion
//#region ../../../node_modules/lodash-es/_getPrototype.js
var yc = Js(Object.getPrototypeOf, Object), bc = Object.getOwnPropertySymbols ? function(e) {
	for (var t = []; e;) vc(t, gc(e)), e = yc(e);
	return t;
} : pc;
//#endregion
//#region ../../../node_modules/lodash-es/_copySymbolsIn.js
function xc(e, t) {
	return Go(e, bc(e), t);
}
//#endregion
//#region ../../../node_modules/lodash-es/_baseGetAllKeys.js
function Sc(e, t, n) {
	var r = t(e);
	return es(e) ? r : vc(r, n(e));
}
//#endregion
//#region ../../../node_modules/lodash-es/_getAllKeys.js
function Cc(e) {
	return Sc(e, $s, gc);
}
//#endregion
//#region ../../../node_modules/lodash-es/_getAllKeysIn.js
function wc(e) {
	return Sc(e, ic, bc);
}
//#endregion
//#region ../../../node_modules/lodash-es/_DataView.js
var Tc = go(Ia, "DataView"), Ec = go(Ia, "Promise"), Dc = go(Ia, "Set"), Oc = go(Ia, "WeakMap"), kc = "[object Map]", Ac = "[object Object]", jc = "[object Promise]", Mc = "[object Set]", Nc = "[object WeakMap]", Pc = "[object DataView]", Fc = ao(Tc), Ic = ao(_o), Lc = ao(Ec), Rc = ao(Dc), zc = ao(Oc), Bc = Ja;
(Tc && Bc(new Tc(/* @__PURE__ */ new ArrayBuffer(1))) != Pc || _o && Bc(new _o()) != kc || Ec && Bc(Ec.resolve()) != jc || Dc && Bc(new Dc()) != Mc || Oc && Bc(new Oc()) != Nc) && (Bc = function(e) {
	var t = Ja(e), n = t == Ac ? e.constructor : void 0, r = n ? ao(n) : "";
	if (r) switch (r) {
		case Fc: return Pc;
		case Ic: return kc;
		case Lc: return jc;
		case Rc: return Mc;
		case zc: return Nc;
	}
	return t;
});
var Vc = Bc, Hc = Object.prototype.hasOwnProperty;
function Uc(e) {
	var t = e.length, n = new e.constructor(t);
	return t && typeof e[0] == "string" && Hc.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
//#endregion
//#region ../../../node_modules/lodash-es/_Uint8Array.js
var Wc = Ia.Uint8Array;
//#endregion
//#region ../../../node_modules/lodash-es/_cloneArrayBuffer.js
function Gc(e) {
	var t = new e.constructor(e.byteLength);
	return new Wc(t).set(new Wc(e)), t;
}
//#endregion
//#region ../../../node_modules/lodash-es/_cloneDataView.js
function Kc(e, t) {
	var n = t ? Gc(e.buffer) : e.buffer;
	return new e.constructor(n, e.byteOffset, e.byteLength);
}
//#endregion
//#region ../../../node_modules/lodash-es/_cloneRegExp.js
var qc = /\w*$/;
function Jc(e) {
	var t = new e.constructor(e.source, qc.exec(e));
	return t.lastIndex = e.lastIndex, t;
}
//#endregion
//#region ../../../node_modules/lodash-es/_cloneSymbol.js
var Yc = La ? La.prototype : void 0, Xc = Yc ? Yc.valueOf : void 0;
function Zc(e) {
	return Xc ? Object(Xc.call(e)) : {};
}
//#endregion
//#region ../../../node_modules/lodash-es/_cloneTypedArray.js
function Qc(e, t) {
	var n = t ? Gc(e.buffer) : e.buffer;
	return new e.constructor(n, e.byteOffset, e.length);
}
//#endregion
//#region ../../../node_modules/lodash-es/_initCloneByTag.js
var $c = "[object Boolean]", el = "[object Date]", tl = "[object Map]", nl = "[object Number]", rl = "[object RegExp]", il = "[object Set]", al = "[object String]", ol = "[object Symbol]", sl = "[object ArrayBuffer]", cl = "[object DataView]", ll = "[object Float32Array]", ul = "[object Float64Array]", dl = "[object Int8Array]", fl = "[object Int16Array]", pl = "[object Int32Array]", ml = "[object Uint8Array]", hl = "[object Uint8ClampedArray]", gl = "[object Uint16Array]", _l = "[object Uint32Array]";
function vl(e, t, n) {
	var r = e.constructor;
	switch (t) {
		case sl: return Gc(e);
		case $c:
		case el: return new r(+e);
		case cl: return Kc(e, n);
		case ll:
		case ul:
		case dl:
		case fl:
		case pl:
		case ml:
		case hl:
		case gl:
		case _l: return Qc(e, n);
		case tl: return new r();
		case nl:
		case al: return new r(e);
		case rl: return Jc(e);
		case il: return new r();
		case ol: return Zc(e);
	}
}
//#endregion
//#region ../../../node_modules/lodash-es/_baseCreate.js
var yl = Object.create, bl = function() {
	function e() {}
	return function(t) {
		if (!Ya(t)) return {};
		if (yl) return yl(t);
		e.prototype = t;
		var n = new e();
		return e.prototype = void 0, n;
	};
}();
//#endregion
//#region ../../../node_modules/lodash-es/_initCloneObject.js
function xl(e) {
	return typeof e.constructor == "function" && !qs(e) ? bl(yc(e)) : {};
}
//#endregion
//#region ../../../node_modules/lodash-es/_baseIsMap.js
var Sl = "[object Map]";
function Cl(e) {
	return qo(e) && Vc(e) == Sl;
}
//#endregion
//#region ../../../node_modules/lodash-es/isMap.js
var wl = Vs && Vs.isMap, Tl = wl ? Ls(wl) : Cl, El = "[object Set]";
function Dl(e) {
	return qo(e) && Vc(e) == El;
}
//#endregion
//#region ../../../node_modules/lodash-es/isSet.js
var Ol = Vs && Vs.isSet, kl = Ol ? Ls(Ol) : Dl, Al = 1, jl = 2, Ml = 4, Nl = "[object Arguments]", Pl = "[object Array]", Fl = "[object Boolean]", Il = "[object Date]", Ll = "[object Error]", Rl = "[object Function]", zl = "[object GeneratorFunction]", Bl = "[object Map]", Vl = "[object Number]", Hl = "[object Object]", Ul = "[object RegExp]", Wl = "[object Set]", Gl = "[object String]", Kl = "[object Symbol]", ql = "[object WeakMap]", Jl = "[object ArrayBuffer]", Yl = "[object DataView]", Xl = "[object Float32Array]", Zl = "[object Float64Array]", Ql = "[object Int8Array]", $l = "[object Int16Array]", eu = "[object Int32Array]", tu = "[object Uint8Array]", nu = "[object Uint8ClampedArray]", ru = "[object Uint16Array]", iu = "[object Uint32Array]", au = {};
au[Nl] = au[Pl] = au[Jl] = au[Yl] = au[Fl] = au[Il] = au[Xl] = au[Zl] = au[Ql] = au[$l] = au[eu] = au[Bl] = au[Vl] = au[Hl] = au[Ul] = au[Wl] = au[Gl] = au[Kl] = au[tu] = au[nu] = au[ru] = au[iu] = !0, au[Ll] = au[Rl] = au[ql] = !1;
function ou(e, t, n, r, i, a) {
	var o, s = t & Al, c = t & jl, l = t & Ml;
	if (n && (o = i ? n(e, r, i, a) : n(e)), o !== void 0) return o;
	if (!Ya(e)) return e;
	var u = es(e);
	if (u) {
		if (o = Uc(e), !s) return dc(e, o);
	} else {
		var d = Vc(e), f = d == Rl || d == zl;
		if (as(e)) return uc(e, s);
		if (d == Hl || d == Nl || f && !i) {
			if (o = c || f ? {} : xl(e), !s) return c ? xc(e, ac(o, e)) : _c(e, ec(o, e));
		} else {
			if (!au[d]) return i ? e : {};
			o = vl(e, d, s);
		}
	}
	a ||= new zo();
	var p = a.get(e);
	if (p) return p;
	a.set(e, o), kl(e) ? e.forEach(function(r) {
		o.add(ou(r, t, n, r, e, a));
	}) : Tl(e) && e.forEach(function(r, i) {
		o.set(i, ou(r, t, n, i, e, a));
	});
	var m = u ? void 0 : (l ? c ? wc : Cc : c ? ic : $s)(e);
	return Bo(m || e, function(r, i) {
		m && (i = r, r = e[i]), Wo(o, i, ou(r, t, n, i, e, a));
	}), o;
}
//#endregion
//#region ../../../node_modules/lodash-es/cloneDeep.js
var su = 1, cu = 4;
function lu(e) {
	return ou(e, su | cu);
}
//#endregion
//#region src/assets/onify-logo.png
var uu = "data:image/png;base64,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", du = { class: "pa-6" }, fu = ["src"], pu = { class: "h-layout__header-controls" }, mu = ["src"], hu = {
	key: 1,
	class: "text-headline-medium ml-4"
}, gu = {
	key: 0,
	class: "h-layout__page-title"
}, _u = { class: "d-flex mr-2" }, vu = { class: "h-layout__user-avatar" }, yu = {
	class: "mx-auto text-center",
	style: { padding: "16px" }
}, bu = { class: "h-layout__user-avatar" }, xu = { class: "mt-2" }, Su = { class: "text-label-large mt-1" }, Cu = /*#__PURE__*/ xt({
	__name: "index",
	props: {},
	setup(e) {
		X(e, "HHelixLayout");
		let { user_settings: d } = ve(), p = y(!1), { hPageTitle: m, hIsTitleEmpty: h } = he(), { oUserSettings: g } = it(ye()), v = se(), b = y(!1), C = y(!1);
		function w() {
			C.value = !C.value;
		}
		let D = Xe(), k = t(() => /^\/admin(?:\/|$)/.test(D.path)), A = Ze(), j = t(() => D?.params?.workspaceSlug), { hHttpRequest: M } = Y(), N = y(), P = y(!1);
		async function F() {
			P.value = !0, N.value = await (await M({
				url: "/my/notifications",
				params: {
					term: "*",
					status: ["new", "read"],
					sort: "timestamp",
					sortby: "desc",
					startfrom: 0,
					pagesize: 100,
					metaonly: !1
				}
			}).response()).json(), P.value = !1;
		}
		F(), Je(() => {
			F();
		}, 6e4);
		let I = async () => {
			let e = [], t = lu(N.value);
			for (let n of t?.records ?? []) n.status = "read", e.push({
				id: n.id,
				status: "read"
			});
			t.aggregations.status_count.buckets = [{
				key: "read",
				doc_count: t.records.filter((e) => e.status === "read").length
			}, {
				key: "new",
				doc_count: t.records.filter((e) => e.status === "new").length
			}], N.value = t, M({
				url: "/my/notifications",
				method: "PUT"
			}, { json: e });
		}, L = async (e, t) => {
			let n = lu(N.value);
			n.records.find((t) => t.id === e).status = t, n.aggregations.status_count.buckets = [{
				key: "read",
				doc_count: n.records.filter((e) => e.status === "read").length
			}, {
				key: "new",
				doc_count: n.records.filter((e) => e.status === "new").length
			}], N.value = n, M({
				url: `/my/notifications/${e}`,
				method: "PUT",
				payload: { status: t }
			});
		}, [z, B] = Ye();
		async function V() {
			await R();
			let e = encodeURIComponent(window.location.href);
			window.location.href = `${v.logoutUrl}?redirect=${e}`;
		}
		return (e, t) => {
			let v = S("h-notification-drawer"), y = S("h-dialog"), M = S("router-link"), F = S("h-navigation-menu"), R = S("h-search-items"), H = S("h-notification-badge"), U = S("h-theme-scope"), ee = S("h-menu");
			return _(), i("div", { class: f(["h-layout", {
				[`workspace-${j.value}`]: !!j.value,
				"h-layout--admin": k.value
			}]) }, [
				c(v, {
					modelValue: C.value,
					"onUpdate:modelValue": t[0] ||= (e) => C.value = e,
					title: ("useHTranslate" in e ? e.useHTranslate : E(Z))("notification_title"),
					"notification-data": N.value,
					onMarkAllAsRead: I,
					onUpdateStatus: L
				}, null, 8, [
					"modelValue",
					"title",
					"notification-data"
				]),
				c(y, {
					modelValue: E(z),
					"onUpdate:modelValue": t[3] ||= (e) => l(z) ? z.value = e : null,
					class: "h-helix-layout-user-settings-dialog",
					header: e.$t("user_settings")
				}, {
					header: O(() => [s(T(("useHTranslate" in e ? e.useHTranslate : E(Z))("user_settings")), 1)]),
					default: O(() => [a("div", du, [c(Wr, {
						class: "h-helix-layout-user-settings",
						onClose: t[1] ||= (e) => E(B)(!1),
						onSuccess: t[2] ||= (e) => E(B)(!1)
					})])]),
					_: 1
				}, 8, ["modelValue", "header"]),
				c(F, {
					modelValue: p.value,
					"onUpdate:modelValue": t[5] ||= (e) => p.value = e,
					loading: b.value,
					"onUpdate:loading": t[6] ||= (e) => b.value = e,
					class: "h-helix-layout-navigation-menu",
					"workspace-slug": j.value,
					width: k.value ? 360 : 300,
					"admin-design": k.value,
					"active-path": E(D).path
				}, o({ _: 2 }, [k.value ? {
					name: "logo",
					fn: O(() => [c(M, {
						to: "/admin/dashboard",
						class: "h-layout__admin-logo",
						"aria-label": "Onify",
						onClick: t[4] ||= (e) => p.value = !1
					}, {
						default: O(() => [a("img", {
							src: E(uu),
							width: "192",
							height: "96",
							alt: "Onify"
						}, null, 8, fu)]),
						_: 1
					})]),
					key: "0"
				} : void 0]), 1032, [
					"modelValue",
					"loading",
					"workspace-slug",
					"width",
					"admin-design",
					"active-path"
				]),
				c(ht, {
					class: "h-layout__header",
					height: k.value ? 72 : 109,
					flat: ""
				}, {
					default: O(() => [a("div", pu, [
						c(gt, {
							class: "h-layout__nav-btn",
							variant: "text",
							size: "default",
							"aria-label": ("useHTranslate" in e ? e.useHTranslate : E(Z))("navigation_menu"),
							disabled: b.value,
							onClick: t[7] ||= (e) => p.value = !p.value
						}, null, 8, ["aria-label", "disabled"]),
						k.value ? (_(), n(M, {
							key: 0,
							to: "/admin/dashboard",
							class: "h-layout__admin-logo",
							"aria-label": "Onify"
						}, {
							default: O(() => [a("img", {
								src: E(uu),
								width: "192",
								height: "96",
								alt: "Onify"
							}, null, 8, mu)]),
							_: 1
						})) : (_(), i("div", hu, [E(h) ? (_(), n(xe, {
							key: 1,
							class: "h-layout__page-title-loader",
							type: "sentences"
						})) : (_(), i("span", gu, T(E(m)), 1))])),
						c(be, { class: "h-layout__header-spacer" }),
						k.value ? r("", !0) : (_(), n(Le, {
							key: 2,
							class: "h-layout__header-search"
						}, {
							default: O(() => [j.value ? (_(), n(R, {
								key: 0,
								class: "h-layout__header-search-bar text-on-surface-variant",
								workspace: j.value,
								"search:append-inner-icon": "mdi:mdi-magnify",
								"search:placeholder": e.$t("what_are_you_looking_for"),
								"search:single-line": !0,
								"search:flat": !0,
								"component-map": e.componentMap,
								"item-card-template": e.itemCardTemplate
							}, null, 8, [
								"workspace",
								"search:placeholder",
								"component-map",
								"item-card-template"
							])) : r("", !0)]),
							_: 1
						})),
						a("div", _u, [c(H, {
							class: "h-helix-layout-notification-badge",
							color: "badge-primary",
							disabled: P.value && !N.value?.aggregations,
							aggregations: N.value?.aggregations,
							onClick: w
						}, null, 8, ["disabled", "aggregations"]), c(ee, {
							class: "h-helix-layout-user-menu",
							"min-width": "200px",
							location: "bottom"
						}, {
							activator: O(({ props: t }) => [c(U, u(t, {
								id: "btn-notification",
								name: "HScopedHelixLayoutUserBtn",
								component: E(lt),
								class: "h-helix-layout-user-btn",
								icon: "",
								"aria-label": ("useHTranslate" in e ? e.useHTranslate : E(Z))("user_menu")
							}), {
								default: O(() => [c(U, {
									name: "HScopedHelixLayoutUserAvatar",
									component: E(ct),
									class: "h-helix-layout-user-avatar",
									color: "primary",
									size: "32"
								}, {
									default: O(() => [a("span", vu, T(E(g)?.name?.[0]), 1)]),
									_: 1
								}, 8, ["component"])]),
								_: 1
							}, 16, ["component", "aria-label"])]),
							default: O(() => [c(Fe, { class: "h-helix-layout-user-card" }, {
								default: O(() => [c(Le, { class: "h-helix-layout-user-card-text" }, {
									default: O(() => [a("div", yu, [
										c(U, {
											name: "HScopedHelixLayoutUserMenuAvatar",
											component: E(ct),
											class: "h-helix-layout-user-menu-avatar",
											color: "primary"
										}, {
											default: O(() => [a("span", bu, T(E(g)?.name?.[0]), 1)]),
											_: 1
										}, 8, ["component"]),
										a("h3", xu, T(E(g)?.name), 1),
										a("p", Su, T(E(g)?.custom?.personnummer), 1),
										c(dt, { class: "my-3 h-helix-layout-user-menu-divider" }),
										x(e.$slots, "prepend-menu-actions", {}, void 0, !0),
										E(d) ? (_(), n(U, {
											key: 0,
											name: "HScopedHelixLayoutSettingsBtn",
											component: E(lt),
											class: "h-helix-layout-settings-btn",
											rounded: "",
											variant: "text",
											onClick: t[8] ||= (e) => E(B)(!0)
										}, {
											default: O(() => [s(T(("useHTranslate" in e ? e.useHTranslate : E(Z))("settings")), 1)]),
											_: 1
										}, 8, ["component"])) : r("", !0),
										E(d) ? (_(), n(dt, {
											key: 1,
											class: "my-3 h-helix-layout-user-menu-divider"
										})) : r("", !0),
										c(U, {
											name: "HScopedHelixLayoutCitizenPortalBtn",
											component: E(lt),
											class: "h-helix-layout-citizen-portal-btn",
											rounded: "",
											variant: "text",
											onClick: t[9] ||= (e) => E(A).push("/")
										}, {
											default: O(() => [s(T(("useHTranslate" in e ? e.useHTranslate : E(Z))("citizen_portal_link_title")), 1)]),
											_: 1
										}, 8, ["component"]),
										c(dt, { class: "my-3 h-helix-layout-user-menu-divider" }),
										c(U, {
											name: "HScopedHelixLayoutLogoutBtn",
											component: E(lt),
											class: "h-helix-layout-logout-btn",
											rounded: "",
											variant: "text",
											onClick: t[10] ||= (e) => V()
										}, {
											default: O(() => [s(T(("useHTranslate" in e ? e.useHTranslate : E(Z))("logout")), 1)]),
											_: 1
										}, 8, ["component"]),
										x(e.$slots, "append-menu-actions", {}, void 0, !0)
									])]),
									_: 3
								})]),
								_: 3
							})]),
							_: 3
						})])
					])]),
					_: 3
				}, 8, ["height"]),
				c(vt, { class: "h-helix-layout-main" }, {
					default: O(() => [x(e.$slots, "default", {}, void 0, !0)]),
					_: 3
				})
			], 2);
		};
	}
}, [["__scopeId", "data-v-3e8bb225"]]);
//#endregion
export { Rn as HAdminAgents, tn as HAdminAudit, an as HAdminBulletins, Cr as HAdminConnectorDatasourceFile, Tr as HAdminConnectorDatasourceLdap, Or as HAdminConnectorDatasourceRest, Ar as HAdminConnectorDatasourceSql, Mr as HAdminConnectorIndex, xr as HAdminConnectorPipelines, Pr as HAdminConnectorPurge, Ir as HAdminConnectorReader, Rr as HAdminConnectorScript, Br as HAdminConnectorTransform, Yt as HAdminDashboard, ln as HAdminDashboards, sn as HAdminDomains, fn as HAdminForms, hn as HAdminGuides, bn as HAdminItems, Nn as HAdminLocales, $t as HAdminLogs, Cn as HAdminOptions, en as HAdminProcesses, vr as HAdminResources, jn as HAdminRoles, Dn as HAdminSettings, kn as HAdminShortcuts, In as HAdminStrings, $n as HAdminSystemLogs, Bn as HAdminUsers, Wn as HAdminWorkflows, Kn as HAdminWorkspaces, ma as HBasicLayout, ba as HBlankLayout, _a as HEmbedLayout, Cu as HHelixLayout, si as HLegacyError, ti as HLegacyError404, sa as HLegacyLayout, Gi as HLoginInternal, Ji as HLogout, Zi as HMaintenance, Ui as HThemesSelect, Wr as HUserSettings, Mi as HWorkspace, zi as HWorkspacesList };

//# sourceMappingURL=helix-pages.es.js.map